webpackJsonp([212],{

/***/ "+4G4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-email\"><defs><style type=\"text/css\"></style></defs><path d=\"M513 583.8l448.5-448.5c-11.6-4.7-24.3-7.3-37.5-7.3L100 128c-12.7 0-24.9 2.4-36.1 6.7L513 583.8z\" p-id=\"9121\" /><path d=\"M513 674.3 14.6 175.9C5.3 191.1 0 208.9 0 228l0 568c0 55.2 44.8 100 100 100l824 0c55.2 0 100-44.8 100-100l0-568c0-18.5-5.1-35.9-13.9-50.8L513 674.3z\" p-id=\"9122\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "+AaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//================================

function QnLoginClient(base, platformId) {
    var baseUrl = base;
    var platformId = platformId;
    var that = this;

    this.geBaseUrl = function () {
        return baseUrl;
    };

    this.getPlatformId = function () {
        return platformId;
    };

    this.getCheckPagePath = function () {
        return "loginCheck.html";
    };

    this.getUniloginPagePath = function () {
        return "unilogin.html";
    };

    this.getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    };

    this.validateTGC = function () {
        var postParams = "dont_login=1&clean_dirty=1";
        qnapi.query('passport/validate/tgc', postParams, handleOnValidateInClient);
    };

    this.getJumpUrl = function (target, redirectUrl, userType, dontLogin) {
        var targetPath = "";
        if (target == "login") {
            targetPath = this.getUniloginPagePath();
        } else {
            targetPath = this.getCheckPagePath();
        }
        var url = this.geBaseUrl() + targetPath + "?platform_id=" + this.getPlatformId() + "&redirect_url=" + redirectUrl;
        if (dontLogin) {
            url += "&dont_login=" + 1;
            //userType = 'merchant';//hack
        }
        if (userType) {
            url += "&user_type=" + userType;
        }
        // console.log('jump url = ' + url);
        return url;
    };

    this.firstCheck = function (redirectBackUrl, onCheckFail) {
        if (!redirectBackUrl) {
            return;
        }

        var tgc = this.getCookie('QNTGC');
        if (tgc) {
            //go and check
            // console.log('has tgc');
            var url = this.getJumpUrl('check', redirectBackUrl, null, 1);
            window.location.href = url;
        } else {
            //no login, run check fail
            // console.log('no tgc');
            if (onCheckFail) {
                onCheckFail();
            }
        }
    };

    this.jumpToCheck = function (redirectBackUrl, userType) {
        if (!redirectBackUrl || !userType) {
            return;
        }
        var url = this.getJumpUrl('check', redirectBackUrl, userType);
        console.log(url);
        console.log("jumpToCheck");
        window.location.href = url;
        return;
        console.log("jumpToCheck22222333");
    };

    this.jumpToLogin = function (redirectBackUrl, userType) {
        if (!redirectBackUrl || !userType) {
            return;
        }
        var url = this.getJumpUrl('login', redirectBackUrl, userType);
        window.location.href = url;
    };

    /*
     * =====================================================
     *                    以下是新的扩展 
     * =====================================================
     */

    var currentSessKey = '';
    this.localSessName = 'local_sess';
    this.isLocalSessOk = false;

    this.findGetParameter = function (parameterName) {
        var useDecodeURI = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var result = null,
            tmp = [];
        location.search.substr(1).split("&").forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) {
                if (useDecodeURI) {
                    result = decodeURIComponent(tmp[1]);
                } else {
                    result = tmp[1];
                }
            }
        });
        return result;
    };

    this.localRunConfig = {
        JumpBackUrl: null,
        OnLocalSessionOkDo: null, //检测到或成功获取本地session时执行
        OnLocalSessionNotOkDo: null, //检测到无本地session是执行
        OnHasTicketDo: null, //有ticket时执行
        OnAfterLocalSessionOkDo: null, //本地sessionOK后执行
        OnSessionFailDo: null, //没有session时执行
        OnTicketValidateFail: null //ticket 无效时，应该如何处理，理论上要重新去passport一趟
    };

    this.getLocalSess = function () {
        return that.getCookie(that.localSessName);
    };

    this.setLocalSess = function (value, duration) {
        if (!that.getLocalSess()) {
            // console.log("set local!");
            var expires = "";
            if (duration) {
                var date = new Date();
                date.setTime(date.getTime() + duration * 1000);
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = that.localSessName + "=" + value + expires + "; path=/";
        }
    };

    this.removeLocalSess = function () {
        document.cookie = that.localSessName + '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT';
    };

    var checkSessChange = function checkSessChange() {
        if (currentSessKey) {
            var localSession = that.getLocalSess();
            if (currentSessKey != localSession) {
                // console.log("local sess has changed");
                currentSessKey = localSession;
                window.location.reload(false);
            }
        }
    };

    this.runOnOnLocalSessionOkDo = function (localSess) {
        var localSession = null;
        if (localSess) {
            localSession = localSess;
        } else {
            localSession = that.getLocalSess();
        }
        if (localSession) {
            currentSessKey = localSession;
            that.isLocalSessOk = true;
            that.localRunConfig.OnLocalSessionOkDo();
            if (that.localRunConfig.OnAfterLocalSessionOkDo) {
                that.localRunConfig.OnAfterLocalSessionOkDo();
            }

            window.onfocus = checkSessChange;
            //window.setInterval(repeatCheckSessChange, (3 + Math.floor(Math.random() * 3)) * 1000);
        } else {
            if (that.localRunConfig.OnSessionFailDo) {
                that.localRunConfig.OnSessionFailDo();
            }
        }
    };

    this.handleTicketValidate = function (rspData) {
        if (rspData.code == 0) {
            // console.log("ticket validate ok");

            that.setLocalSess(rspData.data.session_key, rspData.data.duration);
            that.runOnOnLocalSessionOkDo();
        } else {
            // console.log("ticket validate fail:" + rspData.code);
            //有ticket但是无效，需要又去passport才行
            if (that.localRunConfig.OnTicketValidateFail) {
                that.localRunConfig.OnTicketValidateFail();
            }
        }
    };

    this.runInPageReady = function (runConfig) {
        //1.config
        if (!runConfig.JumpBackUrl || !runConfig.OnLocalSessionOkDo || !runConfig.OnLocalSessionNotOkDo || !runConfig.OnHasTicketDo) {
            alert("请检查runInPageReady的使用参数！");
            // console.log(runConfig);
        }
        that.localRunConfig.JumpBackUrl = runConfig.JumpBackUrl;
        that.localRunConfig.OnLocalSessionOkDo = runConfig.OnLocalSessionOkDo;
        that.localRunConfig.OnLocalSessionNotOkDo = runConfig.OnLocalSessionNotOkDo;
        that.localRunConfig.OnHasTicketDo = runConfig.OnHasTicketDo;
        if (runConfig.OnAfterLocalSessionOkDo) {
            that.localRunConfig.OnAfterLocalSessionOkDo = runConfig.OnAfterLocalSessionOkDo;
        }
        if (runConfig.OnSessionFailDo) {
            that.localRunConfig.OnSessionFailDo = runConfig.OnSessionFailDo;
        }
        if (runConfig.OnTicketValidateFail) {
            that.localRunConfig.OnTicketValidateFail = runConfig.OnTicketValidateFail;
        }

        //2.start
        var withLocalSessClean = that.findGetParameter('local_sess_clean');
        var ticket = that.findGetParameter('service_ticket');
        if (withLocalSessClean) {
            that.removeLocalSess();
            if (ticket) {
                window.location.href = decodeURIComponent(that.localRunConfig.JumpBackUrl) + '?service_ticket=' + ticket;
                return;
            }
        }

        var localSession = that.getLocalSess();
        if (localSession) {
            // 有本地系统的cookie，判定为已登录
            that.runOnOnLocalSessionOkDo(localSession);
        } else {
            //没有本地系统的cookie,尝试取ticket
            that.localRunConfig.OnLocalSessionNotOkDo();

            if (ticket) {
                // console.log('has ticket!');
                //OnHasTicketDo
                that.localRunConfig.OnHasTicketDo(ticket);
            } else {
                //ticket也没用，检查tgc
                that.firstCheck(that.localRunConfig.JumpBackUrl, that.localRunConfig.OnSessionFailDo);
            }
        }
    };

    this.logout = function () {
        document.cookie = 'QNTGC=; path=/; domain=.qnbar.com; expires=Thu, 01 Jan 1970 00:00:01 GMT';
        document.cookie = 'QNTGC=; path=/; domain=.qnbar.cn; expires=Thu, 01 Jan 1970 00:00:01 GMT';
        document.cookie = 'QNTGC=; path=/; domain=.qnbar.net; expires=Thu, 01 Jan 1970 00:00:01 GMT';

        that.removeLocalSess();

        //OnLoginOutDo
    };
}

/* harmony default export */ __webpack_exports__["a"] = ({
    QnLoginClient: QnLoginClient
});

/***/ }),

/***/ "+D4M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-mima",
  "use": "icon-mima-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mima\"><defs><style type=\"text/css\"></style></defs><path d=\"M780.8 354.579692 665.6 354.579692 665.6 311.689846c0-72.310154-19.849846-193.299692-153.6-193.299692-138.870154 0-153.6 135.049846-153.6 193.299692l0 42.889846L243.2 354.579692 243.2 311.689846C243.2 122.249846 348.790154 0 512 0s268.8 122.249846 268.8 311.689846L780.8 354.579692zM588.8 669.420308C588.8 625.900308 554.220308 590.769231 512 590.769231s-76.8 35.131077-76.8 78.651077c0 29.459692 15.399385 54.468923 38.439385 67.820308l0 89.639385c0 21.740308 17.250462 39.699692 38.4 39.699692s38.4-17.959385 38.4-39.699692l0-89.639385C573.44 723.889231 588.8 698.88 588.8 669.420308zM896 512l0 393.609846c0 65.260308-51.869538 118.390154-115.2 118.390154L243.2 1024c-63.291077 0-115.2-53.129846-115.2-118.390154L128 512c0-65.220923 51.869538-118.390154 115.2-118.390154l537.6 0C844.130462 393.609846 896 446.779077 896 512z\" p-id=\"9230\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "+NXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-balanceRecord",
  "use": "icon-balanceRecord-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-balanceRecord\"><defs><style type=\"text/css\"></style></defs><path d=\"M792.877 120.155c8.982 0 17.493 3.564 23.964 10.035s10.036 14.982 10.036 23.964v715.689c0 8.982-3.564 17.493-10.036 23.965s-14.982 10.035-23.964 10.035H231.123c-8.982 0-17.493-3.564-23.965-10.035-6.472-6.471-10.035-14.982-10.035-23.965V154.155c0-8.982 3.564-17.493 10.035-23.964S222.14 120.156 231.123 120.156l561.754-0.001m0-56H231.123c-49.5 0-90 40.5-90 90v715.689c0 49.5 40.5 90 90 90h561.755c49.5 0 90-40.5 90-90V154.155c-0.001-49.5-40.501-90-90.001-90z\" fill=\"#ffffff\" p-id=\"4585\" /><path d=\"M730.42 826.312H293.58c-15.464 0-28-12.536-28-28s12.536-28 28-28h436.84c15.464 0 28 12.536 28 28s-12.536 28-28 28zM730.42 672.312H293.58c-15.464 0-28-12.536-28-28s12.536-28 28-28h436.84c15.464 0 28 12.536 28 28s-12.536 28-28 28z\" fill=\"#ffffff\" p-id=\"4586\" /><path d=\"M617.019 422.396H540v-47.495h77.019c15.464 0 28-12.536 28-28s-12.536-28-28-28H551.69l73.028-73.028c10.935-10.935 10.935-28.663 0-39.598-10.934-10.936-28.664-10.935-39.598 0l-73.119 73.12-73.121-73.12c-10.935-10.935-28.663-10.935-39.598 0s-10.935 28.663 0 39.598l73.029 73.028h-65.33c-15.464 0-28 12.536-28 28s12.536 28 28 28H484v47.495h-77.019c-15.464 0-28 12.536-28 28s12.536 28 28 28H484v29.228c0 14.43 12.536 26.128 28 26.128s28-11.698 28-26.128v-29.228h77.019c15.464 0 28-12.536 28-28s-12.537-28-28-28z\" fill=\"#ffffff\" p-id=\"4587\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "+k1u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-idle",
  "use": "icon-idle-usage",
  "viewBox": "0 0 72 72",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 72 72\" id=\"icon-idle\">  <image id=\"icon-idle_image0\" width=\"72\" height=\"72\" x=\"0\" y=\"0\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAABGdBTUEAALGPC/xhBQAAACBjSFJN\nAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABuVBMVEVHcEz/////////////\n////////////////////////////////////////////////////////////////////////////\n////////////////////////////////////////////////////////////////////////////\n////////////////////////////////////////////////////////////////////////////\n////////////////////////////////////////////////////////////////////////////\n////////////////////////////////////////////////////////////////////////////\n////////////////////////////////////////////////////////////////////////////\n////////////////////////////////////////////////////////////////////////////\n//////////////////////////////////////+86m99AAAAknRSTlMAJr3621E0x/vRQvnGMwfh\n/DUU7/QiI/XoEDiIU21uSzyWWniCTmhpRQMM4ukWGOsKmNWyHqTXrygqqkQ+Lf3ThyemHfFX/nA5\nVpfy8yETrCUBwn5DwNjc2fd2qOokW9AJcZmevgQ2HALt2qUyuj/w3c/En2e0riBdWZCTBbAGtbOj\nc/gwd+Pleg5PqTpynO7fY9yOt20AAAABYktHRAH/Ai3eAAAAB3RJTUUH4wMBEjAUeSZLqQAAAiVJ\nREFUWMPt2GlT00AAh/EFyhGgUGmVo8jRCtqi4kEpcpWjFpRLUVQUD8CKgkI55JCCUhAUUGA/sZtN\nuoROm91N8kJm8n+VZyb5Demk7RQA/uOlpWdYMhWdlZ0j5Co6V8jLtzI4BYUQQtsF0kV21I6LpC8V\noy4ppUNlUJyTdDnuy6QrcFfSoSp8YjVpF243aTdulwmZ0DmDrPjEK6RrcNeSvor7Gh3yCOi84jTS\n3jrU12+QvlmP2nKLDoGi23fuZim6wdfob1L0PX+jr4HBMXeu1qxhSSGoYSZEX0trm9cQCK090NFp\nCCRaXd3GQBAG7xsEwVCPQRAMuXRB1t4HD/ukw/4Bvc/RoE86HtL/QDqlm3ukG3o8jOOJ/rfIUxwj\n+iGPQ4wSA960z8TIMQB6LoZDPzRoE+OFXDZ+Z1S+9CWuV3KN8UNj0pWvg7jeyJDAD73FFw5YcNS/\nk6FmfqgLXebtsUsxHn/l3Rr+oonJ96PycXY4Dn3ghxSrmyIfIx8/6XCmT3+HAVCt3Zk58/vts0Yl\n9GU24QtpmA+Yi0Qi8wuLS90gcbN8UCtIua88znJqB6z0cdzYlAoEVtmhNaC6b6zOuroDon42Z8ND\ngcDmdxbnxybNQdIW3ZmM0h30LRXbVmcyxlkYcTsBNUdg+Q9L/PZi9lSMPcbw8ihW+nM3GbP36zcX\nIy66f5DwnAcP9sPcDF748M/fkchRXujoeGHipI366Jhj2z8Q8Ftgu0k4BAAAACV0RVh0ZGF0ZTpj\ncmVhdGUAMjAxOS0wMy0wMlQwMTo0ODoyMC0wNzowMIfXiO8AAAAldEVYdGRhdGU6bW9kaWZ5ADIw\nMTktMDMtMDJUMDE6NDg6MjAtMDc6MDD2ijBTAAAAAElFTkSuQmCC\"></image>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "+nHC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_qnbar_platform_js__ = __webpack_require__("Ljt4");
//qnbar平台工具的基础配置
//var PT = require('./vendor/qnbar/platform.js');


var PT = new __WEBPACK_IMPORTED_MODULE_0__vendor_qnbar_platform_js__["a" /* default */].Platform();
PT.config.env = "test";
PT.config.hostBaseUrl = 'http://bz.local.qnbar.cn/';
PT.config.platformUsagespace = 'PT_MIX_BZ';
PT.config.apiBaseUrl = 'http://api2.qnbar.cn/';
PT.config.qnloginBaseUrl = "http://passport.t.qnbar.cn/";
PT.config.qnloginPlatformNo = 10;
PT.config.loginJumpBackUrl = encodeURIComponent(PT.config.hostBaseUrl);
PT.config.wsHost = "10.10.4.6";
PT.config.wsPort = "16666";
PT.config.wsProto = "ws";
PT.init();

/* unused harmony default export */ var _unused_webpack_default_export = ({
    PT: PT
});

/***/ }),

/***/ "0Gq2":
/***/ (function(module, exports, __webpack_require__) {

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = __webpack_require__("LkYP");
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.AuthKeyReq', null, global);
goog.exportSymbol('proto.BindReq', null, global);
goog.exportSymbol('proto.Msg', null, global);
goog.exportSymbol('proto.MsgEndPoint', null, global);
goog.exportSymbol('proto.MsgRsp', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AuthKeyReq = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.AuthKeyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.AuthKeyReq.displayName = 'proto.AuthKeyReq';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.AuthKeyReq.prototype.toObject = function (opt_includeInstance) {
    return proto.AuthKeyReq.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.AuthKeyReq} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.AuthKeyReq.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      sysdimension: jspb.Message.getFieldWithDefault(msg, 1, ""),
      key: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AuthKeyReq}
 */
proto.AuthKeyReq.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AuthKeyReq();
  return proto.AuthKeyReq.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AuthKeyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AuthKeyReq}
 */
proto.AuthKeyReq.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setSysdimension(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setKey(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AuthKeyReq.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.AuthKeyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AuthKeyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AuthKeyReq.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSysdimension();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
};

/**
 * optional string sysDimension = 1;
 * @return {string}
 */
proto.AuthKeyReq.prototype.getSysdimension = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.AuthKeyReq.prototype.setSysdimension = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string key = 2;
 * @return {string}
 */
proto.AuthKeyReq.prototype.getKey = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.AuthKeyReq.prototype.setKey = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.BindReq = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.BindReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.BindReq.displayName = 'proto.BindReq';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.BindReq.prototype.toObject = function (opt_includeInstance) {
    return proto.BindReq.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.BindReq} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.BindReq.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      tobindbzid: jspb.Message.getFieldWithDefault(msg, 1, 0),
      op: jspb.Message.getFieldWithDefault(msg, 2, ""),
      bindendpoint: (f = msg.getBindendpoint()) && proto.MsgEndPoint.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BindReq}
 */
proto.BindReq.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.BindReq();
  return proto.BindReq.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BindReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BindReq}
 */
proto.BindReq.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */reader.readInt32();
        msg.setTobindbzid(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setOp(value);
        break;
      case 3:
        var value = new proto.MsgEndPoint();
        reader.readMessage(value, proto.MsgEndPoint.deserializeBinaryFromReader);
        msg.setBindendpoint(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.BindReq.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.BindReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BindReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.BindReq.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTobindbzid();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getOp();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getBindendpoint();
  if (f != null) {
    writer.writeMessage(3, f, proto.MsgEndPoint.serializeBinaryToWriter);
  }
};

/**
 * optional int32 toBindBzId = 1;
 * @return {number}
 */
proto.BindReq.prototype.getTobindbzid = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};

/** @param {number} value */
proto.BindReq.prototype.setTobindbzid = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string op = 2;
 * @return {string}
 */
proto.BindReq.prototype.getOp = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.BindReq.prototype.setOp = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional MsgEndPoint bindEndPoint = 3;
 * @return {?proto.MsgEndPoint}
 */
proto.BindReq.prototype.getBindendpoint = function () {
  return (/** @type{?proto.MsgEndPoint} */jspb.Message.getWrapperField(this, proto.MsgEndPoint, 3)
  );
};

/** @param {?proto.MsgEndPoint|undefined} value */
proto.BindReq.prototype.setBindendpoint = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};

proto.BindReq.prototype.clearBindendpoint = function () {
  this.setBindendpoint(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.BindReq.prototype.hasBindendpoint = function () {
  return jspb.Message.getField(this, 3) != null;
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Msg = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Msg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.Msg.displayName = 'proto.Msg';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.Msg.prototype.toObject = function (opt_includeInstance) {
    return proto.Msg.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.Msg} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.Msg.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      msgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
      bzid: jspb.Message.getFieldWithDefault(msg, 2, 0),
      op: jspb.Message.getFieldWithDefault(msg, 3, ""),
      frommsgid: jspb.Message.getFieldWithDefault(msg, 4, ""),
      from: (f = msg.getFrom()) && proto.MsgEndPoint.toObject(includeInstance, f),
      to: (f = msg.getTo()) && proto.MsgEndPoint.toObject(includeInstance, f),
      sdata: jspb.Message.getFieldWithDefault(msg, 7, ""),
      bzdata: jspb.Message.getFieldWithDefault(msg, 8, ""),
      rdata: jspb.Message.getFieldWithDefault(msg, 9, ""),
      tag: jspb.Message.getFieldWithDefault(msg, 10, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Msg}
 */
proto.Msg.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Msg();
  return proto.Msg.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Msg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Msg}
 */
proto.Msg.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setMsgid(value);
        break;
      case 2:
        var value = /** @type {number} */reader.readInt32();
        msg.setBzid(value);
        break;
      case 3:
        var value = /** @type {string} */reader.readString();
        msg.setOp(value);
        break;
      case 4:
        var value = /** @type {string} */reader.readString();
        msg.setFrommsgid(value);
        break;
      case 5:
        var value = new proto.MsgEndPoint();
        reader.readMessage(value, proto.MsgEndPoint.deserializeBinaryFromReader);
        msg.setFrom(value);
        break;
      case 6:
        var value = new proto.MsgEndPoint();
        reader.readMessage(value, proto.MsgEndPoint.deserializeBinaryFromReader);
        msg.setTo(value);
        break;
      case 7:
        var value = /** @type {string} */reader.readString();
        msg.setSdata(value);
        break;
      case 8:
        var value = /** @type {string} */reader.readString();
        msg.setBzdata(value);
        break;
      case 9:
        var value = /** @type {string} */reader.readString();
        msg.setRdata(value);
        break;
      case 10:
        var value = /** @type {string} */reader.readString();
        msg.setTag(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Msg.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.Msg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Msg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Msg.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getMsgid();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getBzid();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
  f = message.getOp();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getFrommsgid();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(5, f, proto.MsgEndPoint.serializeBinaryToWriter);
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(6, f, proto.MsgEndPoint.serializeBinaryToWriter);
  }
  f = message.getSdata();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getBzdata();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getRdata();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getTag();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
};

/**
 * optional string msgId = 1;
 * @return {string}
 */
proto.Msg.prototype.getMsgid = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setMsgid = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional int32 bzId = 2;
 * @return {number}
 */
proto.Msg.prototype.getBzid = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};

/** @param {number} value */
proto.Msg.prototype.setBzid = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string op = 3;
 * @return {string}
 */
proto.Msg.prototype.getOp = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 3, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setOp = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string fromMsgId = 4;
 * @return {string}
 */
proto.Msg.prototype.getFrommsgid = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 4, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setFrommsgid = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional MsgEndPoint from = 5;
 * @return {?proto.MsgEndPoint}
 */
proto.Msg.prototype.getFrom = function () {
  return (/** @type{?proto.MsgEndPoint} */jspb.Message.getWrapperField(this, proto.MsgEndPoint, 5)
  );
};

/** @param {?proto.MsgEndPoint|undefined} value */
proto.Msg.prototype.setFrom = function (value) {
  jspb.Message.setWrapperField(this, 5, value);
};

proto.Msg.prototype.clearFrom = function () {
  this.setFrom(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.Msg.prototype.hasFrom = function () {
  return jspb.Message.getField(this, 5) != null;
};

/**
 * optional MsgEndPoint to = 6;
 * @return {?proto.MsgEndPoint}
 */
proto.Msg.prototype.getTo = function () {
  return (/** @type{?proto.MsgEndPoint} */jspb.Message.getWrapperField(this, proto.MsgEndPoint, 6)
  );
};

/** @param {?proto.MsgEndPoint|undefined} value */
proto.Msg.prototype.setTo = function (value) {
  jspb.Message.setWrapperField(this, 6, value);
};

proto.Msg.prototype.clearTo = function () {
  this.setTo(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.Msg.prototype.hasTo = function () {
  return jspb.Message.getField(this, 6) != null;
};

/**
 * optional string sData = 7;
 * @return {string}
 */
proto.Msg.prototype.getSdata = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 7, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setSdata = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string bzData = 8;
 * @return {string}
 */
proto.Msg.prototype.getBzdata = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 8, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setBzdata = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string rData = 9;
 * @return {string}
 */
proto.Msg.prototype.getRdata = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 9, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setRdata = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string tag = 10;
 * @return {string}
 */
proto.Msg.prototype.getTag = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 10, "")
  );
};

/** @param {string} value */
proto.Msg.prototype.setTag = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MsgEndPoint = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MsgEndPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.MsgEndPoint.displayName = 'proto.MsgEndPoint';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.MsgEndPoint.prototype.toObject = function (opt_includeInstance) {
    return proto.MsgEndPoint.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.MsgEndPoint} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.MsgEndPoint.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      group: jspb.Message.getFieldWithDefault(msg, 1, ""),
      sn: jspb.Message.getFieldWithDefault(msg, 2, ""),
      timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MsgEndPoint}
 */
proto.MsgEndPoint.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MsgEndPoint();
  return proto.MsgEndPoint.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MsgEndPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MsgEndPoint}
 */
proto.MsgEndPoint.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */reader.readString();
        msg.setGroup(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setSn(value);
        break;
      case 3:
        var value = /** @type {number} */reader.readInt32();
        msg.setTimestamp(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MsgEndPoint.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.MsgEndPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MsgEndPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MsgEndPoint.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getGroup();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getSn();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt32(3, f);
  }
};

/**
 * optional string group = 1;
 * @return {string}
 */
proto.MsgEndPoint.prototype.getGroup = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 1, "")
  );
};

/** @param {string} value */
proto.MsgEndPoint.prototype.setGroup = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string sn = 2;
 * @return {string}
 */
proto.MsgEndPoint.prototype.getSn = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.MsgEndPoint.prototype.setSn = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional int32 timestamp = 3;
 * @return {number}
 */
proto.MsgEndPoint.prototype.getTimestamp = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};

/** @param {number} value */
proto.MsgEndPoint.prototype.setTimestamp = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MsgRsp = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MsgRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.MsgRsp.displayName = 'proto.MsgRsp';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.MsgRsp.prototype.toObject = function (opt_includeInstance) {
    return proto.MsgRsp.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.MsgRsp} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.MsgRsp.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      code: jspb.Message.getFieldWithDefault(msg, 1, 0),
      codemsg: jspb.Message.getFieldWithDefault(msg, 2, ""),
      msgid: jspb.Message.getFieldWithDefault(msg, 3, ""),
      bzid: jspb.Message.getFieldWithDefault(msg, 4, 0),
      op: jspb.Message.getFieldWithDefault(msg, 5, ""),
      frommsgid: jspb.Message.getFieldWithDefault(msg, 6, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MsgRsp}
 */
proto.MsgRsp.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MsgRsp();
  return proto.MsgRsp.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MsgRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MsgRsp}
 */
proto.MsgRsp.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */reader.readInt32();
        msg.setCode(value);
        break;
      case 2:
        var value = /** @type {string} */reader.readString();
        msg.setCodemsg(value);
        break;
      case 3:
        var value = /** @type {string} */reader.readString();
        msg.setMsgid(value);
        break;
      case 4:
        var value = /** @type {number} */reader.readInt32();
        msg.setBzid(value);
        break;
      case 5:
        var value = /** @type {string} */reader.readString();
        msg.setOp(value);
        break;
      case 6:
        var value = /** @type {string} */reader.readString();
        msg.setFrommsgid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MsgRsp.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.MsgRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MsgRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MsgRsp.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(1, f);
  }
  f = message.getCodemsg();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getMsgid();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getBzid();
  if (f !== 0) {
    writer.writeInt32(4, f);
  }
  f = message.getOp();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getFrommsgid();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
};

/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.MsgRsp.prototype.getCode = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};

/** @param {number} value */
proto.MsgRsp.prototype.setCode = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string codeMsg = 2;
 * @return {string}
 */
proto.MsgRsp.prototype.getCodemsg = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 2, "")
  );
};

/** @param {string} value */
proto.MsgRsp.prototype.setCodemsg = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string msgId = 3;
 * @return {string}
 */
proto.MsgRsp.prototype.getMsgid = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 3, "")
  );
};

/** @param {string} value */
proto.MsgRsp.prototype.setMsgid = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional int32 bzId = 4;
 * @return {number}
 */
proto.MsgRsp.prototype.getBzid = function () {
  return (/** @type {number} */jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};

/** @param {number} value */
proto.MsgRsp.prototype.setBzid = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional string op = 5;
 * @return {string}
 */
proto.MsgRsp.prototype.getOp = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 5, "")
  );
};

/** @param {string} value */
proto.MsgRsp.prototype.setOp = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string fromMsgId = 6;
 * @return {string}
 */
proto.MsgRsp.prototype.getFrommsgid = function () {
  return (/** @type {string} */jspb.Message.getFieldWithDefault(this, 6, "")
  );
};

/** @param {string} value */
proto.MsgRsp.prototype.setFrommsgid = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

goog.object.extend(exports, proto);

/***/ }),

/***/ "0Sc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cropper__ = __webpack_require__("YZ0n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cropper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cropper__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'QnCropper',
	components: {
		VueCropper: __WEBPACK_IMPORTED_MODULE_1_vue_cropper__["VueCropper"]
	},
	inheritAttrs: false,
	props: {
		// 裁剪图片的地址
		data: {
			type: Object,
			default: function _default() {
				return {
					name: '',
					uid: '',
					url: ''
				};
			}
		},
		// 裁剪后的分辨率
		resolution: {
			type: String
		},
		// 裁剪生成图片的质量
		outputSize: {
			type: Number,
			default: 1 // 0.1 ~ 1
		},
		// 裁剪框的大小信息
		infoTrue: {
			type: Boolean,
			default: true
		},
		// 图片是否允许滚轮缩放
		canScale: {
			type: Boolean,
			default: true
		},
		// 是否默认生成截图框
		autoCrop: {
			type: Boolean,
			default: true
		},
		// 默认生成截图框宽度
		autoCropWidth: {
			type: Number,
			default: 200
		},
		// 默认生成截图框高度
		autoCropHeight: {
			type: Number,
			default: 200
		},
		// 截图框能否拖动
		canMoveBox: {
			type: Boolean,
			default: true
		},
		// 截图框是否被限制在图片里面
		centerBox: {
			type: Boolean,
			default: false
		},
		// 容器宽度
		width: {
			type: String,
			default: '400px'
		},
		// 容器高度
		height: {
			type: String,
			default: '400px'
		},
		// 是否显示功能栏
		funBar: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		// 裁剪生成图片的格式
		outputType: function outputType() {
			var name = this.data.name;
			if (!name) return '';
			var i = name.lastIndexOf('.');
			var suffix = name.slice(i + 1);
			suffix = suffix === 'jpg' ? 'jpeg' : suffix;
			return suffix;
		},

		// 是否开启截图框宽高固定比例
		fixed: function fixed() {
			return this.resolution ? true : false;
		},

		// 截图框的宽高比例, 开启fixed生效
		fixedNumber: function fixedNumber() {
			if (this.resolution) {
				var _resolution$split = this.resolution.split('*'),
				    _resolution$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_resolution$split, 2),
				    w = _resolution$split2[0],
				    h = _resolution$split2[1];

				return [Number(w), Number(h)];
			}
			return [200, 200];
		},

		// 固定截图框大小
		fixedBox: function fixedBox() {
			return this.resolution ? true : false;
		},

		// 图片根据截图框输出比例倍数
		enlarge: function enlarge() {
			return this.fixedNumber[0] / this.autoCropWidth;
		}
	},
	methods: {
		handleToConfirm: function handleToConfirm() {
			var _this = this;

			this.$refs.qnCropper.getCropBlob(function (res) {
				var rawFile = new File([res], _this.data.name, { type: 'image/' + _this.outputType });
				rawFile.uid = _this.data.uid;
				// 和上传组件构建的file保持一致
				var file = {
					status: 'ready',
					name: rawFile.name,
					size: rawFile.size,
					percentage: 0,
					uid: rawFile.uid,
					raw: rawFile
				};
				try {
					file.url = URL.createObjectURL(rawFile);
				} catch (err) {
					console.error(err);
					return;
				}
				_this.$emit('success', file);
				_this.close();
			});
		},
		handleRotateLeft: function handleRotateLeft() {
			this.$refs.qnCropper.rotateLeft();
		},
		handleScalePlus: function handleScalePlus() {
			this.$refs.qnCropper.changeScale(1);
		},
		handleScaleSubtract: function handleScaleSubtract() {
			this.$refs.qnCropper.changeScale(-1);
		},
		close: function close() {
			this.$emit('update:visible', false);
		}
	}
});

/***/ }),

/***/ "0aOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isRouterAlive) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "Prompt",
      "src": "/static/basicimg/Prompt.mp3",
      "controls": "controls",
      "hidden": "true",
      "preload": "preload"
    }
  })], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-52f6eacb", esExports)
  }
}

/***/ }),

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = parseTime;
/* unused harmony export formatTime */
/* harmony export (immutable) */ __webpack_exports__["k"] = setRouteQuery;
/* harmony export (immutable) */ __webpack_exports__["j"] = createDownloadUrl;
/* harmony export (immutable) */ __webpack_exports__["m"] = validate;
/* harmony export (immutable) */ __webpack_exports__["n"] = resetFields;
/* harmony export (immutable) */ __webpack_exports__["o"] = validateField;
/* harmony export (immutable) */ __webpack_exports__["d"] = filterEmptyProperty;
/* harmony export (immutable) */ __webpack_exports__["a"] = agencyQnbarRequest;
/* unused harmony export toFormData */
/* harmony export (immutable) */ __webpack_exports__["l"] = deepCopy;
/* unused harmony export limitOperationHz */
/* harmony export (immutable) */ __webpack_exports__["b"] = toMulFormData;
/* harmony export (immutable) */ __webpack_exports__["g"] = calculateMd5ByChunkSize;
/* harmony export (immutable) */ __webpack_exports__["c"] = calculateMD5File_2;
/* harmony export (immutable) */ __webpack_exports__["p"] = getChangeProps;
/* harmony export (immutable) */ __webpack_exports__["i"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["e"] = agencyQnbarRequest2;
/* harmony export (immutable) */ __webpack_exports__["f"] = getImageInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__env__ = __webpack_require__("yZtZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svrapi__ = __webpack_require__("Mp/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_spark_md5__ = __webpack_require__("JSQk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_spark_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_spark_md5__);










var PT = __WEBPACK_IMPORTED_MODULE_4__env__["a" /* default */].PT;

function parseTime(time, cFormat) {
  var isUTC = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date = void 0;
  if ((typeof time === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(time)) === 'object') {
    date = time;
  } else {
    if (/^[0-9]{0,}$/.test(time + '')) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    if (key === 'a') return ['日', '一', '二', '三', '四', '五', '六'][value];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

function formatTime(time, option) {
  time = +time * 1000;
  var d = new Date(time);
  var now = Date.now();

  var diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * 设置路由查询参数
 * @param param {Object} 要设置的参数对象
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
function setRouteQuery(param) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'push';

  this.$router[method](this.$route.path + '?' + toFormData(param));
}

/**
 * 获取下载地址(新)
 * @param name {string} api名称
 * @param params {object} 参数
 * @param auth {boolean} 是否需要鉴权参数
 * @returns {string} 完整的下载地址
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
function createDownloadUrl(name, params) {
  var auth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var query = '?';
  if (auth) {
    var token = __WEBPACK_IMPORTED_MODULE_7_js_cookie___default.a.get(PT.qnlogin.localSessName);
    query += 'api_local_sess=' + token + '&api_usagespace=' + PT.config.platformUsagespace + '&';
  }
  if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(params).length) {
    query += '' + toFormData(params);
  }
  return '' + PT.config.apiBaseUrl + __WEBPACK_IMPORTED_MODULE_5__svrapi__["a" /* default */][name] + query;
}

/**
 * 验证表单
 * @param name
 * @returns {Promise<any>}
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
function validate(name) {
  var _this = this;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    _this.$refs[name].validate(function (valid) {
      if (valid) {
        resolve();
      } else {
        reject();
      }
    });
  });
}

/**
 * 重置表单
 * @param name
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
function resetFields(name) {
  this.$refs[name].resetFields();
}

/**
 * 对部分表单字段进行校验的方法
 * @param prop 表单字段
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
function validateField(prop) {
  var _this2 = this;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    _this2.$refs[name].validateField(prop, function (err) {
      if (err) {
        resolve(err);
      } else {
        reject(err);
      }
    });
  });
}

/**
 * 过滤掉空属性
 * @param obj {object} 需要过滤的对象
 * @returns {object}
 */
function filterEmptyProperty(obj) {
  var params = {};
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
      params[key] = obj[key];
    }
  });
  return params;
}

/**
 * 代理http请求，返回promise对象
 * @param name {string} api名称
 * @param params {object} api参数
 * @returns Promise
 */
function agencyQnbarRequest(name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_5__svrapi__["a" /* default */][name], params, function (res) {
      if (res.code === 0) {
        resolve(res);
      } else {
        reject(res);
        if (__WEBPACK_IMPORTED_MODULE_5__svrapi__["a" /* default */][name] !== "warehouse/mix/psn/check") {
          __WEBPACK_IMPORTED_MODULE_6_element_ui__["MessageBox"].alert(res.msg, '提示');
        }
        // MessageBox.alert(res.msg, '提示')
      }
    });
  });
}

/**
 * 将参数对象转化为键值对的字符串
 * @param data {object} 参数对象
 * @returns {string}
 */
function toFormData(data) {
  var res = '';
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
    res += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]) + '&';
  });
  return res.slice(0, -1);
}

/**
 * 深克隆数据
 * @param data {object} 参数对象
 * @returns {Object}
 */
function deepCopy() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
}

/**
 * 限制操作频率
 * @param      { Function }    cb      定时器回调函数
 * @param      { number= }     time    时间间隔
 * @returns    {Function}
 */
function limitOperationHz(cb) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;

  var interval = null;
  return function () {
    var _this3 = this,
        _arguments = arguments;

    if (interval) {
      // console.log('清除定时器')
      clearInterval(interval);
    }
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      interval = setTimeout(function () {
        // console.log('执行回调')
        resolve(cb.apply(_this3, _arguments));
      }, time);
    });
  };
}

function toMulFormData(data) {
  var formData = new FormData();
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
    formData.append(key, data[key]);
  });
  return formData;
}

//计算视频md5的方法
function calculateMd5ByChunkSize(file) {
  var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1024 * 1024;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var fileReader = new FileReader();
    var chunks = Math.ceil(file.size / chunkSize);
    var currentChunk = 0;
    var spark = new __WEBPACK_IMPORTED_MODULE_8_spark_md5___default.a.ArrayBuffer();

    //读取完成时触发事件
    fileReader.onload = function (e) {
      spark.append(e.target.result);
      currentChunk++;
      if (currentChunk < chunks) {
        readChunk();
      } else {
        resolve(spark.end());
      }
    };

    fileReader.onerror = function (e) {
      reject(e);
    };

    function readChunk() {
      var start = currentChunk * chunkSize;
      var end = start + chunkSize >= file.size ? file.size : start + chunkSize;
      fileReader.readAsArrayBuffer(file.slice(start, end));
    }

    readChunk();
  });
}

// 计算文件的MD5
function calculateMD5File_2(file, chunkSize) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
    var chunks = Math.ceil(file.size / chunkSize);
    var currentChunk = 0;
    var spark = new __WEBPACK_IMPORTED_MODULE_8_spark_md5___default.a.ArrayBuffer();
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
      spark.append(e.target.result);
      currentChunk++;
      if (currentChunk < chunks) {
        loadNext();
      } else {
        var md5 = spark.end();
        resolve(md5);
      }
    };
    fileReader.onerror = function (e) {
      reject(e);
    };
    function loadNext() {
      var start = currentChunk * chunkSize;
      var end = start + chunkSize;
      if (end > file.size) {
        end = file.size;
      }
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }
    loadNext();
  });
}

/**
 * 返回有变动的属性
 * @param oldVal {Object} 旧的对象
 * @param newVal {Object} 新对象
 * @param filter {Array=} 例外的属性不检测
 * @returns {(boolean|Object)} 变动属性组成的对象，如果属性无变动则返回false
 */
function getChangeProps(oldVal, newVal) {
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (oldVal === newVal) return {};
  var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(oldVal);
  var changeProps = {};
  keys.forEach(function (key) {
    if (filter.includes(key)) return;
    if (oldVal[key] !== newVal[key]) {
      changeProps[key] = newVal[key];
    }
  });
  if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(changeProps).length) return false;
  return changeProps;
}

// 防抖
function debounce(fn, delay) {
  var timer = null;
  return function () {
    var _this4 = this,
        _arguments2 = arguments;

    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      fn.apply(_this4, _arguments2);
    }, delay);
  };
}

/**
 * 添加了自动转参数
 * @returns Promise
 */
function agencyQnbarRequest2() {
  try {
    arguments[1] = humpToUnderline(arguments[1]);
  } catch (e) {}
  return agencyQnbarRequest.apply(null, arguments);
}

// 获取图片分辨率
function getImageInfo(url) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    var image = new Image();
    var w = void 0,
        h = void 0;
    image.src = url;
    if (!image.complete) {
      image.onload = function () {
        w = image.width;
        h = image.height;
        image.onload = null;
        resolve({
          width: w,
          height: h
        });
      };
      return;
    }
    w = image.width;
    h = image.height;
    resolve({
      width: w,
      height: h
    });
  });
}

/***/ }),

/***/ "0z76":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-input', _vm._g(_vm._b({
    ref: "input",
    attrs: {
      "icon": _vm.value.toString().length ? _vm.closeIcon : (_vm.$attrs && _vm.$attrs.icon),
      "value": _vm.value,
      "on-icon-click": _vm.clearValue
    },
    on: {
      "input": function (e) { return _vm.$emit('input', e); }
    }
  }, 'el-input', _vm.$attrs, false), _vm.$listeners), [_vm._l((Object.keys(this.$slots)), function(name) {
    return _vm._t(name, null, {
      slot: name
    })
  })], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0876e83d", esExports)
  }
}

/***/ }),

/***/ "11jX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("o0jG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0876e83d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("0z76");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0876e83d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/QnInput/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0876e83d", Component.options)
  } else {
    hotAPI.reload("data-v-0876e83d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "13E8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-xinrenzhinan",
  "use": "icon-xinrenzhinan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-xinrenzhinan\"><defs><style type=\"text/css\"></style></defs><path d=\"M780.108 761.059c54.451 60.351 87.706 138.983 87.706 225.358 0 12.015-0.659 23.882-1.902 35.581l-71.955 0c1.589-11.675 2.695-23.493 2.695-35.581 0-71.578-29.094-136.386-76.189-185.002C658.778 836.02 587.76 855.95 512 855.95c-75.689 0-146.65-19.888-208.294-54.432-47.129 48.604-76.358 113.305-76.358 184.9 0 12.088 1.105 23.906 2.695 35.581l-71.955 0c-1.243-11.699-1.902-23.567-1.902-35.581 0-86.366 33.19-165.055 87.587-225.446-96.765-78.277-158.75-197.84-158.75-331.998C85.023 193.163 276.188 2.001 512 2.001s426.977 191.162 426.977 426.972C938.977 563.184 876.94 682.785 780.108 761.059zM512 295.787c-196.511 0-355.814-80.302-355.814 122.251 0 202.551 159.303 366.749 355.814 366.749s355.814-164.199 355.814-366.749C867.814 215.485 708.511 295.787 512 295.787zM678.047 500.136c-26.2 0-47.442-21.24-47.442-47.442 0-26.197 21.242-47.442 47.442-47.442 26.202 0 47.442 21.244 47.442 47.442C725.488 478.896 704.249 500.136 678.047 500.136zM654.326 630.601c0 32.754-63.722 59.302-142.326 59.302s-142.326-26.549-142.326-59.302c0-8.445 4.376-16.446 12.017-23.719 21.98 20.927 71.979 35.579 130.309 35.579s108.329-14.652 130.309-35.579C649.949 614.155 654.326 622.156 654.326 630.601zM345.953 500.136c-26.202 0-47.442-21.24-47.442-47.442 0-26.197 21.24-47.442 47.442-47.442 26.2 0 47.442 21.244 47.442 47.442C393.395 478.896 372.153 500.136 345.953 500.136z\" p-id=\"9555\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "1BzD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarItem__ = __webpack_require__("6o49");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__env_js__ = __webpack_require__("yZtZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svrapi_js__ = __webpack_require__("Mp/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__("0xDb");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 //获取vuex数据





var getStoreStatus = function getStoreStatus(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* agencyQnbarRequest */])('getStoreStatus', params);
};

var PT = __WEBPACK_IMPORTED_MODULE_4__env_js__["a" /* default */].PT;
var store_sn = void 0;
var SHOW = void 0;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user_title: "",
      username: "",
      routes: [],
      baseInfo: false,
      group_id: ""
    };
  },
  components: { SidebarItem: __WEBPACK_IMPORTED_MODULE_3__SidebarItem__["default"] },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(["sidebar", "getUserTitle"]), {
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  created: function created() {
    store_sn = (JSON.parse(localStorage.getItem('user_data')) || {}).agent_id;
    getStoreStatus({ store_sn: store_sn }).then(function (res) {
      res.data.interval_status === '1' ? SHOW = false : SHOW = true;
    });
    var self = this;
    // console.log(self)
    // self.routes = self.$router.options.routes;
    // return;
    // console.log("8888888888888888888888888888");
    PT.apiClient.query("bz-mix/bz/get-base-info", "", function (rsp) {
      if (rsp.code == 0) {
        // console.log("router请求");
        localStorage.setItem("user_data", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rsp.data));
        self.$store.commit("SET_ROUTE", rsp.data);
        var mythisroutes = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.$router.options.routes));
        //租赁权限
        var lease_type = JSON.parse(localStorage.getItem('user_data')).lease_type;
        // //注释权限
        // self.routes = mythisroutes;
        // return;
        var userInfo = JSON.parse(localStorage.getItem("user_data"));
        var identity = JSON.parse(localStorage.getItem("identity"));
        var user_all = JSON.parse(localStorage.getItem("user_all"));
        var is_open = userInfo.is_open;
        var interface_set = userInfo.interface_set;
        // console.log(userInfo);
        //基本信息显示隐藏
        if (userInfo.agentType == 1 || userInfo.agentType == 2) {
          $("title").html("青柠后台管理系统");
          self.baseInfo = false;
        } else {
          $("title").html("青柠微影商户管理系统");
          self.baseInfo = true;
        }
        var newarr = [];

        //获取特殊权限
        PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_5__svrapi_js__["a" /* default */].specialCompets, {}, function (rsp) {
          if (rsp.code == 0) {
            var user_data = JSON.parse(localStorage.getItem("user_data"));
            var group_id = user_data.group_id;
            // console.log(rsp);
            if (rsp.data.length <= 0) {} else {
              user_all = rsp.data;
            }
            for (var i = 0, ilen = mythisroutes.length; i < ilen; i++) {
              //一级菜单
              //首页
              if (mythisroutes[i].path == "/homepage") {
                newarr.push(mythisroutes[i]);
              } else if (user_all.indexOf("store_base_modul") >= 0 && mythisroutes[i].path == "/storeMat") {
                //门店管理
                var myarr = [];
                for (var index = 0, indexlen = mythisroutes[i].children.length; index < indexlen; index++) {
                  //界面设置
                  if (user_all.indexOf("store_interface_mgr") >= 0 && mythisroutes[i].children[index].path == "/storeMat/interfaceMat") {
                    //界面设置子路由
                    var threearr = [];
                    for (var k = 0, klen = mythisroutes[i].children[index].children.length; k < klen; k++) {
                      if (user_all.indexOf("store_interface_1_list") >= 0 && mythisroutes[i].children[index].children[k].path == "Interfaceone" && group_id != 2) {
                        threearr.push(mythisroutes[i].children[index].children[k]);
                      } else if (user_all.indexOf("store_interface_2_list") >= 0 && mythisroutes[i].children[index].children[k].path == "Interfacetwo" && group_id != 2) {
                        threearr.push(mythisroutes[i].children[index].children[k]);
                      } else if (
                      // 此处待加权限验证
                      mythisroutes[i].children[index].children[k].path == "Interfacethree" && group_id != 2) {
                        threearr.push(mythisroutes[i].children[index].children[k]);
                      } else if (
                      // 此处待加权限验证
                      mythisroutes[i].children[index].children[k].path == "Interfacefour" && group_id != 2) {
                        threearr.push(mythisroutes[i].children[index].children[k]);
                      } else if (
                      // 此处待加权限验证
                      mythisroutes[i].children[index].children[k].path == "Interfacefive" && group_id != 2) {
                        threearr.push(mythisroutes[i].children[index].children[k]);
                      } else if (
                      // 此处待加权限验证
                      mythisroutes[i].children[index].children[k].path == "InterfaceSix" && group_id != 2) {
                        threearr.push(mythisroutes[i].children[index].children[k]);
                      } else if (
                      // 此处待加权限验证
                      mythisroutes[i].children[index].children[k].path == "InterfaceSeven" && group_id != 2) {
                        threearr.push(mythisroutes[i].children[index].children[k]);
                      } else if (
                      // 此处待加权限验证
                      mythisroutes[i].children[index].children[k].path == "InterfaceEight" && group_id != 2) {
                        threearr.push(mythisroutes[i].children[index].children[k]);
                      } else if (
                      // 此处待加权限验证
                      mythisroutes[i].children[index].children[k].path == "hotelIntroduction" && group_id != 2) {
                        threearr.push(mythisroutes[i].children[index].children[k]);
                      } else if (
                      // 此处待加权限验证
                      mythisroutes[i].children[index].children[k].path == "technicianService" && group_id != 2) {
                        threearr.push(mythisroutes[i].children[index].children[k]);
                      } else if (
                      // 此处待加权限验证
                      mythisroutes[i].children[index].children[k].path == "examine") {
                        threearr.push(mythisroutes[i].children[index].children[k]);
                      }
                      // meituanhotel
                      else if (
                        // 此处待加权限验证
                        mythisroutes[i].children[index].children[k].path == "meituanhotel" && group_id == 2) {
                          threearr.push(mythisroutes[i].children[index].children[k]);
                        } else if (user_all.indexOf("store_interface_message_list") >= 0 && mythisroutes[i].children[index].children[k].path == "Interfacetnews") {
                          threearr.push(mythisroutes[i].children[index].children[k]);
                        } else if (user_all.indexOf("store_interface_settlement_list") >= 0 && mythisroutes[i].children[index].children[k].path == "Interfacetwosts") {
                          threearr.push(mythisroutes[i].children[index].children[k]);
                        } else if (user_all.indexOf("store_interface_ctrl_pwd_mgr") >= 0 && mythisroutes[i].children[index].children[k].path == "consolepwd") {
                          threearr.push(mythisroutes[i].children[index].children[k]);
                        } else if (user_all.indexOf("store_interface_welcome_list") >= 0 && mythisroutes[i].children[index].children[k].path == "welcome") {
                          console.log('我有权限');
                          threearr.push(mythisroutes[i].children[index].children[k]);
                          console.log("threearr", threearr);
                        }
                    }
                    mythisroutes[i].children[index].children = threearr;
                    myarr.push(mythisroutes[i].children[index]);

                    console.log(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(myarr)));
                    console.log(mythisroutes);
                  } else if (
                  //员工管理
                  user_all.indexOf("store_staff_mgr") >= 0 && mythisroutes[i].children[index].path == "/storeMat/employeeMat") {
                    //员工管理子路由
                    var threearr = [];
                    for (var _k = 0, _klen = mythisroutes[i].children[index].children.length; _k < _klen; _k++) {
                      if (user_all.indexOf("store_staff_account_list") >= 0 && mythisroutes[i].children[index].children[_k].path == "staff_list") {
                        threearr.push(mythisroutes[i].children[index].children[_k]);
                      } else if (user_all.indexOf("store_staff_role_list") >= 0 && mythisroutes[i].children[index].children[_k].path == "role_list") {
                        threearr.push(mythisroutes[i].children[index].children[_k]);
                      }
                    }
                    mythisroutes[i].children[index].children = threearr;
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (user_all.indexOf("store_opinion_list") >= 0 && mythisroutes[i].children[index].path == "opinionMat/opinion_list") {
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (user_all.indexOf("store_room_list") >= 0 && mythisroutes[i].children[index].path == "roomMat/room_list") {
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (user_all.indexOf("store_log_list") >= 0 && mythisroutes[i].children[index].path == "journalMat/journal_list") {
                    myarr.push(mythisroutes[i].children[index]);
                  } else if (user_all.indexOf("store_function_pub_list") >= 0 && mythisroutes[i].children[index].path == "functionMat/function_list") {
                    myarr.push(mythisroutes[i].children[index]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              } else if (user_all.indexOf("copyright_base_modul") >= 0 && mythisroutes[i].path == "/demandMat") {
                //点播付费
                var myarr = [];
                for (var _index = 0, _indexlen = mythisroutes[i].children.length; _index < _indexlen; _index++) {
                  //点播订单
                  if (user_all.indexOf("copyright_order_mgr") >= 0 && mythisroutes[i].children[_index].path == "demandOdr/demandOdr_list") {
                    myarr.push(mythisroutes[i].children[_index]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              } else if (user_all.indexOf("finance_base_modul") >= 0 && mythisroutes[i].path == "/financeMat") {
                //财务数据
                var myarr = [];
                for (var _index2 = 0, _indexlen2 = mythisroutes[i].children.length; _index2 < _indexlen2; _index2++) {
                  //财务结算
                  if (user_all.indexOf("finance_settle_mgr") >= 0 && mythisroutes[i].children[_index2].path == "/financeMat/financial_set") {
                    //财务结算子路由
                    var threearr = [];
                    for (var _k2 = 0, _klen2 = mythisroutes[i].children[_index2].children.length; _k2 < _klen2; _k2++) {
                      if (user_all.indexOf("finance_settle_copyright_list") >= 0 && mythisroutes[i].children[_index2].children[_k2].path == "demand_set") {
                        threearr.push(mythisroutes[i].children[_index2].children[_k2]);
                      } else if (user_all.indexOf("finance_settle_shopping_list") >= 0 && mythisroutes[i].children[_index2].children[_k2].path == "shopping_set") {
                        threearr.push(mythisroutes[i].children[_index2].children[_k2]);
                      }
                    }
                    mythisroutes[i].children[_index2].children = threearr;
                    myarr.push(mythisroutes[i].children[_index2]);
                  } else if (
                  //营收统计
                  user_all.indexOf("finance_revenue_mgr") >= 0 && mythisroutes[i].children[_index2].path == "/financeMat/revenue_sts") {
                    //营收统计子路由
                    var threearr = [];
                    for (var _k3 = 0, _klen3 = mythisroutes[i].children[_index2].children.length; _k3 < _klen3; _k3++) {
                      if (user_all.indexOf("finance_revenue_copyright_list") >= 0 && mythisroutes[i].children[_index2].children[_k3].path == "demand_rve") {
                        threearr.push(mythisroutes[i].children[_index2].children[_k3]);
                      } else if (user_all.indexOf("finance_revenue_shopping_list") >= 0 && mythisroutes[i].children[_index2].children[_k3].path == "shopping") {
                        threearr.push(mythisroutes[i].children[_index2].children[_k3]);
                      }
                    }
                    mythisroutes[i].children[_index2].children = threearr;
                    myarr.push(mythisroutes[i].children[_index2]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              } else if (user_all.indexOf("projector_shopping_base_modul") >= 0 && mythisroutes[i].path == "/commodityshpMat") {
                //商品购物
                var myarr = [];
                for (var _index3 = 0, _indexlen3 = mythisroutes[i].children.length; _index3 < _indexlen3; _index3++) {
                  //商品配送
                  if (user_all.indexOf("projector_shopping_distribution_mgr") >= 0 && mythisroutes[i].children[_index3].path == "/commodityshpMat/commoditydsn") {
                    //商品配送子路由
                    var threearr = [];
                    for (var _k4 = 0, _klen4 = mythisroutes[i].children[_index3].children.length; _k4 < _klen4; _k4++) {
                      if (user_all.indexOf("projector_shopping_distribution_list_list") >= 0 && mythisroutes[i].children[_index3].children[_k4].path == "distribution_list") {
                        threearr.push(mythisroutes[i].children[_index3].children[_k4]);
                      } else if (user_all.indexOf("projector_shopping_distribution_ok_list") >= 0 && mythisroutes[i].children[_index3].children[_k4].path == "distribution_record") {
                        threearr.push(mythisroutes[i].children[_index3].children[_k4]);
                      } else if (user_all.indexOf("projector_shopping_distribution_not_list") >= 0 && mythisroutes[i].children[_index3].children[_k4].path == "wait_distribution") {
                        threearr.push(mythisroutes[i].children[_index3].children[_k4]);
                      }
                    }
                    mythisroutes[i].children[_index3].children = threearr;
                    myarr.push(mythisroutes[i].children[_index3]);
                  } else if (
                  //商品管理
                  user_all.indexOf("projector_shopping_goods_relation_mgr") >= 0 && mythisroutes[i].children[_index3].path == "/commodityshpMat/commoditymat") {
                    //商品管理子路由
                    var threearr = [];
                    for (var _k5 = 0, _klen5 = mythisroutes[i].children[_index3].children.length; _k5 < _klen5; _k5++) {
                      if (user_all.indexOf("projector_shopping_goods_list") >= 0 && mythisroutes[i].children[_index3].children[_k5].path == "commodity_list") {
                        threearr.push(mythisroutes[i].children[_index3].children[_k5]);
                      } else if (user_all.indexOf("projector_shopping_category_list") >= 0 && mythisroutes[i].children[_index3].children[_k5].path == "commodity_class") {
                        threearr.push(mythisroutes[i].children[_index3].children[_k5]);
                      }
                    }
                    mythisroutes[i].children[_index3].children = threearr;
                    myarr.push(mythisroutes[i].children[_index3]);
                  } else if (
                  //商品订单
                  user_all.indexOf("projector_shopping_order_list") >= 0 && mythisroutes[i].children[_index3].path == "/commodityshpMat/commodityodr") {
                    myarr.push(mythisroutes[i].children[_index3]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              } else if (user_all.indexOf("bar_tech_service_fee_moudle") >= 0 && mythisroutes[i].path == "/storeYb") {
                //影吧付费
                var myarr = [];
                for (var _index4 = 0, _indexlen4 = mythisroutes[i].children.length; _index4 < _indexlen4; _index4++) {
                  //扫码支付
                  if (user_all.indexOf("bar_tech_service_fee_pay_mgr") >= 0 && mythisroutes[i].children[_index4].path == "scavengingPayment/payment") {
                    myarr.push(mythisroutes[i].children[_index4]);
                  } else if (user_all.indexOf("bar_tech_service_fee_record_mgr") >= 0 && mythisroutes[i].children[_index4].path == "payRecord/recordList") {
                    myarr.push(mythisroutes[i].children[_index4]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              } else if (
              // 租赁管理
              mythisroutes[i].path == "/leaseManagement" && lease_type != 0) {
                var myarr = [];
                for (var _index5 = 0, _indexlen5 = mythisroutes[i].children.length; _index5 < _indexlen5; _index5++) {
                  //租赁二
                  if (mythisroutes[i].children[_index5].path == "/lease" && lease_type == 2) {
                    var threearr = [];
                    for (var _k6 = 0, _klen6 = mythisroutes[i].children[_index5].children.length; _k6 < _klen6; _k6++) {
                      if (mythisroutes[i].children[_index5].children[_k6].path == "device") {
                        threearr.push(mythisroutes[i].children[_index5].children[_k6]);
                      } else if (mythisroutes[i].children[_index5].children[_k6].path == "useRecord") {
                        threearr.push(mythisroutes[i].children[_index5].children[_k6]);
                      } else if (mythisroutes[i].children[_index5].children[_k6].path == "payRecord") {
                        threearr.push(mythisroutes[i].children[_index5].children[_k6]);
                      } else if (mythisroutes[i].children[_index5].children[_k6].path == "disbuteRecords") {
                        threearr.push(mythisroutes[i].children[_index5].children[_k6]);
                      } else if (mythisroutes[i].children[_index5].children[_k6].path == "roomRental" && SHOW === true) {
                        threearr.push(mythisroutes[i].children[_index5].children[_k6]);
                      }
                    }
                    mythisroutes[i].children[_index5].children = threearr;
                    myarr.push(mythisroutes[i].children[_index5]);
                  } else if (
                  //租赁三
                  mythisroutes[i].children[_index5].path == "/lease3" && lease_type == 3) {
                    var threearr = [];
                    for (var _k7 = 0, _klen7 = mythisroutes[i].children[_index5].children.length; _k7 < _klen7; _k7++) {
                      if (mythisroutes[i].children[_index5].children[_k7].path == "roomAuthorization") {
                        threearr.push(mythisroutes[i].children[_index5].children[_k7]);
                      } else if (mythisroutes[i].children[_index5].children[_k7].path == "authorizationRecords") {
                        threearr.push(mythisroutes[i].children[_index5].children[_k7]);
                      } else if (mythisroutes[i].children[_index5].children[_k7].path == "dataStatistics") {
                        threearr.push(mythisroutes[i].children[_index5].children[_k7]);
                      }
                    }
                    mythisroutes[i].children[_index5].children = threearr;
                    myarr.push(mythisroutes[i].children[_index5]);
                  }
                }
                mythisroutes[i].children = myarr;
                //添加到菜单置顶
                newarr.unshift(mythisroutes[i]);
              } else if (
              //售后系统
              mythisroutes[i].path == "/afterSalesManage") {
                var myarr = [];
                for (var _index6 = 0, _indexlen6 = mythisroutes[i].children.length; _index6 < _indexlen6; _index6++) {
                  //扫码支付
                  if (mythisroutes[i].children[_index6].path == "repairOrder") {
                    myarr.push(mythisroutes[i].children[_index6]);
                  } else if (mythisroutes[i].children[_index6].path == "repairOrderAdd") {
                    myarr.push(mythisroutes[i].children[_index6]);
                  } else if (mythisroutes[i].children[_index6].path == "repairOrderDetail") {
                    myarr.push(mythisroutes[i].children[_index6]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              } else if (
              //游戏管理
              mythisroutes[i].path == "/gameManager") {
                var myarr = [];
                for (var _index7 = 0, _indexlen7 = mythisroutes[i].children.length; _index7 < _indexlen7; _index7++) {
                  //扫码支付
                  if (mythisroutes[i].children[_index7].path == "flowOrder") {
                    myarr.push(mythisroutes[i].children[_index7]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              } else if (
              //通用应用
              mythisroutes[i].path == "/currencyApp") {
                var myarr = [];
                for (var _index8 = 0, _indexlen8 = mythisroutes[i].children.length; _index8 < _indexlen8; _index8++) {
                  if (
                  //通用应用
                  mythisroutes[i].children[_index8].path == "generalApp") {
                    myarr.push(mythisroutes[i].children[_index8]);
                  } else if (
                  // 应用卸载
                  mythisroutes[i].children[_index8].path == "appUninstall") {
                    myarr.push(mythisroutes[i].children[_index8]);
                  }
                }
                mythisroutes[i].children = myarr;
                newarr.push(mythisroutes[i]);
              }
            }
            self.routes = newarr;
            var userInfo = JSON.parse(self.commonGetLocalDataNew("user_data"));
            var checkData = {
              store_sn: userInfo.agent_id
            };
            PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_5__svrapi_js__["a" /* default */].byhCheck, checkData, function (res) {
              if (res.code == 0) {
                if (res.data.store_sn) {
                  self.routes = newarr;
                } else {
                  // self.routes[4].children[0].children.pop();
                }
              } else {
                self.$alert(res.msg, "提示");
              }
            });
          } else {
            self.$alert(rsp.msg, "提示");
          }
        });
      } else {
        alert("获取用户信息错误！!");
      }
    });
  },
  watch: {
    username: {
      handler: function handler() {
        // console.log("数据变化")
        // console.log(this.username)
        // console.log(this.$router.options.routes)
        // this.$router.options.routes=[];
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "1KL9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', _vm._g(_vm._b({
    staticClass: "qn-cropper",
    attrs: {
      "modal": false,
      "title": "裁剪"
    }
  }, 'el-dialog', _vm.$attrs, false), _vm.$listeners), [_c('vue-cropper', _vm._b({
    ref: "qnCropper",
    style: ({
      width: _vm.width,
      height: _vm.height
    }),
    attrs: {
      "mode": "cover",
      "img": _vm.data.url,
      "output-size": _vm.outputSize,
      "info-true": _vm.infoTrue,
      "can-scale": _vm.canScale,
      "auto-crop": _vm.autoCrop,
      "auto-crop-width": _vm.autoCropWidth,
      "auto-crop-height": _vm.autoCropHeight,
      "fixed": _vm.fixed,
      "fixed-number": _vm.fixedNumber,
      "fixed-box": _vm.fixedBox,
      "can-move-box": _vm.canMoveBox,
      "centerBox": _vm.centerBox,
      "output-type": _vm.outputType,
      "enlarge": _vm.enlarge
    }
  }, 'vue-cropper', _vm.$attrs, false)), _vm._v(" "), (_vm.funBar) ? _c('el-button-group', [_c('el-button', {
    attrs: {
      "title": "旋转"
    },
    on: {
      "click": _vm.handleRotateLeft
    }
  }, [_vm._v("\n\t\t\t\t旋转\n\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "title": "放大"
    },
    on: {
      "click": _vm.handleScalePlus
    }
  }, [_vm._v("\n\t\t\t\t放大\n\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "title": "缩小"
    },
    on: {
      "click": _vm.handleScaleSubtract
    }
  }, [_vm._v("\n\t\t\t\t缩小\n\t\t\t")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleToConfirm
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d850c2c", esExports)
  }
}

/***/ }),

/***/ "1Nx3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


// Qnapi
function Qnapi(base, pusagespace, pgetLocalSessFunc) {
    var baseUrl = base;
    var usagespace = pusagespace;
    var getLocalSessFunc = pgetLocalSessFunc;
    var that = this;

    var class2type = {};
    "Boolean Number String Function Array Date RegExp Object Error".split(" ").forEach(function (e, i) {
        class2type["[object " + e + "]"] = e.toLowerCase();
    });

    this.typeof = function (obj) {
        if (obj == null) {
            return String(obj);
        }
        return (typeof obj === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) === "object" || typeof obj === "function" ? class2type[class2type.toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj);
    };

    this.setBaseUrl = function (base) {
        baseUrl = base;
    };

    //阻塞请求队列
    //this.blocked = false;
    this.blockArr = [false, false, false, false, false, false, false, false, false, false]; //9个lock格子，简粗吧23333
    this.blockQueryObjQueue = [];
    this.blockQueryObj = function (func, apiPath, paramObj, callbackSucc, callbackOnFail, queryMode) {
        this.func = func;
        this.apiPath = apiPath;
        this.paramObj = paramObj;
        this.callbackSucc = callbackSucc;
        this.callbackOnFail = callbackOnFail;
        this.queryMode = queryMode;
    };

    this.blockQuery = function () {
        var lockidx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        if (lockidx > 9 || lockidx < 0) {
            return;
        }
        that.blockArr[lockidx] = true;
    };

    this.isBlocked = function () {
        var blocked = false;
        for (var i = 0; i <= 9; i++) {
            if (that.blockArr[i]) {
                blocked = true;
                break;
            }
        }
        return blocked;
    };

    this.resumeQuery = function () {
        var lockidx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        if (lockidx > 9 || lockidx < 0) {
            return;
        }
        that.blockArr[lockidx] = false;

        if (!that.isBlocked()) {
            // console.log('【query resumed ok】');
            for (var i = 0; i < that.blockQueryObjQueue.length; i++) {
                var obj = that.blockQueryObjQueue[i];
                obj.func(obj.apiPath, obj.paramObj, obj.callbackSucc, obj.callbackOnFail, obj.queryMode);
            }
        }
    };

    this.query = function (apiPath, paramObj, callbackSucc, callbackOnFail) {
        var queryMode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
        var noneBlock = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;


        if (!noneBlock && that.isBlocked()) {
            that.blockQueryObjQueue.push(new that.blockQueryObj(this.query, apiPath, paramObj, callbackSucc, callbackOnFail, queryMode));
            return;
        }

        var paramsType = that.typeof(paramObj);
        var poststr = "";
        if (paramsType == 'object') {
            if (queryMode && queryMode.toLowerCase() == 'json') {
                if (usagespace) {
                    paramObj.api_usagespace = usagespace;
                }
                if (getLocalSessFunc) {
                    var sess = getLocalSessFunc();
                    if (sess) {
                        paramObj.api_local_sess = sess;
                    }
                }
                poststr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(paramObj);
                console.log(poststr);
            } else {
                for (var key in paramObj) {
                    if (poststr != "") {
                        poststr += "&";
                    }
                    poststr += key + "=" + encodeURIComponent(paramObj[key]);
                }
            }
        } else {
            poststr = paramObj;
        }

        if (!queryMode || queryMode.toLowerCase() != 'json') {
            if (usagespace) {
                if (poststr != "") {
                    poststr += "&";
                }
                poststr += "api_usagespace=" + usagespace;
            }
            if (getLocalSessFunc) {
                var sess = getLocalSessFunc();
                if (sess) {
                    if (poststr != "") {
                        poststr += "&";
                    }
                    poststr += "api_local_sess=" + sess;
                }
            }
        }

        var url = baseUrl + apiPath;
        var xmlhttp = new XMLHttpRequest();
        xmlhttp.open("POST", url, true);
        xmlhttp.timout = 3000;
        xmlhttp.withCredentials = true;
        //xmlhttp.setRequestHeader("Content-type","application/x-www-form-urlencoded");

        if (queryMode && queryMode.toLowerCase() == 'json') {
            xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            xmlhttp.setRequestHeader("Content-type", "application/json");
        } else {
            xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        }

        try {
            xmlhttp.onreadystatechange = function () {
                if (xmlhttp.readyState == 4) {
                    if (xmlhttp.status == 200) {
                        var obj = JSON && JSON.parse(xmlhttp.responseText) || $.parseJSON(xmlhttp.responseText);
                        callbackSucc(obj);
                    } else {
                        if (callbackOnFail != null) {
                            // console.log('query fail : ' + xmlhttp.status );
                            callbackOnFail(xmlhttp.status);
                        }
                    }
                }
            };
            xmlhttp.send(poststr);
        } catch (e) {
            //   console.log('catch error', e);
            callbackOnFail(e);
        }
    };

    //fetch 模式获取请求
    this.q = function (apiPath, paramObj) {
        /*
        // Return a new promise.
        return new Promise(function(resolve, reject) {
               var paramsType = that.typeof(paramObj);
            var poststr = "";
            if (paramsType == 'object'){
                for (var key in paramObj) {
                    if (poststr != "") {
                        poststr += "&";
                    }
                    poststr += key + "=" + encodeURIComponent(paramObj[key]);
                }
            }else{
                poststr = paramObj;
            }
             if (usagespace){
                if (poststr != "") {
                    poststr += "&";
                }
                poststr += "api_usagespace=" + usagespace;
            }
            if (getLocalSessFunc){
                var sess = getLocalSessFunc();
                if (sess){
                    if (poststr != "") {
                        poststr += "&";
                    }
                    poststr += "api_local_sess=" + sess;
                }
            }
             var url = baseUrl + apiPath;
            var xmlhttp = new XMLHttpRequest();
            xmlhttp.open("POST", url, true);
            xmlhttp.timout = 3000;
            xmlhttp.withCredentials = true;
            xmlhttp.setRequestHeader("Content-type","application/x-www-form-urlencoded");
             try{
                xmlhttp.onreadystatechange=function(){
                    if (xmlhttp.readyState==4){
                        if (xmlhttp.status==200){
                            var obj = JSON && JSON.parse(xmlhttp.responseText) || $.parseJSON(xmlhttp.responseText);
                            resolve(obj);
                        }else{
                            if (callbackOnFail != null){
                                console.log('query fail : ' + xmlhttp.status);
                                reject(Error(xmlhttp.status));
                            }
                        }
                    }
                };
                 xmlhttp.onerror = function() {
                    reject(Error("Network Error"));
                };
                 xmlhttp.send(poststr);
             } catch(e) {
                console.log('catch error', e);
                reject(e);
            }
         });*/
    };
};

/* harmony default export */ __webpack_exports__["a"] = ({
    Qnapi: Qnapi
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "1VZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ajax__ = __webpack_require__("5PKf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__upload_dragger_vue__ = __webpack_require__("JoLq");





/* harmony default export */ __webpack_exports__["a"] = ({
  // inject: ['uploader'],
  components: {
    UploadDragger: __WEBPACK_IMPORTED_MODULE_2__upload_dragger_vue__["a" /* default */]
  },
  props: {
    type: String,
    action: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: 'file'
    },
    data: Object,
    headers: Object,
    withCredentials: Boolean,
    multiple: Boolean,
    accept: String,
    onStart: Function,
    onProgress: Function,
    onSuccess: Function,
    onError: Function,
    beforeUpload: Function,
    drag: Boolean,
    onPreview: {
      type: Function,
      default: function _default() {}
    },
    onRemove: {
      type: Function,
      default: function _default() {}
    },
    fileList: Array,
    autoUpload: Boolean,
    listType: String,
    httpRequest: {
      type: Function,
      default: __WEBPACK_IMPORTED_MODULE_1__ajax__["a" /* default */]
    },
    disabled: Boolean,
    maxLength: [Number, String]
  },

  data: function data() {
    return {
      mouseover: false,
      reqs: {}
    };
  },


  methods: {
    isImage: function isImage(str) {
      return str.indexOf('image') !== -1;
    },
    handleChange: function handleChange(ev) {
      var files = ev.target.files;

      if (!files) return;
      this.uploadFiles(files);
    },
    uploadFiles: function uploadFiles(files) {
      var _this = this;

      var postFiles = Array.prototype.slice.call(files);
      if (!this.multiple) {
        postFiles = postFiles.slice(0, 1);
      } else {
        if (this.maxLength) {
          postFiles = postFiles.slice(0, this.maxLength - this.fileList.length);
        }
      }

      if (postFiles.length === 0) {
        return;
      }

      postFiles.forEach(function (rawFile) {
        _this.onStart(rawFile);
        if (_this.autoUpload) _this.upload(rawFile);
      });
    },
    upload: function upload(rawFile, file) {
      var _this2 = this;

      this.$refs.input.value = null;

      if (!this.beforeUpload) {
        return this.post(rawFile);
      }

      var before = this.beforeUpload(rawFile);
      if (before && before.then) {
        before.then(function (processedFile) {
          if (Object.prototype.toString.call(processedFile) === '[object File]') {
            _this2.post(processedFile);
          } else {
            _this2.post(rawFile);
          }
        }, function () {
          _this2.onRemove(null, rawFile);
        });
      } else if (before !== false) {
        this.post(rawFile);
      } else {
        this.onRemove(null, rawFile);
      }
    },
    abort: function abort(file) {
      var reqs = this.reqs;

      if (file) {
        var uid = file;
        if (file.uid) uid = file.uid;
        if (reqs[uid]) {
          reqs[uid].abort();
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(reqs).forEach(function (uid) {
          if (reqs[uid]) reqs[uid].abort();
          delete reqs[uid];
        });
      }
    },
    post: function post(rawFile) {
      var _this3 = this;

      var uid = rawFile.uid;

      var options = {
        headers: this.headers,
        withCredentials: this.withCredentials,
        file: rawFile,
        data: this.data,
        filename: this.name,
        action: this.action,
        onProgress: function onProgress(e) {
          _this3.onProgress(e, rawFile);
        },
        onSuccess: function onSuccess(res) {
          _this3.onSuccess(res, rawFile);
          delete _this3.reqs[uid];
        },
        onError: function onError(err) {
          _this3.onError(err, rawFile);
          delete _this3.reqs[uid];
        }
      };
      var req = this.httpRequest(options);
      this.reqs[uid] = req;
      if (req && req.then) {
        req.then(options.onSuccess, options.onError);
      }
    },
    handleClick: function handleClick() {
      if (!this.disabled) {
        this.$refs.input.value = null;
        this.$refs.input.click();
      }
    }
  },

  render: function render(h) {
    var handleClick = this.handleClick,
        drag = this.drag,
        name = this.name,
        handleChange = this.handleChange,
        multiple = this.multiple,
        accept = this.accept,
        listType = this.listType,
        uploadFiles = this.uploadFiles,
        disabled = this.disabled;

    var data = {
      class: {
        'el-upload': true
      },
      on: {
        click: handleClick
      }
    };
    data.class['el-upload--' + listType] = true;
    return h(
      'div',
      data,
      [drag ? h(
        'upload-dragger',
        {
          attrs: { disabled: disabled },
          on: {
            'file': uploadFiles
          }
        },
        [this.$slots.default]
      ) : this.$slots.default, h('input', { 'class': 'el-upload__input', attrs: { type: 'file', name: name, multiple: multiple, accept: accept },
        ref: 'input', on: {
          'change': handleChange
        }
      })]
    );
  }
});

/***/ }),

/***/ "1wdh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-shouce",
  "use": "icon-shouce-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shouce\"><defs><style type=\"text/css\"></style></defs><path d=\"M896 192v704H256.8c-71.2 0-128.8-57.6-128.8-128.8V256.8C128 185.6 185.6 128 256.8 128H768v512H257.6c-36 0-65.6 29.6-65.6 65.6v60.8c0 36 29.6 65.6 65.6 65.6H832V192h64zM768 704H256v64h512v-64z\" p-id=\"8326\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "2J+X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "icon screenfull",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "t": "1497503607356",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "p-id": "4109",
      "fill": _vm.fill,
      "width": _vm.width,
      "height": _vm.height
    },
    on: {
      "click": _vm.click
    }
  }, [_c('path', {
    attrs: {
      "d": "M604.157933 512l204.484208 204.484208 82.942037-82.942037c10.364045-10.952446 26.498514-13.83817 40.309054-8.067746 13.249769 5.742794 22.465664 18.99154 22.465664 33.977859l0 258.042008c0 20.168342-16.695241 36.863582-36.863582 36.863582L659.452283 954.357873c-14.986319 0-28.236088-9.215896-33.977859-23.025413-5.770424-13.249769-2.885723-29.384237 8.067746-39.748283l82.942037-82.942037L512 604.157933 307.515792 808.642141l82.942037 82.942037c10.952446 10.364045 13.83817 26.498514 8.067746 39.748283-5.742794 13.809517-18.99154 23.025413-33.977859 23.025413L106.504686 954.357873c-20.168342 0-36.863582-16.695241-36.863582-36.863582L69.641103 659.452283c0-14.986319 9.215896-28.236088 23.025413-33.977859 13.249769-5.770424 29.384237-2.8847 39.748283 8.067746l82.942037 82.942037 204.484208-204.484208L215.357859 307.515792l-82.942037 82.942037c-6.890944 6.918573-16.10684 10.952446-25.911136 10.952446-4.593622 0-9.804297-1.14815-13.83817-2.8847-13.809517-5.742794-23.025413-18.99154-23.025413-33.977859L69.641103 106.504686c0-20.168342 16.695241-36.863582 36.863582-36.863582L364.546693 69.641103c14.986319 0 28.236088 9.215896 33.977859 23.025413 5.770424 13.249769 2.8847 29.384237-8.067746 39.748283l-82.942037 82.942037 204.484208 204.484208L716.484208 215.357859l-82.942037-82.942037c-10.952446-10.364045-13.83817-26.498514-8.067746-39.748283 5.742794-13.809517 18.99154-23.025413 33.977859-23.025413l258.042008 0c20.168342 0 36.863582 16.695241 36.863582 36.863582l0 258.042008c0 14.986319-9.215896 28.236088-22.465664 33.977859-4.593622 1.736551-9.804297 2.8847-14.397918 2.8847-9.804297 0-19.020192-4.033873-25.911136-10.952446l-82.942037-82.942037L604.157933 512z",
      "p-id": "4110"
    }
  })])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-031e4c81", esExports)
  }
}

/***/ }),

/***/ "3+JG":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("IBKg");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0aa289c6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ce21a81e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarItem.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ce21a81e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarItem.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3+lv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-Settlement",
  "use": "icon-Settlement-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Settlement\"><defs><style type=\"text/css\"></style></defs><path d=\"M515.2 1024c-281.6 0-512-230.4-512-512s230.4-512 512-512c176 0 339.2 89.6 432 240 9.6 16 6.4 35.2-9.6 44.8-16 9.6-35.2 6.4-44.8-9.6-80-134.4-224-211.2-377.6-211.2-246.4 0-448 201.6-448 448s201.6 448 448 448c128 0 249.6-54.4 332.8-150.4 12.8-12.8 32-12.8 44.8-3.2 12.8 12.8 12.8 32 3.2 44.8-96 112-236.8 172.8-380.8 172.8z\" p-id=\"5304\" fill=\"#bfcbd9\" /><path d=\"M924.8 326.4c-6.4 0-9.6 0-16-3.2l-179.2-57.6c-16-6.4-25.6-22.4-19.2-41.6 6.4-16 22.4-25.6 41.6-19.2L915.2 256 960 92.8c6.4-16 22.4-25.6 38.4-22.4 16 6.4 25.6 22.4 22.4 38.4l-54.4 182.4c-3.2 12.8-12.8 22.4-22.4 28.8-3.2 6.4-12.8 6.4-19.2 6.4zM736 512H288c-19.2 0-32-12.8-32-32s12.8-32 32-32h448c19.2 0 32 12.8 32 32s-12.8 32-32 32z\" p-id=\"5305\" fill=\"#bfcbd9\" /><path d=\"M512 832c-19.2 0-32-12.8-32-32V480c0-19.2 12.8-32 32-32s32 12.8 32 32v320c0 19.2-12.8 32-32 32z\" p-id=\"5306\" fill=\"#bfcbd9\" /><path d=\"M704 672H320c-19.2 0-32-12.8-32-32s12.8-32 32-32h384c19.2 0 32 12.8 32 32s-12.8 32-32 32zM480 480c-9.6 0-22.4-6.4-28.8-16l-96-160c-6.4-16-3.2-35.2 12.8-44.8s35.2-3.2 44.8 9.6l96 160c9.6 16 3.2 35.2-9.6 44.8-6.4 6.4-12.8 6.4-19.2 6.4z\" p-id=\"5307\" fill=\"#bfcbd9\" /><path d=\"M544 480c-6.4 0-12.8 0-16-3.2-16-9.6-19.2-28.8-9.6-44.8l96-160c6.4-16 25.6-19.2 41.6-12.8 16 9.6 19.2 28.8 12.8 44.8l-96 160c-6.4 9.6-19.2 16-28.8 16z\" p-id=\"5308\" fill=\"#bfcbd9\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "3p1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-breadcrumb', {
    staticClass: "app-levelbar",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.levelList), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [(item.redirect === "noredirect" || index == _vm.levelList.length - 1) ? _c('router-link', {
      staticClass: "no-redirect",
      attrs: {
        "to": ""
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('router-link', {
      attrs: {
        "to": item.redirect || item.path
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a0bc5c6", esExports)
  }
}

/***/ }),

/***/ "3zpo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    created: function created() {
        this.getBreadcrumb();
    },
    data: function data() {
        return {
            levelList: null
        };
    },

    methods: {
        getBreadcrumb: function getBreadcrumb() {
            var matched = this.$route.matched.filter(function (item) {
                return item.name;
            });
            var first = matched[0];
            if (first && (first.name !== '首页' || first.path !== '')) {
                matched = [{ name: '首页', path: '/' }].concat(matched);
            }
            this.levelList = matched;
        }
    },
    watch: {
        $route: function $route() {
            this.getBreadcrumb();
        }
    }
});

/***/ }),

/***/ "41Of":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-from",
  "use": "icon-from-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-from\"><defs><style type=\"text/css\"></style></defs><path d=\"M960 256v64H64v-64c0-35.2 28.8-64 64-64h768c35.2 0 64 28.8 64 64z m0 128v384c0 35.2-28.8 64-64 64H128c-35.2 0-64-28.8-64-64V384h896zM256 640H128v32h128v-32z m128-64H128v32h256v-32z\" p-id=\"8100\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "49jO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Show migrating guide in browser console.
 *
 * Usage:
 * import Migrating from 'element-ui/src/mixins/migrating';
 *
 * mixins: [Migrating]
 *
 * add getMigratingConfig method for your component.
 *  getMigratingConfig() {
 *    return {
 *      props: {
 *        'allow-no-selection': 'allow-no-selection is removed.',
 *        'selection-mode': 'selection-mode is removed.'
 *      },
 *      events: {
 *        selectionchange: 'selectionchange is renamed to selection-change.'
 *      }
 *    };
 *  },
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    if (true) return;
    if (!this.$vnode) return;

    var _getMigratingConfig = this.getMigratingConfig(),
        props = _getMigratingConfig.props,
        events = _getMigratingConfig.events;

    var _$vnode = this.$vnode,
        data = _$vnode.data,
        componentOptions = _$vnode.componentOptions;

    var definedProps = data.attrs || {};
    var definedEvents = componentOptions.listeners || {};

    for (var propName in definedProps) {
      if (definedProps.hasOwnProperty(propName) && props[propName]) {
        console.warn('[Element Migrating][Attribute]: ' + props[propName]);
      }
    }

    for (var eventName in definedEvents) {
      if (definedEvents.hasOwnProperty(eventName) && events[eventName]) {
        console.warn('[Element Migrating][Event]: ' + events[eventName]);
      }
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {},
        events: {}
      };
    }
  }
});

/***/ }),

/***/ "4hTs":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9d/r");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("ac505da8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-52f6eacb\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-52f6eacb\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "5PKf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = upload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

function getError(action, option, xhr) {
  var msg = void 0;
  if (xhr.response) {
    msg = xhr.status + ' ' + (xhr.response.error || xhr.response);
  } else if (xhr.responseText) {
    msg = xhr.status + ' ' + xhr.responseText;
  } else {
    msg = 'fail to post ' + action + ' ' + xhr.status;
  }

  var err = new Error(msg);
  err.status = xhr.status;
  err.method = 'post';
  err.url = action;
  return err;
}

function getBody(xhr) {
  var text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

function upload(option) {
  if (typeof XMLHttpRequest === 'undefined') {
    return;
  }

  var xhr = new XMLHttpRequest();
  var action = option.action;

  if (xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }
      option.onProgress(e);
    };
  }

  var formData = new FormData();

  if (option.data) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(option.data).forEach(function (key) {
      formData.append(key, option.data[key]);
    });
  }

  formData.append(option.filename, option.file);

  xhr.onerror = function error(e) {
    option.onError(e);
  };

  xhr.onload = function onload() {
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(action, option, xhr));
    }

    option.onSuccess(getBody(xhr));
  };

  xhr.open('post', action, true);

  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }

  var headers = option.headers || {};

  for (var item in headers) {
    if (headers.hasOwnProperty(item) && headers[item] !== null) {
      xhr.setRequestHeader(item, headers[item]);
    }
  }
  xhr.send(formData);
  return xhr;
}

/***/ }),

/***/ "5SbU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-QQ",
  "use": "icon-QQ-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-QQ\"><defs><style type=\"text/css\"></style></defs><path d=\"M273.5104 480.17408 272.31232 476.44672 271.33952 471.6032 270.6944 468.95104 270.6944 465.6128 270.6944 461.62944 270.6944 458.02496 271.85152 453.72416 273.02912 449.1776 274.5856 444.40576 276.6848 439.0912 279.43936 433.57184 283.33056 428.04224 283.33056 424.17152 283.70944 420.54656 284.3136 415.62112 285.98272 410.08128 287.51872 404.10112 288.74752 401.3568 290.16064 398.7968 291.98336 395.95008 293.96992 393.8304 293.96992 389.9392 293.96992 385.56672 293.96992 380.16 295.1168 373.11488 296.27392 364.93312 298.33216 355.14368 301.16864 344.95488 303.27808 339.3536 305.36704 333.2608 307.6608 327.5776 310.40512 321.4848 313.20064 314.81856 316.416 308.57216 320.03072 301.90592 324.58752 295.24992 326.69696 291.4304 328.93952 288.3072 333.824 281.26208 338.85184 274.23744 344.55552 267.008 350.6688 259.97312 357.30432 253.04064 364.22656 245.9136 372.60288 238.22336 377.91744 233.54368 384.39936 228.49536 390.97344 224.04096 398.08 219.76064 404.91008 215.95136 412.61056 212.79744 420.79232 208.91648 428.92288 206.25408 437.03296 203.48928 445.7984 200.74496 454.5536 198.656 463.75936 196.9152 473.09824 195.40992 482.31424 194.18112 491.52 192.9216 501.34016 192.38912 510.67904 192.38912 520.33536 192.38912 530.35008 192.38912 540.01664 193.60768 549.7344 194.7648 559.63648 195.79904 568.832 198.01088 578.53952 200.07936 587.65312 202.45504 597.63712 205.1072 606.7712 208.34304 615.51616 212.03968 624.85504 215.95136 633.37472 220.22144 641.65888 224.9728 649.7792 230.20544 656.77312 235.06944 660.0192 237.81376 663.41888 239.8208 669.91104 245.32992 675.3792 250.65472 680.83712 256.16384 686.15168 262.2464 690.5344 268.14464 695.7568 274.23744 699.392 280.7808 703.0784 286.59712 706.99008 293.36576 710.23616 299.25376 715.69408 311.71584 718.37696 318.1568 720.47616 324.12672 722.57536 330.60864 724.45952 336.70144 725.77024 341.94432 727.47008 348.1088 730.44992 359.1168 732.35456 368.75264 733.5936 378.07104 734.65856 385.56672 736.33792 396.98432 736.7168 398.7968 738.05824 400.85504 741.67296 406.76352 743.99744 410.76736 746.05568 414.93504 748.67712 419.39968 750.99136 424.7552 752.49664 430.2336 754.13504 436.24448 755.37408 442.40896 755.93728 445.44 756.45952 449.1776 756.45952 452.42368 755.93728 455.63904 755.93728 459.64288 754.9952 463.52384 753.27488 471.04 751.29856 474.83904 749.83424 479.10912 749.83424 480.17408 750.53056 481.49504 752.49664 484.61824 761.05728 497.28512 767.81568 506.79808 771.05152 513.14688 775.41376 520.09984 779.2128 527.7184 783.59552 535.8592 787.97824 545.01376 792.91392 555.37664 795.6992 561.72544 798.23872 567.93088 800.43008 574.47424 802.59072 580.36224 804.23936 586.5472 805.91872 592.35328 808.0384 603.67872 809.71776 615.24992 810.87488 625.5104 810.87488 631.11168 810.87488 635.71968 810.87488 639.98976 810.09664 645.12 808.99072 653.9776 807.4752 661.93408 805.12 669.15328 804.23936 672.09216 802.59072 675.6352 801.21856 678.10304 799.37536 681.14432 797.75744 683.0592 795.6992 685.53728 793.856 687.53408 791.88992 689.24416 789.53472 690.2784 787.41504 691.31264 785.67424 691.88608 784.15872 691.88608 783.01184 691.88608 781.312 691.31264 778.07616 689.7152 776.59136 688.65024 775.03488 687.53408 773.33504 686.00832 771.61472 684.29824 768.77824 681.14432 765.41952 676.68992 762.7776 672.09216 760.13568 668.416 757.5552 664.13568 753.92 656.5376 749.83424 648.63232 749.35296 648.35584 748.67712 648.35584 747.01824 649.59488 746.05568 651.6736 744.45824 654.25408 741.67296 661.93408 737.47456 672.86016 732.09856 686.00832 728.05376 692.56192 723.8144 699.40224 718.77632 707.09248 713.43104 714.61888 710.69696 718.0288 707.3792 721.74592 699.7504 729.2416 700.416 729.91744 701.45024 730.99264 705.25952 733.22496 721.13152 740.85376 728.05376 744.7552 734.65856 748.544 741.19168 753.31584 747.01824 758.23104 749.83424 760.45312 751.95392 763.01312 754.13504 765.98272 755.93728 769.19808 756.91008 771.87072 758.09792 775.07584 758.60992 777.85088 759.17312 781.08672 758.60992 783.2576 758.60992 785.4592 758.09792 787.73248 756.91008 789.8112 756.45952 791.43936 755.37408 793.41568 752.49664 797.3376 749.83424 800.48128 747.776 802.83648 746.05568 804.57728 741.67296 807.77216 736.7168 810.55744 731.43296 813.21984 725.77024 815.77984 719.45216 818.25792 716.05248 819.29216 713.07264 820.13184 705.73056 821.84192 698.15296 823.47008 690.5344 825.088 682.25024 826.43968 673.71008 826.79808 664.95488 827.8528 656.29184 827.8528 647.17824 827.8528 637.77792 827.8528 627.97824 827.27936 618.8544 826.43968 609.01376 825.088 599.25504 824.04352 588.97408 822.60992 579.01056 820.13184 569.2928 818.25792 559.63648 815.49312 549.7344 811.95008 540.01664 809.02144 534.89664 807.31136 530.35008 805.69344 527.47264 804.57728 524.61568 803.97312 520.93952 803.97312 516.53632 803.97312 507.19744 803.31776 502.4768 802.83648 496.39424 802.16064 492.4928 805.69344 487.168 809.02144 479.9488 812.53376 471.9616 816.91648 467.10784 819.29216 462.03904 821.17632 450.84672 825.7536 444.76416 827.27936 438.38464 828.99968 429.53728 830.72 423.99744 831.15008 418.14016 831.65184 412.02688 832.32768 404.91008 832.59392 398.08 832.59392 390.97344 832.59392 375.83872 832.59392 359.424 832.32768 343.48032 830.72 335.4112 829.57312 327.61856 828.416 320.03072 827.27936 312.44288 825.7536 305.36704 823.47008 298.33216 821.84192 291.98336 819.29216 285.98272 816.91648 280.38144 814.24384 275.51744 811.32544 270.6944 807.77216 269.04576 806.05184 266.88512 803.97312 265.24672 802.16064 263.77216 800.07168 262.41024 797.99296 261.35552 795.89376 259.82976 791.43936 259.29728 789.13536 258.62144 786.57536 258.62144 784.20992 259.29728 781.53728 259.29728 778.88512 259.82976 776.23296 259.82976 774.61504 259.82976 770.87744 260.08576 768.0512 261.35552 764.81536 262.41024 761.57952 264.32512 757.67808 265.728 756.1728 266.88512 754.432 269.90592 750.73536 272.31232 748.83072 274.5856 747.49952 276.6848 745.80992 280.00256 744.7552 282.66496 743.13728 285.98272 741.4272 289.76128 740.29056 293.56032 739.13344 297.96352 738.17088 302.1312 737.61792 307.07712 736.9728 312.44288 736.5632 313.83552 736.1024 314.14272 736.1024 314.81856 735.52896 314.81856 734.8736 313.83552 733.5424 310.9888 732.19072 303.872 726.02624 299.08992 722.21696 293.56032 717.37344 287.98976 711.95648 282.19392 705.03424 275.51744 697.23136 273.02912 693.01248 269.73184 688.65024 266.88512 683.61216 264.32512 678.10304 260.87424 672.86016 258.62144 666.88 255.93856 660.91008 253.25568 654.25408 251.31008 647.87456 249.45664 639.98976 248.90368 639.70304 248.34048 639.70304 248.05376 639.13984 247.36768 639.13984 246.24128 639.70304 245.67808 639.98976 244.89984 641.31072 244.62336 642.9184 244.03968 644.352 243.02592 646.73792 239.7696 652.53376 238.08 656.04608 235.39712 659.10784 232.5504 662.79424 229.40672 666.88 226.08896 670.50496 222.18752 674.01728 218.58304 677.31456 214.58944 679.936 210.2272 682.67008 206.0288 684.29824 201.08288 685.53728 196.22912 686.00832 195.75808 686.00832 195.08224 686.00832 193.96608 685.53728 193.08544 683.61216 191.66208 682.67008 189.7984 678.10304 188.63104 675.6352 187.38176 672.09216 186.34752 668.416 185.79456 664.79104 184.25856 656.5376 183.67488 651.6736 183.67488 646.73792 183.67488 635.71968 184.25856 623.81056 185.22112 617.728 186.34752 611.46112 187.38176 604.71296 189.21472 598.43584 191.27296 591.2064 193.39264 584.16128 196.22912 576.91136 198.90176 569.99936 202.5984 562.98496 206.0288 555.37664 210.2272 548.23936 215.16288 540.53888 220.18048 533.61664 225.42336 525.91616 229.79584 520.5504 235.39712 514.4064 241.29536 508.2112 244.03968 505.26208 247.36768 501.94432 252.20096 497.75616 257.16736 493.48608 265.24672 486.2464 271.33952 481.792Z\" p-id=\"9447\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "5cV2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.hamburger[data-v-4ccf6f4e] {\n    display: inline-block;\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n    transform: rotate(0deg);\n    transition: .38s;\n    transform-origin: 50% 50%;\n}\n.hamburger.is-active[data-v-4ccf6f4e] {\n    transform: rotate(90deg);\n}\n", ""]);

// exports


/***/ }),

/***/ "5dAb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-icons",
  "use": "icon-icons-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icons\"><defs><style type=\"text/css\"></style></defs><path d=\"M871.424 61.44q18.432 0 34.816 6.656t28.672 18.944 19.456 28.672 7.168 35.84l0 720.896q0 38.912-25.088 64.512t-62.976 25.6l-721.92 0q-40.96 0-66.048-26.624t-25.088-66.56l0-718.848q0-35.84 24.576-62.464t65.536-26.624l720.896 0zM633.856 829.44q18.432 0 26.624-8.704t8.192-23.04q0-13.312-8.192-22.528t-26.624-9.216l-62.464 0q1.024-2.048 1.024-6.144l0-507.904 63.488 0q18.432 0 25.6-9.216t7.168-22.528-7.168-22.528-25.6-9.216l-249.856 0q-18.432 0-25.6 9.216t-7.168 22.528 7.168 22.528 25.6 9.216l57.344 0 0 507.904q0 2.048 0.512 3.072t0.512 3.072l-56.32 0q-18.432 0-26.624 9.216t-8.192 22.528q0 14.336 8.192 23.04t26.624 8.704l245.76 0z\" p-id=\"14765\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "6HNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon-svg',
  props: {
    iconClass: {
      type: String,
      required: true
    }
  },
  computed: {
    iconName: function iconName() {
      return '#icon-' + this.iconClass;
    }
  }
});

/***/ }),

/***/ "6PsS":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAACsCAYAAACTkDk+AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo2RjQ2QTQ5MDJGRDYxMUU3QTMzREE2QjI4QjY4NUVENyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo2RjQ2QTQ5MTJGRDYxMUU3QTMzREE2QjI4QjY4NUVENyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjZGNDZBNDhFMkZENjExRTdBMzNEQTZCMjhCNjg1RUQ3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjZGNDZBNDhGMkZENjExRTdBMzNEQTZCMjhCNjg1RUQ3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+JirVnAAAEOlJREFUeNrsXV1sJMdx7u6Z/eX/8XhHSj6eeDxHPxfLPsGyE0Sxz35IbMBIlLxEcAJEseA85CFwAgRIXmLZkB+Sh0QOAgQwHFgw4JcAgWU7QCw/2DoYgbOgI1oSaCl3ou5MkeLmyOXt7+zOzkxXenaJRNNVw8yKR+d4VwUMBigWu3rmG3Z9rK7uloLlf2R5fq5ublOWes1cF2zbp/78/Npjn5yz9Y2P3P/t6aPom2J4jocwUAwUCwN1F4p7l5KGS+Z2ydafedh5VSqRe6fOcUUvCkXFtn1lpdb76UuNhF4p0WWgbq3EIH3eVn7sD/OtqdNyIgvr+8fP1te8OiDWx0MfxygWBoqFgWLWd2exu8WYoNn67mL51Z2Pn27Z+i9ecT19VSZ001ea0ex3q8g2X5Z/Y27ft9SagXr3I4aduxMgZS6Yyk2k/E5CH4bCARDI1u/A3np15zoPfSwMFAPFwmTiXUrMDFZRjHKER+mnVm+CjCDBJnKNcNfc3iDa3magbp2AuS4i9KJB7g7pT/5wpyUwcbhsSMOv8dDHwkAxUCwMFMvdSSaq5vqYrczv+b+x9A9vnLT1Oq/+Qvl6x1LXGagjFsPWeub2oq1fFoMZ3mXiV1Z+nmkhHvo4RrEwUCx3Voxanp9bMLcPEz+KsxCS+BCpOaLQXJcJfY+BunUSg/RNQh/n7uy0UDzhR807fdmQhks89LEwUAwUCwPFcniRtwmTe9LcniR+1DbXeIKuTeWaex+aPWcbniwGe9Pj+kSCBmoRSSUc29Z/pXfNX+tSJCMwV87S/cQQj88x6xvKfeb6KKGPZ1EXEl9WAGuthyZRLfjMTLBanAwuZGF9/St+O4Xip7FEHvpYGCgGiuUOj1GGNMSB/X22Pio7Y8rXqKoHlGxIDbZtTxAVQDkp+mMu2Hp/n5AkleMy7LsStSGl8AGS9k5e+KbfHyAe55ohGY07Eqj9QI3KtPy5YmX78XsXUn7H1u8ROjFfCqsPTQULmcjBZ8Y2zLWQhUxs/rC39/JXm6uE7W+Z63ke+lgYKAaKhYG62+XIUkiGKf2xuT2SYHGOzDfeP30ekYn5YrP93olJlK440Q8nCjpBeMJIeq4DZdt2cSzqLE8GY9bDwT1FDz1j3h1vnpu4B/kLQENOqoT9+tWW96/f2UL+qi/5r3k3IrDUnmGCf3TcWN/HzfWbiRdnnqv2q3OUbVwL/iiiiAW9PZ7XNjsjtxMo5zSaODRvsVVQGrG+SRcqM4XCo1lY3y8+6K5dH28gf1s/6pWJfsR0/UiA4qGPYxQLA3UXyqFjlCENxTgxYOshp6QMdYsgL0A0A/vxIamEQQrI1kek7bDaqGU581K6TfoThD0AkP5UQUbGQct6uo55H/cR7dYNyaj/vwJl5JfM9QNbufehE6v1D57IOrcjBZHqkXKQd7P1Dmk7HB0mbDQEPb8kRfq800SyD5L0t/T5086urxL6qBaK2peq14g2v2Cup3no4xjFwkCxMFB3ooyUQjKM5i/NLVHpE064he69ZbTCvHVh0uu+p1y2nDkPnPIj27YfyXbegXFb/wtTQTRd1IkqolCLnqtEEbEiCd6YC5Y/gKVyB6eQnHy76BTG8VerQAudsHdkrlfOzyJ/tb7uutItJZ65HoivPvsmem9RLfrP4Lp/k3ilXzRscO8oWN9nzHU28XC+Xr/x6/PUojAqpSOmSxHVbpxCQlVBJ0vRtnn5mVJItD9JVyFF/Yq5MlUh5ZS7tjR1Bvk7XcL9gMlia/J3MdOtfyXeqoKsenpWDCdCeejjGMXCQLEwUMdW3FsAbBrYzgjtkrZAs9JR/MkR+yaJPhza3/RTs46hj0hf+1L1lWUxZ5OPbxkm+Phh/6J0Rt2AlY7QbpTy1uCQ/mDEvgHRh8P7c2R02L8oHvo4RrEwUEwmhrI8Pxf/h4/WK/nzxTfNKHzjnbpgMudT/11PlXRnphiuWCO+Q43tBQfap4p6BXVODhaWbVrqeHJvheh2x9bHMa7WL6AoXnSi9pgTrqTEGGkpvM322ys47LheBMk2IhBwZixC/mq+anuhRG1ARIa0G6Owvhikv7WVO5dObfuni3ZKZ10Q+wpNFaPVhcnwYpavpaigMl+MqKogtJBNjJRCEq1GiLfN7oOqGKAyVSGFOly74e1Q/qh+tOaL48hfTkLlzbaL/OlGRKW43uahj2MUCwPFwkAde9a3z37wirwImilsa5tooU/oD9pECrXxxORWc8H1k4Yge65EKwvF1xtn+rUol2nFoRRA+kux76XYdm09pPjbZ7q4DSV9QxXbRLuZgZIE24qL/AWh9yhb00KV1NOyQdnGIC3muplWHCoBlD9y4hCE3EjpG2W/l2KL9DJ9+wPanwbKvsRDH8coFgaKZRij9vchSv7nPpM/I4E4fCSnYoJQTcZD6C5MhIhkzJWi5kIpstsgU0hxnNvuOsifp7G//WCNbO/LeU1bb1iLrkV59DFGIL16kF/FsV1rDSphX3RUe77kIltXOe1QJ59PA+jpoE/4czsLJYnauHlvTmsfEvbSlf1lgTGJycTXECB5tfLWE4sXs6R0pBTrizMBSiG9pxytGqAypZAagapcabrIFjRkTiF9emoLpZAMSK1ndt+LU0haVfZ0/mIWMjEp82u/f+GjmVJIDb/Tem7te8hfXuqKIxXyt/dnp1p+lDz31/t+S7T/pfE1Hvo4RrEwUCwM1HFKIa0TGQif0u+ni7wkUxocMrKekmJZz5RCGqabUBt9UMjfPutDtn+6cb675pUT+ryC4K/PXrN3tBQveif9K/0x1MbvnH8wmC4UE/YFx2mnPB/SG9ZH7aAZC/k+JbHjpiFQ1HsbAIUYm4xgT9CHjCAWpoGeODTSTNELIt20S9katkSxvh5l+3Y/3+xoJ6HvatF6sNBGLOyl3hTp7/7p2dZssTSRxR+lV1KmpZBIf0CwTKkk+d546OMYxcJAMZnYHzuV7GUlEzKFTIAA77BkIgCZmUwUlEZBWEkIXvPHUXDXKucXHRe1sVprBGNuN2Ffdp32+2enMpEJAE2SCZD086WQCS87mdDZyQSkkAkp5KHJRE5CZjLha4X8hSBbX6mfRcH9gZnZ3b965BHUxmPfvtzS1jm8s4V87zuf+OVMZEJKRZIJCUwmOEaxMFAsDNSdzfrwBKErycm5OKsjrIk8Rw5SRc2UzESmiUNDSDzKXx+yTxxeOtls7kHemsgTuhaU0Mf4VrvpPfMf/4bayCsBvShZe15ynbR3gfQRaOr4PrHPXFcJ1odr3YeVXqsUUGhCS4awQukp1help5BWU9rApE8Oti+4mDGFRE4cjuVgNdBoorJVCzAL6wRBxVx4olLkDAtLTuR1wyit1h3pnRTWJwT9fCTrcyT53njo4xjFwkDdpWSCOLxEpJX8NoiASJY0gyBLmskdMCGlpDkUqpGSEUC2SgLyd0CJMelPArZ3h+m07Sz9iAT4vlbIX0+rqBPiQ1s6feX3IpmwDwLyvQ2AWsAppMEqv0yHmkBKSbMU2UuaZUrJrztMC2YqadYgkb9RS4xBUgvZIHNJM4DT2uqVkb+arzbebLuojVerxVYvTJKX6bZXnSVLtlk4RrEwUAwUy+3L+laIFFJL0FsExGxp00ohkdsXALGdwAEppDblz7Al5E+kbF+Qkxq1ASDTUjqkv/PjIdj7L0kpvKcuv4RsZ4v5Tq3XT+hzSkNBZvcn5cCdtJgn9d4GQD2akkLKtJ1AlDpxOHIKCfkrquwppAAU8mdexEEpHeSv7GL7QAdrP7nZypRCKjjQeng6uz/zISF/hnlyColjFAsDxfK/MYqSzBsPpoENI2ysKFNsNe0vZRNGOJKNFWNbYk/EQZ/tXJixk9T2RhFIN9Qykz/DL5xRgMq88aBI2XhQjrCxIqTYKtpfyiaM8kg2VswpiB450c/aBqzU8ki503HDN3bzmfyBlBEPfRyjWBgoFgbquLG+CmIHwyqkSkoA3bCYTpxC2rUNb/aV141kxWZKS+MhCpZFB9rnxkPk7xt781FBRBtWG10g+uYWVGe8oCv/J8sZStrzUdJNsUV6DakUJbM/w/o8yjYGCh3uoW5BCqkTylVzoVTI0jhutKCgUigA6sdKY3LbtJEphfTwlLf6YKF30RouDkohZTpERaTvuIn0Sqb4k9n9GdbHKSSOUSwMFAsDdexY3xJKm9T7v7f8d1cesPWbTyz6/qli4pDgSMvgRz8rowOF75vpw8JkiA5MXqnlETcyzDHeAhy18dBU4I8N54jeyawiJbHtlleAf3qrbB9g7AHBxNL8qXifLFsnzSMStqaNiGjDM+8C/zVI+oDmc39/1ZMWVQRXvWVuv42AWq/uXLeVy/NzbZK9AHmAcY6y1cOZy0wHJpsHTrNF/sxDkwcYw2By1NIP38FEVn/7IE1YH4aT0oaT0mfcboq/AUjWCkcZaKAw4aGPYxQLA3WXkglK4gkYXDUTAnWoCVmFJCB7FZJIqdLRII0/yFSFJOmqp5GqkFLs0w5tQXoTctL8kZVF4ErzhGDbj3SISp5KIZmGqaogeiGbzF6FJFKqdJTMvgMm0FVPI1UhHVkKKcWf+fD5EBWOUSwMFAsDdceyvm+Y60Vbec8/bz5npzzCMbez8QdLaIXcZt3tb9bRoSbqw4te5kNUXm/mmqgka7jDAF5xKIBaqTfSikPKvh/J3upWCdk6CrqRlpn8nX6hGo5dbaE2dF49pXxt6xuZgVqv7uyY246tX56fm7ZZmNOLyBWH1ArAA2SDbmNwW0i+YUmuADTgZT5EJc0fZW+4857pB+5bRPaD9Ke60YaMAK/KjOA1Kl3EQx/HKBYGiuVAMpEm/26uxJiqc6oz8dNmzzbsLRTbwUx+zRrvnZ22i1JISkFPa7lm62fKUc9VYKen6vtZAVvahD4SdJ15L6UNZB9Bqj+kV4GOxq62kT9DwP7L3C6n9COTyMMibQjGJXP7ga2v/crJ1foHT4ySQkJVOu9b6G2P5/W7PodX3IIqpCCSaz/eLGVKIeUaQWvxuWuUvy8Y0vA0D30co1gYKBYG6k6UW0EmTprbY7Y+mMp9WgXwkJ15EcTEYfv+id3djwzaSUjOgZgVFRM6BfVAy2nb9ux0sDc3Hp7IwvqavrN7ZSeP/O1XFiXsx66169Mv7CB/Oifr5vkSelCi57bDZ4jX9LohE6//POk5EtOBeIHA8wjA4Tl9F7K0kdvrVyhbw7jQxGHMwijbvh7UbF/Iwvq0FhXTDvZH2EdtWHO8ENk6NPtsmPfxPA99HKNYGCiWWyLuEbZ9zVwvEx8Gmo+SADfL1zvo4JDeQqmjCyrTISpiuCX3Og47xKEmgj7UpPyzThBv1ZyIn/X+TeI5YtkSw3ktOyYeL6BMUP2TzMxRzD1d2vA+Yes3n1jc9k8XMx2iYvgrdfgIfahJyglpC9/aatklxnE3zLN8gIc+FgaKgWJhoFhokbdDJ5bn5+JgjQJ2cCL/pOGIk4kMxGy+Xf3UPWhtfcGFpnmYhK2SoDVI9DFO/XivXni5hdJCTjf8uvJ13VJXDZn4LgN1MIDXze3sO3VR2V27/tlzh5o4PPVCtTLxepOaOFzKWhXEQx8LA8VAsRy5uLd5/7rCSsuAGswxUakaTei9A9puHacP93YHqmSTAalTV6MrkXGV+gF6zUMfCwPFQLEwUCx3Fpl41lyJVI/Oq5mF57fQYjFwhCcjtHMkuZ2A6kdXzI1KC9Vv1xchj9uXtTw/97i5fZP40Si1519er+58joc+FgaKgWJhoFgOL/8twABQLgzCG+S8qAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "6o49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("aacO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce21a81e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("qghf");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("3+JG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce21a81e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce21a81e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/SidebarItem.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SidebarItem.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ce21a81e", Component.options)
  } else {
    hotAPI.reload("data-v-ce21a81e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7ScC":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.navbar[data-v-3e29d41e] {\n  height: 50px;\n  line-height: 50px;\n  border-radius: 0px !important;\n}\n.navbar .hamburger-container[data-v-3e29d41e] {\n    line-height: 58px;\n    height: 50px;\n    float: left;\n    padding: 0 10px;\n}\n.navbar .errLog-container[data-v-3e29d41e] {\n    display: inline-block;\n    position: absolute;\n    right: 150px;\n}\n.navbar .screenfull[data-v-3e29d41e] {\n    position: absolute;\n    right: 90px;\n    top: 16px;\n    width: 22px;\n    height: 22px;\n}\n.navbar .avatar-container[data-v-3e29d41e] {\n    height: 50px;\n    display: inline-block;\n    position: absolute;\n    right: 35px;\n}\n.navbar .avatar-container .avatar-wrapper[data-v-3e29d41e] {\n      cursor: pointer;\n      margin-top: 5px;\n      position: relative;\n}\n.navbar .avatar-container .avatar-wrapper .user-avatar[data-v-3e29d41e] {\n        width: 40px;\n        height: 40px;\n        border-radius: 10px;\n}\n.navbar .avatar-container .avatar-wrapper .el-icon-caret-bottom[data-v-3e29d41e] {\n        position: absolute;\n        right: -20px;\n        top: 25px;\n        font-size: 12px;\n}\n.navbar .nav-info[data-v-3e29d41e] {\n    position: absolute;\n    right: 140px;\n    top: 0;\n    font-size: 18px;\n}\n@media screen and (min-width: 1515px) {\n.five_div[data-v-3e29d41e] {\n    display: block;\n}\n.four_div[data-v-3e29d41e] {\n    display: block;\n}\n.three_div[data-v-3e29d41e] {\n    display: block;\n}\n.two_div[data-v-3e29d41e] {\n    display: block;\n}\n.one_div[data-v-3e29d41e] {\n    display: block;\n}\n}\n@media screen and (max-width: 1515px) {\n.five_div[data-v-3e29d41e] {\n    display: none;\n}\n.four_div[data-v-3e29d41e] {\n    display: none;\n}\n.three_div[data-v-3e29d41e] {\n    display: block;\n}\n.two_div[data-v-3e29d41e] {\n    display: block;\n}\n.one_div[data-v-3e29d41e] {\n    display: block;\n}\n}\n@media screen and (max-width: 1200px) {\n.five_div[data-v-3e29d41e] {\n    display: none;\n}\n.four_div[data-v-3e29d41e] {\n    display: none;\n}\n.three_div[data-v-3e29d41e] {\n    display: none;\n}\n.two_div[data-v-3e29d41e] {\n    display: block;\n}\n.one_div[data-v-3e29d41e] {\n    display: block;\n}\n}\n@media screen and (max-width: 825px) {\n.five_div[data-v-3e29d41e] {\n    display: none;\n}\n.four_div[data-v-3e29d41e] {\n    display: none;\n}\n.three_div[data-v-3e29d41e] {\n    display: none;\n}\n.two_div[data-v-3e29d41e] {\n    display: none;\n}\n.one_div[data-v-3e29d41e] {\n    display: block;\n}\n}\n@media screen and (max-width: 685px) {\n.five_div[data-v-3e29d41e] {\n    display: none;\n}\n.four_div[data-v-3e29d41e] {\n    display: none;\n}\n.three_div[data-v-3e29d41e] {\n    display: none;\n}\n.two_div[data-v-3e29d41e] {\n    display: none;\n}\n.one_div[data-v-3e29d41e] {\n    display: none;\n}\n}\n.headercontent[data-v-3e29d41e] {\n  padding-left: 15px;\n  line-height: 50px;\n  min-height: 50px;\n  font-size: 13px;\n  background-color: #eef1f6;\n}\n", ""]);

// exports


/***/ }),

/***/ "7XAT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-menu', {
    staticClass: "navbar",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('hamburger', {
    staticClass: "hamburger-container",
    attrs: {
      "toggleClick": _vm.toggleSideBar,
      "isActive": _vm.sidebar.opened
    }
  }), _vm._v(" "), _c('levelbar'), _vm._v(" "), _c('screenfull', {
    staticClass: "screenfull"
  }), _vm._v(" "), _c('el-dropdown', {
    staticClass: "avatar-container",
    attrs: {
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('img', {
    staticClass: "user-avatar",
    attrs: {
      "src": _vm.photoUrl
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "user-dropdown",
    slot: "dropdown"
  }, [(_vm.myname) ? _c('el-dropdown-item', {
    staticStyle: {
      "border-top": "0px",
      "margin-top": "0px"
    },
    attrs: {
      "divided": ""
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.myname))])]) : _vm._e(), _vm._v(" "), (_vm.showDiv) ? _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.changePSW
    }
  }, [_vm._v("修改密码")])]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.runLogout
    }
  }, [_vm._v("退出")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pass"
  }, [_c('el-dialog', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "修改密码"
    },
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm2,
      "status-icon": "",
      "rules": _vm.rules2,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.pass),
      callback: function($$v) {
        _vm.ruleForm2.pass = $$v
      },
      expression: "ruleForm2.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.ruleForm2.checkPass = $$v
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('ruleForm2')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetForm('ruleForm2')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseInfo),
      expression: "baseInfo"
    }],
    staticClass: "headercontent"
  }, [_c('div', {
    staticClass: "one_div",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("门店：" + _vm._s(_vm.navbarData.agent_name))]), _vm._v(" "), _c('div', {
    staticClass: "two_div",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "15px"
    }
  }, [_vm._v("合作商：" + _vm._s(_vm.navbarData.qnbar_agent_name))]), _vm._v(" "), _c('div', {
    staticClass: "three_div",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "15px"
    }
  }, [_vm._v("技术服务电话:" + _vm._s(_vm.navbarData.qnbar_agent_tel))]), _vm._v(" "), _c('div', {
    staticClass: "one_div",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.complaintCall))]), _vm._v(" "), _c('div', {
    staticClass: "four_div",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "15px"
    }
  }, [_vm._v("已使用:" + _vm._s(_vm.navbarData.useDay) + "天")]), _vm._v(" "), _c('div', {
    staticClass: "five_div",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "15px"
    }
  }, [_vm._v("还剩余:" + _vm._s(_vm._f("lastDayFilter")(_vm.navbarData.distime, _vm.navbarData.lastDay)) + "天")])])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e29d41e", esExports)
  }
}

/***/ }),

/***/ "7bVv":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n/*登陆整个背景*/\n    .login-wrap{\n        background: #fff;\n    }\n    /*商家后台头部背景颜色*/\n    .login_head{\n    \tbackground:#fff;\n    }\n    /*中部背景*/\n    .login_box{\n        background:#00c;\n    }\n    /*底部背景*/\n    .login_bottom{\n    \tbackground:#fff;\n    }\n\n\n\n\n\n.header{\n    background-color: #242f42;\n}\n\n.plugins-tips{\n    background: #eef1f6;\n}\n.plugins-tips a{\n    color: #20a0ff;\n}\n.el-upload--text em {\n    color: #20a0ff;\n}\n.pure-button{\n    background: #20a0ff;\n}\n\n\n.login_box{\n    background-color: #324157;\n}\n", ""]);

// exports


/***/ }),

/***/ "7eqC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_interfaceSetting_pic_loading_png__ = __webpack_require__("uZLf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_interfaceSetting_pic_loading_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_interfaceSetting_pic_loading_png__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'QnImage',
  props: {
    realImg: {
      type: String,
      default: ''
    },
    loadingImg: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_0__assets_interfaceSetting_pic_loading_png___default.a
    }
  },
  data: function data() {
    return {
      previewImg: ''
    };
  },

  watch: {
    realImg: function realImg(val) {
      this.proxySetSrc(val);
    }
  },
  created: function created() {
    if (this.realImg) {
      this.proxySetSrc(this.realImg);
    } else {
      this.setSrc(this.loadingImg);
    }
  },

  methods: {
    setSrc: function setSrc(url) {
      this.previewImg = url;
    },
    proxySetSrc: function proxySetSrc(url) {
      var _this = this;

      this.setSrc(this.loadingImg);
      var img = document.createElement('img');
      img.onload = function () {
        _this.setSrc(url);
      };
      img.src = url;
    }
  }
});

/***/ }),

/***/ "83ef":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.tabs-view-container[data-v-57015451] {\n  display: inline-block;\n  vertical-align: top;\n  margin-left: 10px;\n}\n.tabs-view-container .tabs-view[data-v-57015451] {\n    margin-left: 10px;\n}\n", ""]);

// exports


/***/ }),

/***/ "90Fk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.svg": "sEM+",
	"./EXCEL.svg": "BMOy",
	"./QQ.svg": "5SbU",
	"./Settlement.svg": "3+lv",
	"./a.svg": "GUmw",
	"./agent.svg": "Liw6",
	"./anquan.svg": "EbX0",
	"./b.svg": "9kJb",
	"./balanceRecord.svg": "+NXU",
	"./bug.svg": "SVqS",
	"./c.svg": "PloX",
	"./capital.svg": "zmfK",
	"./demand.svg": "t21O",
	"./description.svg": "rn/p",
	"./downArrow.svg": "MCxY",
	"./editor.svg": "Fc7P",
	"./email.svg": "+4G4",
	"./feedback.svg": "VQSA",
	"./from.svg": "41Of",
	"./function_prop.svg": "eTcC",
	"./goods.svg": "XNJ4",
	"./goodsMgr.svg": "f2LE",
	"./icons.svg": "5dAb",
	"./idle.svg": "+k1u",
	"./interface.svg": "I2U8",
	"./jinyong.svg": "K370",
	"./lease.svg": "fK1T",
	"./mima.svg": "+D4M",
	"./password.svg": "QjmH",
	"./quanxian.svg": "mwRM",
	"./revenue.svg": "CRqx",
	"./rizhi.svg": "jTNx",
	"./shouce.svg": "1wdh",
	"./shouye.svg": "IeYc",
	"./stafff.svg": "Lk1P",
	"./store.svg": "Lta+",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./tongzhi.svg": "H5AX",
	"./tubiao.svg": "nQME",
	"./tuozhuai.svg": "I8fT",
	"./upArrow.svg": "SpuY",
	"./weixin.svg": "E+Kt",
	"./wifi.svg": "cNBo",
	"./wujiaoxing.svg": "sHk8",
	"./xinrenzhinan.svg": "13E8",
	"./yanjing.svg": "tAWD",
	"./yonghuming.svg": "vXUM",
	"./zonghe.svg": "oglU",
	"./zujian.svg": "ILQa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";

/***/ }),

/***/ "9d/r":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.i(__webpack_require__("zN+a"), "");
exports.i(__webpack_require__("7bVv"), "");
exports.i(__webpack_require__("quWu"), "");
exports.i(__webpack_require__("JdRO"), "");

// module
exports.push([module.i, "\n.el-upload input[type=\"file\"] {\n  display: none !important;\n}\n.el-upload__input {\n  display: none;\n}\n.el-dialog {\n  transform: none;\n  left: 0;\n  position: relative;\n  margin: 0 auto;\n}\n.upload-container .el-upload {\n  width: 100%;\n}\n.upload-container .el-upload .el-upload-dragger {\n    width: 100%;\n    height: 200px;\n}\n.navigation .el-table td,\n.navigation .el-table th {\n  padding: 0 !important;\n}\n.navigation .el-table th > .cell {\n  text-align: center;\n}\n.navigation .el-table .cell,\n.navigation .el-table th > div {\n  padding: 0 !important;\n  text-align: center;\n}\n.navigation .pass .el-dialog--small {\n  width: 28%;\n}\n.botttomform .el-input__inner {\n  margin-bottom: 20px !important;\n}\n.bottomone .el-input,\n.bottomone .el-input__inner {\n  width: 100% !important;\n}\n.bottomone .el-form-item {\n  display: inline-block !important;\n  margin-left: 9px;\n  width: 35%;\n}\n.bottomone .el-form-item__content {\n  margin-left: 0 !important;\n}\n.el-table .cell .setoverflow {\n  display: block;\n  width: 120px;\n  height: 24px !important;\n  overflow: hidden !important;\n  margin: auto !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n#goodsListWrap .el-form-item__content {\n  width: 300px !important;\n  margin: 0 auto !important;\n}\n#goodsListWrap #editShowDialog .el-form-item__content {\n  margin-left: 130px !important;\n}\n#goodsListWrap .el-form-item {\n  text-align: center;\n  margin-bottom: 20px;\n}\n#goodsClass th {\n  text-align: left;\n}\n#goodsClass th > div {\n  text-align: left;\n}\n#goodsListWrap th > div {\n  text-align: left;\n}\n#balanceRecord th > div {\n  text-align: left;\n}\n#staffOpeList .el-table__header div {\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n#welcomePage textarea {\n  background: rgba(0, 0, 0, 0) !important;\n  border: none;\n  color: white;\n  padding: 20px 64px;\n}\n#welcomePage .el-loading-mask {\n  background-color: rgba(255, 255, 255, 0) !important;\n}\n#welcomePage #cccc {\n  height: 228px !important;\n}\n#welcomePage textarea {\n  height: 228px !important;\n}\n.link {\n  color: #1c8de0 !important;\n}\n.link:hover {\n    color: #1c94ea !important;\n}\nbody {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;\n}\nhtml {\n  box-sizing: border-box;\n}\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\na:focus,\na:active {\n  outline: none;\n}\na,\na:focus,\na:hover {\n  cursor: pointer;\n  color: inherit;\n  text-decoration: none;\n}\n.clearfix:after {\n  visibility: hidden;\n  display: block;\n  font-size: 0;\n  content: \" \";\n  clear: both;\n  height: 0;\n}\n.fade-enter-active,\n.fade-leave-active {\n  transition: all .2s ease;\n}\n.fade-enter,\n.fade-leave-active {\n  opacity: 0;\n}\n.app-main {\n  min-height: 100%;\n}\n.app-container {\n  padding: 20px;\n}\n.svg-icon {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n.red {\n  color: red;\n}\n#goodsListWrap .progress {\n  margin: 10px auto;\n  margin-top: 3px;\n}\n#goodsClass .el-table__body-wrapper {\n  overflow: hidden;\n}\n#goodsListWrap .el-table__body-wrapper {\n  overflow: hidden;\n}\n#balanceRecordInfo .el-table__body-wrapper {\n  overflow: hidden;\n}\n.setspanMusic div > span {\n  display: none !important;\n}\n.setspanMusic .progress {\n  display: none !important;\n}\n.theDialogContent {\n  max-width: 600px;\n}\n.roomcontainer .el-form-item__label {\n  width: 120px !important;\n}\n.roomcontainer .el-form-item__content {\n  margin-left: 120px !important;\n}\n.roomcontainer .el-dialog--tiny {\n  width: 40%;\n}\n.otherC .inputC .el-select > .el-input {\n  margin: 5px 0;\n}\n.orderlistC .top .el-input__inner {\n  display: inline-block !important;\n}\n.el-table th > .cell {\n  text-align: center;\n}\n.el-table .cell {\n  text-align: center !important;\n}\n#interfaceDetail .el-table__body-wrapper {\n  overflow: hidden;\n}\n#interfaceDetail .el-table__body {\n  min-height: 60px;\n}\n#interfaceDetail .el-table td {\n  height: 60px;\n}\n", ""]);

// exports


/***/ }),

/***/ "9fML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__upload_list__ = __webpack_require__("dneg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__upload__ = __webpack_require__("GBiV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iframe_upload__ = __webpack_require__("wSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress__ = __webpack_require__("WcXo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_migrating__ = __webpack_require__("49jO");







function noop() {}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ElUpload',

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_migrating__["a" /* default */]],

  components: {
    ElProgress: __WEBPACK_IMPORTED_MODULE_3__progress__["a" /* default */],
    UploadList: __WEBPACK_IMPORTED_MODULE_0__upload_list__["a" /* default */],
    Upload: __WEBPACK_IMPORTED_MODULE_1__upload__["a" /* default */],
    IframeUpload: __WEBPACK_IMPORTED_MODULE_2__iframe_upload__["a" /* default */]
  },

  provide: {
    // uploader: this
  },

  props: {
    action: {
      type: String,
      required: true
    },
    headers: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    data: Object,
    multiple: Boolean,
    name: {
      type: String,
      default: 'file'
    },
    drag: Boolean,
    dragger: Boolean,
    withCredentials: Boolean,
    showFileList: {
      type: Boolean,
      default: true
    },
    accept: String,
    type: {
      type: String,
      default: 'select'
    },
    beforeUpload: Function,
    onRemove: {
      type: Function,
      default: noop
    },
    onChange: {
      type: Function,
      default: noop
    },
    onPreview: {
      type: Function
    },
    onSuccess: {
      type: Function,
      default: noop
    },
    onProgress: {
      type: Function,
      default: noop
    },
    onError: {
      type: Function,
      default: noop
    },
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    listType: {
      type: String,
      default: 'text' // text,picture,picture-card
    },
    httpRequest: Function,
    disabled: Boolean,
    maxLength: [Number, String]
  },

  data: function data() {
    return {
      uploadFiles: [],
      dragOver: false,
      draging: false,
      tempIndex: 1
    };
  },


  computed: {
    showUpload: function showUpload() {
      if (this.maxLength === '' || this.maxLength === undefined) return true;
      return this.listType === 'picture-card' && this.uploadFiles.length < Number(this.maxLength);
    }
  },

  watch: {
    fileList: {
      immediate: true,
      handler: function handler(fileList) {
        var _this = this;

        this.uploadFiles = fileList.map(function (item) {
          item.uid = item.uid || Date.now() + _this.tempIndex++;
          item.status = item.status || 'success';
          return item;
        });
      }
    }
  },

  methods: {
    handleStart: function handleStart(rawFile) {
      rawFile.uid = Date.now() + this.tempIndex++;
      var file = {
        status: 'ready',
        name: rawFile.name,
        size: rawFile.size,
        percentage: 0,
        uid: rawFile.uid,
        raw: rawFile
      };

      try {
        file.url = URL.createObjectURL(rawFile);
      } catch (err) {
        console.error(err);
        return;
      }

      this.uploadFiles.push(file);
      this.onChange(file, this.uploadFiles);
    },
    handleProgress: function handleProgress(ev, rawFile) {
      var file = this.getFile(rawFile);
      this.onProgress(ev, file, this.uploadFiles);
      file.status = 'uploading';
      file.percentage = ev.percent || 0;
    },
    handleSuccess: function handleSuccess(res, rawFile) {
      var file = this.getFile(rawFile);

      if (file) {
        file.status = 'success';
        file.response = res;

        this.onSuccess(res, file, this.uploadFiles);
        this.onChange(file, this.uploadFiles);
      }
    },
    handleError: function handleError(err, rawFile) {
      var file = this.getFile(rawFile);
      var fileList = this.uploadFiles;

      file.status = 'fail';

      fileList.splice(fileList.indexOf(file), 1);

      this.onError(err, file, this.uploadFiles);
      this.onChange(file, this.uploadFiles);
    },
    handleRemove: function handleRemove(file, raw) {
      if (raw) {
        file = this.getFile(raw);
      }
      this.abort(file);
      var fileList = this.uploadFiles;
      fileList.splice(fileList.indexOf(file), 1);
      this.onRemove(file, fileList);
    },
    getFile: function getFile(rawFile) {
      var fileList = this.uploadFiles;
      var target = void 0;
      fileList.every(function (item) {
        target = rawFile.uid === item.uid ? item : null;
        return !target;
      });
      return target;
    },
    abort: function abort(file) {
      this.$refs['upload-inner'].abort(file);
    },
    clearFiles: function clearFiles() {
      this.uploadFiles = [];
    },
    submit: function submit() {
      var _this2 = this;

      this.uploadFiles.filter(function (file) {
        return file.status === 'ready' || file.status === 'warning';
      }).forEach(function (file) {
        _this2.$refs['upload-inner'].upload(file.raw);
      });
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'default-file-list': 'default-file-list is renamed to file-list.',
          'show-upload-list': 'show-upload-list is renamed to show-file-list.',
          'thumbnail-mode': 'thumbnail-mode has been deprecated, you can implement the same effect according to this case: http://element.eleme.io/#/zh-CN/component/upload#yong-hu-tou-xiang-shang-chuan'
        }
      };
    }
  },

  render: function render(h) {
    var uploadList = void 0;

    if (this.showFileList) {
      uploadList = h(__WEBPACK_IMPORTED_MODULE_0__upload_list__["a" /* default */], {
        attrs: {
          disabled: this.disabled,
          listType: this.listType,
          files: this.uploadFiles,

          handlePreview: this.onPreview,
          handleChange: this.onChange },
        on: {
          'remove': this.handleRemove
        }
      });
    }

    var uploadData = {
      style: {
        display: this.showUpload ? 'inline-block' : 'none'
      },
      props: {
        type: this.type,
        drag: this.drag,
        action: this.action,
        multiple: this.multiple,
        'before-upload': this.beforeUpload,
        'with-credentials': this.withCredentials,
        headers: this.headers,
        name: this.name,
        data: this.data,
        accept: this.accept,
        fileList: this.uploadFiles,
        autoUpload: this.autoUpload,
        listType: this.listType,
        disabled: this.disabled,
        'on-start': this.handleStart,
        'on-progress': this.handleProgress,
        'on-success': this.handleSuccess,
        'on-error': this.handleError,
        'on-preview': this.onPreview,
        'on-remove': this.handleRemove,
        'http-request': this.httpRequest,
        maxLength: this.maxLength
      },
      ref: 'upload-inner'
    };

    var trigger = this.$slots.trigger || this.$slots.default;
    var uploadComponent = typeof FormData !== 'undefined' || this.$isServer ? h(
      'upload',
      uploadData,
      [trigger]
    ) : h(
      'iframeUpload',
      uploadData,
      [trigger]
    );

    return h('div', [this.listType === 'picture-card' ? uploadList : '', this.$slots.trigger ? [uploadComponent, this.$slots.default] : uploadComponent, this.$slots.tip, this.listType !== 'picture-card' ? uploadList : '']);
  }
});

/***/ }),

/***/ "9kJb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-b",
  "use": "icon-b-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-b\"><defs><style type=\"text/css\"></style></defs><path d=\"M712.347826 0h44.521739v979.478261h-44.521739zM267.130435 534.26087h44.521739v445.217391H267.130435zM489.73913 311.652174h44.52174v667.826087h-44.52174zM44.521739 712.347826h44.521739v267.130435H44.521739zM934.956522 445.217391h44.521739v534.26087h-44.521739z\" fill=\"\" p-id=\"8895\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "9r41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'preview',
    props: {
        data: {
            type: Object,
            required: true
        },
        list: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        isEdit: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            selection: {}
        };
    },

    watch: {
        data: function data(val) {
            this.selection = val;
        }
    },
    methods: {
        handleBeforeClose: function handleBeforeClose(done) {
            this.stopVideo();
            done();
        },
        handleToEdit: function handleToEdit() {
            this.$emit('edit', this.selection);
            this.close();
        },
        handleClose: function handleClose() {
            this.close();
        },
        handleSwitch: function handleSwitch(item) {
            this.selection = item;
            this.stopVideo();
        },
        stopVideo: function stopVideo() {
            if (this.isVideo(this.selection)) {
                this.$refs.video.pause();
            }
        },
        isVideo: function isVideo(file) {
            if (file.info && file.info.type) {
                return file.info.type.includes('video');
            } else if (file.raw && file.raw.type) {
                return file.raw.type.includes('video');
            } else if (file.url) {
                return file.url.includes('.mp4');
            }
            return false;
        },
        close: function close() {
            this.$emit('update:visible', false);
            this.stopVideo();
        }
    }
});

/***/ }),

/***/ "A66B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (file) {
  return function () {
    return __webpack_require__("Opzk")("./" + file + '.vue');
  };
};

/***/ }),

/***/ "AkUR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__("aret");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f289638_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__("xfsc");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("MeRa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f289638"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f289638_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/Layout.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Layout.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f289638", Component.options)
  } else {
    hotAPI.reload("data-v-5f289638", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BGh/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_formCheck_js__ = __webpack_require__("z035");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svrapi__ = __webpack_require__("Mp/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__env__ = __webpack_require__("yZtZ");








var PT = __WEBPACK_IMPORTED_MODULE_5__env__["a" /* default */].PT;

var route_processe = {
  state: {
    // routers: constantRouterMap,
    addRouters: [],
    order_route: false,
    revenue_route: false,
    list_route: false,
    record_route: false,
    wait_route: false
  },
  mutations: {
    SET_ORDER_ROUTER: function SET_ORDER_ROUTER(state, router) {
      state.order_route = router;
    },
    SET_REVENUE_ROUTER: function SET_REVENUE_ROUTER(state, router) {
      state.revenue_route = router;
    },
    SET_LIST_ROUTER: function SET_LIST_ROUTER(state, router) {
      state.list_route = router;
    },
    SET_RECORD_ROUTER: function SET_RECORD_ROUTER(state, router) {
      state.record_route = router;
    },
    SET_WAIT_ROUTER: function SET_WAIT_ROUTER(state, router) {
      state.wait_route = router;
    },
    SET_ROUTE: function SET_ROUTE(state, view) {
      // console.log(view)
      // console.log(router)
      // console.log(router.addRoutes)
      // router.beforeEach((to, from, next) => {
      //   console.log(store.getters.addRouters)
      //   NProgress.start()
      //   console.log(asyncCeshi)
      //   router.addRoutes(asyncCeshi)
      //   next() // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
      // })

      // router.afterEach(() => {
      //   NProgress.done() // 结束Progress
      // })
    }
  },
  actions: {
    // 获取用户信息
    GetUserInfo: function GetUserInfo(_ref) {
      var commit = _ref.commit,
          state = _ref.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        //开始执行鉴权请求
        PT.apiClient.query("bz-mix/bz/get-base-info", '', function (rsp) {
          resolve(rsp);
        });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (route_processe);

/***/ }),

/***/ "BMOy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-EXCEL",
  "use": "icon-EXCEL-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-EXCEL\"><defs><style type=\"text/css\"></style></defs><path d=\"M625.664 132.608V199.68h309.76v43.008h-309.76V312.32h309.76v43.008h-309.76v68.608h309.76v43.008h-309.76v68.608h309.76v43.008h-309.76v68.608h309.76v43.008h-309.76v68.096h309.76v43.008h-309.76v89.088H1024v-757.76h-398.336zM0 914.944L577.024 1024V0L0 109.056\" p-id=\"10098\" /><path d=\"M229.376 660.48H139.776l118.272-187.904-112.64-180.736h92.16l65.536 119.808L370.688 291.84h89.088l-112.64 177.664L466.944 660.48H373.248l-70.144-125.44L229.376 660.48z\" p-id=\"10099\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "BupL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-view-container"
  }, _vm._l((Array.from(_vm.visitedViews)), function(tag) {
    return _c('router-link', {
      key: tag.path,
      staticClass: "tabs-view",
      attrs: {
        "to": tag.path
      }
    }, [_c('el-tag', {
      attrs: {
        "closable": true,
        "type": _vm.isActive(tag.path) ? 'primary' : ''
      },
      on: {
        "close": function($event) {
          _vm.closeViewTabs(tag, $event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tag.name) + "\n    ")])], 1)
  }))
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-57015451", esExports)
  }
}

/***/ }),

/***/ "CRCD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("cUsY");


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    t: function t() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return __WEBPACK_IMPORTED_MODULE_0__locale__["a" /* t */].apply(this, args);
    }
  }
});

/***/ }),

/***/ "CRqx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-revenue",
  "use": "icon-revenue-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-revenue\"><defs><style type=\"text/css\"></style></defs><path d=\"M677.439063 701.060937l165.421155 0 0-23.642466L677.439063 677.41847 677.439063 701.060937zM677.420643 630.155027l165.439575 0 0-23.622L677.420643 606.533027 677.420643 630.155027zM181.137735 771.94638l661.722483 0L842.860218 748.305961 181.137735 748.305961 181.137735 771.94638zM246.619735 215.431537l78.709798 143.984299 2.484689 0 0 1.14201L229.591222 360.557846l0 33.131585 98.221977 0 0 49.118698L229.591222 442.808128l0 33.141818 98.221977 0 0 191.970196L253.854806 667.920142l0 33.141818 279.905156 0 0-33.141818-70.232382 0L463.527581 475.948923l94.513363 0 0-33.141818-94.513363 0 0-49.118698 94.513363 0 0-33.131585-94.513363 0 0-9.162684-1.205504 0 82.364174-135.963625 0-1.1328 61.846044 0 0-33.140795L436.816148 181.15692l0 33.140795 44.489036 0-83.185923 137.097448-12.971961 0-75.841353-137.097448 41.492673 0 0-33.140795-169.660886 0 0 33.140795 65.482 0L246.619735 215.431537zM181.137735 842.833871l661.722483 0 0-23.641443L181.137735 819.192428 181.137735 842.833871zM677.420643 488.363673l165.439575 0 0-23.632233L677.420643 464.73144 677.420643 488.363673zM677.439063 204.789153l165.421155 0 0-23.632233L677.439063 181.15692 677.439063 204.789153zM904.889441 62.996776 119.109535 62.996776c-31.004378 0-56.126551 25.130354-56.126551 56.124252l0 785.756921c0 30.984688 25.122173 56.125275 56.126551 56.125275l785.779906 0c31.005402 0 56.127575-25.139563 56.127575-56.125275L961.017016 119.121028C961.015993 88.12713 935.89382 62.996776 904.889441 62.996776zM904.889441 886.170888c0 10.32209-8.386338 18.708084-18.70885 18.708084L137.818386 904.878972c-10.322513 0-18.70885-8.385994-18.70885-18.708084L119.109535 137.830135c0-10.331299 8.386338-18.708084 18.70885-18.708084l748.362205 0c10.322513 0 18.70885 8.376785 18.70885 18.708084L904.889441 886.170888zM677.420643 275.67562l165.439575 0 0-23.622L677.420643 252.05362 677.420643 275.67562zM677.420643 417.467997l165.439575 0 0-23.632233L677.420643 393.835763 677.420643 417.467997zM677.420643 346.580506l165.439575 0L842.860218 322.948273 677.420643 322.948273 677.420643 346.580506zM677.420643 559.25935l165.439575 0 0-23.632233L677.420643 535.627117 677.420643 559.25935z\" p-id=\"3419\" fill=\"#bfcbd9\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Ch8x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "mode": "vertical",
      "theme": "dark",
      "unique-opened": "",
      "default-active": _vm.$route.path
    }
  }, [_c('div', {
    class: {
      'logo-name': _vm.sidebar.opened, 'logo-img': !_vm.sidebar.opened
    }
  }, [(_vm.sidebar.opened) ? _c('span', [(_vm.baseInfo) ? _c('span', [_vm._v("青柠微影" + _vm._s(_vm.getUserTitle) + "管理后台")]) : _vm._e(), _vm._v(" "), (!_vm.baseInfo) ? _c('span', [_vm._v("青柠后台")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.sidebar.opened) ? _c('span', [_c('img', {
    staticClass: "logoImage",
    attrs: {
      "src": __webpack_require__("6PsS"),
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('sidebar-item', {
    attrs: {
      "routes": _vm.routes
    }
  })], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0fae5d84", esExports)
  }
}

/***/ }),

/***/ "DOpt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("1BzD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fae5d84_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("Ch8x");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("X9fQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fae5d84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fae5d84_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/Sidebar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Sidebar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0fae5d84", Component.options)
  } else {
    hotAPI.reload("data-v-0fae5d84", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DfDl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var service = 'http://api2.dev.qnbar.cn/';
var api = {
    login: service + "zyu/oss/admin/login", //登录
    addstoreinfo: service + "bz-oss/oss/mix-agent/create-agent", //增加门店 
    editstoreinfo: service + "bz-oss/oss/mix-agent/update-agent", //编辑门店
    getstorelist: service + "bz-oss/oss/mix-agent/get-list", //门店列表信息
    changepass: service + "bz-oss/oss/change/pwd", //oss修改密码
    getprovincelist: service + "common/oss/region/get-province", //省份列表
    getcitylist: service + "common/oss/region/get-city" //市区列表 
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
    api: api
});

/***/ }),

/***/ "E+Kt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-weixin",
  "use": "icon-weixin-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-weixin\"><defs><style type=\"text/css\"></style></defs><path d=\"M1024 636.032c0-141.888-141.866667-257.429333-301.461333-257.429333-169.088 0-301.866667 115.541333-301.866667 257.429333 0 142.250667 132.778667 257.386667 301.866667 257.386667 35.370667 0 71.146667-9.024 106.496-17.642667l97.450667 53.418667-26.666667-88.789333C970.922667 786.965333 1024 715.84 1024 636.032zM624.618667 591.616c-17.642667 0-35.328-17.664-35.328-35.392 0-17.621333 17.685333-35.328 35.328-35.328 26.752 0 44.458667 17.706667 44.458667 35.328C669.077333 573.952 651.370667 591.616 624.618667 591.616zM820.010667 591.616c-17.664 0-35.306667-17.664-35.306667-35.392 0-17.621333 17.642667-35.328 35.306667-35.328 26.709333 0 44.416 17.706667 44.416 35.328C864.426667 573.952 846.293333 591.616 820.010667 591.616z\" p-id=\"2464\" fill=\"#1afa29\" /><path d=\"M693.248 347.242667c11.626667 0 23.296 0.810667 34.901333 2.005333-31.274667-146.133333-187.392-254.464-365.674667-254.464C163.370667 94.784 0 230.442667 0 403.029333c0 99.562667 54.208 181.418667 144.917333 244.864L108.8 757.034667l126.826667-63.786667c45.354667 8.810667 81.877333 18.069333 126.848 18.069333 11.221333 0 22.506667-0.405333 33.749333-1.557333-7.232-24.128-11.242667-49.749333-11.242667-75.882667C384.96 475.690667 521.066667 347.242667 693.248 347.242667zM498.133333 248.896c27.285333 0 45.333333 18.069333 45.333333 45.376 0 27.264-18.069333 45.333333-45.333333 45.333333-27.306667 0-54.570667-18.069333-54.570667-45.333333C443.968 266.944 471.210667 248.896 498.133333 248.896zM244.458667 339.562667c-27.306667 0-54.570667-18.048-54.570667-45.333333 0-27.306667 27.285333-45.354667 54.570667-45.354667 27.328 0 45.397333 18.069333 45.397333 45.354667C289.834667 321.130667 271.786667 339.562667 244.458667 339.562667z\" p-id=\"2465\" fill=\"#1afa29\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "EVlv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.iconName
    }
  })])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0cfbc316", esExports)
  }
}

/***/ }),

/***/ "EbX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-anquan",
  "use": "icon-anquan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-anquan\"><path fill=\"#ffffff\" d=\"M867.584 160.192c-149.632-16.928-262.208-57.408-334.592-120.352l-19.04-16.544-20.544 14.656C379.968 118.944 267.776 160 160 160H128v448c0 137.344 121.088 261.92 370.208 380.864l13.088 6.24 13.344-5.728C771.072 883.52 896 755.232 896 608V163.424l-28.416-3.232zM832 608c0 116.8-107.392 223.36-319.328 316.8C299.872 821.024 192 714.464 192 608V222.976c104.672-6.784 211.584-46.688 318.496-118.944C587.232 162.528 695.168 201.536 832 220.256V608zM359.776 468.672a32 32 0 1 0-47.968 42.4l121.792 137.824c12.608 14.24 30.176 21.568 47.904 21.568a64.384 64.384 0 0 0 49.696-23.52l197.6-242.72a32 32 0 0 0-49.632-40.416l-197.6 242.688-121.792-137.824z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "FRhB":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("aat2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7a37bcc0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9f1a49f2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./upload-list.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-9f1a49f2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./upload-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Fc7P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-editor",
  "use": "icon-editor-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-editor\"><defs><style type=\"text/css\"></style></defs><path d=\"M201.675742 124.830489c-54.615298 0-99.270649 44.376353-99.270649 99.269226l0 598.22598c0 54.613875 44.655351 98.991651 99.270649 98.991651l598.503555 0c54.613875 0 98.991651-44.377777 98.991651-98.991651L899.170948 429.194622l102.699764-99.269226 0 528.803855c0 91.312087-77.377841 165.270777-168.691351 165.270777L165.270763 1024.000028C73.96437 1024.000028-1.4e-05 950.041338-1.4e-05 858.729251L-1.4e-05 197.932257c0-91.306393 73.964384-175.508299 165.270777-175.508299l528.805279 0-98.991651 102.412225L201.675742 124.836183 201.675742 124.830489zM567.776741 610.96899l-221.870378 62.859976 63.432207-220.452612L567.776741 610.96899 567.776741 610.96899zM589.974171 588.782948 431.241343 431.473581l348.741909-346.461527L938.71608 242.310034 589.974171 588.782948 589.974171 588.782948zM1010.400082 171.198262l-47.507964 47.224696L804.166408 60.830322l47.50227-47.224696c17.642358-17.349126 45.227582-18.210319 61.447904-1.985726l99.269226 98.41942C1028.604707 126.248255 1027.743514 153.849137 1010.400082 171.198262L1010.400082 171.198262zM1010.400082 171.198262\" p-id=\"2475\" fill=\"#8a8a8a\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Fp0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("9r41");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d60a365_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("wK7E");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Ne9V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d60a365"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d60a365_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/QnUpload-1.0.0/preview/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3d60a365", Component.options)
  } else {
    hotAPI.reload("data-v-3d60a365", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GBiV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue__ = __webpack_require__("1VZG");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/QnUpload-1.0.0/upload/src/upload.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0252ef18", Component.options)
  } else {
    hotAPI.reload("data-v-0252ef18", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GUmw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-a",
  "use": "icon-a-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-a\"><defs><style type=\"text/css\"></style></defs><path d=\"M44.521739 0h44.521739v979.478261H44.521739zM267.130435 534.26087h44.521739v445.217391H267.130435zM489.73913 311.652174h44.52174v667.826087h-44.52174zM712.347826 712.347826h44.521739v267.130435h-44.521739zM934.956522 445.217391h44.521739v534.26087h-44.521739z\" fill=\"\" p-id=\"8555\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Gb2x":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("83ef");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("29d62897", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-57015451\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabsView.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-57015451\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabsView.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "H5AX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tongzhi",
  "use": "icon-tongzhi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tongzhi\"><path fill=\"#bfbfbf\" d=\"M543.069623 45.439912 272.968975 303.066457 96.77816 303.066457c-53.036937 0-96.430236 43.393299-96.430236 96.430236l0 225.004567c0 53.036937 43.394323 96.430236 96.430236 96.430236l176.191838 0L543.069623 978.560088c13.029758 12.428054 34.603099 3.192715 34.603099-14.814404L577.672722 60.254316C577.672722 42.247196 556.100404 33.011858 543.069623 45.439912zM908.201647 249.424746c-17.455557-16.030092-44.63764-14.856359-60.653405 2.599198-16.043395 17.46886-14.869662 44.623313 2.599198 60.653405 55.692417 51.108005 87.640036 123.766838 87.640036 199.318558s-31.94762 148.196227-87.640036 199.318558c-17.46886 16.043395-18.629289 43.212174-2.599198 60.681034 8.468882 9.224082 20.027126 13.891382 31.640628 13.891382 10.370185 0 20.767999-3.745301 29.012777-11.292184 73.371054-67.3622 115.451452-163.065889 115.451452-262.59879C1023.652076 412.44868 981.572702 316.743968 908.201647 249.424746zM785.133727 349.167424c-15.442714-18.028609-42.527582-20.082384-60.541865-4.695952-18.014282 15.415085-20.111037 42.527582-4.695952 60.541865 25.462928 29.753651 39.494503 67.738777 39.494503 106.98257s-14.031575 77.256548-39.494503 106.995873c-15.415085 18.028609-13.31833 45.112454 4.695952 60.541865 8.092305 6.931876 18.028609 10.313903 27.90863 10.313903 12.102642 0 24.1357-5.086855 32.632211-15.009855 38.767955-45.308929 60.122309-103.139032 60.122309-162.841785C845.256036 452.29213 823.901683 394.476353 785.133727 349.167424z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Hana":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Levelbar__ = __webpack_require__("N2mp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Hamburger__ = __webpack_require__("dahE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TabsView__ = __webpack_require__("jSdT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Screenfull__ = __webpack_require__("k0sJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_js__ = __webpack_require__("DfDl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__env_js__ = __webpack_require__("yZtZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svrapi_js__ = __webpack_require__("Mp/4");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 //获取vuex数据
 //面包屑导航
 //隐藏侧边栏
 //历史打开页面保存
 //全屏

// 请求参数设置



var PT = __WEBPACK_IMPORTED_MODULE_9__env_js__["a" /* default */].PT;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Levelbar: __WEBPACK_IMPORTED_MODULE_3__Levelbar__["default"],
    Hamburger: __WEBPACK_IMPORTED_MODULE_4__components_Hamburger__["a" /* default */],
    Screenfull: __WEBPACK_IMPORTED_MODULE_6__components_Screenfull__["a" /* default */],
    TabsView: __WEBPACK_IMPORTED_MODULE_5__TabsView__["default"]
  },
  data: function data() {
    var _this = this;

    var validatePass = function validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (_this.ruleForm2.checkPass !== "") {
          _this.$refs.ruleForm2.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== _this.ruleForm2.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      user_title: "",
      myname: "",
      photoUrl: "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80",
      showDialog: false,
      ruleForm2: {
        pass: "",
        checkPass: ""
      },
      rules2: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      },
      showDiv: false,
      lastD: "",
      baseInfo: false,
      complaintCall: '' //投诉电话
    };
  },
  mounted: function mounted() {
    var self = this;
    PT.apiClient.query("bz-mix/bz/get-base-info", "", function (rsp) {
      if (rsp.code == 0) {
        localStorage.setItem("user_data", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(rsp.data));
        var userInfo = JSON.parse(self.commonGetLocalDataNew("user_data"));
        var identity = JSON.parse(self.commonGetLocalDataNew("identity"));
        var user_all = JSON.parse(localStorage.getItem("user_all"));
        // console.log(userInfo)
        self.userInfo = userInfo;
        self.identity = identity;
        if (identity.user_type == "merchant_staff" || identity.user_type == "merchant") {
          self.showDiv = true;
        } else {
          self.showDiv = false;
        }
        if (identity.user_type == "merchant_staff") {
          self.myname = identity.merchant_staff_name;
        } else {
          self.myname = userInfo.login_name;
        }
        //基本信息显示隐藏
        if (userInfo.agentType == 1 || userInfo.agentType == 2) {
          self.baseInfo = false;
        } else {
          self.baseInfo = true;
        }
      } else {
        alert("获取用户信息错误！!");
      }
    });
    // eventBus.$on("user_title", function(val) {
    //   self.user_title = val;
    // });
    // eventBus.$on("Jurisdiction", function(val) {
    //   if (val == true) {
    //     self.showDiv = true;
    //   } else {
    //     self.showDiv = false;
    //   }
    // });
    this.getComplaintCall();
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(["sidebar", "avatar", "navbarData"])),
  methods: {
    //获取投诉电话
    getComplaintCall: function getComplaintCall() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* agencyQnbarRequest */])('GetDutyStaff').then(function (res) {
        _this2.complaintCall = res.data.contact_information;
      });
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    handleOnLogout: function handleOnLogout(rsp) {
      window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl);
    },

    // 退出登录
    runLogout: function runLogout() {
      var postParams = {
        local_sess: PT.qnlogin.getLocalSess()
      };
      PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_10__svrapi_js__["a" /* default */].logout, postParams, this.handleOnLogout);
      PT.qnlogin.logout();

      this.hasLogin = PT.qnlogin.isLocalSessOk;
    },
    submitForm: function submitForm(formName) {
      var self = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var data = {
            new_pwd: self.ruleForm2.pass,
            repeat_new_pwd: self.ruleForm2.checkPass
          };
          //老板
          if (self.identity.user_type == "merchant") {
            PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_10__svrapi_js__["a" /* default */].modifymyBoss, data, function (rsp) {
              if (rsp.code == 0) {
                self.$alert("密码修改成功", "提示");
                self.runLogout();
              } else {
                self.$alert(res.msg, "提示");
              }
            });
          } else if (self.identity.user_type == "merchant_staff") {
            //员工
            PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_10__svrapi_js__["a" /* default */].modifymyStaff, data, function (rsp) {
              if (rsp.code == 0) {
                self.$alert("密码修改成功", "提示");
                self.runLogout();
              } else {
                self.$alert(res.msg, "提示");
              }
            });
          }
        } else {
          alert("error submit!");
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    changePSW: function changePSW() {
      var self = this;
      self.showDialog = true;
    }
  }
});

/***/ }),

/***/ "I2U8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-interface",
  "use": "icon-interface-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-interface\"><defs><style type=\"text/css\"></style></defs><path d=\"M922.5 858.3H664.4c-5.3 0-9.5-4.3-9.5-9.5s4.3-9.5 9.5-9.5h258.1c10.4 0 18.8-8.4 18.8-18.8V187.8c0-10.4-8.4-18.8-18.8-18.8H102c-10.4 0-18.8 8.4-18.8 18.8v641.5c0 5.4 4.4 9.9 9.9 9.9h342.6c5.3 0 9.5 4.3 9.5 9.5s-4.3 9.5-9.5 9.5H93c-16 0-28.9-13-28.9-28.9V187.8c0-20.9 17-37.9 37.9-37.9h820.5c20.9 0 37.9 17 37.9 37.9v632.5c0 21-17 38-37.9 38z\" fill=\"#bfcbd9\" p-id=\"3948\" /><path d=\"M950.8 330.2H73.6c-5.3 0-9.5-4.3-9.5-9.5 0-5.3 4.3-9.5 9.5-9.5h877.2c5.3 0 9.5 4.3 9.5 9.5 0.1 5.2-4.2 9.5-9.5 9.5z\" fill=\"#bfcbd9\" p-id=\"3949\" /><path d=\"M163.1 240.1m-17.9 0a17.9 17.9 0 1 0 35.8 0 17.9 17.9 0 1 0-35.8 0Z\" fill=\"#bfcbd9\" p-id=\"3950\" /><path d=\"M234.7 240.1m-17.9 0a17.9 17.9 0 1 0 35.8 0 17.9 17.9 0 1 0-35.8 0Z\" fill=\"#bfcbd9\" p-id=\"3951\" /><path d=\"M306.3 240.1m-17.9 0a17.9 17.9 0 1 0 35.8 0 17.9 17.9 0 1 0-35.8 0Z\" fill=\"#bfcbd9\" p-id=\"3952\" /><path d=\"M288.4 580.8H145.2c-5.3 0-9.5-4.3-9.5-9.5V428c0-5.3 4.3-9.5 9.5-9.5h143.2c5.3 0 9.5 4.3 9.5 9.5v143.2c0.1 5.3-4.2 9.6-9.5 9.6z m-133.6-19.1h124.1V437.6H154.8v124.1zM701.7 437.6H369c-5.3 0-9.5-4.3-9.5-9.5 0-5.3 4.3-9.5 9.5-9.5h332.7c5.3 0 9.5 4.3 9.5 9.5s-4.2 9.5-9.5 9.5zM637.5 509.2H369c-5.3 0-9.5-4.3-9.5-9.5s4.3-9.5 9.5-9.5h268.5c5.3 0 9.5 4.3 9.5 9.5s-4.2 9.5-9.5 9.5zM548 580.8H369c-5.3 0-9.5-4.3-9.5-9.5s4.3-9.5 9.5-9.5h179c5.3 0 9.5 4.3 9.5 9.5s-4.2 9.5-9.5 9.5zM596.3 873.5c-2.2 0-4.3-0.7-6-2.1L476.6 780c-4.1-3.3-4.8-9.3-1.5-13.4L732 447.2c3.3-4.1 9.3-4.8 13.4-1.5l113.7 91.4c4.1 3.3 4.8 9.3 1.5 13.4L603.7 870c-1.6 2-3.9 3.2-6.4 3.5h-1zM496 771.1l98.8 79.5 245-304.6-98.8-79.5-245 304.6z\" fill=\"#bfcbd9\" p-id=\"3953\" /><path d=\"M841.8 545c-2.1 0-4.2-0.7-6-2.1l-90.9-73.1c-4.1-3.3-4.8-9.3-1.5-13.4l29.2-36.3c14.9-18.6 42.2-21.5 60.7-6.6l38.5 30.9c18.6 14.9 21.5 42.2 6.6 60.7l-29.2 36.3c-1.9 2.3-4.6 3.6-7.4 3.6z m-77.5-84.2l76.1 61.2 23.2-28.9c4-5 5.9-11.3 5.2-17.7-0.7-6.4-3.8-12.2-8.9-16.2l-38.5-30.9c-5-4-11.3-5.9-17.7-5.2-6.4 0.7-12.2 3.8-16.2 8.9l-23.2 28.8zM447.1 942.6c-2.1 0-4.2-0.7-6-2.1-3-2.4-4.2-6.3-3.2-10l42.6-154.8c0.9-3.1 3.2-5.6 6.3-6.5 3.1-1 6.4-0.4 8.9 1.6l99.5 80c2.5 2 3.8 5.2 3.5 8.3-0.3 3.2-2.2 6-5 7.5l-142.1 74.8c-1.5 0.9-3 1.2-4.5 1.2zM495 794.8l-32.9 119.6 109.7-57.8-76.8-61.8z\" fill=\"#bfcbd9\" p-id=\"3954\" /><path d=\"M447.1 933.1l11.4-46.8s17.9-10.7 26.9-1.7 5 27.4 5 27.4l-43.3 21.1zM512.2 799.8c-1 0-2.1-0.3-3-1-2.1-1.6-2.4-4.6-0.7-6.7l250.6-313.3c1.6-2.1 4.6-2.4 6.7-0.7 2.1 1.6 2.4 4.6 0.7 6.7L515.9 798c-0.9 1.2-2.3 1.8-3.7 1.8zM570.4 840.1c-1 0-2.1-0.3-3-1-2.1-1.6-2.4-4.6-0.7-6.7L817.3 519c1.6-2.1 4.6-2.4 6.7-0.7 2.1 1.6 2.4 4.6 0.7 6.7L574.1 838.3c-0.9 1.2-2.3 1.8-3.7 1.8z\" fill=\"#bfcbd9\" p-id=\"3955\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "I8fT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tuozhuai",
  "use": "icon-tuozhuai-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tuozhuai\"><defs><style type=\"text/css\"></style></defs><path d=\"M574.957891 267.016403 511.503696 267.016403l204.64896 0L511.212054 63.654762l-203.361641 203.361641L449.041086 267.016403l0 189.662641L258.687714 456.679044l0 125.916804L449.041086 582.595848l0 190.354396 125.916804 0L574.957891 582.595848l188.874695 0L763.832586 456.679044 574.957891 456.679044 574.957891 267.016403zM511.25401 960.345238l189.620685-187.394994L323.125305 772.950244 511.25401 960.345238zM71.291696 518.891967l187.394994 189.620685L258.68669 330.762239 71.291696 518.891967zM763.832586 330.762239l0 377.74939 188.874695-189.620685L763.832586 330.762239z\" p-id=\"9008\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "IBKg":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.svg-icon[data-v-ce21a81e] {\n  margin-right: 10px;\n}\n.hideSidebar .menu-indent[data-v-ce21a81e] {\n  display: block;\n  text-indent: 10px;\n}\n.el-badge[data-v-ce21a81e] {\n  float: right;\n  margin-right: 22px;\n}\n", ""]);

// exports


/***/ }),

/***/ "ILQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-zujian",
  "use": "icon-zujian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zujian\"><defs><style type=\"text/css\"></style></defs><path d=\"M568.6 0h454.9v454.9H568.6V0z m0 568.6h454.9v454.9H568.6V568.6zM0 568.6h454.9v454.9H0V568.6zM0 0h454.9v454.9H0V0z\" fill=\"\" p-id=\"10531\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__("bREw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_route_processe__ = __webpack_require__("BGh/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__("UjVw");









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
    modules: {
        app: __WEBPACK_IMPORTED_MODULE_2__modules_app__["a" /* default */],
        user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
        route_processe: __WEBPACK_IMPORTED_MODULE_4__modules_route_processe__["a" /* default */]
    },
    getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "IeYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-shouye",
  "use": "icon-shouye-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shouye\"><defs><style type=\"text/css\"></style></defs><path d=\"M853.333333 967.111111h-284.444444v-227.555555H455.111111v227.555555H170.666667V415.288889h56.888889V910.222222h170.666666v-227.555555h227.555556v227.555555h170.666666V415.288889h56.888889z\" fill=\"#bfcbd9\" p-id=\"3554\" /><path d=\"M944.355556 574.577778L512 136.533333l-432.355556 438.044445-45.511111-39.822222L512 56.888889l477.866667 477.866667z\" fill=\"#bfcbd9\" p-id=\"3555\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Jb2M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = huaweiUpload;
/* unused harmony export sectionUploadfile */
/* unused harmony export uploadfile */
/* unused harmony export StopUpload */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommonUpload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_huaweiUploadUiti__ = __webpack_require__("hWpG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_pool__ = __webpack_require__("pnUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_wcs_js_sdk__ = __webpack_require__("HZPe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_wcs_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_wcs_js_sdk__);










var CancelToken = __WEBPACK_IMPORTED_MODULE_7_axios___default.a.CancelToken;
var cancel = void 0;

var controller = new AbortController();
// 网宿上传对象
var WSuploadObj = null;

/**
 * 华为云上传
 * @param {string} platform
 * @param {string} module
 * @param {string} func
 * @param {string} object_key    文件名
 * @param {object} file		     需要上传文件
 * @param {function} callback    上传结果回调
 * @param {function} ProgressBar  进度条回调
 * @param {string} base_module   原上传接口的module字段，兼容之前的接口
 */
function huaweiUpload(platform, module, func, object_key, file, callback, ProgressBar) {
	var base_module = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';

	// 根据参数发起请求获取上传链接
	var part_number = '';
	if (file.size > 52428800) {
		var arr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_huaweiUploadUiti__["a" /* getChunks */])(file, 8388608);
		part_number = arr.length;
	} else {
		part_number = '';
	}
	var content_type = file.type;
	var parameter = {
		platform: platform,
		module: module,
		func: func,
		object_key: object_key,
		part_number: part_number,
		base_module: base_module,
		content_type: content_type
	};
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* agencyQnbarRequest */])('HuaweiAndWsUpload', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["d" /* filterEmptyProperty */])(parameter)).then(function (res) {
		var upload_config = res.data.upload_config;
		if (res.data.server_provider === 'WCS') {
			// 使用网宿上传
			WsUploadFile(platform, module, func, object_key, file, callback, ProgressBar, base_module, upload_config);
		} else if (res.data.server_provider === 'HW') {
			// 使用华为上传
			// 超过50mb进行分段上传
			if (file.size > 52428800) {
				return sectionUploadfile(platform, module, func, object_key, file, callback, ProgressBar, base_module, upload_config);
			} else {
				return uploadfile(platform, module, func, object_key, file, callback, ProgressBar, base_module, upload_config);
			}
		}
	});

	// agencyQnbarRequest('')
}
/**
 * 分段上传
 * @param {string} platform
 * @param {string} module
 * @param {string} func
 * @param {string} object_key		文件名
 * @param {File} file				文件
 * @param {Function} callback		上传回调函数
 * @param {Function} ProgressBar	进度条回调函数
 */
function sectionUploadfile(platform, module, func, object_key, file, callback, ProgressBar, base_module, upload_config) {
	// 默认切片为8m字节
	var arr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_huaweiUploadUiti__["a" /* getChunks */])(file, 8388608);
	var parameter = {
		platform: platform,
		module: module,
		func: func,
		base_module: base_module,
		object_key: object_key,
		part_number: arr.length
	};
	var uploadfile = file;
	var Host = upload_config[0].headers.Host;
	var fileChunks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_huaweiUploadUiti__["a" /* getChunks */])(uploadfile, 8388608);
	console.log(upload_config);
	var urls = upload_config.map(function (item) {
		return {
			url: item.url,
			part_number: item.part_number
		};
	});
	uploadChunks(platform, module, func, Host, fileChunks, urls, uploadfile, object_key, callback, ProgressBar, base_module);
}
/**
 * 上传所有分段
 * @param {Object} Host
 * @param {Object} fileChunks
 * @param {Object} url
 * @param {Object} file
 */
function uploadChunks(platform, module, func, Host, fileChunks, urls, file, object_key, callback, ProgressBar, base_module) {
	var Host_2 = Host;
	var upload_id = '';
	var fileChunks_2 = fileChunks;
	var uploadArr = [];
	var platform_2 = platform;
	var base_module_2 = base_module;
	var module_2 = module;
	var func_2 = func;
	// let temporaryUrl = ''
	var service = __WEBPACK_IMPORTED_MODULE_7_axios___default.a.create({
		headers: {
			"host": Host,
			'Content-Type': file.type
		}
	});
	var part_number = [];
	var percent = 0;
	var loaded = 0;
	var size = file.size;
	upload_id = getUrlParams(urls[0].url, 'uploadId');

	var _loop = function _loop(i) {
		var index = i + 1;
		//已上传的块

		var _loop2 = function _loop2(j) {
			var urlIndex = getUrlParams(urls[j].url, 'partNumber');
			if (index == urlIndex) {
				uploadArr[i] = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
					resolve(service({
						method: 'put',
						// url: str_1 + '&partNumber=' + index + '&' + str_2 ,
						url: urls[j].url,
						data: fileChunks_2[i],
						signal: controller.signal,
						onUploadProgress: function onUploadProgress(progressEvent) {
							var progress = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_huaweiUploadUiti__["b" /* getProgressInfoItem */])(progressEvent.loaded, progressEvent.total);
							// ProgressBar({total:progress})
						}
						// data: flie
					}).then(function (res) {
						var item = {
							PartNumber: index,
							ETag: res.headers.etag.replaceAll('"', '')
						};
						loaded = loaded + fileChunks_2[i].size;
						percent = (loaded / size).toFixed(2);
						var value = {
							total: {
								loaded: loaded,
								percent: percent * 100,
								size: size
							}
						};
						ProgressBar(value);
						part_number.push(item);
						if (parseInt(percent - 0) === 1) {
							mergeFile(platform, module, func, base_module, file, object_key, upload_id, part_number, callback);
						}
					}));
				});
			}
		};

		for (var j = 0; j < urls.length; j++) {
			_loop2(j);
		}
	};

	for (var i = 0; i < fileChunks_2.length; i++) {
		_loop(i);
	}
	var callback_3 = function callback_3() {
		// console.log('完成了回调aaa')
	};
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_pool__["a" /* createPoolAndRunTask */])(uploadArr, 8, callback_3);

	// Promise.all(uploadArr)
	// .then(
	// 	res => {
	// 		console.log('上传成功')
	// 		let arr = part_number.filter(item => item != null)
	// 		arr.sort(compare('PartNumber'))
	// 		let parameter = {
	// 			platform: platform_2,
	// 			module: module_2,
	// 			func: func_2,
	//        base_module: base_module_2,
	// 			object_key: file.name,
	// 			upload_id: upload_id,
	// 			parts: JSON.stringify(arr)
	// 		}
	// 		agencyQnbarRequest('HuaWeiMergeSection',filterEmptyProperty(parameter))
	// 		.then(
	// 			res => {
	// 				return callback(res)
	// 			}
	// 		)
	// 	}
	// )
	// .catch(
	// 	err => {
	// 		console.log('上传失败err=> ',err)
	// 		let parameter = {
	// 			platform: platform_2,
	// 			module: module_2,
	// 			func: func_2,
	// 		base_module: base_module,
	// 			object_key: file.name,
	// 			upload_id: upload_id,
	// 			// parts: JSON.stringify(arr)
	// 		}
	// 		agencyQnbarRequest('HuaWeiCancelUpload',filterEmptyProperty(parameter))
	// 		.then(
	// 			res => {
	// 				console.log('取消分段任务')
	// 			}
	// 		)
	// 	}
	// )
}

/** 获取url上的参数的值
 * @param {string} url
 * @param {string} arg
 */
function getUrlParams(url, key) {
	var Params = new URLSearchParams(url.split('?')[1]);
	return Params.get(key);
}

/**
 * 修改链接中的url值
 * @param {Object} url		链接
 * @param {Object} arg		需要修改的参数名
 * @param {Object} arg_val  修改的值
 * @return {string}
 */
function changeURLArg(url, arg, arg_val) {
	var pattern = arg + '=([^&]*)';
	var replaceText = arg + '=' + arg_val;
	if (url.match(pattern)) {
		var tmp = '/(' + arg + '=)([^&]*)/gi';
		tmp = url.replace(eval(tmp), replaceText);
		return tmp;
	} else {
		if (url.match('[\?]')) {
			return url + '&' + replaceText;
		} else {
			return url + '?' + replaceText;
		}
	}
}

/**
 * 单文件直传不分片
 * @param {Object} platform
 * @param {Object} module
 * @param {Object} func
 * @param {Object} object_key	文件名
 * @param {Object} file			文件
 * @param {Object} callback		进度回调
 */
function uploadfile(platform, module, func, object_key, file, callback, callback_2, base_module, upload_config) {
	// let host,url,promise
	var host = upload_config.headers.Host;
	var url = upload_config.url;
	console.log(upload_config.headers['Content-type'], '我在上');
	var contentType = upload_config.headers['Content-type'];
	var filePath = upload_config.access_host + upload_config.file_path;
	var service = __WEBPACK_IMPORTED_MODULE_7_axios___default.a.create({
		headers: {
			'host': host,
			'Content-Type': contentType
		},
		signal: controller.signal,
		onUploadProgress: function onUploadProgress(progressEvent) {
			var progress = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_huaweiUploadUiti__["b" /* getProgressInfoItem */])(progressEvent.loaded, progressEvent.total);
			callback_2({ total: progress });
		}
	});
	service({
		method: 'put',
		url: url,
		// url: 'https://qnbar-test.obs.cn-east-3.myhuaweicloud.com:443/interface/img/1668667373922000.png?AccessKeyId=2ENXRG86DYW3VNYY1OCA&Expires=1668667673&Signature=DwRsJsb%2BYp4lQiJFFh3xMiHm8n8%3D',
		signal: controller.signal,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
		data: file
	}).then(function (res) {
		var data = {
			status: 200,
			fileType: file.type,
			fileSize: file.size,
			fileUrl: filePath
		};
		return callback(data);
	}).catch(function (err) {
		StopUpload();
		var data = {
			status: 500,
			message: err
		};
		console.log(data);
		return callback(data);
	});
}

// 停止上传
function StopUpload() {
	// const controller = new AbortController()
	// let signal = controller.signal
	setTimeout(function () {
		controller.abort();
		cancel('cancelUpload');
	}, 100);
	if (WSuploadObj != null) {
		setTimeout(function () {
			WSuploadObj.stop();
			WSuploadObj = null;
		}, 100);
	}
}
/**
 * 发送请求合并块
 * @param {string} platform
 * @param {string} module
 * @param {string} func
 * @param {string} base_module
 * @param {string} object_key
 * @param {string} upload_id
 * @param {Array} part_number 	所有已上传块的标识参数
 * @param {Function} callback
 */
function mergeFile(platform, module, func, base_module, file, object_key, upload_id, part_number, callback) {
	var arr = part_number.filter(function (item) {
		return item !== null;
	});
	arr.sort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_huaweiUploadUiti__["c" /* compare */])('PartNumber'));
	var parameter = {
		platform: platform,
		module: module,
		func: func,
		base_module: base_module,
		object_key: object_key,
		upload_id: upload_id,
		parts: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(arr)
	};

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* agencyQnbarRequest */])('HuaWeiMergeSection', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["d" /* filterEmptyProperty */])(parameter)).then(function (res) {
		console.log(res);
		var data = {
			status: 200,
			fileType: file.type,
			fileSize: file.size,
			fileUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_huaweiUploadUiti__["d" /* removeUrlParameters */])(res.data.access_host + res.data.url)
		};
		console.log(res.data.access_host + res.data.url);
		console.log(data);
		callback(data);
	}).catch(function (err) {
		var data = {
			status: 500,
			message: err
		};
		callback(data);
		// 取消上传
		var parameter = {
			platform: platform,
			module: module,
			func: func,
			base_module: base_module,
			object_key: object_key,
			upload_id: upload_id
		};
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* agencyQnbarRequest */])('HuaWeiCancelUpload', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["d" /* filterEmptyProperty */])(parameter)).then(function (res) {
			console.log('取消成功');
		}).catch(function (err) {
			console.log('取消失败');
		});
	});
}
/**
 * 网宿上传
 * @param {Object} platform
 * @param {Object} module
 * @param {Object} func
 * @param {Object} object_key
 * @param {Object} file
 * @param {Object} callback			结果回调函数
 * @param {Object} ProgressBar		进度回调函数
 * @param {Object} base_module
 */
function WsUploadFile(platform, module, func, object_key, file, callback, ProgressBar, base_module, upload_config) {
	var token = upload_config.token;
	var prefix = 'https://';
	if (false) {
		prefix = 'http://';
	}
	console.log(upload_config);
	var uploadUrl = prefix + upload_config.request_url;
	var extraConfig = {
		bucket: upload_config.bucket,
		file_name_rule: upload_config.file_name_rule,
		max_size_mb: upload_config.max_size_mb,
		retryCount: 0,
		key: upload_config.dir + object_key,
		concurrentRequestLimit: 6, //  并发数 默认为6
		blockSize: 8 //  文件块上传大小 默认为8M
	};
	var handlers = {
		Authorization: 'UpToken ' + upload_config.token,
		uploadBatch: file.id
	};
	console.log(handlers);
	// 创建网宿上传对象
	WSuploadObj = __WEBPACK_IMPORTED_MODULE_8_wcs_js_sdk__["wcsUpload"](file, token, uploadUrl, extraConfig, handlers);
	console.log(WSuploadObj);
	// 网宿上传进度回调
	WSuploadObj.uploadProgress = function (progress) {
		ProgressBar(progress);
	};
	// 网宿上传失败回调
	WSuploadObj.onError = function (err) {
		var data = {
			status: 500,
			message: err.message
		};
	};
	// 网宿上传成功回调
	WSuploadObj.onComplete = function (res) {
		var data = {
			status: 200,
			fileType: file.type,
			fileSize: file.size,
			fileUrl: upload_config.access_host + '/' + upload_config.dir + object_key
		};
		callback(data);
	};
	WSuploadObj.putFile();
}
// 上传对象
var CommonUpload = function () {
	function CommonUpload(platform, module, func, object_key, file, callback_2, base_module) {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CommonUpload);

		this.platform = platform;
		this.module = module;
		this.func = func;
		this.object_key = object_key;
		this.file = file;
		this.onComplete = function (data) {
			console.log(data, 'callback');
			callback_2(data);
		};
		this.uploadProgress = function (data) {
			console.log(data, 'jindu');
		};
		this.base_module = base_module;
	}
	// 上传文件


	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CommonUpload, [{
		key: 'putFile',
		value: function putFile() {
			huaweiUpload(this.platform, this.module, this.func, this.object_key, this.file, this.onComplete, this.uploadProgress, this.base_module);
		}
		// 停止上传

	}, {
		key: 'stop',
		value: function stop() {
			StopUpload();
		}
	}]);

	return CommonUpload;
}();

/***/ }),

/***/ "JdRO":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in\n *    IE on Windows Phone and in iOS.\n */\n\nhtml {\n  line-height: 1.15; /* 1 */\n  -ms-text-size-adjust: 100%; /* 2 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\n\nbody {\n  margin: 0;\n}\n\n/**\n * Add the correct display in IE 9-.\n */\n\narticle,\naside,\nfooter,\nheader,\nnav,\nsection {\n  display: block;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in IE.\n */\n\nfigcaption,\nfigure,\nmain { /* 1 */\n  display: block;\n}\n\n/**\n * Add the correct margin in IE 8.\n */\n\nfigure {\n  margin: 1em 40px;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\n\na {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}\n\n/**\n * 1. Remove the bottom border in Chrome 57- and Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\n\nb,\nstrong {\n  font-weight: inherit;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font style in Android 4.3-.\n */\n\ndfn {\n  font-style: italic;\n}\n\n/**\n * Add the correct background and color in IE 9-.\n */\n\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\naudio,\nvideo {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in iOS 4-7.\n */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Remove the border on images inside links in IE 10-.\n */\n\nimg {\n  border-style: none;\n}\n\n/**\n * Hide the overflow in IE.\n */\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: sans-serif; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\nhtml [type=\"button\"], /* 1 */\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Correct the padding in Firefox.\n */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * 1. Add the correct display in IE 9-.\n * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  display: inline-block; /* 1 */\n  vertical-align: baseline; /* 2 */\n}\n\n/**\n * Remove the default vertical scrollbar in IE.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n */\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n */\n\ndetails, /* 1 */\nmenu {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n  display: list-item;\n}\n\n/* Scripting\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\ncanvas {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in IE.\n */\n\ntemplate {\n  display: none;\n}\n\n/* Hidden\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10-.\n */\n\n[hidden] {\n  display: none;\n}\n", ""]);

// exports


/***/ }),

/***/ "JeEN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', _vm._b({
    staticClass: "qn-image",
    attrs: {
      "src": _vm.previewImg,
      "alt": "图片"
    }
  }, 'img', _vm.$attrs, false))
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07ce388e", esExports)
  }
}

/***/ }),

/***/ "JoLq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_dragger_vue__ = __webpack_require__("pqE5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c0e13c7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_upload_dragger_vue__ = __webpack_require__("lzf8");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_dragger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c0e13c7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_upload_dragger_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/QnUpload-1.0.0/upload/src/upload-dragger.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] upload-dragger.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6c0e13c7", Component.options)
  } else {
    hotAPI.reload("data-v-6c0e13c7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jysk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tab",
  "use": "icon-tab-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tab\"><defs><style type=\"text/css\"></style></defs><path d=\"M896 320H128V160c0-17.6 14.4-32 32-32h704c17.6 0 32 14.4 32 32v160zM320 896H160c-17.6 0-32-14.4-32-32V384h192v512zM864 896H384V384h512v480c0 17.6-14.4 32-32 32z\" p-id=\"8213\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "K370":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-jinyong",
  "use": "icon-jinyong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jinyong\"><path fill=\"#d81e06\" d=\"M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333zM170.666667 512a341.333333 341.333333 0 0 0 550.016 270.08L241.92 303.36A339.84 339.84 0 0 0 170.666667 512z m341.333333-341.333333a339.882667 339.882667 0 0 0-209.877333 72.106666L781.226667 721.92A341.333333 341.333333 0 0 0 512 170.666667z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "K5n2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("uMKz");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("20baa131", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4a0bc5c6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Levelbar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4a0bc5c6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Levelbar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Liw6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-agent",
  "use": "icon-agent-usage",
  "viewBox": "0 0 1230 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1230 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-agent\"><defs><style type=\"text/css\"></style></defs><path d=\"M821.128 972.82l-0.467-4.741c0-2.485 0.185-4.926 0.523-7.318a375.941 375.941 0 0 0-0.326-7.656l-0.074-1.414a344.144 344.144 0 0 0-0.486-7.324l-0.123-1.519a369.601 369.601 0 0 0-0.664-7.434l-0.006-0.08m0.677 7.514a369.601 369.601 0 0 0-0.67-7.434m-0.868-7.662l-0.16-1.292a349.8 349.8 0 0 0-0.971-7.071l-0.246-1.667a338.457 338.457 0 0 0-1.15-7.139l-0.03-0.172-0.075-0.418c-0.4-2.282-0.824-4.55-1.266-6.826l-0.29-1.494a374.527 374.527 0 0 0-1.438-6.894l-0.37-1.623a362.798 362.798 0 0 0-1.604-6.9l-0.21-0.811a342.606 342.606 0 0 0-1.641-6.37l-0.412-1.538a321.886 321.886 0 0 0-1.82-6.445l-0.59-1.986a359.388 359.388 0 0 0-1.95-6.327l-0.492-1.513a356.085 356.085 0 0 0-1.802-5.411l-0.658-1.925a328.414 328.414 0 0 0-2.152-5.977l-0.86-2.319a352.138 352.138 0 0 0-1.993-5.171l-1.046-2.607a374.964 374.964 0 0 0-1.875-4.575l-0.935-2.22a370.524 370.524 0 0 0-2.41-5.492l-1.101-2.435a359.037 359.037 0 0 0-2.367-5.091l-1.193-2.466a331.416 331.416 0 0 0-2.067-4.194l-1.168-2.324a364.614 364.614 0 0 0-2.669-5.117l-1.451-2.693a367.75 367.75 0 0 0-4.188-7.502l-1.814-3.13c-0.615-1.045-1.23-2.09-1.857-3.136a364.596 364.596 0 0 0-9.168-14.463l-1.722-2.546a330.824 330.824 0 0 0-3.1-4.483l-1.801-2.558-2.19-3.025-1.967-2.65a372.276 372.276 0 0 0-3.296-4.354l-1.697-2.196a380.516 380.516 0 0 0-3.837-4.82l-1.495-1.845c-0.867-1.046-1.74-2.103-2.62-3.149l-1.432-1.69a350.705 350.705 0 0 0-4.335-5.006l-1.433-1.612a334.474 334.474 0 0 0-4.673-5.128l-1.28-1.377a355.163 355.163 0 0 0-2.89-3.05l-0.996-1.027a359.67 359.67 0 0 0-5.227-5.295l-1.402-1.377a332.607 332.607 0 0 0-5.417-5.209l-0.88-0.824a352.408 352.408 0 0 0-3.216-2.97l-0.922-0.836a328.707 328.707 0 0 0-5.793-5.135l-1.205-1.039a355.858 355.858 0 0 0-5.952-5.006l-0.935-0.774a369.737 369.737 0 0 0-3.505-2.829c-53.64-42.744-119.806-70.452-192.103-76.7a311.005 311.005 0 0 1-47.288 1.169l-0.24-0.013h-0.098l-0.142-0.012-0.246-0.012h-0.104l-0.135-0.013-0.246-0.012-0.105-0.006-0.135-0.006-0.246-0.019h-0.11l-0.124-0.012-0.246-0.012-0.123-0.006-0.123-0.013-0.24-0.012-0.123-0.006-0.123-0.006-0.24-0.019-0.122-0.006-0.117-0.006-0.246-0.012-0.123-0.013-0.117-0.006-0.24-0.012-0.135-0.012-0.105-0.007-0.246-0.018-0.135-0.006-0.104-0.006-0.246-0.019-0.142-0.012h-0.098l-0.24-0.018-0.148-0.013-0.092-0.006-0.246-0.018-0.147-0.013h-0.086l-0.246-0.018-0.16-0.012-0.08-0.007-0.246-0.018-0.154-0.012h-0.08l-0.246-0.025-0.166-0.012h-0.074l-0.24-0.025-0.172-0.012h-0.067l-0.246-0.025-0.172-0.012-0.062-0.006-0.246-0.019-0.178-0.012-0.062-0.006-0.24-0.025-0.184-0.012h-0.055l-0.246-0.025-0.185-0.012-0.049-0.006-0.246-0.025-0.184-0.012h-0.056l-0.234-0.03-0.202-0.02h-0.043l-0.234-0.024-0.21-0.018h-0.036l-0.24-0.025-0.203-0.018h-0.037l-0.24-0.025-0.209-0.018h-0.03l-0.24-0.025-0.215-0.018h-0.025l-0.24-0.025-0.221-0.018h-0.019l-0.24-0.031-0.22-0.018h-0.02l-0.24-0.025-0.227-0.025h-0.006l-0.246-0.024-0.233-0.019-0.246-0.03-0.234-0.019C247.599 630.386 103.583 784.357 103.583 972.02v0.185h-0.99l0.062 0.615a51.088 51.088 0 0 1-102.183 0l-0.46-4.741c0-4.047 0.473-7.982 1.358-11.745 0.086-2.755 0.203-5.498 0.332-8.24l0.19-3.266c0.1-1.703 0.185-3.413 0.308-5.116 0.062-1.04 0.154-2.078 0.234-3.111 0.123-1.673 0.246-3.34 0.381-5.006l0.381-4.09c0.123-1.352 0.246-2.705 0.388-4.058 0.141-1.359 0.295-2.712 0.449-4.07l0.467-4.114 0.474-3.696c0.196-1.513 0.387-3.026 0.602-4.538 0.166-1.2 0.345-2.386 0.523-3.585 0.209-1.433 0.418-2.866 0.646-4.299 0.209-1.346 0.43-2.687 0.658-4.034 0.22-1.322 0.436-2.65 0.676-3.972a446.96 446.96 0 0 1 1.476-8.006l0.732-3.69c0.295-1.451 0.59-2.908 0.897-4.354a469.656 469.656 0 0 1 1.71-7.73l0.873-3.707c0.338-1.402 0.676-2.81 1.027-4.206l0.94-3.714 1.015-3.862 1.077-3.936 1.063-3.788 1.126-3.868 1.137-3.787 1.181-3.825c0.4-1.255 0.8-2.515 1.211-3.77l1.267-3.855a411.312 411.312 0 0 1 2.57-7.478l1.28-3.56 1.457-3.985 1.205-3.173 1.667-4.31 1.168-2.922c0.578-1.432 1.15-2.859 1.74-4.286l1.316-3.123c0.59-1.403 1.175-2.798 1.783-4.194l1.236-2.804c0.646-1.47 1.292-2.934 1.956-4.39l1.082-2.338c0.75-1.63 1.5-3.259 2.275-4.876l0.941-1.955a449.496 449.496 0 0 1 2.38-4.895c0.523-1.052 1.058-2.091 1.587-3.136 0.658-1.31 1.31-2.62 1.986-3.918l0.467-0.891A459.983 459.983 0 0 1 71.115 726.99l0.455-0.738a450.89 450.89 0 0 1 3.167-4.944l1.095-1.698c1.088-1.666 2.189-3.32 3.296-4.968l0.91-1.353a423.045 423.045 0 0 1 3.443-5.012l0.96-1.383a347.732 347.732 0 0 1 3.474-4.87l1.008-1.396a362.6 362.6 0 0 1 3.432-4.655l1.217-1.636c1.132-1.5 2.263-2.982 3.413-4.464l1.28-1.66a409.084 409.084 0 0 1 3.566-4.508l1.156-1.445a448.613 448.613 0 0 1 3.8-4.655l1.04-1.248a343.591 343.591 0 0 1 3.86-4.563l1.157-1.353a346.347 346.347 0 0 1 3.954-4.52l1.033-1.168a427.432 427.432 0 0 1 4.175-4.612l0.954-1.045a420.343 420.343 0 0 1 4.236-4.539l1.021-1.076c1.458-1.525 2.921-3.05 4.403-4.55l0.812-0.83c1.525-1.556 3.062-3.1 4.612-4.63l0.738-0.726a725.34 725.34 0 0 1 4.944-4.797l0.172-0.16a461.484 461.484 0 0 1 115.674-80.641l0.061-0.025 0.05-0.024 0.055-0.031 0.049-0.025 0.061-0.024 0.05-0.025 0.055-0.03 0.055-0.025 0.05-0.025 0.06-0.024 0.05-0.025 1.291-0.627 0.062-0.025 0.05-0.03 0.054-0.025 0.271-0.13 0.055-0.024 0.05-0.024 0.061-0.031 0.05-0.025 0.055-0.024 0.049-0.025 0.061-0.025 0.05-0.03 0.055-0.025 0.055-0.025 0.05-0.024 0.06-0.025 0.05-0.03 0.055-0.025 0.056-0.025 0.049-0.024 0.061-0.031 0.05-0.025 0.055-0.024 0.055-0.025 0.05-0.024a520.424 520.424 0 0 1 9.9-4.619c-72.125-56.376-118.497-144.187-118.497-242.834C154.438 137.928 292.353 0 462.473 0c170.131 0 308.04 137.928 308.04 308.041 0 62.262-18.478 120.206-50.239 168.65l-0.178-0.142a53.179 53.179 0 0 1-95.412-32.302c0-22.936 16.898-36.557 25.384-56.376a204.186 204.186 0 0 0 16.431-80.518c0-113.172-91.747-204.906-204.912-204.906S256.669 194.18 256.669 307.353c0 105.62 79.916 192.551 182.572 203.688 2.435-0.117 4.87-0.216 7.311-0.295v0.202c5.012-0.16 10.048-0.245 15.109-0.245 97.238 0 187.46 30.063 261.91 81.379v-0.043a466.85 466.85 0 0 1 12.249 8.787l1.31 0.966 2.084 1.555c1.599 1.206 3.185 2.442 4.772 3.665l0.43 0.338c1.009 0.775 1.999 1.569 2.995 2.356l2.048 1.623c1.033 0.83 2.06 1.66 3.087 2.503l1.937 1.58 2.871 2.38 2.147 1.808 2.89 2.472 1.943 1.685 2.908 2.558 1.92 1.71 2.963 2.68 1.74 1.593 2.89 2.687 2.116 1.999 2.46 2.337 2.275 2.22 2.398 2.348 2.152 2.153 2.454 2.472 1.63 1.678c1.014 1.046 2.029 2.091 3.037 3.149l0.35 0.369a464.33 464.33 0 0 1 19.838 22.254l0.916 1.088 2.577 3.137 1.636 2.01 2.305 2.89 1.692 2.14 2.324 3.001 1.617 2.091 2.472 3.29 1.31 1.759c0.812 1.094 1.611 2.189 2.41 3.29l1.544 2.14 2.128 2.982 1.617 2.306 2.177 3.148 1.383 2.036 2.245 3.345 1.353 2.054c0.738 1.119 1.475 2.244 2.195 3.37l1.39 2.176 2.01 3.173 1.556 2.521 1.876 3.057 1.42 2.38c0.64 1.07 1.285 2.14 1.919 3.215l1.15 2.005a471.753 471.753 0 0 1 8.252 14.838l0.006 0.019c0.615 1.144 1.205 2.293 1.802 3.443l1.23 2.368c0.615 1.187 1.211 2.386 1.814 3.585l1.1 2.195 1.642 3.37 1.267 2.62 1.531 3.252 1.23 2.645 1.488 3.277 1.23 2.73 1.414 3.247 1.2 2.786 1.365 3.259 1.193 2.878 1.303 3.228 1.083 2.737 1.346 3.462 1.027 2.724 1.292 3.456 1.02 2.828 1.144 3.21 1.187 3.456 0.953 2.786 1.107 3.394c0.326 0.996 0.658 1.986 0.971 2.989 0.376 1.18 0.738 2.373 1.107 3.566l0.855 2.743c0.332 1.094 0.652 2.201 0.972 3.302l0.953 3.235 0.012 0.055c0.59 2.066 1.168 4.132 1.734 6.21l0.006 0.025a520.886 520.886 0 0 1 1.648 6.272l0.025 0.08 0.78 3.161 0.837 3.382 0.787 3.382 0.714 3.081 0.72 3.308c0.245 1.12 0.491 2.251 0.725 3.376l0.658 3.247c0.221 1.107 0.449 2.214 0.658 3.32l0.608 3.198 0.652 3.567 0.541 3.105 0.585 3.518 0.51 3.191 0.547 3.61 0.455 3.124 0.474 3.492 0.442 3.407 0.406 3.358 0.388 3.333 0.369 3.572 0.338 3.333 0.307 3.395 0.29 3.419 0.276 3.61 0.228 3.227c0.086 1.292 0.16 2.583 0.233 3.875l0.172 3.037c0.087 1.679 0.154 3.364 0.222 5.043l0.074 1.764c0.086 2.337 0.153 4.692 0.203 7.041 0.295 2.214 0.448 4.47 0.448 6.765l0.468 4.747c0 28.219-22.875 51.088-51.094 51.088a51.088 51.088 0 0 1-51.089-51.088v-0.006m-3.861-55.098a345.59 345.59 0 0 0-1.15-7.145m-3.468-17.421a355.796 355.796 0 0 0-1.605-6.9m57.286-399.622l1.2-1.199c61.824-35.278 103.516-101.8 103.516-178.082 0-84.528-51.186-157.096-124.246-188.414-18.312-7.859-36.483-14.13-56.585-14.13a48.548 48.548 0 0 1-48.555-48.53l-0.443-4.508a48.555 48.555 0 0 1 46.489-48.518l2.398-2.398c159.346 11.806 284.957 144.833 284.957 307.18 0 97.023-44.859 183.556-114.954 240.018 0.14 1.728 0.215 3.474 0.233 5.24 154.691 71.903 262.795 227.104 266.602 408.015a51.654 51.654 0 0 1 0.448 6.764l0.462 4.748c0 28.225-22.876 51.088-51.088 51.088a51.088 51.088 0 0 1-51.089-51.088l-0.467-4.741c0-2.515 0.185-4.981 0.535-7.392-3.96-127.615-74.547-238.425-178.113-298.854a359.258 359.258 0 0 0-27.026-14.26c-22.36-13.295-41.692-13.049-62.926-23.933a70.993 70.993 0 0 1-38.672-63.227l-0.652-6.592c0-31.158 20.07-57.618 47.982-67.18h-0.006z\" p-id=\"2289\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Ljt4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__qnapi_js__ = __webpack_require__("1Nx3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__qnlogin_js__ = __webpack_require__("+AaE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__qnpermission_js__ = __webpack_require__("rGfR");





function Platform() {
    var that = this;

    //==================== 全局全站配置，每个站点独立配置一份来统一加载即可 ====================
    this.config = function () {
        this.env = "local"; //local test release
        this.hostBaseUrl = 'http://passport.tt.qnbar.com/'; //当前页面访问环境的host base
        this.platformUsagespace = 'PT_AGENT_BZ'; //平台标记，固定需要，请求要带上 【后端给具体定义】

        //api访问地址相关
        this.apiBaseUrl = 'http://passportapi.tt.qnbar.com/'; //后端服务api 访问基本地址

        //统一登录相关
        this.qnloginBaseUrl = "http://passport.tt.qnbar.com/"; //统一登录服务的基本地址
        this.qnloginPlatformNo = 8; //统一登录中本平台的编号 - 【后端给具体定义】
        this.loginJumpBackUrl = encodeURIComponent(hostBaseUrl + "test_agent.html"); //统一登录成功后无参数的回跳地址，url_encode的

        // websocket消息通知相关
        this.wsHost = "10.10.4.6";
        this.wsPort = "16666";
        this.wsProto = "ws";
    };

    //==================== 固定工具初始化，固定逻辑 ====================
    //初始化qnlogin通用接口对象
    this.qnlogin = null;
    this.apiClient = null;
    this.permissionChecker = null; //全局用的权限检查器

    this.init = function () {
        that.qnlogin = new __WEBPACK_IMPORTED_MODULE_1__qnlogin_js__["a" /* default */].QnLoginClient(that.config.qnloginBaseUrl, that.config.qnloginPlatformNo); //【todo url记得改, 平台编号记得改】
        //后端api请求工具
        that.apiClient = new __WEBPACK_IMPORTED_MODULE_0__qnapi_js__["a" /* default */].Qnapi(that.config.apiBaseUrl, that.config.platformUsagespace, that.qnlogin.getLocalSess);
        that.permissionChecker = new __WEBPACK_IMPORTED_MODULE_2__qnpermission_js__["a" /* default */].PermissionChecker();
    };
}

/* harmony default export */ __webpack_exports__["a"] = ({
    Platform: Platform
});

/***/ }),

/***/ "Lk1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-stafff",
  "use": "icon-stafff-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-stafff\"><defs><style type=\"text/css\"></style></defs><path d=\"M949.946663 967.548249c-14.001285-96.120027-60.696594-184.567464-133.61919-251.886095-41.141081-37.979271-88.655517-67.362277-140.026042-87.181698 28.988161-15.116799 55.821419-34.725094 79.60046-58.504135 61.227453-61.228468 94.947671-142.634662 94.947671-229.224599s-33.720217-167.99613-94.947671-229.224599C694.673423 50.299671 613.266215 16.579454 526.677293 16.579454S358.681163 50.299671 297.452694 111.528139c-61.227453 61.227453-94.947671 142.634662-94.947671 229.224599s33.720217 167.99613 94.947671 229.224599c21.288165 21.28715 45.0195 39.24095 70.555553 53.61678-56.478141 19.731113-108.660688 50.843725-153.332033 92.087324-72.927671 67.330812-119.617906 155.791444-133.60701 251.923651-2.62892 18.067483 11.044511 34.492653 29.623568 35.653844l2.05137 0.127893c16.701257 1.043448 31.309528-10.730867 33.690781-26.969272 11.949915-81.509726 51.597891-156.521248 113.475976-213.651037 65.401245-60.383966 149.761167-95.195337 239.091678-99.023005 9.15453 0.769391 18.382142 1.181492 27.674716 1.181492 5.830316 0 11.634241-0.165449 17.412791-0.468943 84.832925 6.316514 164.561278 40.648793 227.006764 98.29523 61.875041 57.119638 101.527077 132.11898 113.487142 213.618556 2.383284 16.238405 16.99257 28.01069 33.693827 26.965212l2.050355-0.127893C938.906213 1002.042932 952.578629 985.615733 949.946663 967.548249zM268.481789 340.751723c0-68.96602 26.856604-133.80494 75.623584-182.57192 48.76698-48.765965 113.604885-75.623584 182.57192-75.623584s133.80494 26.856604 182.57192 75.623584c48.76698 48.76698 75.623584 113.6059 75.623584 182.57192s-26.856604 133.80494-75.623584 182.57192c-48.138678 48.137663-111.94024 74.909004-179.910519 75.591103-4.587923-0.140074-9.184981-0.217216-13.792189-0.217216-64.788169-2.730423-125.307133-29.240902-171.440117-75.373887C295.339408 474.556663 268.481789 409.717743 268.481789 340.751723z\" p-id=\"4799\" fill=\"#bfcbd9\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Lta+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-store",
  "use": "icon-store-usage",
  "viewBox": "0 0 1028 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1028 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-store\"><defs><style type=\"text/css\"></style></defs><path d=\"M1022.8256 187.1856 1022.8256 33.2736C1022.8256 14.9712 1007.9824 0 989.8416 0L36.336 0C18.192 0 3.344 14.9712 3.344 33.2736l0 154.1184c0 1.2208 0.072 2.432 0.2 3.6192C2.272 198.128 1.6 205.4144 1.6 212.808c0 17.8768 3.8208 35.16 11.056 50.9152l0 724.1616c0 18.3024 14.8448 33.272 32.992 33.272l932.5536 0c18.1488 0 32.9904-14.968 32.9904-33.272L1011.192 280.1328c10.4304-18.2016 16-38.9232 16-60.5088C1027.1856 208.5056 1025.6864 197.6192 1022.8256 187.1856L1022.8256 187.1856zM61.5344 161.976 61.5344 58.6896l0 0L964.64 58.6896l0 103.2864M859.784 974.2064 167.4384 974.2064 167.4384 467.1488l692.3456 0L859.784 974.2064 859.784 974.2064zM964.64 974.2064l-58.3024 0L906.3376 453.472c0-18.3024-14.848-33.2736-32.9888-33.2736L153.88 420.1984c-18.144 0-32.992 14.9712-32.992 33.2736l0 520.7344-61.68 0L59.208 316.3296c18.6544 11.5136 40.1392 17.6752 62.5632 17.6752 21.6016 0 42.3472-5.7504 60.4464-16.3872 19.7248 13.608 43.304 21.1808 67.8592 21.1808 32.1024 0 62.2784-12.6064 84.9744-35.5024 6.392-6.44 11.9712-13.4864 16.6992-21.0016 3.992 5.7296 8.5056 11.1568 13.5136 16.2128 22.7024 22.8896 52.8784 35.4976 84.976 35.4976 21.6 0 42.3472-5.7504 60.4432-16.3872 19.7232 13.608 43.3056 21.1808 67.8624 21.1808 32.096 0 62.2768-12.6064 84.9744-35.5024 6.096-6.1424 11.4416-12.8368 16.0272-19.9664 4.1568 6.0992 8.8944 11.856 14.192 17.2 22.696 22.8944 52.8784 35.5024 84.9744 35.5024 21.5968 0 42.3472-5.7584 60.44-16.3936 19.7248 13.616 43.304 21.1824 67.8656 21.1824 20.4672 0 40.1536-5.136 57.6192-14.7856L964.6384 974.2064 964.64 974.2064z\" p-id=\"1862\" /><path d=\"M805.5072 601.3008c0-10.7088-9.6576-19.392-21.5712-19.392L245.0816 581.9088c-11.9136 0-21.5728 8.6832-21.5728 19.392l0 0.4336c0 10.7104 9.6592 19.3936 21.5728 19.3936L783.936 621.128c11.9136 0 21.5712-8.6832 21.5712-19.3936L805.5072 601.3008z\" p-id=\"1863\" /><path d=\"M805.5072 706.4608c0-10.712-9.6576-19.3936-21.5712-19.3936L245.0816 687.0672c-11.9136 0-21.5728 8.6816-21.5728 19.3936l0 0.432c0 10.7088 9.6592 19.392 21.5728 19.392L783.936 726.2848c11.9136 0 21.5712-8.6832 21.5712-19.392L805.5072 706.4608z\" p-id=\"1864\" /><path d=\"M805.2848 818.8704c0-10.7104-9.6592-19.3936-21.5712-19.3936L244.8544 799.4768c-11.912 0-21.5712 8.6832-21.5712 19.3936l0 0.432c0 10.7104 9.6592 19.392 21.5712 19.392L783.712 838.6944c11.912 0 21.5712-8.6816 21.5712-19.392L805.2832 818.8704z\" p-id=\"1865\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52f6eacb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("0aOF");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("4hTs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52f6eacb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-52f6eacb", Component.options)
  } else {
    hotAPI.reload("data-v-52f6eacb", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9A7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = login;
/* harmony export (immutable) */ __webpack_exports__["b"] = getInfo;
/* harmony export (immutable) */ __webpack_exports__["c"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__("Vo7i");


function login(username, password) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/user/login',
    method: 'post',
    data: {
      username: username,
      password: password
    }
  });
}

function getInfo(token) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/user/info',
    method: 'get',
    params: { token: token }
  });
}

function logout() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/user/logout',
    method: 'post'
  });
}

/***/ }),

/***/ "MCxY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-downArrow",
  "use": "icon-downArrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-downArrow\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 1024L819.2 512l-614.4 0L512 1024zM614.4 0l-204.8 0L409.6 512 614.4 512 614.4 0z\" p-id=\"43370\" fill=\"#1afa29\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "MeRa":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dh+R");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4ac3d44b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f289638\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Layout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f289638\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Layout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Mp/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _loginValidateTicket$;

/* harmony default export */ __webpack_exports__["a"] = (_loginValidateTicket$ = {
  // 登录相关
  loginValidateTicket: 'bz-mix/login/validate-ticket',
  logout: 'bz-mix/logout',
  loginUserInfo: 'bz-mix/login/user-info', // 获取已登录用户的详细信息
  // 平台跳转授权请求
  grantJumpPlatform: 'bz-mix/grant/platform-jump',
  // 定制页面
  customer: 'bz-mix/bz/get/list/custom', // 获取定制页面数据
  gitPic: 'bz-mix/bz/screen/set', // 设置图片
  delPic: 'bz-mix/bz/screen/pic/del',
  rollWords: 'bz-mix/bz/agent/introduce/update', // 滚动字幕
  picName: 'bz-mix/bz/file/name/set-name', // 修改图片名字
  // 详情页
  getPicVideo: 'bz-mix/bz/get/details/list', // 拉取图片和视频
  delPicVideo: 'bz-mix/bz/screen/pic/del', // 删除图片视频
  setPicVideo: 'bz-mix/bz/screen/set', // 上传图片视频
  showPicVideo: 'bz-mix/bz/type/setting/show', // 显示图片视频
  // 图片排序
  dragPicUrl: 'bz-mix/bz/screen/set-sort',
  // 跑马灯
  getFontSize: 'bz-mix/bz/agent/title/get-font', // 获取字体
  getSubtitle: 'bz-mix/bz/agent/title/get-subtitle', // 获取字幕
  setSubtitle: 'bz-mix/bz/agent/title/set-subtitle', // 设置字幕
  // 客户反馈
  feedBack: 'bz-mix/bz/mix-agent/feed-back/get-list',
  // 拖拽
  // dragPicUrl: "bz-mix/bz/screen/set-sort",

  // 轮询拉取投影仪消息
  getRemindMsg: 'bz-mix/bz/agent/getRemindMsg',
  // 投影仪房间管理
  getPsnList: 'bz-mix/bz/mix-agent/psn/list/get', // 获取门店psn列表
  editRoom: 'bz-mix/bz/mix-agent/room/edit', // 房间编辑（新增，修改）
  getRoomList: 'bz-mix/bz/mix-agent/room/list/get', // 房间列表
  delRoom: 'bz-mix/bz/mix-agent/room/del', // 房间删除
  unbundRoom: 'bz-mix/bz/mix-agent/room/psn/unbind', // 房间解绑psn

  // 酒店管理新加
  getinterface: 'bz-mix/bz/agent/getStoreBootInterface', // 获取界面启动
  setinterface: 'bz-mix/bz/agent/setStoreBootInterface', // 设置界面启动

  // 订单、角色、营收相关
  getOrderList: 'bz-mix/bz/projector-retail/web/retail-order/list', // 获取订单列表
  getOrderDetail: 'bz-mix/bz/projector-retail/web/retail-order/info', // 获取订单详情
  getRevenueList: 'bz-mix/bz/settlement/revenue/list/get', // 获取营收列表
  getRevenueDetail: 'bz-mix/bz/settlement/revenue/detail', // 获取营收详情
  refuseOrder: 'bz-mix/bz/projector-retail/web/retail-order/refuse', // 拒绝订单
  acceptOrder: 'bz-mix/bz/projector-retail/web/retail-order/distribution', // 接受（配送）订单
  excelExport: 'bz-mix/bz/settlement/excel/export', // excel导出
  downloadExcel: 'bz-oss/excel/download', // 下载excel文件
  getDistributionStaff: 'bz-mix/bz/bz-staff/get-distribution-list', // 获取配送人员列表
  waitDistribution: 'bz-mix/bz/projector-retail/web/retail-order/num-notic', // 代配送数量和提醒
  // 权限角色相关
  getStaffList: 'bz-mix/bz/bz-staff/get-list', // 获取员工列表
  addStaff: 'bz-mix/bz/bz-staff/create-staff', // 新增员工
  editStaff: 'bz-mix/bz/bz-staff/update-staff', // 编辑员工
  delStaff: 'bz-mix/bz/bz-staff/del-staff', // 删除员工
  getRoleList: 'bz-mix/bz/role/get-list', // 获取角色列表
  getRoleDetail: 'bz-mix/bz/role/get-info', // 获取角色详情
  modifyPass: 'bz-mix/bz/bz-staff/change-pwd', // 老板修改员工修改密码
  modifymyBoss: 'bz-mix/bz/change/pwd', // 老板修改自己密码
  modifymyStaff: 'bz-mix/bz/bz-staff/change-self-pwd', // 员工修改自己密码
  queryOpen: 'bz-oss/oss/store/function/ctrl', // 查询购物功能是否开通
  // 商品购物

  // 商品分类
  getCategoryList: 'bz-mix/bz/projector-retail/web/retail-category/list', // 拉取商品分类列表
  addCategory: 'bz-mix/bz/projector-retail/web/retail-category/add', // 添加商品分类
  editCategory: 'bz-mix/bz/projector-retail/web/retail-category/edit', // 编辑商品分类
  delCategory: 'bz-mix/bz/projector-retail/web/retail-category/delete', // 删除商品分类

  // 商品
  getGoodsList: 'bz-mix/bz/projector-retail/web/retail/list', // 获取商品列表
  addGoods: 'bz-mix/bz/projector-retail/web/retail/add', // 添加商品
  editGoods: 'bz-mix/bz/projector-retail/web/retail/edit', // 编辑商品
  delGoods: 'bz-mix/bz/projector-retail/web/retail/delete', // 删除商品
  goodsChangeStatus: 'bz-mix/bz/projector-retail/web/retail/status', // 修改商品上下架状态

  // 结算记录
  getRecords: 'bz-mix/bz/settlement/cycle/bill/list/get', // 获取结算记录列表
  getRecordInfo: 'bz-mix/bz/settlement/cycle/bill/detail', // 获取结算记录详情
  getSettlementInfo: 'bz-oss/oss/store/settlement/data/get', // 获取出账入账详情
  getUnPayRecordInfo: 'bz-oss/oss/store/settlement/data/get', // 获取未结算账单详情

  // 日志管理
  getOperationList: 'bz-mix/bz/operation/log/list/get', // 获取员工操作日志
  getOpeStaffList: 'bz-mix/bz/operation/staff/account/list/get', // 获取员工列表

  // 资金流水
  getCapitalFlow: 'bz-mix/bz/mix-agent/cash-flow/list', // 资金流水列表
  CapitalExport: 'bz-mix/bz/mix-agent/cash-flow/export', // 资金流水导出表
  CommonDownloadExcel: 'common/excel/download', // 公共下载

  // 界面管理
  getInterfaceDetail: 'bz-mix/interface/getInterfaceUseInfo', // 界面详情
  getInterfaceList: 'bz-mix/getInterfaceList', // 界面模块列表
  editInterfacesModule: 'bz-oss/interface/editStoreModule', // 模块&&(二级界面)编辑
  updateModuleSort: 'bz-oss/interface/updateModuleSort', // 模块排序
  getDefultImage: 'bz-mix/useDefaultPicture', // 使用默认图
  getSonModule: 'bz-oss/interface/getSonModule', // 二级界面列表
  deleteSonModule: 'bz-mix/deleteSonModule', // 删除二级界面资源
  updateSonSort: 'bz-oss/interface/updateSonSort', // 二级界面排序
  addPicOrVideo: 'bz-oss/interface/addPicOrVideo', // 新增二级界面资源
  getOssList: 'bz-oss/getInterfaceList', // 获取oss列表资源
  getWelcomeType: 'bz-mix/bz/welcome/type/get', // 获取启用模式(欢迎界面)
  editWelcomeTypeUpdate: 'bz-mix/bz/welcome/type/update', // 修改启用模式(欢迎界面)
  editPicDel: 'bz-mix/bz/welcome/pic/del', // 修改启用模式(欢迎界面)

  // 立即消息
  realTimeSend: 'bz-mix/bz/agent/title/set-true-subtitle', // 立即消息发送
  getNewRoomList: 'bz-mix/bz/agent/title/get-room-list', // 立即消息获取包间
  getnewsRecord: 'bz-mix/bz/agent/title/get-true-subtitle', // 获取立即消息记录

  // 爱奇艺1.4迭代
  getDemandRevenue: 'bz-mix/bz/revenue/count/list/get', // 获取点播营收列表
  exportDemandRevenue: 'bz-mix/bz/revenue/count/excel/export', // 点播营收报表导出
  getDemandList: 'bz-mix/bz/copyright/iqiyi-order-list', // 点播订单列表
  exportDemandList: 'bz-mix/bz/copyright/iqiyi-order-export', // 点播订单导出
  demandSettlementInfo: 'bz-mix/bz/copyright/account-info', // 点播结算分账信息
  getSettleStatistic: 'bz-mix/bz/copyright/settle-statistic', // 点播结算统计金额
  getDemandStaList: 'bz-mix/bz/copyright/settle-list', // 点播结算列表

  // 1.5迭代相关
  getControlpwd: 'bz-mix/bz/control/key/get', // 获取控制台密码
  editControlpwd: 'bz-mix/bz/control/key/update', // 编辑控制台密码
  recoveryControlpwd: 'bz-mix/bz/control/key/default/set', // 恢复控制台密码
  getFontColor: 'bz-mix/bz/font/face/get', // 获取字体颜色大小
  setFontColor: 'bz-mix/bz/font/face/update', // 设置字体颜色大小
  recoveryFontColor: 'bz-mix/bz/font/default/set', // 恢复字体颜色大小
  getAppList: 'bz-oss/interface/getAppList', // 拉取软件列表
  oneKeyDefault: 'bz-oss/interface/setDefaultModule', // 一键恢复默认

  // 商家扫码支付技术服务费相关
  specialCompets: 'fbs/bz/tech-service-fee/get-expire-permission', // 获取特殊权限
  getRecordList: 'fbs/bz/tech-service-fee/record-list', // 获取支付记录
  payBill: 'fbs/bz/tech-service-fee/create-order', // 服务费下单
  getEffectiveInfo: 'fbs/bz/tech-service-fee/get-parames-for-order', // 获取有效信息

  // 别样红欢迎页面
  // https://gitlab.qnbar.com/qnbar_developer/qnbar_api/wikis/byh-proj
  getMessageInfo: 'bz-mix/bz/welcome/message/get', // 获取欢迎页面信息
  editMessageInfo: 'bz-mix/bz/welcome/message/edit', // 编辑欢迎页面信息
  setWelcomPic: 'bz-mix/bz/welcome/pic/set', // 背景图片设置
  delWelcomPic: 'bz-mix/bz/welcome/pic/del', // 背景图片删除
  setWelcomMusic: 'bz-mix/bz/welcome/music/set', // 背景音乐设置
  delWelcomMusic: 'bz-mix/bz/welcome/music/del', // 背景音乐删除
  byhCheck: 'bz-mix/bz/welcome/byh/check', // 别样红菜单权限
  setWelcomeStatus: 'bz-mix/bz/welcome/open/status', // 开通或关闭欢迎信息
  getWelcomeStatus: 'bz-mix/bz/welcome/open/status/get', // 获取当前欢迎信息状态

  // 租赁管理
  storeRecord: 'bz-mix/leaseOrder/storeRecord', // 购买记录
  exportStoreRecord: 'bz-mix/leaseOrder/exportStoreRecord', // 导出购买记录
  createOrder: 'bz-mix/leaseOrder/createOrder', // 创建订单
  leaseKeysPrice: 'bz-mix/bz/lease/keys/price', // 密钥购买
  getLeasePsn: 'bz-mix/bz/lease/psn/get', // 获取设备
  detailLeaseKeys: 'bz-mix/bz/lease/keys/detail', // 密钥详情
  detailLeaseKeysInfo: 'bz-mix/bz/lease/keys/detail/info', // 密钥详情info
  exportLeaseDetail: 'bz-mix/bz/lease/exportLeaseDetail', // 导出密钥详情
  exportDetailInfo: 'agent/bz/qnbar-agent/lease/exportDetailInfo', // 导出密钥详情info
  leaseKeyOther: 'bz-mix/bz/lease/keys/other', // 密钥剩余情况
  // 租赁三
  leaseDistributeList: 'bz-mix/bz/lease/distribute/logs/get', // 获取分发记录
  leaseExportDistributeKey: 'bz-mix/bz/lease/exportDistributeKeys', // 导出分发记录
  getRoomLease: 'bz-mix/bz/lease/room/get', // 获取房间列表
  getModelList: 'bz-mix/bz/lease/keys/models', // 获取可选型号
  getStoreStatus: 'bz-mix/bz/lease/store/status/get', // 获取门店租赁状态
  merchantRoomOpen: 'bz-mix/bz/lease/room/open', // 开启房间
  merchantRoomClose: 'bz-mix/bz/lease/room/close', // 关闭房间
  leaseExportPsnGet: 'bz-mix/bz/lease/exportLeasePsnGet', // 导出设备

  // 上传相关
  commonOssUpload: 'common/oss/upload', // 拉取上传配置
  uploadWSCommonOss: 'common/ws/upload', // 拉取上传配置(网宿)
  HuaWeiCommonOssUpload: 'common/hwobs/upload', // 拉取华为云上传配置
  HuaWeiSectionUpload: 'common/hwobspart/upload', // 拉取华为云分段上传配置
  // HuaWeiSectionUploadInit: 'common/hwobspart/init',						// 华为云分段上传初始化配置
  HuaWeiMergeSection: 'common/hwobspart/merge', // 华为云分段上传后合并端
  HuaWeiCancelUpload: 'common/hwobspart/cancel', // 取消华为云上传
  HuaweiAndWsUpload: 'common/upload', // 获取上传配置（根据后端的返回的结果，决定是华为还是网宿）

  // 维修相关
  addRepair: 'warehouse/mix/repair/add', // 新增维修单
  getRepair: 'warehouse/mix/repair/get', // 查询维修单
  editDetailsRepair: 'warehouse/mix/repair/edit', // 编辑维修单信息
  getWarehouseGoods: 'warehouse/goods/list', // 获取商品列表
  payOrderRepair: 'warehouse/agent/repair/order/pay', // 下单支付
  editCheckStatusWarehouse: 'warehouse/mix/check/status/edit', // 更新维修单状态接口
  queryActivationTime: 'warehouse/mix/psn/check', // 查询激活时间
  getFileWarehouse: 'warehouse/mix/file/get', // 附件查询
  addFileWarehouse: 'warehouse/mix/file/add', // 附件新增
  deleteFileWarehouse: 'warehouse/mix/file/del' }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editCheckStatusWarehouse', 'warehouse/mix/check/status/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'getLogsRepair', 'warehouse/mix/repair/logs/get'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editPriceRepair', 'warehouse/mix/repair/price/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editStatusPayRepair', 'warehouse/mix/repair/pay/status/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'getOsnOrderRepair', 'warehouse/mix/repair/order/osn/get'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'getDetailsRepair', 'warehouse/mix/repair/details/get'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'getprovincelist', 'common/oss/region/get-province'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'getcitylist', 'common/oss/region/get-city'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'getAreasList', 'common/oss/region/get-areas'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'checkPriceOrder', 'warehouse/mix/order/price/check'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'getInterfaceSix', 'bz-mix/interface/six/module/list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editInterfaceSixLogo', 'bz-mix/interface/six/logo/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editInterfaceSixTheme', 'bz-mix/interface/six/theme/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editInterfaceSixbackground', 'bz-mix/interface/six/background/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editInterfaceSixHomepageModule', 'bz-mix/interface/six/media/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSixAddModule', 'bz-mix/interface/six/module/add'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSixEditModule', 'bz-mix/interface/six/module/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSixEditModuleOrder', 'bz-mix/interface/six/module/sort/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSixDelModule', 'bz-mix/interface/six/module/del'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSixGetContent', 'bz-mix/interface/six/extension/get'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSixAddContent', 'bz-mix/interface/six/extension/add'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSixEditContent', 'bz-mix/interface/six/extension/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSixDelContent', 'bz-mix/interface/six/extension/del'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSixDelContentSort', 'bz-mix/interface/six/extension/sort/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSixediteMovieAddresses', 'bz-mix/interface/six/url/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSixaKeyRecovery', 'bz-mix/interface/six/module/init'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSixEditLiveTv', 'bz-mix/interface/six/live/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceRestoreSixVideo', 'bz-mix/interface/six/home/video/init'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceRestoreContentVideo', 'bz-mix/interface/six/extension/video/init'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'uploadWSCommonOss', 'common/ws/upload'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'DeleteWSFiles', 'common/ws/del'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'BatchDeletion', 'common/ws/batch_del'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'getInterfaceSeven', 'bz-mix/interface/seven/module/list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editInterfaceSevenLogo', 'bz-mix/interface/seven/logo/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editInterfaceSevenTheme', 'bz-mix/interface/seven/theme/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editInterfaceSevenbackground', 'bz-mix/interface/seven/background/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editInterfaceSevenHomepageModule', 'bz-mix/interface/seven/media/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editInterfaceSevenWelecomeText', 'bz-mix/interface/seven/home/msg/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenAddModule', 'bz-mix/interface/seven/module/add'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenEditModule', 'bz-mix/interface/seven/module/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenEditModuleOrder', 'bz-mix/interface/seven/module/sort/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenDelModule', 'bz-mix/interface/seven/module/del'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenGetContent', 'bz-mix/interface/seven/extension/get'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenAddContent', 'bz-mix/interface/seven/extension/add'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenEditContent', 'bz-mix/interface/seven/extension/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenDelContent', 'bz-mix/interface/seven/extension/del'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenDelContentSort', 'bz-mix/interface/seven/extension/sort/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenEditMovieAddresses', 'bz-mix/interface/seven/url/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenaKeyRecovery', 'bz-mix/interface/seven/module/init'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenEditLiveTv', 'bz-mix/interface/seven/live/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceRestoreVideo', 'bz-mix/interface/seven/home/video/init'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenRestoreContentVideo', 'bz-mix/interface/seven/extension/video/init'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'InterfaceSevenEditIndexModuleOrder', 'bz-mix/interface/seven/home/module/sort/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'QueryDeviceInterfaceSettings', 'bz-mix/interface/set/get'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'EditDeviceInterfaceSettings', 'bz-mix/interface/set/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'EditTimeDisplaySettings', 'bz-mix/bz/agent/time/set/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'GetTimeDisplaySettings', 'bz-mix/bz/agent/time/set/get'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'bzmixInterfaceAuditList', 'bz-mix/interface/audit/list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'bzmixInterfaceAuditItems', 'bz-mix/interface/audit/items'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'bzWelcomeLogoSet', 'bz-mix/bz/welcome/logo/set'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'getHotelInfo', 'bz-mix/interface/mt-store/list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'eidtMeituanAudiovisual', '/bz-mix/interface/mt-store/editMTYY'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editMeituanJiguangTV', '/bz-mix/interface/mt-store/editJGTV'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editMeituanCableTV', '/bz-mix/interface/mt-store/editYXDS'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editMeituanOneKeyScreen', '/bz-mix/interface/mt-store/editYJTP'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editMeiTuanHotelIntroduce', '/bz-mix/interface/mt-store/editJDJS'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editMeiTuanViewingGuide', '/bz-mix/interface/mt-store/editGYZN'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editMeiTuanViewingSweetDream', '/bz-mix/interface/mt-store/editMMSG'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'getQueryWeather', 'bz-mix/interface/mt-store/queryWeather'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'MeirTuanOnkeyRecovery', 'bz-mix/interface/mt-store/initDefaultJDJS'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editMeituanAudioVideoInterface', '/bz-mix/interface/mt-store/editFaceMTYY'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editMeituanlogo', '/bz-mix/interface/mt-store/editLogo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'GetDutyStaff', 'bz-mix/bz/get/duty/staff'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'editMTWMContentImage', 'bz-mix/interface/mt-store/editMTWM'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'mixThirdAppNewGet', 'software/mix/thirdApp/new/get'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'mixThirdAppOpBindStore', 'software/mix/thirdApp/opBindStore'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'mixAgentRoomListGet', 'bz-mix/bz/mix-agent/room/list/get'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'mixAgentRoomEdit', 'bz-mix/bz/mix-agent/room/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'mixAgentRoomSortEdit', 'bz-mix/bz/mix-agent/room/sort/edit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'leaseXcRoomList', 'bz-mix/bz/lease/xc/room/list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'leaseXcRoomOpen', 'bz-mix/bz/lease/xc/room/open'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'leaseXcRoomBatchOpen', 'bz-mix/bz/lease/xc/room/batch/open'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'leaseXcRoomClose', 'bz-mix/bz/lease/xc/room/close'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'leaseXcRecordList', 'bz-mix/bz/lease/xc/record/list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'leaseXcRecordReport', 'bz-mix/bz/lease/xc/record/report'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'leaseXcRecordReportExport', 'bz-mix/bz/lease/xc/record/report/export'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'leaseXcDetailReport', 'bz-mix/bz/lease/xc/detail/report'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'leaseXcDetailReportExport', 'bz-mix/bz/lease/xc/detail/report/export'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'gameOrderList', 'bz-mix/game/order/list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'gameOrderExport', 'bz-mix/game/order/export'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'allowUninstallList', "bz-mix/allow/uninstall/list"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'allowUninstallAdd', "bz-mix/allow/uninstall/add"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'allowUninstallRemove', "bz-mix/allow/uninstall/remove"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'commonClearrojectorCache', "common/clear/projector/cache"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'commonClearStore', '/common/clear/store'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'mixAgentRoomUnifyWifi', 'bz-mix/bz/mix-agent/room/unify/wifi'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightModuleList', "bz-mix/interface/eight/module/list"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightLogoEdit', "bz-mix/interface/eight/logo/edit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightFirstModuleEdit', "bz-mix/interface/eight/first/module/edit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightModuleEdit', "bz-mix/interface/eight/module/edit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightMediaEdit', "bz-mix/interface/eight/media/edit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightExtensionAdd', "bz-mix/interface/eight/extension/add"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightExtensionEdit', "bz-mix/interface/eight/extension/edit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightExtensionDel', "bz-mix/interface/eight/extension/del"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightExtensionGet', "bz-mix/interface/eight/extension/get"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightExtensSortEdit', "bz-mix/interface/eight/extension/sort/edit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightModuleInit', "bz-mix/interface/eight/module/init"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightModuleAdd', "bz-mix/interface/eight/module/add"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightModuleDel', "bz-mix/interface/eight/module/del"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightModuleSortEdit', "bz-mix/interface/eight/module/sort/edit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loginValidateTicket$, 'interfaceEightMediaDelete', "bz-mix/interface/eight/media/delete"), _loginValidateTicket$);

/***/ }),

/***/ "N2mp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Levelbar_vue__ = __webpack_require__("3zpo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a0bc5c6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Levelbar_vue__ = __webpack_require__("3p1m");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("K5n2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a0bc5c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Levelbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a0bc5c6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Levelbar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/Levelbar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Levelbar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4a0bc5c6", Component.options)
  } else {
    hotAPI.reload("data-v-4a0bc5c6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css__ = __webpack_require__("q8zI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons__ = __webpack_require__("Q7M0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__permission__ = __webpack_require__("kTXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_js_common__ = __webpack_require__("oHFL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_hover_editor__ = __webpack_require__("tgmO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_QnImage__ = __webpack_require__("ojPt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_QnUpload_1_0_0__ = __webpack_require__("szRj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_QnInput__ = __webpack_require__("11jX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__env_js__ = __webpack_require__("yZtZ");




// import locale from 'element-ui/lib/locale/lang/en'


 //vuex数据
 // icon
 // 权限
 //公共JS函数文件
 // 悬浮编辑图标指令





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('qn-image', __WEBPACK_IMPORTED_MODULE_10__components_QnImage__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('qn-upload-t', __WEBPACK_IMPORTED_MODULE_11__components_QnUpload_1_0_0__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('qn-input', __WEBPACK_IMPORTED_MODULE_12__components_QnInput__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__common_js_common__["a" /* default */]);

// 注册全局自定义指令
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('hover-editor', __WEBPACK_IMPORTED_MODULE_9__directives_hover_editor__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.axios = __WEBPACK_IMPORTED_MODULE_14_axios___default.a;
//Vue.use(addressPicker);//导入会有错

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
 //just run

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
window.eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "Ne9V":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ghZq");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("037db21a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3d60a365\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3d60a365\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Opzk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.vue": [
		"+H76",
		111
	],
	"./Journal/JournalMat.vue": [
		"o0JU",
		196
	],
	"./afterSalesManage/repairOrder/addMaintenance.vue": [
		"QtFR",
		15
	],
	"./afterSalesManage/repairOrder/components/addSerialDialog.vue": [
		"pl3Z",
		47
	],
	"./afterSalesManage/repairOrder/components/editCommodity.vue": [
		"qoRF",
		195
	],
	"./afterSalesManage/repairOrder/components/editInformation.vue": [
		"0R8j",
		58
	],
	"./afterSalesManage/repairOrder/components/importDialog.vue": [
		"Lf8w",
		63
	],
	"./afterSalesManage/repairOrder/components/uploadComponents.vue": [
		"EzwF",
		70
	],
	"./afterSalesManage/repairOrder/detailOrder.vue": [
		"uqWK",
		46
	],
	"./afterSalesManage/repairOrder/index.vue": [
		"GEo/",
		99
	],
	"./balanceRecord/balanceRecord.vue": [
		"QtFK",
		91
	],
	"./balanceRecord/balanceRecordInfo.vue": [
		"9upd",
		90
	],
	"./capitalflow/capitalflow_list.vue": [
		"qy9f",
		129
	],
	"./commodityshpMat/commoditydsn/distribution_list.vue": [
		"Y3Kq",
		194
	],
	"./commodityshpMat/commoditydsn/distribution_record.vue": [
		"Ka0v",
		193
	],
	"./commodityshpMat/commoditydsn/index.vue": [
		"C2xm",
		210
	],
	"./commodityshpMat/commoditydsn/list_detail.vue": [
		"HslW",
		192
	],
	"./commodityshpMat/commoditydsn/record_detail.vue": [
		"xoYg",
		191
	],
	"./commodityshpMat/commoditydsn/wait_detail.vue": [
		"M4z+",
		190
	],
	"./commodityshpMat/commoditydsn/wait_distribution.vue": [
		"Egn1",
		189
	],
	"./commodityshpMat/commoditymat/Commodity_class.vue": [
		"irC5",
		89
	],
	"./commodityshpMat/commoditymat/commodity_list.vue": [
		"nLDJ",
		88
	],
	"./commodityshpMat/commoditymat/index.vue": [
		"SEom",
		209
	],
	"./commodityshpMat/commodityodr/index.vue": [
		"zdPy",
		208
	],
	"./commodityshpMat/commodityodr/order_detail.vue": [
		"OcDU",
		188
	],
	"./commodityshpMat/commodityodr/order_list.vue": [
		"AQ+M",
		187
	],
	"./currencyApp/appUninstall/index.vue": [
		"0Xm0",
		98
	],
	"./currencyApp/generalApp/components/cancelPushOrPush.vue": [
		"8dzj",
		186
	],
	"./currencyApp/generalApp/index.vue": [
		"T9Ic",
		97
	],
	"./customerFeedback/feedback.vue": [
		"m89j",
		65
	],
	"./demandMat/demandOdr/demandOdr_list.vue": [
		"p2qI",
		128
	],
	"./description/description.vue": [
		"l6je",
		185
	],
	"./distribution/list/index.vue": [
		"lhaN",
		207
	],
	"./distribution/list/list.vue": [
		"yZ6R",
		184
	],
	"./distribution/list/list_detail.vue": [
		"Mc+F",
		183
	],
	"./distribution/record/index.vue": [
		"1TN+",
		206
	],
	"./distribution/record/record.vue": [
		"66Pc",
		182
	],
	"./distribution/record/record_detail.vue": [
		"vKTs",
		181
	],
	"./distribution/wait/index.vue": [
		"BRGn",
		205
	],
	"./distribution/wait/wait.vue": [
		"wXyI",
		180
	],
	"./distribution/wait/wait_detail.vue": [
		"4voX",
		179
	],
	"./employeeMat/employlow/index.vue": [
		"Urnd",
		204
	],
	"./employeeMat/employlow/role_detail.vue": [
		"ZEnE",
		178
	],
	"./employeeMat/employlow/role_list.vue": [
		"T9yZ",
		177
	],
	"./employeeMat/staff_list.vue": [
		"zU9J",
		176
	],
	"./financeMat/financial_set/demand_set.vue": [
		"sMl5",
		175
	],
	"./financeMat/financial_set/index.vue": [
		"+Zg9",
		203
	],
	"./financeMat/financial_set/shopping_detail.vue": [
		"HMgW",
		87
	],
	"./financeMat/financial_set/shopping_set.vue": [
		"JUyZ",
		86
	],
	"./financeMat/order_flow/demand_water.vue": [
		"aU3a",
		174
	],
	"./financeMat/order_flow/index.vue": [
		"+Dpe",
		202
	],
	"./financeMat/order_flow/shopping.vue": [
		"vGad",
		127
	],
	"./financeMat/revenue_sts/demand_rve.vue": [
		"ZAQ7",
		126
	],
	"./financeMat/revenue_sts/index.vue": [
		"VMG6",
		201
	],
	"./financeMat/revenue_sts/revenue_detail.vue": [
		"gmf/",
		173
	],
	"./financeMat/revenue_sts/shopping_rve.vue": [
		"Pty5",
		125
	],
	"./footbath/footbathMGR.vue": [
		"8axg",
		60
	],
	"./functionProp/functionProp.vue": [
		"2M58",
		85
	],
	"./gameManager/flowOrder.vue": [
		"7BH/",
		172
	],
	"./goodsMgr/goodsClassification.vue": [
		"eP4m",
		84
	],
	"./goodsMgr/goodsLists.vue": [
		"njTK",
		83
	],
	"./goodsMgr/goodsOffShelf.vue": [
		"xPDH",
		82
	],
	"./goodsMgr/goodsOnShelf.vue": [
		"swTO",
		81
	],
	"./goodsMgr/goodsSalesData.vue": [
		"tCWX",
		80
	],
	"./homepage/homepage.vue": [
		"aqd6",
		110
	],
	"./hotel/hotelMGR.vue": [
		"Xrc5",
		61
	],
	"./interfaceSetting/feedback.vue": [
		"NOer",
		69
	],
	"./interfaceSetting/hotelIntroduction/components/BackgroundMusic/index.vue": [
		"xejL",
		35
	],
	"./interfaceSetting/hotelIntroduction/components/addDialog/index.vue": [
		"sn96",
		45
	],
	"./interfaceSetting/hotelIntroduction/components/editDialog/index.vue": [
		"zKI/",
		44
	],
	"./interfaceSetting/hotelIntroduction/components/editVideoDialog/index.vue": [
		"wx1K",
		21
	],
	"./interfaceSetting/hotelIntroduction/components/projectionDisplay/index.vue": [
		"ffC8",
		109
	],
	"./interfaceSetting/hotelIntroduction/index.vue": [
		"U/HZ",
		8
	],
	"./interfaceSetting/index.vue": [
		"w0aM",
		200
	],
	"./interfaceSetting/interfaceDetail.vue": [
		"A4QG",
		171
	],
	"./interfaceSetting/interfaceEight/components/InfoImagePanel.vue": [
		"NDhL",
		170
	],
	"./interfaceSetting/interfaceEight/components/appPanel.vue": [
		"n0UK",
		124
	],
	"./interfaceSetting/interfaceEight/components/disabledModuleItem.vue": [
		"O9jm",
		169
	],
	"./interfaceSetting/interfaceEight/components/editApplication.vue": [
		"a34V",
		168
	],
	"./interfaceSetting/interfaceEight/components/editCastScreen.vue": [
		"wlSc",
		123
	],
	"./interfaceSetting/interfaceEight/components/editChildModule.vue": [
		"mYHW",
		167
	],
	"./interfaceSetting/interfaceEight/components/editHome.vue": [
		"qYEm",
		166
	],
	"./interfaceSetting/interfaceEight/components/editHomeCarousel.vue": [
		"i3nD",
		67
	],
	"./interfaceSetting/interfaceEight/components/editHomeImage.vue": [
		"xbWE",
		165
	],
	"./interfaceSetting/interfaceEight/components/editHomeVideo.vue": [
		"6oPE",
		164
	],
	"./interfaceSetting/interfaceEight/components/editHotelFootBath.vue": [
		"v5lV",
		163
	],
	"./interfaceSetting/interfaceEight/components/editLogo.vue": [
		"panQ",
		162
	],
	"./interfaceSetting/interfaceEight/components/editModule.vue": [
		"xRW4",
		161
	],
	"./interfaceSetting/interfaceEight/components/editMovie.vue": [
		"D4vD",
		160
	],
	"./interfaceSetting/interfaceEight/components/homePanel.vue": [
		"CWGy",
		51
	],
	"./interfaceSetting/interfaceEight/components/mgrPanel.vue": [
		"qag5",
		96
	],
	"./interfaceSetting/interfaceEight/components/moviePanel.vue": [
		"isXr",
		159
	],
	"./interfaceSetting/interfaceEight/hotelIntroduction/components/BackgroundMusic/index.vue": [
		"VX+I",
		34
	],
	"./interfaceSetting/interfaceEight/hotelIntroduction/components/addDialog/index.vue": [
		"hMV4",
		43
	],
	"./interfaceSetting/interfaceEight/hotelIntroduction/components/editDialog/index.vue": [
		"ssKU",
		42
	],
	"./interfaceSetting/interfaceEight/hotelIntroduction/components/editVideoDialog/index.vue": [
		"pwyh",
		20
	],
	"./interfaceSetting/interfaceEight/hotelIntroduction/components/projectionDisplay/index.vue": [
		"2OF8",
		108
	],
	"./interfaceSetting/interfaceEight/hotelIntroduction/index.vue": [
		"mWt7",
		7
	],
	"./interfaceSetting/interfaceEight/index.vue": [
		"q8tf",
		1
	],
	"./interfaceSetting/interfaceEight/technicianService/components/BackgroundMusic/index.vue": [
		"gN83",
		33
	],
	"./interfaceSetting/interfaceEight/technicianService/components/addDialog/index.vue": [
		"pIRy",
		27
	],
	"./interfaceSetting/interfaceEight/technicianService/components/editDialog/index.vue": [
		"XBeY",
		26
	],
	"./interfaceSetting/interfaceEight/technicianService/components/editVideoDialog/index.vue": [
		"2kMO",
		19
	],
	"./interfaceSetting/interfaceEight/technicianService/components/projectionDisplay/index.vue": [
		"803E",
		107
	],
	"./interfaceSetting/interfaceEight/technicianService/index.vue": [
		"srly",
		4
	],
	"./interfaceSetting/interfaceSeven/components/DisableModule.vue": [
		"t0ZF",
		158
	],
	"./interfaceSetting/interfaceSeven/components/editModuleName.vue": [
		"qxte",
		49
	],
	"./interfaceSetting/interfaceSeven/components/liveOnTV.vue": [
		"bPOw",
		157
	],
	"./interfaceSetting/interfaceSeven/components/storesService.vue": [
		"YUdt",
		156
	],
	"./interfaceSetting/interfaceSeven/hotelIntroduction/components/BackgroundMusic/index.vue": [
		"fLSU",
		32
	],
	"./interfaceSetting/interfaceSeven/hotelIntroduction/components/addDialog/index.vue": [
		"T0UJ",
		41
	],
	"./interfaceSetting/interfaceSeven/hotelIntroduction/components/editDialog/index.vue": [
		"Ksja",
		40
	],
	"./interfaceSetting/interfaceSeven/hotelIntroduction/components/editVideoDialog/index.vue": [
		"FSSH",
		18
	],
	"./interfaceSetting/interfaceSeven/hotelIntroduction/components/projectionDisplay/index.vue": [
		"y5PD",
		106
	],
	"./interfaceSetting/interfaceSeven/hotelIntroduction/index.vue": [
		"X5XS",
		6
	],
	"./interfaceSetting/interfaceSeven/index.vue": [
		"OFCQ",
		10
	],
	"./interfaceSetting/interfaceSeven/technicianService/components/BackgroundMusic/index.vue": [
		"gMl6",
		31
	],
	"./interfaceSetting/interfaceSeven/technicianService/components/addDialog/index.vue": [
		"9kE8",
		25
	],
	"./interfaceSetting/interfaceSeven/technicianService/components/editDialog/index.vue": [
		"20JM",
		24
	],
	"./interfaceSetting/interfaceSeven/technicianService/components/editVideoDialog/index.vue": [
		"HHRv",
		17
	],
	"./interfaceSetting/interfaceSeven/technicianService/components/projectionDisplay/index.vue": [
		"jC0N",
		105
	],
	"./interfaceSetting/interfaceSeven/technicianService/index.vue": [
		"Z5ja",
		3
	],
	"./interfaceSetting/interfaceSix/components/DisableModule.vue": [
		"7WTU",
		155
	],
	"./interfaceSetting/interfaceSix/components/editModuleName.vue": [
		"UFuu",
		48
	],
	"./interfaceSetting/interfaceSix/components/liveOnTV.vue": [
		"fs+x",
		154
	],
	"./interfaceSetting/interfaceSix/components/storesService.vue": [
		"ZATp",
		153
	],
	"./interfaceSetting/interfaceSix/index.vue": [
		"YqS5",
		9
	],
	"./interfaceSetting/interfacechoice.vue": [
		"REhB",
		95
	],
	"./interfaceSetting/mainInterface.vue": [
		"OteW",
		59
	],
	"./interfaceSetting/meituanHotel/components/HWupload/index.vue": [
		"baX3",
		54
	],
	"./interfaceSetting/meituanHotel/components/cableTV/index.vue": [
		"IB9D",
		152
	],
	"./interfaceSetting/meituanHotel/components/dialogBox/editContentImage.vue": [
		"QkAl",
		39
	],
	"./interfaceSetting/meituanHotel/components/dialogBox/editHotelIntroduction.vue": [
		"92Kg",
		29
	],
	"./interfaceSetting/meituanHotel/components/dialogBox/editLogo.vue": [
		"I7AH",
		38
	],
	"./interfaceSetting/meituanHotel/components/dialogBox/editMeituanTakeout.vue": [
		"Kgvd",
		28
	],
	"./interfaceSetting/meituanHotel/components/dialogBox/editShowModule.vue": [
		"d2SL",
		37
	],
	"./interfaceSetting/meituanHotel/components/dialogBox/editTakeoutContentImage.vue": [
		"zYDB",
		36
	],
	"./interfaceSetting/meituanHotel/components/dialogBox/editWifiModule.vue": [
		"9JM5",
		104
	],
	"./interfaceSetting/meituanHotel/components/hotelIntroduction/index.vue": [
		"o+3w",
		103
	],
	"./interfaceSetting/meituanHotel/components/jiGuangTV/index.vue": [
		"buDa",
		151
	],
	"./interfaceSetting/meituanHotel/components/meituanMovieVideo/index.vue": [
		"Hrqf",
		122
	],
	"./interfaceSetting/meituanHotel/components/meituanTakeout/index.vue": [
		"YxE8",
		150
	],
	"./interfaceSetting/meituanHotel/components/movieGuide/index.vue": [
		"yKHC",
		149
	],
	"./interfaceSetting/meituanHotel/components/oneKeyScreen/index.vue": [
		"VbFJ",
		148
	],
	"./interfaceSetting/meituanHotel/components/sweetDream/index.vue": [
		"a0+s",
		147
	],
	"./interfaceSetting/meituanHotel/index.vue": [
		"RVTv",
		0
	],
	"./interfaceSetting/otherset.vue": [
		"FthE",
		62
	],
	"./interfaceSetting/technicianService/components/BackgroundMusic/index.vue": [
		"+Y+U",
		30
	],
	"./interfaceSetting/technicianService/components/addDialog/index.vue": [
		"TZIP",
		23
	],
	"./interfaceSetting/technicianService/components/editDialog/index.vue": [
		"MiX1",
		22
	],
	"./interfaceSetting/technicianService/components/editVideoDialog/index.vue": [
		"SdHF",
		16
	],
	"./interfaceSetting/technicianService/components/projectionDisplay/index.vue": [
		"0uTu",
		102
	],
	"./interfaceSetting/technicianService/index.vue": [
		"6nP9",
		2
	],
	"./layout/AppMain.vue": [
		"TAmc"
	],
	"./layout/Layout.vue": [
		"AkUR"
	],
	"./layout/Levelbar.vue": [
		"N2mp"
	],
	"./layout/Navbar.vue": [
		"kzJD"
	],
	"./layout/Sidebar.vue": [
		"DOpt"
	],
	"./layout/SidebarItem.vue": [
		"6o49"
	],
	"./layout/TabsView.vue": [
		"jSdT"
	],
	"./leaseManagement/index.vue": [
		"aGZ8",
		146
	],
	"./leaseManagement/lease/device/components/SearchBar.vue": [
		"ymxV",
		121
	],
	"./leaseManagement/lease/device/index.vue": [
		"Hv4B",
		76
	],
	"./leaseManagement/lease/disbuteRecords/components/SearchBar.vue": [
		"MGHX",
		120
	],
	"./leaseManagement/lease/disbuteRecords/index.vue": [
		"yEsb",
		75
	],
	"./leaseManagement/lease/payRecord/components/SearchBar.vue": [
		"Bjis",
		119
	],
	"./leaseManagement/lease/payRecord/index.vue": [
		"5bq4",
		56
	],
	"./leaseManagement/lease/roomRental/components/SearchBar.vue": [
		"6cKr",
		118
	],
	"./leaseManagement/lease/roomRental/index.vue": [
		"3mYT",
		74
	],
	"./leaseManagement/lease/useDetailList/components/SearchBar.vue": [
		"MTqQ",
		117
	],
	"./leaseManagement/lease/useDetailList/index.vue": [
		"yRqZ",
		73
	],
	"./leaseManagement/lease/useRecord/components/SearchBar.vue": [
		"ZKJU",
		116
	],
	"./leaseManagement/lease/useRecord/index.vue": [
		"64qb",
		72
	],
	"./leaseManagement/lease3/authorizationRecords.vue": [
		"4Zxt",
		145
	],
	"./leaseManagement/lease3/components/QnCarousel.vue": [
		"qvUs",
		144
	],
	"./leaseManagement/lease3/components/RoomCard.vue": [
		"U1RG",
		101
	],
	"./leaseManagement/lease3/components/waitDialog.vue": [
		"q+yx",
		143
	],
	"./leaseManagement/lease3/dataStatistics.vue": [
		"dR5J",
		142
	],
	"./leaseManagement/lease3/dataStatisticsDetails.vue": [
		"ya0s",
		141
	],
	"./leaseManagement/lease3/roomAuthorization.vue": [
		"TBTl",
		55
	],
	"./login/index.vue": [
		"T+/8",
		115
	],
	"./operationLog/staffList.vue": [
		"s6mG",
		94
	],
	"./operationLog/staffOpeList.vue": [
		"uIPG",
		93
	],
	"./orderManagement/index.vue": [
		"gC1k",
		199
	],
	"./orderManagement/order_detail.vue": [
		"bhgT",
		140
	],
	"./orderManagement/order_list.vue": [
		"GaF0",
		139
	],
	"./ordersMgt/goodsOrders.vue": [
		"zTbJ",
		79
	],
	"./ordersMgt/serviceOrders.vue": [
		"jCra",
		78
	],
	"./revenue/revenue_detail.vue": [
		"Ojs5",
		138
	],
	"./revenue/revenue_list.vue": [
		"4gZh",
		114
	],
	"./roomManagement/roomMgt.vue": [
		"e3XD",
		137
	],
	"./storeMat/employeeMat/index.vue": [
		"WSRf",
		198
	],
	"./storeMat/employeeMat/role_detail.vue": [
		"1bb2",
		136
	],
	"./storeMat/employeeMat/role_list.vue": [
		"etID",
		135
	],
	"./storeMat/employeeMat/staff_list.vue": [
		"lVhK",
		134
	],
	"./storeMat/functionMat/function_list.vue": [
		"bu3Q",
		77
	],
	"./storeMat/interfaceMat/InterfaceFour.vue": [
		"lwkO",
		57
	],
	"./storeMat/interfaceMat/InterfaceThree.vue": [
		"UP+M",
		13
	],
	"./storeMat/interfaceMat/Interfacedetail.vue": [
		"dNhD",
		14
	],
	"./storeMat/interfaceMat/Interfaceone.vue": [
		"qMqn",
		52
	],
	"./storeMat/interfaceMat/Interfacetnews.vue": [
		"KogJ",
		68
	],
	"./storeMat/interfaceMat/Interfacetwo.vue": [
		"cnub",
		50
	],
	"./storeMat/interfaceMat/Interfacetwosts.vue": [
		"HmoN",
		133
	],
	"./storeMat/interfaceMat/components/AlyUpload.vue": [
		"0/cL",
		53
	],
	"./storeMat/interfaceMat/consolepwd.vue": [
		"1QnT",
		132
	],
	"./storeMat/interfaceMat/examine.vue": [
		"JFHs",
		131
	],
	"./storeMat/interfaceMat/index.vue": [
		"Qjqe",
		197
	],
	"./storeMat/interfaceMat/interfaceFive/components/addBgData.vue": [
		"07CG",
		11
	],
	"./storeMat/interfaceMat/interfaceFive/components/addImageUpload.vue": [
		"lBm/",
		66
	],
	"./storeMat/interfaceMat/interfaceFive/components/addVideoUpload.vue": [
		"+c/k",
		71
	],
	"./storeMat/interfaceMat/interfaceFive/index.vue": [
		"bs64",
		5
	],
	"./storeMat/interfaceMat/newsrecord.vue": [
		"PpcQ",
		100
	],
	"./storeMat/interfaceMat/welcome.vue": [
		"sml2",
		12
	],
	"./storeMat/journalMat/journal_list.vue": [
		"0O1O",
		92
	],
	"./storeMat/opinionMat/opinion_list.vue": [
		"1cN2",
		64
	],
	"./storeMat/roomMat/room_list.vue": [
		"07PN",
		113
	],
	"./storeYb/payRecord/recordList.vue": [
		"GCII",
		130
	],
	"./storeYb/scavengingPayment/payment.vue": [
		"AS6K",
		112
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "Opzk";

/***/ }),

/***/ "PloX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-c",
  "use": "icon-c-usage",
  "viewBox": "0 0 1131 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1131 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-c\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 0h53.894737v970.105263H0zM269.473684 431.157895h53.894737v538.947368H269.473684zM538.947368 161.684211h53.894737v808.421052h-53.894737zM808.421053 646.736842h53.894736v323.368421h-53.894736zM1077.894737 323.368421h53.894737v646.736842h-53.894737z\" fill=\"\" p-id=\"8787\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "PvI4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_qnbar_platform_js__ = __webpack_require__("Ljt4");


//qnbar平台工具的基础配置
//var PT = require('./vendor/qnbar/platform.js');


var PT = new __WEBPACK_IMPORTED_MODULE_0__vendor_qnbar_platform_js__["a" /* default */].Platform();
PT.config.env = "test";
PT.config.hostBaseUrl = 'https://bz.qnbar.cn/';
PT.config.platformUsagespace = 'PT_MIX_BZ';
PT.config.apiBaseUrl = 'https://api2.qnbar.cn/';
PT.config.qnloginBaseUrl = "http://passport.t.qnbar.cn/";
PT.config.qnloginPlatformNo = 10;
PT.config.loginJumpBackUrl = encodeURIComponent(PT.config.hostBaseUrl);
PT.config.wsHost = "ws.qnbar.cn";
PT.config.wsPort = "16668";
PT.config.wsProto = "wss";
PT.init();

/* unused harmony default export */ var _unused_webpack_default_export = ({
    PT: PT
});

/***/ }),

/***/ "Q7M0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Icon_svg__ = __webpack_require__("xNsp");

 // svg组件

// register globally
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('icon-svg', __WEBPACK_IMPORTED_MODULE_1__components_Icon_svg__["a" /* default */]);

var requireAll = function requireAll(requireContext) {
  return requireContext.keys().map(requireContext);
};
var req = __webpack_require__("90Fk");
requireAll(req);

/***/ }),

/***/ "QjmH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-password",
  "use": "icon-password-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-password\">\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(50,50) scale(1.2) translate(-50,-50)\">\n    <circle cx=\"65\" cy=\"35\" r=\"20\" />\n    <line x1=\"51\" y1=\"49\" x2=\"20\" y2=\"80\" />\n    <line x1=\"38\" y1=\"62\" x2=\"45\" y2=\"69\" />\n    <line x1=\"28\" y1=\"72\" x2=\"35\" y2=\"79\" />\n  </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "SM0Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
});

/***/ }),

/***/ "SVqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-bug",
  "use": "icon-bug-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-bug\"><defs><style type=\"text/css\"></style></defs><path d=\"M969.142857 548.571429q0 14.848-10.861714 25.709714t-25.709714 10.861714l-128 0q0 97.718857-38.290286 165.705143l118.857143 119.442286q10.861714 10.861714 10.861714 25.709714t-10.861714 25.709714q-10.276571 10.861714-25.709714 10.861714t-25.709714-10.861714l-113.152-112.566857q-2.852571 2.852571-8.557714 7.424t-23.990857 16.274286-37.156571 20.845714-46.848 16.566857-55.442286 7.424l0-512-73.142857 0 0 512q-29.147429 0-58.002286-7.716571t-49.700571-18.870857-37.705143-22.272-24.868571-18.578286l-8.557714-8.009143-104.557714 118.272q-11.446857 11.995429-27.428571 11.995429-13.714286 0-24.576-9.142857-10.861714-10.276571-11.702857-25.417143t8.850286-26.587429l115.419429-129.718857q-33.133714-65.133714-33.133714-156.562286l-128 0q-14.848 0-25.709714-10.861714t-10.861714-25.709714 10.861714-25.709714 25.709714-10.861714l128 0 0-168.009143-98.852571-98.852571q-10.861714-10.861714-10.861714-25.709714t10.861714-25.709714 25.709714-10.861714 25.709714 10.861714l98.852571 98.852571 482.304 0 98.852571-98.852571q10.861714-10.861714 25.709714-10.861714t25.709714 10.861714 10.861714 25.709714-10.861714 25.709714l-98.852571 98.852571 0 168.009143 128 0q14.848 0 25.709714 10.861714t10.861714 25.709714zM694.857143 219.428571l-365.714286 0q0-75.995429 53.430857-129.426286t129.426286-53.430857 129.426286 53.430857 53.430857 129.426286z\" p-id=\"10315\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "SjE8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('draggable', {
    staticClass: "container",
    attrs: {
      "list": _vm.files,
      "options": _vm.drapConfig
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('transition-group', {
    class: [
      'el-upload-list',
      'el-upload-list--' + _vm.listType,
      {
        'is-disabled': _vm.disabled
      }
    ],
    attrs: {
      "tag": "ul",
      "name": "el-list"
    }
  }, _vm._l((_vm.files), function(file, index) {
    return _c('li', {
      key: index,
      class: ['el-upload-list__item', 'is-' + file.status]
    }, [(file.status !== 'uploading' && ['picture-card', 'picture'].indexOf(_vm.listType) > -1) ? _c(_vm.isVideo(file) ? 'video' : 'img', {
      tag: "component",
      staticClass: "el-upload-list__item-thumbnail mosaic-bg",
      attrs: {
        "src": file.url,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "el-upload-list__item-name",
      on: {
        "click": function($event) {
          _vm.handleClick(file)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-document"
    }), _vm._v(_vm._s(file.name) + "\n      ")]), _vm._v(" "), _c('label', {
      staticClass: "el-upload-list__item-status-label"
    }, [_c('i', {
      class: {
        'el-icon-upload-success': true,
        'el-icon-circle-check': _vm.listType === 'text',
          'el-icon-check': ['picture-card', 'picture'].indexOf(_vm.listType) > -1
      }
    })]), _vm._v(" "), (!_vm.disabled) ? _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          _vm.$emit('remove', file)
        }
      }
    }) : _vm._e(), _vm._v(" "), (file.status === 'uploading') ? _c('el-progress', {
      attrs: {
        "type": _vm.listType === 'picture-card' ? 'circle' : 'line',
        "stroke-width": _vm.listType === 'picture-card' ? 6 : 2,
        "percentage": _vm.parsePercentage(file.percentage)
      }
    }) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "disabled": !file.errMsg,
        "placement": "top"
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(file.errMsg)
      },
      slot: "content"
    }), _vm._v(" "), (_vm.listType === 'picture-card') ? _c('span', {
      staticClass: "el-upload-list__item-actions"
    }, [(_vm.handlePreview && _vm.listType === 'picture-card') ? _c('span', {
      staticClass: "el-upload-list__item-preview",
      on: {
        "click": function($event) {
          _vm.handlePreview(file)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-view"
    })]) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('span', {
      staticClass: "el-upload-list__item-delete",
      on: {
        "click": function($event) {
          _vm.$emit('remove', file)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete2"
    })]) : _vm._e()]) : _vm._e()])], 1)
  }))], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9f1a49f2", esExports)
  }
}

/***/ }),

/***/ "SpuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-upArrow",
  "use": "icon-upArrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-upArrow\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0L204.8 512h614.4L512 0zM409.6 1024h204.8V512H409.6v512z\" p-id=\"43181\" fill=\"#f4ea2a\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "TAmc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__ = __webpack_require__("vuLS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cb7825c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__ = __webpack_require__("rSKJ");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cb7825c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AppMain_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/AppMain.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AppMain.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3cb7825c", Component.options)
  } else {
    hotAPI.reload("data-v-3cb7825c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TIfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var TokenKey = 'Admin-Token';

function getToken() {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(TokenKey);
}

function setToken(token) {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(TokenKey, token);
}

function removeToken() {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(TokenKey);
}

/***/ }),

/***/ "TOAs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("9fML");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/QnUpload-1.0.0/upload/src/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a1990aa2", Component.options)
  } else {
    hotAPI.reload("data-v-a1990aa2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
    sidebar: function sidebar(state) {
        return state.app.sidebar;
    },
    visitedViews: function visitedViews(state) {
        return state.app.visitedViews;
    },
    navbarData: function navbarData(state) {
        return state.app.navbarData;
    },
    token: function token(state) {
        return state.user.token;
    },
    avatar: function avatar(state) {
        return state.user.avatar;
    },
    name: function name(state) {
        return state.user.name;
    },
    roles: function roles(state) {
        return state.user.roles;
    },
    addRouters: function addRouters(state) {
        return state.route_processe.addRouters;
    },
    getHotelOrFootbath: function getHotelOrFootbath(state) {
        return state.app.hotelOrFootbathData;
    },
    getUserInfoOrigin: function getUserInfoOrigin(state) {
        return state.user.userInfo;
    },
    getUserTitle: function getUserTitle(state) {
        return state.user.userTitle;
    },
    order_router: function order_router(state) {
        return state.route_processe.order_route;
    },
    revenue_router: function revenue_router(state) {
        return state.route_processe.revenue_route;
    },
    list_router: function list_router(state) {
        return state.route_processe.list_route;
    },
    record_router: function record_router(state) {
        return state.route_processe.record_route;
    },
    wait_router: function wait_router(state) {
        return state.route_processe.wait_route;
    },
    isOrder: function isOrder(state) {
        return state.app.isOrder;
    },
    waitOrder: function waitOrder(state) {
        return state.app.waitOrder;
    },
    the_agent_id: function the_agent_id(state) {
        return state.user.userInfo.agent_id;
    },
    authUpload: function authUpload(state) {
        return state.user.auth.upload;
    },
    authEdit: function authEdit(state) {
        return state.user.auth.edit;
    },
    authMessage: function authMessage(state) {
        return state.user.auth.message;
    },
    examineRemind: function examineRemind(state) {
        return state.app.examineRemind;
    },
    whiteListType: function whiteListType(state) {
        return state.app.whiteListType;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "V8LJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pack__ = __webpack_require__("xPWx");



// node websocket module
// var WebSocket = require('ws');
// proto定义和接口
var proto = __webpack_require__("0Gq2");
// 发包解包工具


var MSG_WS_CMD_HEART_BEAT = 1; // 心跳处理
var MSG_WS_CMD_COMM_MSG = 2; // 通用消息收发
var MSG_WS_CMD_BIND = 3; // 绑定信息
var MSG_WS_CMD_AUTH_KEY = 4; // key 方式 鉴权


// ----------- File 4 client lib ----------- 
var MsgWsClient = {
    ws: null,
    hasInit: false,
    hbIntervalId: 0,
    sendWaitQueue: new Array(),

    conf: {
        proto: "ws",
        host: "",
        port: "",
        path: "",
        authSys: "",
        authKey: "",
        toBindMap: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(),
        onOpen: null,
        onMessage: null,
        onClose: null,
        onError: null,
        onSendSuccess: null,
        onSendFail: null,
        bzMsgDealerMap: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(),
        debug: false
    },

    init: function init(confData) {
        this.conf = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.conf, confData);
        this.hasInit = true;
    },

    startRun: function startRun() {
        if (!this.hasInit) {
            console.log("not init error");
            return;
        }
        var connAddr = this.conf.proto + "://" + this.conf.host + ":" + this.conf.port + this.conf.path;
        console.log("wsaddr:" + connAddr);
        this.ws = new WebSocket(connAddr);

        var that = this;

        this.ws.onopen = function () {
            that.ws.binaryType = 'arraybuffer'; // must

            if (that.conf.onOpen) {
                that.conf.onOpen();
            }

            // send auth
            that.sendAuth();
            // send all bind
            that.sendBinds();

            // send waiting queue
            if (that.sendWaitQueue.length > 0) {
                // just wait auth and binds...
                setTimeout(function () {
                    var copyWaitQueue = that.sendWaitQueue.slice();
                    that.sendWaitQueue = new Array();
                    for (var i = 0; i < copyWaitQueue.length; i++) {
                        that.sendBytes(copyWaitQueue[i]);
                    }
                }, 1000);
            }

            //start heart beat
            if (that.hbIntervalId) {
                clearInterval(that.hbIntervalId);
            }
            that.hbIntervalId = setInterval(function () {
                that.sendHeartBeat();
            }, 5000);
            console.log("ws has closed, wait for reconnect...");
        };

        this.ws.onmessage = function (evt) {
            if (that.conf.onMessage) {
                that.conf.onMessage();
            }
            var packet = __WEBPACK_IMPORTED_MODULE_3__pack__["a" /* default */].MsgSvrPacker.unpack(evt.data);
            if (packet.H_Cmd == MSG_WS_CMD_COMM_MSG && packet.H_Version == 1) {
                var msg = proto.Msg.deserializeBinary(packet.PayloadBody);
                if (that.conf.bzMsgDealerMap && that.conf.bzMsgDealerMap.has(msg.getBzid())) {
                    that.conf.bzMsgDealerMap.get(msg.getBzid())(msg);
                }
            }
        };

        this.ws.onclose = function () {
            if (that.conf.onClose) {
                that.conf.onClose();
            }
            setTimeout(function () {
                that.startRun();
            }, 2000);
        };

        this.ws.onerror = function (event) {
            console.log("WS connect Error");
            if (that.conf.onError) {
                that.conf.onError();
            }
        };
    },

    sendBytes: function sendBytes(uint8ArrBuf) {
        var needSaveFail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (this.ws.readyState == WebSocket.OPEN) {
            this.ws.send(uint8ArrBuf);
            if (this.conf.onSendSuccess) {
                this.conf.onSendSuccess();
            }
        } else {
            if (needSaveFail) {
                this.sendWaitQueue.push(uint8ArrBuf);
            } else {
                console.log(this.ws.readyState);
                console.log("send fail.ws state not open");
            }

            if (this.conf.onSendFail) {
                this.conf.onSendFail();
            }
        }
    },

    sendAuth: function sendAuth(key) {
        var authKey = key;
        if (!authKey) {
            authKey = this.conf.authKey;
        }
        if (!authKey) {
            return;
        }
        var authKeyReq = new proto.AuthKeyReq();
        authKeyReq.setKey(authKey);
        this.sendBytes(__WEBPACK_IMPORTED_MODULE_3__pack__["a" /* default */].MsgSvrPacker.pack(1, MSG_WS_CMD_AUTH_KEY, authKeyReq.serializeBinary()));
    },

    sendBinds: function sendBinds(bindMap) {
        var toBind = bindMap;
        if (!toBind || toBind.length == 0) {
            toBind = this.conf.toBindMap;
        }
        if (!toBind || toBind.length == 0) {
            return;
        }

        // 处理所有的绑定请求
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(toBind.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var bzIdKey = _step.value;

                // 补充bind
                if (!this.conf.toBindMap.has(bzIdKey)) {
                    this.conf.toBindMap.set(bzIdKey, snAtGroup);
                }

                var bindEndPoint = this.makeFromEndPointByBindKey(bzIdKey);
                if (!bindEndPoint) {
                    continue;
                }

                var bindReq = new proto.BindReq();
                bindReq.setTobindbzid(bzIdKey);
                bindReq.setOp("bind");
                bindReq.setBindendpoint(bindEndPoint);
                //console.log(bindReq.serializeBinary());
                this.sendBytes(__WEBPACK_IMPORTED_MODULE_3__pack__["a" /* default */].MsgSvrPacker.pack(1, MSG_WS_CMD_BIND, bindReq.serializeBinary()));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    },

    sendHeartBeat: function sendHeartBeat() {
        var hbReq = this.sendBytes(__WEBPACK_IMPORTED_MODULE_3__pack__["a" /* default */].MsgSvrPacker.pack(1, MSG_WS_CMD_HEART_BEAT, null));
    },

    sendMsg: function sendMsg(bzId, op, bzDataStr, sendToStr) {
        if (!bzId || !op) {
            return;
        }

        // get group and sn to make endpoint
        var endPointFrom = this.makeFromEndPointByBindKey(bzId);
        var msg = new proto.Msg();
        msg.setBzid(bzId);
        msg.setOp(op);
        if (endPointFrom) {
            msg.setFrom(endPointFrom);
        }
        if (bzDataStr) {
            msg.setBzdata(bzDataStr);
        }
        if (sendToStr) {
            var toEndPoint = this.getEndPointObjByStr(sendToStr);
            if (toEndPoint) {
                msg.setTo(toEndPoint);
            }
        }
        this.sendBytes(__WEBPACK_IMPORTED_MODULE_3__pack__["a" /* default */].MsgSvrPacker.pack(1, MSG_WS_CMD_COMM_MSG, msg.serializeBinary()), true);
    },

    getEndPointObjByStr: function getEndPointObjByStr(str) {
        var rows = str.split("@");
        if (rows.length != 2 || !rows[0] || !rows[1]) {
            return null;
        }

        var endPoint = new proto.MsgEndPoint();
        endPoint.setGroup(rows[1]);
        endPoint.setSn(rows[0]);

        return endPoint;
    },

    makeFromEndPointByBindKey: function makeFromEndPointByBindKey(bzId) {
        if (!this.conf.toBindMap.has(bzId)) {
            return null;
        }

        var snAtGroup = this.conf.toBindMap.get(bzId);
        return this.getEndPointObjByStr(snAtGroup);
    }

    // module.exports.MsgWsClient = MsgWsClient;
};/* harmony default export */ __webpack_exports__["a"] = ({
    MsgWsClient: MsgWsClient
});

/***/ }),

/***/ "VQSA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-feedback",
  "use": "icon-feedback-usage",
  "viewBox": "0 0 1148 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1148 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-feedback\"><defs><style type=\"text/css\"></style></defs><path d=\"M828.192044 76.069386a46.605891 46.605891 0 0 1 46.605891 46.605891v281.778147l-316.06294 179.995166L267.84995 410.881823V122.139577a46.605891 46.605891 0 0 1 46.605891-46.605891h511.593404m0-75.533686H316.59864a121.603877 121.603877 0 0 0-121.603877 122.139577v331.062538l325.169839 196.066163a74.462286 74.462286 0 0 0 74.997986 0l354.633333-201.958862V122.139577A121.603877 121.603877 0 0 0 828.192044 0.5357z\" fill=\"#bfcbd9\" p-id=\"3166\" /><path d=\"M1071.399798 380.882628v538.378399c0 13.928197-19.820896 28.927795-46.605891 28.927795H121.603877c-26.784995 0-46.605891-15.535297-46.605891-28.927795v-535.699899l446.773716 267.849949a74.997986 74.997986 0 0 0 76.069386 0L1071.399798 380.882628m75.533686-129.639375l-586.591389 334.276737L0 251.243253v668.017774a114.104079 114.104079 0 0 0 121.603877 104.46148H1023.186808a114.104079 114.104079 0 0 0 121.603877-104.46148V251.243253z\" fill=\"#bfcbd9\" p-id=\"3167\" /><path d=\"M360.526032 181.066566h385.168228\" fill=\"#bfcbd9\" p-id=\"3168\" /><path d=\"M745.69426 218.565559H360.526032a37.498993 37.498993 0 1 1 0-75.533686h385.168228a37.498993 37.498993 0 0 1 0 75.533686z\" fill=\"#bfcbd9\" p-id=\"3169\" /><path d=\"M360.526032 291.420745h234.100856\" fill=\"#bfcbd9\" p-id=\"3170\" /><path d=\"M594.626888 328.919738H360.526032a37.498993 37.498993 0 1 1 0-75.533686h234.100856a37.498993 37.498993 0 0 1 0 75.533686z\" fill=\"#bfcbd9\" p-id=\"3171\" /><path d=\"M1026.936707 146.781772H910.689829v74.997986h115.711178a43.391692 43.391692 0 0 1 43.391692 43.391692v642.839879a43.391692 43.391692 0 0 1-43.391692 43.391692h-910.689829a43.391692 43.391692 0 0 1-43.391692-43.391692v-642.839879a43.391692 43.391692 0 0 1 43.391692-43.391692h116.246878v-74.997986H118.389678A118.389678 118.389678 0 0 0 0 265.17145v642.839879a118.389678 118.389678 0 0 0 118.389678 115.711178h910.689828a118.389678 118.389678 0 0 0 118.389678-118.389677v-642.839879a118.389678 118.389678 0 0 0-120.532477-115.711179z\" fill=\"#bfcbd9\" p-id=\"3172\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Vo7i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_auth__ = __webpack_require__("TIfe");






// 创建axios实例
var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    baseURL: "https://easy-mock.com/mock/5950a2419adc231f356a6636/vue-admin", // api的base_url
    timeout: 15000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(function (config) {
    if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.token) {
        config.headers['X-Token'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_auth__["a" /* getToken */])(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
}, function (error) {
    // Do something with request error
    console.log(error); // for debug
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// respone拦截器
service.interceptors.response.use(function (response) {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    var res = response.data;
    if (res.code !== 20000) {
        if (res.data) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({
                message: res.data,
                type: 'error',
                duration: 5 * 1000
            });
        }

        // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
        if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
            __WEBPACK_IMPORTED_MODULE_2_element_ui__["MessageBox"].confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('FedLogOut').then(function () {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                });
            });
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('error');
    } else {
        return response.data;
    }
}, function (error) {
    console.log('err' + error); // for debug
    if (error.message) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        });
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svrapi__ = __webpack_require__("Mp/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__env__ = __webpack_require__("yZtZ");








var PT = __WEBPACK_IMPORTED_MODULE_6__env__["a" /* default */].PT;

var app = {
    state: {
        sidebar: {
            opened: !+__WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('sidebarStatus')
        },
        visitedViews: [],
        navbarData: {
            name: "mike",
            age: 24
        },
        isOrder: false,
        hotelOrFootbathData: '', //酒店足浴信息
        waitOrder: {}, //等待配送信息
        examineRemind: 0, //审核消息
        whiteListType: true //审核 白名单状态
    },
    mutations: {
        // 审核 通知
        SET_EXAMINE_REMIND: function SET_EXAMINE_REMIND(state, view) {
            state.examineRemind = view;
        },
        //审核 是否白名单
        SET_WHITE_LIST_TYPE: function SET_WHITE_LIST_TYPE(state, view) {
            state.whiteListType = view;
        },
        SET_HOTEL_OR_FOOTBATH: function SET_HOTEL_OR_FOOTBATH(state, view) {
            state.hotelOrFootbathData = view;
        },
        SET_WAIT_ORDER: function SET_WAIT_ORDER(state, view) {
            state.waitOrder = {
                total: view.total
            };
        },

        TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
            if (state.sidebar.opened) {
                __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('sidebarStatus', 1);
            } else {
                __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('sidebarStatus', 0);
            }
            state.sidebar.opened = !state.sidebar.opened;
        },
        ADD_VISITED_VIEWS: function ADD_VISITED_VIEWS(state, view) {
            if (state.visitedViews.some(function (v) {
                return v.path === view.path;
            })) return;
            state.visitedViews.push({ name: view.name, path: view.path });
        },
        DEL_VISITED_VIEWS: function DEL_VISITED_VIEWS(state, view) {
            var index = void 0;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.visitedViews.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref = _step.value;

                    var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                    var i = _ref2[0];
                    var v = _ref2[1];

                    if (v.path === view.path) {
                        index = i;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            state.visitedViews.splice(index, 1);
        },
        GET_NAVBAR_DATA: function GET_NAVBAR_DATA(state, view) {
            state.navbarData = view;
        },
        GET_ISORDER_DATA: function GET_ISORDER_DATA(state, view) {
            state.isOrder = view;
        }
    },
    actions: {
        //审核消息 提醒
        getExamineRemind: function getExamineRemind(_ref3) {
            var commit = _ref3.commit;

            var parame = {
                store_sn: JSON.parse(localStorage.getItem('user_data')).agent_id,
                search_begin_time: '',
                search_end_time: '',
                audit_status: 3,
                keyword: '',
                page: 1,
                page_size: 15
            };
            PT.apiClient.query("/bz-mix/interface/audit/list", parame, function (rsp) {
                console.log('审核消息', rsp);
                var num = rsp.data.total;

                commit('SET_EXAMINE_REMIND', num);
            });
        },

        //审核白名单状态
        getWhiteListType: function getWhiteListType(_ref4) {
            var commit = _ref4.commit;

            var user_type = JSON.parse(localStorage.getItem('identity')).user_type;
            console.log('user_type', user_type);
            if (user_type === 'official_staff') {
                console.log('审核白名单oss权限');
                return commit('SET_WHITE_LIST_TYPE', true);
            }
            var parame = {
                guid: JSON.parse(localStorage.getItem('identity')).guid
            };
            PT.apiClient.query("/bz-oss/interface/audit/whitelist/check", parame, function (rsp) {
                console.log('审核白名单', rsp);
                var type = rsp.data[0];
                commit('SET_WHITE_LIST_TYPE', type);
            });
        },
        ToggleSideBar: function ToggleSideBar(_ref5) {
            var commit = _ref5.commit;

            commit('TOGGLE_SIDEBAR');
        },
        addVisitedViews: function addVisitedViews(_ref6, view) {
            var commit = _ref6.commit;

            commit('ADD_VISITED_VIEWS', view);
        },
        delVisitedViews: function delVisitedViews(_ref7, view) {
            var commit = _ref7.commit,
                state = _ref7.state;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                commit('DEL_VISITED_VIEWS', view);
                resolve([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.visitedViews)));
            });
        },
        getNavbarData: function getNavbarData(_ref8, view) {
            var commit = _ref8.commit;

            commit('GET_NAVBAR_DATA', view);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (app);

/***/ }),

/***/ "WUGP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.qn-upload[data-v-7ec3b6ec] .el-upload-list__item.is-warning {\n  border-color: #F7BA2A;\n}\n.qn-upload[data-v-7ec3b6ec] .el-upload-list__item.is-fail {\n  border-color: #FF4949;\n}\n", ""]);

// exports


/***/ }),

/***/ "WcXo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_progress__ = __webpack_require__("ok+3");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_progress__["a" /* default */]);

/***/ }),

/***/ "X9fQ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("eYJT");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("8e2d20d2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0fae5d84\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0fae5d84\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "XNJ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-goods",
  "use": "icon-goods-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-goods\"><defs><style type=\"text/css\"></style></defs><path d=\"M917.064447 291.579533 768.692032 291.579533c1.551472-1.919168 3.085581-3.948645 4.600283-6.113965 28.344241-40.526208 42.8335-87.548376 40.797895-132.405225-1.037719-22.876809-6.294748-44.07958-15.622987-63.016936-10.050353-20.403033-24.30878-37.155663-42.380008-49.794186C738.017007 27.609677 717.389271 19.963647 694.776999 17.521533c-20.988282-2.268479-42.70787 0.068432-64.553088 6.940259-42.8335 13.475031-82.032939 43.215495-110.37718 83.740682-2.479904 3.545201-4.846435 7.143513-7.112871 10.78268-2.265415-3.639167-4.632967-7.23748-7.112871-10.78268-28.344241-40.526208-67.543681-70.265651-110.37718-83.740682-21.845218-6.872848-43.564806-9.208738-64.553088-6.940259-22.612272 2.442113-43.240008 10.088144-61.310215 22.726666C251.309276 52.886722 237.049828 69.640374 226.999475 90.043407c-9.32926 18.938378-14.585268 40.140128-15.622987 63.016936-2.035605 44.856848 12.453653 91.880038 40.797895 132.405225 1.514703 2.16532 3.048811 4.194797 4.600283 6.113965L101.424201 291.579533c-50.232357 0-91.099705 40.867348-91.099705 91.099705l0 57.56176c0 50.232357 40.867348 91.099705 91.099705 91.099705l4.393965 0 0 377.07922c0 50.233378 40.867348 91.099705 91.099705 91.099705l630.26946 0c50.232357 0 91.098684-40.867348 91.098684-91.099705L918.286015 531.325383c49.670599-0.657767 89.877117-41.260579 89.877117-91.084385l0-57.56176C1008.164153 332.446881 967.296804 291.579533 917.064447 291.579533zM574.250393 146.252864c18.408283-29.642412 46.952714-49.356015 75.897526-58.461594 10.020733-3.15197 19.782035-4.715699 29.024479-4.715699 14.586289 0 27.880536 3.89349 38.865449 11.575269 17.945599 12.551706 28.504598 34.363218 29.732293 61.41746 1.375795 30.311414-11.756053 68.283158-38.005449 91.273339-57.638364 50.482594-126.60993 47.122263-144.555529 34.570557C551.759665 272.508376 537.159076 205.978923 574.250393 146.252864zM277.69758 156.069321c1.227696-27.054242 11.786694-48.866775 29.732293-61.41746 10.984913-7.6828 24.27916-11.575269 38.865449-11.575269 9.242443 0 19.003746 1.562707 29.024479 4.715699 28.94379 9.1066 57.489243 28.819182 75.897526 58.461594 37.090295 59.726059 22.490728 126.25449 9.041232 135.660354-17.945599 12.551706-86.917165 15.912037-144.555529-34.570557C289.453633 224.352479 276.321785 186.380735 277.69758 156.069321zM76.715041 440.240998l0-57.56176c0-13.625173 11.085008-24.710181 24.710181-24.710181l375.392926 0 0 106.982122L101.424201 464.951179C87.800049 464.951179 76.715041 453.867193 76.715041 440.240998zM172.208711 908.419924 172.208711 531.340703l304.609437 0 0 401.789401-279.898235 0C183.293719 933.130105 172.208711 922.045097 172.208711 908.419924zM827.188352 933.130105 545.75703 933.130105l0-401.789401 306.140481 0 0 377.07922C851.897512 922.045097 840.813525 933.130105 827.188352 933.130105zM941.774628 440.240998c0 13.625173-11.086029 24.710181-24.710181 24.710181L545.75703 464.951179 545.75703 357.969057l371.307417 0c13.625173 0 24.710181 11.085008 24.710181 24.710181L941.774628 440.240998z\" p-id=\"2540\" fill=\"#bfcbd9\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "XSqF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("WUGP");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4ea6d354", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ec3b6ec\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ec3b6ec\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "XWx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        visitedViews: function visitedViews() {
            return this.$store.state.app.visitedViews.slice(-6);
        }
    },
    methods: {
        closeViewTabs: function closeViewTabs(view, $event) {
            var _this = this;

            this.$store.dispatch('delVisitedViews', view).then(function (views) {
                if (_this.isActive(view.path)) {
                    var latestView = views.slice(-1)[0];
                    if (latestView) {
                        _this.$router.push(latestView.path);
                    } else {
                        _this.$router.push('/');
                    }
                }
            });
            $event.preventDefault();
        },
        generateRoute: function generateRoute() {
            if (this.$route.name) {
                return this.$route;
            }
            return false;
        },
        addViewTabs: function addViewTabs() {
            var route = this.generateRoute();
            if (!route) {
                return false;
            }
            this.$store.dispatch('addVisitedViews', this.generateRoute());
        },
        isActive: function isActive(path) {
            return path === this.$route.path;
        }
    },
    watch: {
        $route: function $route() {
            this.addViewTabs();
        }
    }
});

/***/ }),

/***/ "YPbV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__("kzJD");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__("DOpt");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Levelbar__ = __webpack_require__("N2mp");
/* unused harmony reexport Levelbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppMain__ = __webpack_require__("TAmc");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__AppMain__["default"]; });








/***/ }),

/***/ "YVNI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("0Sc2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d850c2c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("1KL9");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("zuNs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d850c2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d850c2c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/QnUpload-1.0.0/cropper/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0d850c2c", Component.options)
  } else {
    hotAPI.reload("data-v-0d850c2c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export constantRouterMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__env_js__ = __webpack_require__("yZtZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svrapi_js__ = __webpack_require__("Mp/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_layout_Layout__ = __webpack_require__("AkUR");


var _import = __webpack_require__("A66B");




var PT = __WEBPACK_IMPORTED_MODULE_2__env_js__["a" /* default */].PT;
// in development env not use Lazy Loading,because Lazy Loading too many pages will cause webpack hot update too slow.so only in production use Lazy Loading

/* layout */


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/**
 * icon : the icon show in the sidebar
 * hidden : if `hidden:true` will not show in the sidebar
 * redirect : if `redirect:noredirect` will not redirct in the levelbar
 * noDropdown : if `noDropdown:true` will not has submenu in the sidebar
 * meta : `{ role: ['admin'] }`  will control the page role
 **/
var constantRouterMap = [{ path: '/login', component: _import('login/index'), hidden: true },
// { path: '/404', component: _import('404'), hidden: true },
// ，默认跳转地址

// 路径错误，默认跳转地址
{
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_4__views_layout_Layout__["default"],
  redirect: '/homepage/homepage',
  hidden: true
}, {
  path: '/homepage',
  component: __WEBPACK_IMPORTED_MODULE_4__views_layout_Layout__["default"],
  icon: 'shouye',
  noDropdown: true,
  hidden: true,
  children: [{ path: 'homepage', name: '首页', hidden: true, component: _import('homepage/homepage') }]
}, {
  path: '/commodityshpMat',
  component: __WEBPACK_IMPORTED_MODULE_4__views_layout_Layout__["default"],
  redirect: 'noredirect',
  name: '商品购物',
  icon: 'goods',
  hidden: true,
  children: [{
    path: '/commodityshpMat/commodityodr',
    component: _import('commodityshpMat/commodityodr/index'),
    name: '',
    noDropdown: true,
    children: [{
      path: 'order_list',
      component: _import('commodityshpMat/commodityodr/order_list'),
      name: '商品订单'
    }, {
      path: 'order_detail',
      component: _import('commodityshpMat/commodityodr/order_detail'),
      name: '商品订单 / 订单详情'
    }]
  }, {
    path: '/commodityshpMat/commoditydsn',
    component: _import('commodityshpMat/commoditydsn/index'),
    name: '商品配送',
    children: [{
      path: 'distribution_list',
      component: _import('commodityshpMat/commoditydsn/distribution_list'),
      name: '配送列表'
    }, {
      path: 'distribution_record',
      component: _import('commodityshpMat/commoditydsn/distribution_record'),
      name: '配送记录'
    }, {
      path: 'wait_distribution',
      component: _import('commodityshpMat/commoditydsn/wait_distribution'),
      name: '等待配送'
    }, {
      path: 'list_detail',
      component: _import('commodityshpMat/commoditydsn/list_detail'),
      name: '列表详情',
      hidden: true
    }, {
      path: 'record_detail',
      component: _import('commodityshpMat/commoditydsn/record_detail'),
      name: '记录详情',
      hidden: true
    }, {
      path: 'wait_detail',
      component: _import('commodityshpMat/commoditydsn/wait_detail'),
      name: '等待详情',
      hidden: true
    }]
  }, {
    path: '/commodityshpMat/commoditymat',
    component: _import('commodityshpMat/commoditymat/index'),
    name: '商品管理',
    children: [{
      path: 'commodity_list',
      component: _import('commodityshpMat/commoditymat/commodity_list'),
      name: '商品列表'
    }, {
      path: 'commodity_class',
      component: _import('commodityshpMat/commoditymat/Commodity_class'),
      name: '商品分类'
    }]
  }]
}, {
  path: '/demandMat',
  component: __WEBPACK_IMPORTED_MODULE_4__views_layout_Layout__["default"],
  redirect: 'noredirect',
  icon: 'demand',
  name: '点播付费',
  hidden: true,
  children: [{
    path: 'demandOdr/demandOdr_list',
    component: _import('demandMat/demandOdr/demandOdr_list'),
    name: '点播订单',
    noDropdown: true
  }]
}, {
  path: '/financeMat',
  component: __WEBPACK_IMPORTED_MODULE_4__views_layout_Layout__["default"],
  redirect: 'noredirect',
  name: '财务数据',
  icon: 'capital',
  hidden: true,
  children: [{
    path: '/financeMat/revenue_sts',
    component: _import('financeMat/revenue_sts/index'),
    name: '营收统计',
    children: [{
      path: 'shopping',
      component: _import('financeMat/revenue_sts/shopping_rve'),
      name: '购物营收'
    }, {
      path: 'demand_rve',
      component: _import('financeMat/revenue_sts/demand_rve'),
      name: '点播营收'
    }, {
      path: 'revenue_detail',
      component: _import('financeMat/revenue_sts/revenue_detail'),
      name: '详情',
      hidden: true
    }]
  }, {
    path: '/financeMat/financial_set',
    component: _import('financeMat/financial_set/index'),
    name: '财务结算',
    children: [{
      path: 'shopping_set',
      component: _import('financeMat/financial_set/shopping_set'),
      name: '购物结算'
    }, {
      path: 'demand_set',
      component: _import('financeMat/financial_set/demand_set'),
      name: '点播结算'
    }, {
      path: 'shopping_detail',
      component: _import('financeMat/financial_set/shopping_detail'),
      name: '购物结算 / 结算明细',
      hidden: true
    }]
  }]
}, {
  path: '/storeMat',
  component: __WEBPACK_IMPORTED_MODULE_4__views_layout_Layout__["default"],
  redirect: 'noredirect',
  name: '门店管理',
  icon: 'store',
  children: [{
    path: '/storeMat/interfaceMat',
    component: _import('storeMat/interfaceMat/index'),
    name: '界面设置',
    children: [{
      path: 'examine',
      component: _import('storeMat/interfaceMat/examine'),
      name: '内容审核',
      hidden: true
    }, {
      path: 'Interfaceone',
      component: _import('storeMat/interfaceMat/Interfaceone'),
      name: '界面一'
    }, {
      path: 'Interfacetwo',
      component: _import('storeMat/interfaceMat/Interfacetwo'),
      name: '界面二'
    }, {
      path: 'Interfacethree',
      component: _import('storeMat/interfaceMat/InterfaceThree'),
      name: '界面三'
    }, {
      path: 'Interfacefour',
      component: _import('storeMat/interfaceMat/InterfaceFour'),
      name: '界面四'
    }, {
      path: 'Interfacefive',
      component: _import('storeMat/interfaceMat/interfaceFive/index'),
      name: '界面五'
    }, {
      path: 'InterfaceSix',
      component: _import('interfaceSetting/interfaceSix/index'),
      name: '界面六'
    }, {
      path: 'InterfaceSeven',
      component: _import('interfaceSetting/interfaceSeven/index'),
      name: '界面七'
    }, {
      path: 'InterfaceEight',
      component: _import('interfaceSetting/interfaceEight/index'),
      name: '界面八'
    }, {
      path: 'interfaceEighthotelIntroduction',
      component: _import('interfaceSetting/interfaceEight/hotelIntroduction/index'),
      name: '界面八通用设置',
      hidden: true
    }, {
      path: 'interfaceEighttechnicianService',
      component: _import('interfaceSetting/interfaceEight/technicianService/index'),
      name: '界面八技师设置',
      hidden: true
    }, {
      path: 'interfaceSevenhotelIntroduction',
      component: _import('interfaceSetting/interfaceSeven/hotelIntroduction/index'),
      name: '模块设置-酒店',
      hidden: true
    }, {
      path: 'interfaceSeventechnicianService',
      component: _import('interfaceSetting/interfaceSeven/technicianService/index'),
      name: '模块设置-技师',
      hidden: true
    }, {
      path: 'hotelIntroduction',
      name: '模块设置-酒店',
      component: _import('interfaceSetting/hotelIntroduction/index'),
      meta: 'interface_settings_five',
      hidden: true
    }, {
      path: 'technicianService',
      name: '模块设置-足浴',
      component: _import('interfaceSetting/technicianService/index'),
      meta: 'interface_settings_five',
      hidden: true
    }, {
      path: 'Interfacetnews',
      component: _import('storeMat/interfaceMat/Interfacetnews'),
      name: '消息管理'
    }, {
      path: 'Interfacetwosts',
      component: _import('storeMat/interfaceMat/Interfacetwosts'),
      name: '界面统计'
    }, {
      path: 'consolepwd',
      component: _import('storeMat/interfaceMat/consolepwd'),
      name: '界面设置'
    }, {
      path: 'welcome',
      component: _import('storeMat/interfaceMat/welcome'),
      name: '欢迎页面'
    }, {
      path: 'Interfacedetail',
      component: _import('storeMat/interfaceMat/Interfacedetail'),
      name: '界面详情',
      hidden: true
    }, {
      path: 'newsrecord',
      component: _import('storeMat/interfaceMat/newsrecord'),
      name: '消息记录',
      hidden: true
    }, {
      path: 'meituanhotel',
      component: _import('interfaceSetting/meituanHotel/index'),
      name: '美团酒店'
    }]
  }, {
    path: '/storeMat/employeeMat',
    component: _import('storeMat/employeeMat/index'),
    name: '员工管理',
    hidden: true,
    children: [{
      path: 'staff_list',
      component: _import('storeMat/employeeMat/staff_list'),
      name: '员工列表'
    }, {
      path: 'role_list',
      component: _import('storeMat/employeeMat/role_list'),
      name: '角色列表'
    }, {
      path: 'role_detail',
      component: _import('storeMat/employeeMat/role_detail'),
      name: '角色列表 / 角色详情',
      hidden: true
    }]
  },
  // {
  //   path: 'opinionMat/opinion_list',
  //   component: _import('storeMat/opinionMat/opinion_list'),
  //   name: '意见反馈',
  //   noDropdown: true
  // },
  {
    path: 'roomMat/room_list',
    component: _import('storeMat/roomMat/room_list'),
    name: '房间管理',
    noDropdown: true
    // {
    //     path: 'journalMat/journal_list',
    //     component: _import('storeMat/journalMat/journal_list'),
    //     name: "操作日志",
    //     noDropdown: true,
    // },
    // {
    //     path: 'functionMat/function_list',
    //     component: _import('storeMat/functionMat/function_list'),
    //     name: "功能宣传",
    //     noDropdown: true,
    // },

  }]
}, {
  path: '/storeYb',
  component: __WEBPACK_IMPORTED_MODULE_4__views_layout_Layout__["default"],
  icon: 'capital',
  name: '技术服务费',
  children: [{
    path: 'scavengingPayment/payment',
    component: _import('storeYb/scavengingPayment/payment'),
    name: '扫码付费'
  }, {
    path: 'payRecord/recordList',
    component: _import('storeYb/payRecord/recordList'),
    name: '付费记录'
  }]
}, {
  path: '/leaseManagement',
  component: __WEBPACK_IMPORTED_MODULE_4__views_layout_Layout__["default"],
  name: '租赁管理',
  icon: 'lease',
  children: [{
    path: '/lease',
    component: _import('leaseManagement/index'),
    name: '租赁管理2',
    children: [{
      path: 'device',
      component: _import('leaseManagement/lease/device/index'),
      name: '租赁设备'
    }, {
      path: 'useRecord',
      component: _import('leaseManagement/lease/useRecord/index'),
      name: '使用详情'
    }, {
      path: 'useDetailList/:id',
      component: _import('leaseManagement/lease/useDetailList/index'),
      name: '使用详情 / 详情',
      hidden: true
    }, {
      path: 'payRecord',
      component: _import('leaseManagement/lease/payRecord/index'),
      name: '购买密钥'
    }, {
      path: 'disbuteRecords',
      component: _import('leaseManagement/lease/disbuteRecords/index'),
      name: '分发记录'
    }, {
      path: 'roomRental',
      component: _import('leaseManagement/lease/roomRental/index'),
      name: '房间租赁'
    }]
  }, {
    path: '/lease3',
    component: _import('leaseManagement/index'),
    name: '租赁管理3',
    children: [{
      path: 'roomAuthorization',
      component: _import('leaseManagement/lease3/roomAuthorization'),
      name: '客房授权'
    }, {
      path: 'authorizationRecords',
      component: _import('leaseManagement/lease3/authorizationRecords'),
      name: '授权记录'
    }, {
      path: 'dataStatistics',
      component: _import('leaseManagement/lease3/dataStatistics'),
      name: '数据统计'
    }, {
      path: 'dataStatisticsDetails',
      component: _import('leaseManagement/lease3/dataStatisticsDetails'),
      name: '数据统计 / 详情',
      hidden: true
    }]
  }]
}, {
  path: '/afterSalesManage',
  component: __WEBPACK_IMPORTED_MODULE_4__views_layout_Layout__["default"],
  icon: 'lease',
  meta: 'after_sales_manage',
  name: '售后管理',
  children: [{
    path: 'repairOrder',
    name: '维修工单',
    component: _import('afterSalesManage/repairOrder/index'),
    meta: 'repair_order'
  }, {
    path: 'repairOrderAdd',
    name: '维修工单 / 新增维修',
    component: _import('afterSalesManage/repairOrder/addMaintenance'),
    hidden: true
  }, {
    path: 'repairOrderDetail',
    name: '维修工单 / 工单详情',
    component: _import('afterSalesManage/repairOrder/detailOrder'),
    hidden: true
  }]
}, {
  path: '/gameManager',
  component: __WEBPACK_IMPORTED_MODULE_4__views_layout_Layout__["default"],
  name: '游戏管理',
  icon: 'lease',
  meta: 'after_sales_manage',
  children: [{
    path: 'flowOrder',
    component: _import('gameManager/flowOrder'),
    name: '订单管理',
    meta: 'repair_order'
  }]
}, {
  path: '/currencyApp',
  component: __WEBPACK_IMPORTED_MODULE_4__views_layout_Layout__["default"],
  icon: 'lease',
  // meta: 'currency_app',
  name: '更新管理',
  children: [{
    path: 'generalApp',
    name: '通用应用',
    component: _import('currencyApp/generalApp/index')
  }, {
    path: 'appUninstall',
    name: '应用卸载',
    component: _import('currencyApp/appUninstall/index')
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history', //后端支持可开
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: constantRouterMap
}));

/***/ }),

/***/ "a7fu":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("fUdn");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("10a3391c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-031e4c81\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-031e4c81\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "aacO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SidebarItem",
  props: {
    routes: {
      type: Array
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(["waitOrder", 'examineRemind']))
});

/***/ }),

/***/ "aat2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.mosaic-bg[data-v-9f1a49f2] {\n  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.251), rgba(0, 0, 0, 0.251)), linear-gradient(45deg, #eee 25%, transparent 0, transparent 75%, #eee 0, #eee), linear-gradient(45deg, #eee 25%, #fff 0, #fff 75%, #eee 0, #eee);\n  background-size: 12px 12px;\n  background-position: 0 0, 0 0, 6px 6px;\n}\n.container[data-v-9f1a49f2] {\n  display: inline;\n}\n", ""]);

// exports


/***/ }),

/***/ "afte":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_screenfull__ = __webpack_require__("I95x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_screenfull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_screenfull__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hamburger',
  props: {
    width: {
      type: Number,
      default: 22
    },
    height: {
      type: Number,
      default: 22
    },
    fill: {
      type: String,
      default: '#48576a'
    }
  },
  data: function data() {
    return {
      isFullscreen: false
    };
  },

  methods: {
    click: function click() {
      if (!__WEBPACK_IMPORTED_MODULE_0_screenfull___default.a.enabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        });
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_0_screenfull___default.a.toggle();
    }
  }
});

/***/ }),

/***/ "aret":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layout__ = __webpack_require__("YPbV");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'layout',
    components: {
        Navbar: __WEBPACK_IMPORTED_MODULE_0__views_layout__["a" /* Navbar */],
        Sidebar: __WEBPACK_IMPORTED_MODULE_0__views_layout__["b" /* Sidebar */],
        AppMain: __WEBPACK_IMPORTED_MODULE_0__views_layout__["c" /* AppMain */]
    },
    computed: {
        sidebar: function sidebar() {
            return this.$store.state.app.sidebar;
        }
    },
    methods: {
        toggleSidebar: function toggleSidebar() {
            if (!this.$store.state.app.sidebar.opened) {
                // 修改vuex中silder_bar的值
                this.$store.commit('TOGGLE_SIDEBAR');
            }
        }
    }
});

/***/ }),

/***/ "atwv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__upload_dragger_vue__ = __webpack_require__("JoLq");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    UploadDragger: __WEBPACK_IMPORTED_MODULE_0__upload_dragger_vue__["a" /* default */]
  },
  props: {
    type: String,
    data: {},
    action: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: 'file'
    },
    withCredentials: Boolean,
    accept: String,
    onStart: Function,
    onProgress: Function,
    onSuccess: Function,
    onError: Function,
    beforeUpload: Function,
    onPreview: {
      type: Function,
      default: function _default() {}
    },
    onRemove: {
      type: Function,
      default: function _default() {}
    },
    drag: Boolean,
    listType: String,
    disabled: Boolean
  },

  data: function data() {
    return {
      mouseover: false,
      domain: '',
      file: null,
      submitting: false
    };
  },


  methods: {
    isImage: function isImage(str) {
      return str.indexOf('image') !== -1;
    },
    handleClick: function handleClick() {
      if (!this.disabled) {
        this.$refs.input.click();
      }
    },
    handleChange: function handleChange(ev) {
      var file = ev.target.value;
      if (file) {
        this.uploadFiles(file);
      }
    },
    uploadFiles: function uploadFiles(file) {
      if (this.submitting) return;
      this.submitting = true;
      this.file = file;
      this.onStart(file);

      var formNode = this.getFormNode();
      var dataSpan = this.getFormDataNode();
      var data = this.data;
      if (typeof data === 'function') {
        data = data(file);
      }
      var inputs = [];
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          inputs.push('<input name="' + key + '" value="' + data[key] + '"/>');
        }
      }
      dataSpan.innerHTML = inputs.join('');
      formNode.submit();
      dataSpan.innerHTML = '';
    },
    getFormNode: function getFormNode() {
      return this.$refs.form;
    },
    getFormDataNode: function getFormDataNode() {
      return this.$refs.data;
    }
  },

  created: function created() {
    this.frameName = 'frame-' + Date.now();
  },
  mounted: function mounted() {
    var self = this;
    !this.$isServer && window.addEventListener('message', function (event) {
      if (!self.file) return;
      var targetOrigin = new URL(self.action).origin;
      if (event.origin !== targetOrigin) return;
      var response = event.data;
      if (response.result === 'success') {
        self.onSuccess(response, self.file);
      } else if (response.result === 'failed') {
        self.onError(response, self.file);
      }
      self.submitting = false;
      self.file = null;
    }, false);
  },
  render: function render(h) {
    var drag = this.drag,
        uploadFiles = this.uploadFiles,
        listType = this.listType,
        frameName = this.frameName,
        disabled = this.disabled;

    var oClass = { 'el-upload': true };
    oClass['el-upload--' + listType] = true;

    return h(
      'div',
      {
        'class': oClass,
        on: {
          'click': this.handleClick
        },
        nativeOn: {
          'drop': this.onDrop,
          'dragover': this.handleDragover,
          'dragleave': this.handleDragleave
        }
      },
      [h('iframe', {
        on: {
          'load': this.onload
        },

        ref: 'iframe',
        attrs: { name: frameName
        }
      }), h(
        'form',
        { ref: 'form', attrs: { action: this.action, target: frameName, enctype: 'multipart/form-data', method: 'POST' }
        },
        [h('input', {
          'class': 'el-upload__input',
          attrs: { type: 'file',

            name: 'file',

            accept: this.accept },
          ref: 'input', on: {
            'change': this.handleChange
          }
        }), h('input', {
          attrs: { type: 'hidden', name: 'documentDomain' },
          domProps: {
            'value': this.$isServer ? '' : document.domain
          }
        }), h('span', { ref: 'data' })]
      ), drag ? h(
        'upload-dragger',
        {
          on: {
            'file': uploadFiles
          },
          attrs: { disabled: disabled }
        },
        [this.$slots.default]
      ) : this.$slots.default]
    );
  }
});

/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_theme_js__ = __webpack_require__("qi15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_login__ = __webpack_require__("M9A7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth__ = __webpack_require__("TIfe");





var user = {
    state: {
        token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["a" /* getToken */])(),
        name: '',
        avatar: '',
        roles: [],

        userInfo: {
            agent_id: '',
            guid: '',
            merchant_guid: '',
            user_type: ''
        },
        userTitle: "",
        auth: {
            upload: false,
            edit: false,
            message: false
        }
    },

    mutations: {
        SET_AUTH: function SET_AUTH(state, view) {
            state.auth = view;
        },
        SET_USER_INFO: function SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo;
        },
        SET_USER_TITLE: function SET_USER_TITLE(state, userTitle) {
            state.userTitle = userTitle;
        },
        SET_TOKEN: function SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_NAME: function SET_NAME(state, name) {
            state.name = name;
        },
        SET_AVATAR: function SET_AVATAR(state, avatar) {
            state.avatar = avatar;
        },
        SET_ROLES: function SET_ROLES(state, roles) {
            state.roles = roles;
        }
    },

    actions: {
        setAuth: function setAuth(_ref) {
            var commit = _ref.commit,
                state = _ref.state;

            // const { user_type, guid } = state.userInfo
            // if (user_type === 'official_staff') {
            //     commit('SET_AUTH', {
            //         upload: true,
            //         edit: true,
            //         message: true
            //     })
            //     return Promise.resolve()
            // }
            // return getAuthList()
            //     .then((res) => {
            //         const upload = res.upload.includes(guid)
            //         const edit = res.edit.includes(guid)
            //         const message = res.message.includes(guid)
            //         commit('SET_AUTH', {
            //             upload,
            //             edit,
            //             message
            //         })
            //     })
            return commit('SET_AUTH', {
                upload: true,
                edit: true,
                message: true
            });
        },

        // 登录
        Login: function Login(_ref2, userInfo) {
            var commit = _ref2.commit;

            var username = userInfo.username.trim();
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_login__["a" /* login */])(username, userInfo.password).then(function (response) {
                    var data = response.data;
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["b" /* setToken */])(data.token);
                    commit('SET_TOKEN', data.token);
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            });
        },


        // 获取用户信息
        GetInfo: function GetInfo(_ref3) {
            var commit = _ref3.commit,
                state = _ref3.state;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_login__["b" /* getInfo */])(state.token).then(function (response) {
                    var data = response.data;
                    commit('SET_ROLES', data.role);
                    commit('SET_NAME', data.name);
                    commit('SET_AVATAR', data.avatar);
                    resolve(response);
                }).catch(function (error) {
                    reject(error);
                });
            });
        },


        // 登出
        LogOut: function LogOut(_ref4) {
            var commit = _ref4.commit,
                state = _ref4.state;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_login__["c" /* logout */])(state.token).then(function () {
                    commit('SET_TOKEN', '');
                    commit('SET_ROLES', []);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["c" /* removeToken */])();
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            });
        },


        // 前端 登出
        FedLogOut: function FedLogOut(_ref5) {
            var commit = _ref5.commit;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                commit('SET_TOKEN', '');
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["c" /* removeToken */])();
                resolve();
            });
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),

/***/ "cNBo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-wifi",
  "use": "icon-wifi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-wifi\">\r\n  <path d=\"M0 352.832l93.12 98.752c231.296-245.44 606.464-245.44 837.76 0L1024 352.832C741.44 53.056 283.008 53.056 0 352.832z m372.352 395.008L512 896l139.648-148.16c-76.8-81.92-202.048-81.92-279.296 0zM186.24 550.4l93.12 98.752c128.448-136.32 336.96-136.32 465.408 0L837.824 550.4c-179.648-190.592-471.488-190.592-651.648 0z\" fill=\"currentColor\" p-id=\"6469\" />\r\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "cUsY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return t; });
/* unused harmony export use */
/* unused harmony export i18n */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_zh_CN__ = __webpack_require__("t1l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__format__ = __webpack_require__("q16I");







var deepmerge = function () {

  function isMergeableObject(val) {
    var nonNullObject = val && (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === 'object';

    return nonNullObject && Object.prototype.toString.call(val) !== '[object RegExp]' && Object.prototype.toString.call(val) !== '[object Date]';
  }

  function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
  }

  function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return clone && isMergeableObject(value) ? deepmerge(emptyTarget(value), value, optionsArgument) : value;
  }

  function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function (e, i) {
      if (typeof destination[i] === 'undefined') {
        destination[i] = cloneIfNecessary(e, optionsArgument);
      } else if (isMergeableObject(e)) {
        destination[i] = deepmerge(target[i], e, optionsArgument);
      } else if (target.indexOf(e) === -1) {
        destination.push(cloneIfNecessary(e, optionsArgument));
      }
    });
    return destination;
  }

  function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(target).forEach(function (key) {
        destination[key] = cloneIfNecessary(target[key], optionsArgument);
      });
    }
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(source).forEach(function (key) {
      if (!isMergeableObject(source[key]) || !target[key]) {
        destination[key] = cloneIfNecessary(source[key], optionsArgument);
      } else {
        destination[key] = deepmerge(target[key], source[key], optionsArgument);
      }
    });
    return destination;
  }

  function deepmerge(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var arrayMerge = options.arrayMerge || defaultArrayMerge;

    if (array) {
      return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument);
    } else {
      return mergeObject(target, source, optionsArgument);
    }
  }

  return deepmerge;
}();

var format = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_vue__["default"]);
var lang = __WEBPACK_IMPORTED_MODULE_3__lang_zh_CN__["a" /* default */];
var merged = false;
var i18nHandler = function i18nHandler() {
  var vuei18n = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(this || __WEBPACK_IMPORTED_MODULE_4_vue__["default"]).$t;
  if (typeof vuei18n === 'function' && !!__WEBPACK_IMPORTED_MODULE_4_vue__["default"].locale) {
    if (!merged) {
      merged = true;
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].locale(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.lang, deepmerge(lang, __WEBPACK_IMPORTED_MODULE_4_vue__["default"].locale(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.lang) || {}, { clone: true }));
    }
    return vuei18n.apply(this, arguments);
  }
};

var t = function t(path, options) {
  var value = i18nHandler.apply(this, arguments);
  if (value !== null && value !== undefined) return value;

  var array = path.split('.');
  var current = lang;

  for (var i = 0, j = array.length; i < j; i++) {
    var property = array[i];
    value = current[property];
    if (i === j - 1) return format(value, options);
    if (!value) return '';
    current = value;
  }
  return '';
};

var use = function use(l) {
  lang = l || lang;
};

var i18n = function i18n(fn) {
  i18nHandler = fn || i18nHandler;
};

/* unused harmony default export */ var _unused_webpack_default_export = ({ use: use, t: t, i18n: i18n });

/***/ }),

/***/ "cd6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    staticClass: "svg-icon hamburger",
    class: {
      'is-active': _vm.isActive
    },
    attrs: {
      "t": "1492500959545",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1691",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "64",
      "height": "64"
    },
    on: {
      "click": _vm.toggleClick
    }
  }, [_c('path', {
    attrs: {
      "d": "M966.8023 568.849776 57.196677 568.849776c-31.397081 0-56.850799-25.452695-56.850799-56.850799l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 543.397081 998.200404 568.849776 966.8023 568.849776z",
      "p-id": "1692"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M966.8023 881.527125 57.196677 881.527125c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 856.07443 998.200404 881.527125 966.8023 881.527125z",
      "p-id": "1693"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M966.8023 256.17345 57.196677 256.17345c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.850799 56.850799-56.850799l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.850799l0 0C1023.653099 230.720755 998.200404 256.17345 966.8023 256.17345z",
      "p-id": "1694"
    }
  })])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ccf6f4e", esExports)
  }
}

/***/ }),

/***/ "cqz9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mediainfo_js__ = __webpack_require__("Fof0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mediainfo_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mediainfo_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__upload__ = __webpack_require__("iO5a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_HWupload__ = __webpack_require__("Jb2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__preview__ = __webpack_require__("Fp0J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cropper__ = __webpack_require__("YVNI");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var uploadModule = {
    PROJECTOR_PAGE: {
        platform: 'PT_MIX_BZ',
        base_module: 'PROJECTOR_PAGE',
        module: 'PROJECTOR_PAGE',
        func: 'page_img'
    },
    INTERFACE_VIDEO: {
        platform: 'PT_MIX_BZ',
        base_module: 'INTERFACE',
        module: 'HW',
        func: 'video'
    },
    INTERFACE_IMG: {
        platform: 'PT_MIX_BZ',
        base_module: 'INTERFACE',
        module: 'INTERFACE',
        func: 'img'
    }

    // 文件比特转化为带单位大小
};function bytesToSize(filesize) {
    if (!filesize) return '0 Bytes';
    var unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var index = 0;
    var srcsize = parseFloat(filesize);
    index = Math.floor(Math.log(srcsize) / Math.log(1024));
    var size = srcsize / Math.pow(1024, index);
    size = size.toFixed(2);
    return size + unitArr[index];
}

// 文件带单位大小转换为比特
function sizeToBytes(filesize) {
    if (!filesize) return 0;
    filesize = filesize.toLowerCase();
    var unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var index = 0;
    index = unitArr.findIndex(function (unit) {
        return filesize.includes(unit.toLowerCase());
    });
    var size = parseFloat(filesize);
    size = size * Math.pow(1024, index);
    return size;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'QnUpload',
    components: {
        ElUpload: __WEBPACK_IMPORTED_MODULE_3__upload__["a" /* default */],
        preview: __WEBPACK_IMPORTED_MODULE_6__preview__["a" /* default */],
        cropper: __WEBPACK_IMPORTED_MODULE_7__cropper__["a" /* default */]
    },
    model: {
        prop: 'fileList',
        event: 'change'
    },
    props: {
        type: {
            type: String,
            default: 'PROJECTOR_PAGE'
        },
        size: {
            type: [Number, String, Array],
            default: '2MB'
        },
        accept: {
            type: String,
            default: 'image/jpg,image/png,image/jpeg'
        },
        resolution: {
            type: [String, Array],
            default: ''
        },
        frameRate: {
            type: [Number, String, Array],
            default: ''
        },
        maxLength: {
            type: [Number, String],
            default: ''
        },
        edit: {
            type: Boolean,
            default: true
        },
        listType: {
            type: String,
            default: 'picture-card'
        },
        autoUpload: {
            type: Boolean,
            default: false
        },
        fileList: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        isCropper: {
            type: Boolean,
            default: true
        },
        // 严格模式，即上传的文件必须符合要求，否则不上传
        strict: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            action: 'cdnq001.up17.v1.wcsapi.com',
            headers: {},
            data: {},
            name: '',
            fileInfo: '',
            preview: {
                data: {},
                list: []
            },
            cropper: {
                resolution: '',
                data: {}
            },
            dialogs: {
                preview: false,
                cropper: false
            }
        };
    },

    computed: {
        tip: function tip() {
            var tip = '注：';
            tip += '\u683C\u5F0F' + this.accept.replaceAll(/(image\/|video\/)/g, '').replaceAll(',', ' | ') + '\uFF0C\u5927\u5C0F';
            if (typeof this.size === 'number') {
                tip += '<=' + bytesToSize(this.size);
            } else if (typeof this.size === 'string') {
                tip += '<=' + bytesToSize(sizeToBytes(this.size));
            } else if (this.size instanceof Array) {
                var _size = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(this.size, 2),
                    min = _size[0],
                    max = _size[1];

                tip += '=>' + bytesToSize(sizeToBytes(min)) + (max ? '且<=' + bytesToSize(sizeToBytes(max)) : '');
            }
            if (this.resolution) {
                tip += '\uFF0C\u5C3A\u5BF8';
                if (typeof this.resolution === 'string') {
                    tip += '' + this.resolution;
                } else if (this.resolution instanceof Array) {
                    tip += '' + this.resolution.join(' | ');
                }
            }
            if (this.frameRate) {
                tip += '\uFF0C\u5E27\u7387';
                if (typeof this.frameRate === 'number' || typeof this.frameRate === 'string') {
                    tip += '<=' + this.frameRate;
                } else if (this.frameRate instanceof Array) {
                    var _frameRate = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(this.frameRate, 2),
                        _min = _frameRate[0],
                        _max = _frameRate[1];

                    tip += '>=' + _min + (_max ? '且<=' + _max : '');
                }
            }
            if (this.maxLength) {
                tip += '\uFF0C\u6570\u91CF<=' + this.maxLength;
            }
            return tip;
        }
    },
    watch: {
        resolution: {
            handler: function handler(val) {
                if (typeof val === 'string') {
                    this.cropper.resolution = val;
                } else if (val instanceof Array) {
                    this.cropper.resolution = '';
                }
            },

            immediate: true
        }
    },
    methods: {
        submit: function submit() {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                // 有不符合要求的文件
                if (_this.strict && _this.fileList.some(function (file) {
                    return file.status === 'warning';
                })) {
                    _this.$message.warning('文件不符合要求，请检查文件格式');
                    reject();
                    // 文件全部上传成功
                } else if (_this.fileList.every(function (file) {
                    return file.status === 'success';
                })) {
                    resolve();
                    // 监听文件状态变化
                } else {
                    var cb = function cb(fileList) {
                        // 文件全部上传成功
                        if (fileList.every(function (file) {
                            return file.status === 'success';
                        })) {
                            _this.$off('change', cb); // 关闭监听
                            resolve();
                            // 有文件上传失败
                        } else if (fileList.every(function (file) {
                            return file.status !== 'uploading' || file.status !== 'ready';
                        }) && fileList.some(function (file) {
                            return file.status === 'fail';
                        })) {
                            _this.$message.error('文件上传失败，请重新提交');
                            _this.$off('change', cb); // 关闭监听
                            reject();
                        }
                    };
                    _this.$on('change', cb);
                    _this.$refs.upload.submit();
                }
            });
        },
        handleSuccess: function handleSuccess(res, file, fileList) {
            var i = fileList.findIndex(function (item) {
                return item === file;
            });
            var url = file.response.fileUrl;
            var newFile = {
                name: url.slice(url.lastIndexOf('/') + 1),
                url: url,
                info: file.info,
                status: file.status
            };
            fileList.splice(i, 1, newFile);
        },
        handleChange: function handleChange(file, fileList) {
            var _this2 = this;

            if (file.status === 'ready') {
                this.getFileInfo(file.raw).then(function (info) {
                    file.info = info;
                    var checkRes = _this2.checkFile(file.info);
                    if (!checkRes.status) {
                        file.status = 'warning';
                        file.errMsg = '<div class="error">' + checkRes.errMsg.join('<br>') + '</div>';
                    }
                    _this2.$emit('change', fileList);
                });
            } else {
                this.$emit('change', fileList);
            }
        },
        handlePreview: function handlePreview(file) {
            this.preview.data = file;
            this.preview.list = this.fileList;
            this.dialogs.preview = true;
        },
        handleRemove: function handleRemove(file, fileList) {
            this.$emit('change', fileList);
        },
        handleBeforeUpload: function handleBeforeUpload(file) {
            console.log('handleBeforeUpload', file);
            return true;
        },
        handleUpload: function handleUpload(options) {
            var _this3 = this;

            console.log('handleUpload', options);
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var params = uploadModule[_this3.type];
                var rawFile = options.file;
                var commonUpload = new __WEBPACK_IMPORTED_MODULE_4__utils_HWupload__["a" /* CommonUpload */](params.platform, params.module, params.func, _this3.getFileName(rawFile), rawFile, function () {}, params.base_module);
                // 上传完成
                commonUpload.onComplete = function (res) {
                    console.log('onComplete', res);
                    if (res.status === 200) {
                        resolve(res);
                    } else {
                        reject(res);
                    }
                };
                // 上传进度
                commonUpload.uploadProgress = function (res) {
                    var e = res.total;
                    options.onProgress(e);
                };
                // 上传
                commonUpload.putFile();
            });
        },
        handleCropper: function handleCropper(file) {
            var fileList = this.fileList;
            var i = fileList.findIndex(function (item) {
                return item.uid === file.uid;
            });
            fileList.splice(i, 1, file);
            this.handleChange(file, fileList);
        },
        handleToEdit: function handleToEdit(e) {
            this.cropper.data = {
                name: e.name,
                uid: e.uid,
                url: e.url
            };
            this.dialogs.cropper = true;
        },
        getFileName: function getFileName(rawFile) {
            console.log('getFileName', rawFile);
            var suffix = '' + rawFile.name.slice(rawFile.name.lastIndexOf('.'));
            var file = this.getFile(rawFile);
            return '' + file.uid + suffix;
        },
        getFile: function getFile(rawFile) {
            return this.$refs.upload.getFile(rawFile);
        },

        // 获取上传参数
        getParams: function getParams(config, file) {
            if (!this.uploadFile) return {};
            var key = config.dir + file.name;
            return {
                file: file,
                token: config.token,
                uploadUrl: 'https://' + config.request_url,
                handlers: {
                    Authorization: 'UpToken ' + config.token,
                    uploadBatch: file.id
                },
                extraConfig: {
                    bucket: config.bucket,
                    file_name_rule: config.file_name_rule,
                    max_size_mb: config.max_size_mb,
                    retryCount: 0,
                    key: key
                }
            };
        },

        // 文件检测
        checkFile: function checkFile(info) {
            var checkList = [this.checkType(info.type), this.checkSize(info.size), this.checkResolution(info.resolution)];
            if (info.framRate) checkList.push(this.checkFramRate(info.framRate));
            if (checkList.every(function (check) {
                return check === true;
            })) {
                return {
                    status: true
                };
            }
            return {
                status: false,
                errMsg: checkList.filter(function (check) {
                    return check instanceof Error;
                }).map(function (err) {
                    return err.message;
                })
            };
        },

        // 检测类型
        checkType: function checkType(type) {
            if (!this.accept) return true;
            if (this.accept.includes(type)) {
                return true;
            } else {
                return new Error('\u5F53\u524D\u7C7B\u578B\uFF1A<i>' + type + '</i>\uFF0C\u63A8\u8350\u7C7B\u578B\uFF1A<b>' + this.accept.replaceAll(',', '，') + '</b>');
            }
        },

        // 检测大小
        checkSize: function checkSize(size) {
            if (typeof this.size === 'number') {
                if (size <= this.size) {
                    return true;
                } else {
                    return new Error('\u5F53\u524D\u5927\u5C0F\uFF1A<i>' + bytesToSize(size) + '</i>\uFF0C\u63A8\u8350\u5927\u5C0F\uFF1A<b>&lt;=' + bytesToSize(this.size) + '</b>');
                }
            }
            if (typeof this.size === 'string') {
                if (size <= sizeToBytes(this.size)) {
                    return true;
                } else {
                    return new Error('\u5F53\u524D\u5927\u5C0F\uFF1A<i>' + bytesToSize(size) + '</i>\uFF0C\u63A8\u8350\u5927\u5C0F\uFF1A<b>&lt;=' + bytesToSize(sizeToBytes(this.size)) + '</b>');
                }
            }
            if (this.size instanceof Array) {
                var _size2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(this.size, 2),
                    min = _size2[0],
                    max = _size2[1];

                if ((min ? size >= sizeToBytes(min) : true) && (max ? size <= sizeToBytes(max) : true)) {
                    return true;
                } else {
                    return new Error('\u5F53\u524D\u5927\u5C0F\uFF1A<i>' + bytesToSize(size) + '</i>\uFF0C\u63A8\u8350\u5927\u5C0F\uFF1A<b>&gt;=' + bytesToSize(sizeToBytes(min)) + (max ? '且&lt;=' + bytesToSize(sizeToBytes(max)) : '') + '</b>');
                }
            }
        },

        // 检测分辨率
        checkResolution: function checkResolution(resolution) {
            if (!this.resolution) return true;
            if (typeof this.resolution === 'string') {
                if (resolution === this.resolution) {
                    return true;
                } else {
                    return new Error('\u5F53\u524D\u5206\u8FA8\u7387\uFF1A<i>' + resolution + '</i>\uFF0C\u63A8\u8350\u5206\u8FA8\u7387\uFF1A<b>' + this.resolution + '</b>');
                }
            }
            if (this.resolution instanceof Array) {
                if (this.resolution.includes(resolution)) {
                    return true;
                } else {
                    return new Error('\u5F53\u524D\u5206\u8FA8\u7387\uFF1A<i>' + resolution + '</i>\uFF0C\u63A8\u8350\u5206\u8FA8\u7387\uFF1A<b>' + this.resolution.join('，') + '</b>');
                }
            }
        },

        // 检测帧率
        checkFramRate: function checkFramRate(frameRate) {
            if (!this.frameRate) return true;
            frameRate = Number(frameRate);
            if (typeof this.frameRate === 'number' || typeof this.frameRate === 'string') {
                if (frameRate <= Number(this.frameRate)) {
                    return true;
                } else {
                    return new Error('\u5F53\u524D\u5E27\u7387\uFF1A<i>' + frameRate + '</i>\uFF0C\u63A8\u8350\u5E27\u7387\uFF1A<b>&lt;=' + this.frameRate + '</b>');
                }
            }
            if (this.frameRate instanceof Array) {
                var _frameRate2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(this.frameRate, 2),
                    min = _frameRate2[0],
                    max = _frameRate2[1];

                if ((min ? frameRate >= Number(min) : true) && (max ? frameRate <= Number(max) : true)) {
                    return true;
                } else {
                    return new Error('\u5F53\u524D\u5E27\u7387\uFF1A<i>' + frameRate + '</i>\uFF0C\u63A8\u8350\u5E27\u7387\uFF1A<b>&gt;=' + min + (max ? '且&lt;=' + max : '') + '</b>');
                }
            }
        },

        // 获取文件信息
        getFileInfo: function getFileInfo(file) {
            var getSize = function getSize() {
                return file.size;
            };
            var readChunk = function readChunk(chunkSize, offset) {
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        if (event.target.error) {
                            reject(event.target.error);
                        }
                        resolve(new Uint8Array(event.target.result));
                    };
                    reader.readAsArrayBuffer(file.slice(offset, offset + chunkSize));
                });
            };
            return __WEBPACK_IMPORTED_MODULE_2_mediainfo_js___default()().then(function (mediaInfo) {
                return mediaInfo.analyzeData(getSize, readChunk);
            }).then(function (res) {
                res = res && res.media && res.media.track;
                var type = res[1]['@type'];
                switch (type) {
                    case 'Image':
                        return {
                            type: res[1]['@type'].toLowerCase() + '/' + res[1].Format.toLowerCase(),
                            size: res[0].FileSize,
                            bitDepth: res[1].BitDepth,
                            resolution: res[1].Width + '*' + res[1].Height
                        };
                    case 'Video':
                        return {
                            type: file.type,
                            size: res[0].FileSize,
                            bitDepth: res[1].BitDepth,
                            resolution: res[1].Width + '*' + res[1].Height,
                            frameRate: res[1].FrameRate
                        };
                }
            }).then(function (info) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["g" /* calculateMd5ByChunkSize */])(file).then(function (res) {
                    console.log('calculateMd5ByChunkSize', res);
                    info.md5 = res;
                    return info;
                });
            });
        }
    }
});

/***/ }),

/***/ "dahE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("SM0Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ccf6f4e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("cd6s");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("eZw7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ccf6f4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ccf6f4e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Hamburger/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4ccf6f4e", Component.options)
  } else {
    hotAPI.reload("data-v-4ccf6f4e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dh+R":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.app-wrapper[data-v-5f289638] {\n  position: relative;\n  height: 100%;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.app-wrapper[data-v-5f289638]:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.app-wrapper.hideSidebar .sidebar-wrapper[data-v-5f289638] {\n    transform: translate(-140px, 0);\n}\n.app-wrapper.hideSidebar .sidebar-wrapper .sidebar-container[data-v-5f289638] {\n      transform: translate(132px, 0);\n}\n.app-wrapper.hideSidebar .main-container[data-v-5f289638] {\n    margin-left: 40px;\n}\n.app-wrapper .sidebar-wrapper[data-v-5f289638] {\n    width: 180px;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1001;\n    overflow: hidden;\n    transition: all .28s ease-out;\n}\n.app-wrapper .sidebar-container[data-v-5f289638] {\n    transition: all .28s ease-out;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: -17px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n}\n.app-wrapper .main-container[data-v-5f289638] {\n    min-height: 100%;\n    transition: all .28s ease-out;\n    margin-left: 180px;\n}\n", ""]);

// exports


/***/ }),

/***/ "dneg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_list_vue__ = __webpack_require__("tLL1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f1a49f2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_upload_list_vue__ = __webpack_require__("SjE8");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("FRhB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9f1a49f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f1a49f2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_upload_list_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/QnUpload-1.0.0/upload/src/upload-list.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] upload-list.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9f1a49f2", Component.options)
  } else {
    hotAPI.reload("data-v-9f1a49f2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eTcC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-function_prop",
  "use": "icon-function_prop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-function_prop\"><defs><style type=\"text/css\"></style></defs><path d=\"M230.076858 17.952314C104.697896 17.952314 2.585133 119.921459 2.585133 245.444039s102.112763 227.491725 227.491725 227.491725 227.491725-102.112763 227.491725-227.491725-101.969144-227.491725-227.491725-227.491725zM791.050771 564.13352c-125.378962 0-227.491725 102.112763-227.491725 227.491725s102.112763 227.491725 227.491725 227.491726c125.522581 0 227.491725-102.112763 227.491725-227.491726s-101.969144-227.491725-227.491725-227.491725z m0 368.955961c-77.984853 0-141.320617-63.479383-141.320617-141.320617s63.479383-141.320617 141.320617-141.320617c77.984853 0 141.320617 63.479383 141.320617 141.320617s-63.335764 141.320617-141.320617 141.320617zM414.483029 569.01655H45.670687c-23.840673 0-43.085554 19.244881-43.085554 43.085554V980.914446c0 23.840673 19.244881 43.085554 43.085554 43.085554h368.812342c23.840673 0 43.085554-19.244881 43.085554-43.085554V612.102104c0-23.840673-19.244881-43.085554-43.085554-43.085554z m-43.085554 368.812342H88.756241V655.187658h282.641234V937.828892zM775.970827 490.888079c11.058626 0 22.117251-4.164937 30.447125-12.63843l202.358486-202.358485c8.042637-8.042637 12.638429-19.101262 12.638429-30.447125s-4.595792-22.404488-12.638429-30.447125L806.417952 12.638429a43.085554 43.085554 0 0 0-60.894249 0L543.165217 214.996914a43.085554 43.085554 0 0 0 0 60.89425L745.523703 478.249649c8.473492 8.329874 19.532118 12.638429 30.447124 12.63843z m0-386.908275l141.464236 141.464235-141.464236 141.464236L634.506592 245.444039l141.464235-141.464235z\" p-id=\"1984\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "eYJT":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.el-menu[data-v-0fae5d84] {\n  min-height: 100%;\n}\n.logo-name[data-v-0fae5d84] {\n  height: 50px;\n  width: 100%;\n  line-height: 50px;\n  text-align: center;\n  color: #c4d0d9;\n}\n.logo-img[data-v-0fae5d84] {\n  height: 50px;\n  width: 100%;\n  line-height: 50px;\n  text-align: left;\n  color: #c4d0d9;\n}\n.logoImage[data-v-0fae5d84] {\n  height: 32px;\n  margin-left: 17px;\n  margin-top: 7px;\n}\n", ""]);

// exports


/***/ }),

/***/ "eZw7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5cV2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3d916afe", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4ccf6f4e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4ccf6f4e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "f2LE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-goodsMgr",
  "use": "icon-goodsMgr-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-goodsMgr\"><defs><style type=\"text/css\"></style></defs><path d=\"M992 64 845.3 64 776 320 32 320c-9.6 0-18.7 4.3-24.7 11.7s-8.5 17.2-6.6 26.6l64 320c3 15 16.1 25.7 31.4 25.7l575.9 0-17.3 64-529 0c-17.7 0-32 14.3-32 32s14.3 32 32 32L160 832l512 0 31.5 0 190.8-704L992 128c17.7 0 32-14.3 32-32S1009.7 64 992 64zM122.2 640 71 384l687.6 0-69.4 256L122.2 640z\" p-id=\"2936\" /><path d=\"M64 928c0 53 43 96 96 96s96-43 96-96-43-96-96-96S64 875 64 928zM160 896c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32S142.4 896 160 896z\" p-id=\"2937\" /><path d=\"M576 928c0 53 43 96 96 96s96-43 96-96-43-96-96-96S576 875 576 928zM672 896c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32S654.4 896 672 896z\" p-id=\"2938\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "fK1T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-lease",
  "use": "icon-lease-usage",
  "viewBox": "0 0 1280 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1280 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-lease\"><defs><style type=\"text/css\"></style></defs><path d=\"M546.181006 571.351955v-21.309497h64.643575V504.849162h-64.643575v-69.649162c21.738547-4.43352 42.905028-9.439106 63.070391-14.873743l-16.303911-43.763129c-48.339665 15.44581-103.115084 25.886034-165.184358 31.320671l9.439107 42.189944c21.738547-2.002235 42.475978-4.43352 62.64134-7.436871V504.849162h-73.939664v45.193296h69.077095c-17.305028 51.2-44.907263 97.394413-82.806704 138.726257l19.164245 49.197765c27.602235-35.32514 50.77095-74.511732 68.505028-117.84581V832.357542h46.337431V619.119553c12.299441 15.44581 27.173184 35.32514 43.906145 60.210056l25.6-39.758659c-23.168715-24.884916-46.33743-47.338547-69.506145-68.218995z\" fill=\"#cdcdcd\" p-id=\"1644\" /><path d=\"M832.786592 391.436872h-198.793296v379.280446h-42.905028v45.193297h279.597766v-45.193297h-38.042459V391.436872h0.143017z m-46.909497 379.280446H679.329609v-83.521787h106.547486v83.521787z m0-127.713966H679.329609v-82.949721h106.547486v82.949721z m0-127.284916H679.329609v-80.089386h106.547486v80.089386z\" fill=\"#cdcdcd\" p-id=\"1645\" /><path d=\"M1255.401117 45.193296h-171.620111C1075.62905 19.021229 1051.173184 0 1022.283799 0c-29.890503 0-54.918436 20.30838-62.212291 47.910615-3.289385-1.716201-7.007821-2.717318-11.01229-2.717319H778.011173c-13.300559 0-24.026816 10.726257-24.026815 24.026816s10.726257 24.026816 24.026815 24.026815h171.191062c4.576536 0 8.867039-1.287151 12.442458-3.575419 6.721788 19.307263 22.310615 34.467039 41.90391 40.473743-0.143017 0.858101-0.143017 1.859218-0.143016 2.717319v48.625698c0 1.001117 0.143017 1.859218 0.286033 2.860335-26.315084 8.151955-45.336313 32.607821-45.336313 61.497207h-72.509497c-4.290503 0-8.294972 2.145251-11.727374 5.72067-65.930726-43.763128-144.732961-69.363128-229.5419-69.363128-83.950838 0-162.181006 25.027933-227.682681 68.075978-3.289385-2.860335-6.864804-4.43352-10.726257-4.43352h-78.659218c0-27.745251-17.591061-51.343017-42.046927-60.353073 0.143017-1.287151 0.286034-2.574302 0.286033-4.004469v-48.625698c0-1.287151-0.143017-2.574302-0.286033-3.861453 17.305028-6.435754 31.034637-20.022346 37.756424-37.184357 2.431285 0.858101 5.005587 1.287151 7.722905 1.287151h171.191062c13.300559 0 24.026816-10.726257 24.026815-24.026816s-10.726257-24.026816-24.026815-24.026816h-171.620112c-2.145251 0-4.147486 0.286034-6.149721 0.858101C316.496089 19.450279 291.897207 0 262.721788 0c-29.175419 0-53.774302 19.307263-61.640224 45.90838-1.859218-0.42905-3.718436-0.715084-5.72067-0.715084H24.169832C10.869274 45.193296 0.143017 55.919553 0.143017 69.220112s10.726257 24.026816 24.026815 24.026815h171.191062c2.574302 0 5.148603-0.42905 7.436871-1.144134 6.292737 16.303911 19.021229 29.318436 35.182123 36.040224-0.286034 1.573184-0.572067 3.289385-0.572067 4.86257v48.625698c0 1.716201 0.143017 3.289385 0.572067 5.005587-23.168715 9.72514-39.472626 32.607821-39.472625 59.351955v54.203352c0 35.611173 28.746369 64.357542 64.357541 64.357542 22.024581 0 41.331844-11.012291 53.059218-27.888268 1.001117 1.001117 2.002235 2.002235 3.146369 2.717318-57.635754 72.080447-92.102793 163.75419-92.102793 263.579888 0 232.259218 186.922905 420.612291 417.322905 420.612291 230.4 0 417.322905-188.353073 417.322905-420.612291 0-102.256983-36.18324-196.075978-96.536313-268.871508 0.715084-0.286034 1.287151-0.715084 2.002235-1.144134 11.155307 18.878212 31.749721 31.606704 55.347486 31.606704 35.468156 0 64.357542-28.746369 64.357542-64.357542V245.988827c0-28.031285-17.877095-51.772067-42.762012-60.639106 0.286034-1.144134 0.286034-2.431285 0.286034-3.718436V133.005587c0-1.287151-0.143017-2.431285-0.286034-3.718436 17.162011-6.149721 31.034637-19.307263 37.899442-36.18324 0.858101 0.143017 1.573184 0.143017 2.431285 0.143016h171.191061c13.300559 0 24.026816-10.726257 24.026816-24.026815s-10.869274-24.026816-24.169833-24.026816zM1005.979888 64.357542c0-9.010056 7.293855-16.446927 16.446928-16.446927 9.010056 0 16.446927 7.293855 16.446927 16.446927v4.147486c0 9.010056-7.293855 16.446927-16.446927 16.446927-9.010056 0-16.446927-7.293855-16.446928-16.446927V64.357542z m-759.705028 0c0-9.010056 7.293855-16.446927 16.446928-16.446927 9.010056 0 16.446927 7.293855 16.446927 16.446927v4.147486c0 9.010056-7.293855 16.446927-16.446927 16.446927-9.010056 0-16.446927-7.293855-16.446928-16.446927V64.357542z m32.893855 235.548603c0 9.010056-7.293855 16.446927-16.446927 16.446928-9.010056 0-16.446927-7.293855-16.446928-16.446928v-54.203352c0-9.010056 7.293855-16.446927 16.446928-16.446927 9.010056 0 16.446927 7.293855 16.446927 16.446927v54.203352z m364.978771 639.1419C459.798883 939.048045 310.346369 788.594413 310.346369 602.815642c0-185.778771 149.452514-336.375419 333.801117-336.375419s333.801117 150.596648 333.801117 336.375419c0 185.778771-149.452514 336.232402-333.801117 336.232403z m394.58324-639.1419c0 9.010056-7.293855 16.446927-16.446927 16.446928-9.010056 0-16.446927-7.293855-16.446927-16.446928v-54.203352c0-9.010056 7.293855-16.446927 16.446927-16.446927 9.010056 0 16.446927 7.293855 16.446927 16.446927v54.203352z\" fill=\"#cdcdcd\" p-id=\"1646\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "fUdn":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.screenfull[data-v-031e4c81] {\n  display: inline-block;\n  cursor: pointer;\n  vertical-align: -0.15em;\n}\n", ""]);

// exports


/***/ }),

/***/ "ghZq":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.mosaic-bg[data-v-3d60a365] {\n  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.251), rgba(0, 0, 0, 0.251)), linear-gradient(45deg, #eee 25%, transparent 0, transparent 75%, #eee 0, #eee), linear-gradient(45deg, #eee 25%, #fff 0, #fff 75%, #eee 0, #eee);\n  background-size: 12px 12px;\n  background-position: 0 0, 0 0, 6px 6px;\n}\n.preview .bg-img[data-v-3d60a365] {\n  width: 100%;\n  height: 500px;\n  margin-bottom: 10px;\n}\n.preview .bg-img img[data-v-3d60a365],\n  .preview .bg-img video[data-v-3d60a365] {\n    width: 100%;\n    height: 100%;\n    -o-object-fit: contain;\n       object-fit: contain;\n}\n.preview .bg-img .video[data-v-3d60a365] {\n    background-color: #000;\n}\n.preview .thumbnail-list[data-v-3d60a365] {\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0;\n  width: 100%;\n  overflow-y: hidden;\n  overflow-x: auto;\n  list-style: none;\n  box-sizing: border-box;\n}\n.preview .thumbnail-list .thumbnail[data-v-3d60a365] {\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    width: 80px;\n    height: 80px;\n    border: 1px solid #eee;\n    cursor: pointer;\n}\n.preview .thumbnail-list .thumbnail img[data-v-3d60a365],\n    .preview .thumbnail-list .thumbnail video[data-v-3d60a365] {\n      width: 100%;\n      height: 100%;\n      -o-object-fit: fill;\n         object-fit: fill;\n}\n.preview .thumbnail-list .thumbnail + .thumbnail[data-v-3d60a365] {\n      margin-left: 10px;\n}\n", ""]);

// exports


/***/ }),

/***/ "hWpG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getChunks;
/* unused harmony export computeMd5 */
/* unused harmony export readAsArrayBuffer */
/* harmony export (immutable) */ __webpack_exports__["b"] = getProgressInfoItem;
/* harmony export (immutable) */ __webpack_exports__["c"] = compare;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeUrlParameters;
/* unused harmony export removeUrlDomainName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

function getChunks(file, blockSize) {
    var chunks = [];
    console.log(file);
    var count = Math.ceil(file.size / blockSize);
    for (var i = 0; i < count; i++) {
        var chunk = file.slice(blockSize * i, i === count - 1 ? file.size : blockSize * (i + 1));
        chunks.push(chunk);
    }
    return chunks;
}

function computeMd5(data) {
    return readAsArrayBuffer(data).then(function (buffer) {
        var spark = new SparkMD5.ArrayBuffer();
        spark.append(buffer);
        return spark.end();
    });
}

function readAsArrayBuffer(data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsArrayBuffer(data);
        reader.onload = function (evt) {
            var body = evt.target.result;
            resolve(body);
        };
        reader.onerror = function () {
            reject(new Error("fileReader 读取错误"));
        };
    });
}

function getProgressInfoItem(loaded, size) {
    return {
        loaded: loaded,
        size: size,
        percent: loaded / size * 100
    };
}

// 数组排序
function compare(property) {
    return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
    };
}

// 去除url上的所有参数
function removeUrlParameters(url) {
    if (url.indexOf('?') !== -1) {
        return url.split('?')[0];
    }
    return url;
}

// 去除url域名
function removeUrlDomainName(url) {
    return url.replace(/^(http:|https:)\/\/[^/]+/, "");
}

/***/ }),

/***/ "hdtf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-theme",
  "use": "icon-theme-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-theme\"><defs><style type=\"text/css\"></style></defs><path d=\"M788.00002 159.831491C756.00002 128 746 128 724.3801 128L642 128C642 128 576 188.923077 512 188.923077 448 188.923077 384 128 384 128L299.204802 128C276.629934 128 266 140.923077 245.847214 159.831491L81.582979 323.871735C70.243732 335.19552 52 371.692308 81.582979 408.655004 81.582979 408.655004 224.023667 540.29784 238.000003 541.53846L238.000003 835.076924C238.000003 868.452352 286.579 896 320 896L706 896C739.419808 896 788.00002 868.452352 788.00002 835.076924L788.00002 541.53846C802.145492 540.385864 942.448564 408.654992 942.448564 408.654992 974.00002 372 965.851264 334.883878 942.448584 311.513109L788.00002 159.831491Z\" p-id=\"9990\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "iO5a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src__ = __webpack_require__("TOAs");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src__["a" /* default */]);

/***/ }),

/***/ "jSdT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabsView_vue__ = __webpack_require__("XWx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57015451_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_TabsView_vue__ = __webpack_require__("BupL");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Gb2x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57015451"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57015451_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_TabsView_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/TabsView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TabsView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-57015451", Component.options)
  } else {
    hotAPI.reload("data-v-57015451", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jTNx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-rizhi",
  "use": "icon-rizhi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-rizhi\"><defs><style type=\"text/css\"></style></defs><path d=\"M750.074667 531.733333l0 388.714667L136.485333 920.448 136.485333 102.357333 750.074667 102.357333l0 99.584 102.4-98.496L852.474667 89.856C852.474667 40.234667 812.218667 0 762.597333 0L123.984 0C74.32 0 34.106667 40.234667 34.106667 89.856l0 843.093333c0 49.621333 40.213333 89.856 89.856 89.856l638.634667 0c49.621333 0 89.877333-40.234667 89.877333-89.856L852.474667 428.992 750.074667 531.733333z\" p-id=\"2745\" fill=\"#bfcbd9\" /><path d=\"M985.104 183.189333 933.114667 131.221333c-11.498667-11.477333-30.101333-11.477333-41.578667 0l-41.621333 41.6 93.632 93.589333 41.557333-41.6C996.581333 213.312 996.581333 194.666667 985.104 183.189333z\" p-id=\"2746\" fill=\"#bfcbd9\" /><path d=\"M349.392 674.261333 442.426667 767.296 921.829333 288.085333 828.24 194.496Z\" p-id=\"2747\" fill=\"#bfcbd9\" /><path d=\"M330.874667 691.84 256.976 836.032 330.874667 691.84Z\" p-id=\"2748\" fill=\"#bfcbd9\" /><path d=\"M277.818667 856.810667 425.957333 786.901333 330.874667 691.84 256.976 836.032Z\" p-id=\"2749\" fill=\"#bfcbd9\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "k0sJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("afte");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_031e4c81_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("2J+X");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("a7fu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-031e4c81"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_031e4c81_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Screenfull/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-031e4c81", Component.options)
  } else {
    hotAPI.reload("data-v-031e4c81", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kTXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress_nprogress_css__ = __webpack_require__("UVIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");


 // Progress 进度条
 // Progress 进度条样式

 // 验权


var whiteList = ['/login']; // 不重定向白名单
__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].beforeEach(function (to, from, next) {
    __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.start();
    next();
});

__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].afterEach(function () {
    __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.done(); // 结束Progress
});

/***/ }),

/***/ "ko8Y":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7ScC");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("fbbf81ee", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3e29d41e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Navbar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3e29d41e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Navbar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "kzJD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("Hana");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e29d41e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("7XAT");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("ko8Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e29d41e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e29d41e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/layout/Navbar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Navbar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3e29d41e", Component.options)
  } else {
    hotAPI.reload("data-v-3e29d41e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lzf8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-upload-dragger",
    class: {
      'is-dragover': _vm.dragover
    },
    on: {
      "drop": function($event) {
        $event.preventDefault();
        _vm.onDrop($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.onDragover($event)
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragover = false
      }
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c0e13c7", esExports)
  }
}

/***/ }),

/***/ "m52m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qn-upload"
  }, [_c('el-upload', _vm._b({
    ref: "upload",
    attrs: {
      "action": _vm.action,
      "accept": _vm.accept,
      "auto-upload": _vm.autoUpload,
      "max-length": _vm.maxLength,
      "on-change": _vm.handleChange,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.handleBeforeUpload,
      "http-request": _vm.handleUpload,
      "list-type": _vm.listType,
      "file-list": _vm.fileList
    }
  }, 'el-upload', _vm.$attrs, false), [_vm._l((_vm.$slots), function(index, name) {
    return _c('template', {
      slot: name
    }, [_vm._t(name)], 2)
  }), _vm._v(" "), (_vm.listType === 'picture-card') ? [(!_vm.$slots.default) ? _c('i', {
    staticClass: "el-icon-plus"
  }) : _vm._e(), _vm._v(" "), (!_vm.$slots.tip) ? _c('div', {
    staticClass: "el-upload__tip",
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tip))]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('preview', {
    attrs: {
      "visible": _vm.dialogs.preview,
      "data": _vm.preview.data,
      "is-edit": _vm.isCropper,
      "list": _vm.preview.list
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogs.preview = $event
      },
      "edit": _vm.handleToEdit
    }
  }), _vm._v(" "), (_vm.isCropper) ? _c('cropper', {
    attrs: {
      "visible": _vm.dialogs.cropper,
      "data": _vm.cropper.data,
      "resolution": _vm.cropper.resolution
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogs.cropper = $event
      },
      "success": _vm.handleCropper
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7ec3b6ec", esExports)
  }
}

/***/ }),

/***/ "mwRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-quanxian",
  "use": "icon-quanxian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-quanxian\"><defs><style type=\"text/css\"></style></defs><path d=\"M818.246893 412.326906l-45.988404 0 0-70.991868c0-152.307871-123.463939-275.778974-275.778974-275.778974s-275.78102 123.471103-275.78102 275.778974l0 70.991868-45.987381 0c-25.379017 0-45.988404 20.566408-45.988404 45.987381l0 455.407074c0 25.428136 20.560268 45.988404 45.988404 45.988404l643.535779 0c25.37697 0 45.988404-20.560268 45.988404-45.988404L864.235296 458.314287C864.190271 432.893314 843.623863 412.326906 818.246893 412.326906L818.246893 412.326906zM680.331823 412.326906 312.62516 412.326906l0-70.991868c0-101.55393 82.344426-183.853331 183.854355-183.853331 101.509928 0 183.853331 82.343403 183.853331 183.853331L680.332846 412.326906 680.331823 412.326906zM680.331823 412.326906\" p-id=\"9663\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "nQME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tubiao",
  "use": "icon-tubiao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tubiao\"><defs><style type=\"text/css\"></style></defs><path d=\"M64 448 320 448 320 960 64 960 64 448 64 448ZM704 256 960 256 960 960 704 960 704 256 704 256ZM384 64 640 64 640 960 384 960 384 64 384 64Z\" p-id=\"10423\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "o0jG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'QnInput',
  props: {
    clearable: {
      type: Boolean,
      default: true
    },
    value: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    closeIcon: function closeIcon() {
      return this.clearable ? 'close' : '';
    }
  },
  methods: {
    clearValue: function clearValue() {
      if (!this.clearable) return;
      this.$emit('input', '');
      this.$emit('change', '');
      this.$emit('clear');
    }
  }
});

/***/ }),

/***/ "o6Ms":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_qnbar_platform_js__ = __webpack_require__("Ljt4");


//qnbar平台工具的基础配置
//var PT = require('./vendor/qnbar/platform.js');


var PT = new __WEBPACK_IMPORTED_MODULE_0__vendor_qnbar_platform_js__["a" /* default */].Platform();
PT.config.env = "release";
PT.config.hostBaseUrl = 'https://mm.qnbar.com/';
PT.config.platformUsagespace = 'PT_MIX_BZ';
PT.config.apiBaseUrl = 'https://apih.qnbar.com/';
PT.config.qnloginBaseUrl = "https://login.qnbar.com/";
PT.config.qnloginPlatformNo = 10;
PT.config.loginJumpBackUrl = encodeURIComponent(PT.config.hostBaseUrl);
PT.config.wsHost = "ws.qnbar.com";
PT.config.wsPort = "16668";
PT.config.wsProto = "wss";
PT.init();

/* harmony default export */ __webpack_exports__["a"] = ({
    PT: PT
});

/***/ }),

/***/ "oHFL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_js__ = __webpack_require__("DfDl");
// 封装到window对象上的公共函数
// console封装
window.Log = function (input) {
    console.log(input);
};


// 封装到vue原型上的公共函数
/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        // 存储登录信息
        Vue.prototype.commonSetLocalDataNew = function (key, data) {
            localStorage.setItem(key, data);
        };
        // 获取登录信息
        Vue.prototype.commonGetLocalDataNew = function (key) {
            return localStorage.getItem(key);
        };
        // 删除登录信息
        Vue.prototype.commondelLocalAllDataNew = function (key) {
            delete localStorage[key];
        };

        Vue.filter("picVideo", function (value) {
            //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            if (value == 1 || value == 38) {
                return "上传图片、视频";
            } else {
                return "上传图片";
            }
        });
        Vue.filter("lastDayFilter", function (value, msg) {
            //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            if (value == "4070880000") {
                return "永久";
            } else {
                return msg;
            }
        });
        //生成时间
        Vue.filter("filterBornTime", function (value) {
            if (value == 0) {
                return "";
            }
            var out = "0";
            out = getLocalTime(value);
            function getLocalTime(time) {
                var date = new Date(parseInt(time) * 1000);
                var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
                var minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
                var second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
                return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + hour + ":" + minute + ":" + second;
            }
            return out;
        });
        // 时间戳转换YMD
        Vue.filter("turnYMD", function (value) {
            //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            if (!value || value == 0) {
                return "未知";
            }
            var out = "0";
            out = getLocalTime(value);

            function getLocalTime(time) {
                var date = new Date(parseInt(time) * 1000);
                return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
            }
            return out;
        });
        Vue.filter("phoneFilter", function (value) {
            //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            if (!!value) {
                return value;
            } else {
                return "无";
            }
        });
        Vue.filter("emailFilter", function (value) {
            //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            if (!!value) {
                return value;
            } else {
                return "无";
            }
        });
        Vue.filter("filterRoomName", function (value) {
            //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            if (!!value) {
                return value;
            } else {
                return "无";
            }
        });
        Vue.filter("filterGoodsStatus", function (value) {
            //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            if (value) {
                if (value == 1) {
                    return "上架";
                } else {
                    return "下架";
                }
            } else {
                return "异常";
            }
        });
        // 文件导出
        Vue.prototype.commonGetCookies = function () {
            var out = {
                api_local_sess: "",
                api_usagespace: ""
            };
            var name = "local_sess";
            var api_local_sess = "";
            var api_usagespace = "PT_MIX_BZ";
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) {
                api_local_sess = parts.pop().split(";").shift();
            };
            out = {
                api_local_sess: api_local_sess,
                api_usagespace: api_usagespace
            };
            return out;
        };
    }
});

/***/ }),

/***/ "oHMA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasOwn;
/* unused harmony export toObject */
/* unused harmony export getValueByPath */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
};

function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
};

function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
};

var getValueByPath = function getValueByPath(object, prop) {
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

/***/ }),

/***/ "oSYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-table",
  "use": "icon-table-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-table\"><defs><style type=\"text/css\"></style></defs><path d=\"M67.039347 100.410897l889.919259 0 0 200.231347-889.919259 0 0-200.231347Z\" p-id=\"8434\" /><path d=\"M67.039347 345.138668l266.976494 0 0 266.975471-266.976494 0 0-266.975471Z\" p-id=\"8435\" /><path d=\"M67.039347 656.610562l266.976494 0 0 266.976494-266.976494 0 0-266.976494Z\" p-id=\"8436\" /><path d=\"M378.511241 345.138668l266.976494 0 0 266.975471-266.976494 0 0-266.975471Z\" p-id=\"8437\" /><path d=\"M378.511241 656.610562l266.976494 0 0 266.976494-266.976494 0 0-266.976494Z\" p-id=\"8438\" /><path d=\"M689.983135 345.138668l266.976494 0 0 266.975471-266.976494 0 0-266.975471Z\" p-id=\"8439\" /><path d=\"M689.983135 656.610562l266.976494 0 0 266.976494-266.976494 0 0-266.976494Z\" p-id=\"8440\" /><path d=\"M67.039347 100.410897l889.919259 0 0 200.231347-889.919259 0 0-200.231347Z\" p-id=\"8441\" /><path d=\"M67.039347 345.138668l266.976494 0 0 266.975471-266.976494 0 0-266.975471Z\" p-id=\"8442\" /><path d=\"M67.039347 656.610562l266.976494 0 0 266.976494-266.976494 0 0-266.976494Z\" p-id=\"8443\" /><path d=\"M378.511241 345.138668l266.976494 0 0 266.975471-266.976494 0 0-266.975471Z\" p-id=\"8444\" /><path d=\"M378.511241 656.610562l266.976494 0 0 266.976494-266.976494 0 0-266.976494Z\" p-id=\"8445\" /><path d=\"M689.983135 345.138668l266.976494 0 0 266.975471-266.976494 0 0-266.975471Z\" p-id=\"8446\" /><path d=\"M689.983135 656.610562l266.976494 0 0 266.976494-266.976494 0 0-266.976494Z\" p-id=\"8447\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "oglU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-zonghe",
  "use": "icon-zonghe-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zonghe\"><defs><style type=\"text/css\"></style></defs><path d=\"M770.56 460.8l250.88 0C998.4 220.16 803.84 25.6 563.2 2.56l0 250.88C668.16 273.92 750.08 355.84 770.56 460.8L770.56 460.8zM770.56 460.8\" p-id=\"9879\" /><path d=\"M460.8 253.44 460.8 2.56C220.16 25.6 25.6 220.16 2.56 460.8l250.88 0C273.92 355.84 355.84 273.92 460.8 253.44L460.8 253.44zM460.8 253.44\" p-id=\"9880\" /><path d=\"M563.2 770.56l0 250.88c243.2-23.04 435.2-217.6 460.8-460.8l-250.88 0C750.08 668.16 668.16 750.08 563.2 770.56L563.2 770.56zM563.2 770.56\" p-id=\"9881\" /><path d=\"M253.44 563.2 2.56 563.2c23.04 243.2 217.6 435.2 460.8 460.8l0-250.88C355.84 750.08 273.92 668.16 253.44 563.2L253.44 563.2zM253.44 563.2\" p-id=\"9882\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "ojPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("7eqC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07ce388e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("JeEN");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07ce388e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/QnImage/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07ce388e", Component.options)
  } else {
    hotAPI.reload("data-v-07ce388e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ok+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("sC1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a89de698_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_progress_vue__ = __webpack_require__("yDPa");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a89de698_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_progress_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/QnUpload-1.0.0/progress/src/progress.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] progress.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a89de698", Component.options)
  } else {
    hotAPI.reload("data-v-a89de698", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pnUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPoolAndRunTask;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

// 线程池
var pool = [];
var tasks = [];
var relust = false;
/**
 * 把任务添加到线程池
 * @param {objeck} task 任务
 */
function addTask(task) {
	pool.push(task);
	if (task != [] && task) {
		console.log(task);
		task.then(function (res) {
			console.log(pool.indexOf(task));
			pool.splice(pool.indexOf(task), 1);
		});
	}
}
// 跑完一个任务加塞下一个任务
function run(race, tasks, callback) {
	var tasks_2 = tasks;
	race.then(function (res) {
		var task = tasks_2.shift();
		if (relust) {
			callback();
		}
		if (task !== undefined) {
			addTask(task);
			run(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.race(pool), tasks_2, callback);
		}
		if (tasks_2.length == 0) {
			relust = true;
			// callback()
		}
	}).catch(function (err) {
		console.log(err, '我执行失败');
	});
}
/**
 * 创建线程池并执行
 * @param {Object} tasks		需要跑的任务
 * @param {Object} maxthread	最大线程数
 * @param {Function} callback   上传完成的回调函数
 */
function createPoolAndRunTask(tasks, maxthread, callback) {
	// let pool = []
	// let tasks_2 = tasks
	var maxthread_2 = maxthread;
	// 塞满线程池
	// while (pool.length < maxthread_2) {
	//     let task = tasks_2.shift();
	// 	if(task){
	// 		addTask(task,pool)
	// 	}
	// }
	for (var i = 0; i < maxthread_2; i++) {
		var task = tasks.shift();
		if (task) {
			addTask(task, pool);
		}
	}
	var race = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.race(pool);
	run(race, tasks, callback);
}

/***/ }),

/***/ "pqE5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ElUploadDrag',
  props: {
    disabled: Boolean
  },
  data: function data() {
    return {
      dragover: false
    };
  },

  methods: {
    onDragover: function onDragover() {
      if (!this.disabled) {
        this.dragover = true;
      }
    },
    onDrop: function onDrop(e) {
      if (!this.disabled) {
        this.dragover = false;
        this.$emit('file', e.dataTransfer.files);
      }
    }
  }
});

/***/ }),

/***/ "q16I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_util__ = __webpack_require__("oHMA");



var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
/**
 *  String format template
 *  - Inspired:
 *    https://github.com/Matt-Esch/string-template/index.js
 */
/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {

  /**
   * template
   *
   * @param {String} string
   * @param {Array} ...args
   * @return {String}
   */

  function template(string) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (args.length === 1 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(args[0]) === 'object') {
      args = args[0];
    }

    if (!args || !args.hasOwnProperty) {
      args = {};
    }

    return string.replace(RE_NARGS, function (match, prefix, i, index) {
      var result = void 0;

      if (string[index - 1] === '{' && string[index + match.length] === '}') {
        return i;
      } else {
        result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_util__["a" /* hasOwn */])(args, i) ? args[i] : null;
        if (result === null || result === undefined) {
          return '';
        }

        return result;
      }
    });
  }

  return template;
});

/***/ }),

/***/ "q8zI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qghf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.routes), function(item) {
    return [(!item.hidden && item.noDropdown && item.children.length > 0) ? _c('router-link', {
      attrs: {
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.children[0].name) + "\n        ")], 1)], 1) : _vm._e(), _vm._v(" "), (!item.noDropdown && !item.hidden) ? _c('el-submenu', {
      attrs: {
        "index": item.name
      }
    }, [_c('template', {
      slot: "title"
    }, [((item.name === '商品配送' || item.name === '商品购物') && _vm.waitOrder && _vm.waitOrder.total) ? _c('el-badge', {
      staticClass: "item",
      staticStyle: {
        "margin-right": "20px"
      },
      attrs: {
        "value": "new"
      }
    }) : _vm._e(), _vm._v(" "), (item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.name) + "\n        "), (!!_vm.examineRemind) ? _c('el-badge', {
      attrs: {
        "value": _vm.examineRemind,
        "is-dot": "",
        "hidden": item.name !== '门店管理'
      }
    }) : _vm._e()], 1), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [(!!_vm.examineRemind) ? _c('el-badge', {
        attrs: {
          "is-dot": "",
          "hidden": child.name !== '内容审核'
        }
      }) : _vm._e(), _vm._v("\n            " + _vm._s(child.name) + "\n            "), (child.name === '等待配送' && _vm.waitOrder && _vm.waitOrder.total > 0) ? _c('el-badge', {
        staticClass: "item",
        staticStyle: {
          "margin-right": "10px"
        },
        attrs: {
          "max": 99,
          "value": _vm.waitOrder && _vm.waitOrder.total
        }
      }) : _vm._e()], 1)], 1)] : _vm._e()
    })], 2) : _vm._e()]
  })], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ce21a81e", esExports)
  }
}

/***/ }),

/***/ "qi15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWhiteList;
/* unused harmony export getAuthList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var basePath = 'https://store.qnbar.com/oss';

/**
 * 获取青柠首映、青柠电影等白名单
 * @returns 
 */
function getWhiteList() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(basePath + '/ui_theme/whiteList.json').then(function (res) {
        return res.data;
    });
}

/**
 * 获取操作权限（如：上传、文本编辑、消息管理）相关白名单
 * @returns 
 */
function getAuthList() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(basePath + '/mix/authList.json').then(function (res) {
        return res.data;
    });
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
    getWhiteList: getWhiteList,
    getAuthList: getAuthList
});

/***/ }),

/***/ "quWu":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\t.btn{\n        color: #fff;\n\t    background-color: #337ab7;\n\t    border-color: #2e6da4; \n\t    display: inline-block;\n\t    padding: 6px 12px;\n\t    margin-bottom: 0;\n\t    font-size: 14px;\n\t    font-weight: 400;\n\t    line-height: 1.42857143;\n\t    text-align: center;\n\t    white-space: nowrap;\n\t    text-decoration: none;\n\t    vertical-align: middle;\n\t    -ms-touch-action: manipulation;\n\t    touch-action: manipulation;\n\t    cursor: pointer;\n\t    -webkit-user-select: none;\n\t    -moz-user-select: none;\n\t    -ms-user-select: none;\n\t    user-select: none;\n\t    background-image: none;\n\t    border: 1px solid transparent;\n\t    border-radius: 4px;\n\t}\n\ta.btn:hover{\n      background-color: #3366b7;\n\t}\n\t.progress{\n\t\tmargin-top:2px;\n\t    width: 200px;\n\t    height: 14px;\n\t    margin-bottom: 10px;\n\t    overflow: hidden;\n\t    background-color: #f5f5f5;\n\t    border-radius: 4px;\n\t    -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);\n\t    box-shadow: inset 0 1px 2px rgba(0,0,0,.1);\n\t}\n\t.progress-bar{ \n\t\tbackground-color: rgb(92, 184, 92);\n\t\tbackground-image: linear-gradient(45deg, rgba(255, 255, 255, 0.14902) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.14902) 50%, rgba(255, 255, 255, 0.14902) 75%, transparent 75%, transparent);\n\t\tbackground-size: 40px 40px;\n\t\tbox-shadow: rgba(0, 0, 0, 0.14902) 0px -1px 0px 0px inset;\n\t\tbox-sizing: border-box;\n\t\tcolor: rgb(255, 255, 255);\n\t\tdisplay: block;\n\t\tfloat: left; \n\t\tfont-size: 12px;\n\t\theight: 20px;\n\t\tline-height: 20px;\n\t\ttext-align: center;\n\t\ttransition-delay: 0s;\n\t\ttransition-duration: 0.6s;\n\t\ttransition-property: width;\n\t\ttransition-timing-function: ease;\n\t\twidth: 266.188px;\n\t}", ""]);

// exports


/***/ }),

/***/ "rGfR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


//这坨是前端用的权限控制代码
//对qnbarApi有依赖
function PermissionChecker() {
    var that = this;

    var BindThing = function BindThing() {
        this.code = ""; //
        this.type = ""; // page / elementId / function / check
        this.value = ""; //具体id或function对象
        this.noPrmsnDo = null; //没权限时，做啥
        this.ownPrmsnDo = null; //有权限时，做啥
        this.isPrmsnOk = false; //是否权限ok
    };

    var bindArr = [];

    var DoHide = function DoHide(bindThingObj) {
        if (bindThingObj) {
            bindThingObj.style.display = "none";
        }
    };

    var DoShow = function DoShow(bindThingObj) {
        if (bindThingObj) {
            bindThingObj.style.display = "";
        }
    };

    var onQueryFinishOutDoFunc = null;
    var onNoPageCoreDoFunc = null;

    //权限请求后的处理 
    var HandlePermissionQueryOK = function HandlePermissionQueryOK(rsp) {
        if (rsp.code == 0) {
            if (rsp.data.length != bindArr.length) {
                alert("权限验证未对齐错误");
            }

            //set result
            for (var i = 0; i < bindArr.length; i++) {
                if (rsp.data[i] > 0) {
                    bindArr[i].isPrmsnOk = true;
                }
            }

            //run deal
            var isPageCoreOk = true;
            for (var i = 0; i < bindArr.length; i++) {
                if (bindArr[i].type == "page") {
                    if (!bindArr[i].isPrmsnOk) {
                        isPageCoreOk = false;
                    }
                } else if (bindArr[i].type == "elementId") {

                    if (!bindArr[i].isPrmsnOk) {
                        if (bindArr[i].noPrmsnDo) {
                            var element = document.getElementById(bindArr[i].value);
                            if (element) {
                                bindArr[i].noPrmsnDo(element);
                            }
                        }
                    } else {
                        if (bindArr[i].ownPrmsnDo) {
                            var element = document.getElementById(bindArr[i].value);
                            if (element) {
                                bindArr[i].ownPrmsnDo(element);
                            }
                        }
                    }
                } else if (bindArr[i].type == "function") {
                    if (!bindArr[i].isPrmsnOk) {
                        //not run
                    } else {
                        bindArr[i].value();
                    }
                }
            }

            if (!isPageCoreOk) {
                if (onNoPageCoreDoFunc != null) {
                    onNoPageCoreDoFunc();
                } else {
                    alert("你不具有该页面的访问权限");
                }
            } else {
                if (onQueryFinishOutDoFunc) {
                    onQueryFinishOutDoFunc();
                }
            }
        } else {
            alert("请求权限出现错误：" + rsp.code);
        }
    };

    //绑定当前页面访问时控制
    this.bindElementById = function (permissionCode, elementId, noPrmsnMethod, ownPrmsnMethod) {
        var tempBind = new BindThing();
        tempBind.code = permissionCode;
        tempBind.type = "elementId";
        tempBind.value = elementId;

        if (!noPrmsnMethod || noPrmsnMethod == 'hide') {
            tempBind.noPrmsnDo = DoHide;
        } else {
            //todo
        }

        if (ownPrmsnMethod) {
            if (ownPrmsnMethod == 'show') {
                tempBind.ownPrmsnDo = DoShow;
            }
        }

        bindArr.push(tempBind);
    };

    this.bindRunFunc = function (permissionCode, func) {
        var tempBind = new BindThing();
        tempBind.code = permissionCode;
        tempBind.type = "function";
        tempBind.value = func;

        bindArr.push(tempBind);
    };

    /*
     * 绑定页面核心权限，没有核心权限判定为全页无法使用
     */
    this.bindPageCore = function (permissionCode) {
        var tempBind = new BindThing();
        tempBind.code = permissionCode;
        tempBind.type = "page";

        bindArr.push(tempBind);
    };

    /*
     * 绑定要检查的权限，用于外部逻辑
     */
    this.bindCheck = function (permissionCode) {
        var tempBind = new BindThing();
        tempBind.code = permissionCode;
        tempBind.type = "check";

        bindArr.push(tempBind);
    };

    /*
     * 页面无核心权限时的回调
     */
    this.setNoPageCoreDoFunc = function (noPageCoreDoFunc) {
        onNoPageCoreDoFunc = noPageCoreDoFunc;
    };

    this.queryAddress = 'role-permission/role/match-permission';

    //-- 单独请求权限 --
    this.queryPermissions = function (qnbarApiClient, usagespaceParam, localSessionKey, onQueryFinishOutDo) {
        if (bindArr.length == 0) {
            alert("未绑定任何权限和资源错误！");
        }

        onQueryFinishOutDoFunc = onQueryFinishOutDo;

        var codesStr = '';
        for (var i = 0; i < bindArr.length; i++) {
            codesStr += bindArr[i].code;
            if (i != bindArr.length - 1) {
                codesStr += ',';
            }
        }

        var postParams = {
            usagespace: usagespaceParam,
            codes: codesStr
        };
        if (localSessionKey) {
            postParams.local_sess = localSessionKey;
        }
        qnbarApiClient.query(that.queryAddress, postParams, HandlePermissionQueryOK);
    };

    //---- 直接获取全量权限 ----
    var allUserPermissionCodes = [];
    var onQueryAllOKOutDoFunc = null;
    var onQueryAllFailOutDoFunc = null;
    this.queryAllPermissionUrl = 'role-permission/role/get-all';

    var handleAllPermissionsOk = function handleAllPermissionsOk(rsp) {
        if (rsp.code == 0) {
            localStorage.setItem("user_all", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rsp.data));
            if (rsp.data && rsp.data.length > 0) {
                for (var i = 0; i < rsp.data.length; i++) {
                    allUserPermissionCodes.push(rsp.data[i]);
                }
                // console.log("all permission code");
                // console.log(allUserPermissionCodes);
            }

            if (onQueryAllOKOutDoFunc) {
                onQueryAllOKOutDoFunc(rsp);
            }
        } else {
            if (onQueryAllFailOutDoFunc) {
                onQueryAllFailOutDoFunc(rsp);
            } else {
                alert("请求权限出现错误，请尝试重新登录或清理浏览器cookie ：" + rsp.code + rsp.msg);
            }
        }
    };

    this.queryAllPermissions = function (qnbarApiClient, usagespaceParam, localSessionKey, onQueryOKOutDo, onQueryFailOutDo) {
        onQueryAllOKOutDoFunc = onQueryOKOutDo;
        onQueryAllFailOutDoFunc = onQueryFailOutDo;

        var postParams = {
            usagespace: usagespaceParam
        };
        if (localSessionKey) {
            postParams.local_sess = localSessionKey;
        }
        //特殊处理block
        qnbarApiClient.query(that.queryAllPermissionUrl, postParams, handleAllPermissionsOk, null, '', true);
    };

    this.hasPermission = function (permissionCode) {
        if (bindArr.length > 0) {
            for (var i = 0; i < bindArr.length; i++) {
                if (bindArr[i].code == permissionCode && bindArr[i].isPrmsnOk) {
                    return true;
                }
            }
        }

        if (allUserPermissionCodes.length > 0) {
            for (var i = 0; i < allUserPermissionCodes.length; i++) {
                if (allUserPermissionCodes[i] == permissionCode) {
                    return true;
                }
            }
        }

        return false;
    };

    this.checkAndRun = function (permissionCode, outThing, outRunOkFunc, outRunFailFunc) {
        if (that.hasPermission(permissionCode)) {
            if (outRunOkFunc) {
                outRunOkFunc(outThing);
            }
            return;
        }

        if (outRunFailFunc) {
            outRunFailFunc(outThing);
        }
    };
}

/* harmony default export */ __webpack_exports__["a"] = ({
    PermissionChecker: PermissionChecker
});

/***/ }),

/***/ "rSKJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3cb7825c", esExports)
  }
}

/***/ }),

/***/ "rn/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-description",
  "use": "icon-description-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-description\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 8.448a501.248 501.248 0 1 0 501.248 501.248A503.04 503.04 0 0 0 512 8.448z m0 743.68a38.912 38.912 0 0 1-55.04-55.04 28.672 28.672 0 0 1 22.016-11.008 37.632 37.632 0 0 1 38.656 38.656 25.6 25.6 0 0 1-5.632 27.392z m110.08-314.112a220.416 220.416 0 0 1-60.672 66.048 162.048 162.048 0 0 0-44.032 44.032 103.68 103.68 0 0 0-11.008 44.032v27.648h-55.04v-27.392a198.144 198.144 0 0 1 11.008-60.672 123.648 123.648 0 0 1 55.04-49.664 210.432 210.432 0 0 0 49.664-49.664 93.184 93.184 0 0 0 16.64-55.04 70.656 70.656 0 0 0-22.016-55.04 92.416 92.416 0 0 0-66.048-16.64 174.848 174.848 0 0 0-110.08 44.032v-65.792a230.4 230.4 0 0 1 115.456-33.024 134.656 134.656 0 0 1 99.072 33.024 119.808 119.808 0 0 1 38.656 88.064 146.688 146.688 0 0 1-16.64 66.048z\" p-id=\"2862\" fill=\"#d81e06\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "sC1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ElProgress',
  props: {
    type: {
      type: String,
      default: 'line',
      validator: function validator(val) {
        return ['line', 'circle'].indexOf(val) > -1;
      }
    },
    percentage: {
      type: Number,
      default: 0,
      required: true,
      validator: function validator(val) {
        return val >= 0 && val <= 100;
      }
    },
    status: {
      type: String
    },
    strokeWidth: {
      type: Number,
      default: 6
    },
    textInside: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 126
    },
    showText: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    barStyle: function barStyle() {
      var style = {};
      style.width = this.percentage + '%';
      return style;
    },
    relativeStrokeWidth: function relativeStrokeWidth() {
      return (this.strokeWidth / this.width * 100).toFixed(1);
    },
    trackPath: function trackPath() {
      var radius = parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);

      return 'M 50 50 m 0 -' + radius + ' a ' + radius + ' ' + radius + ' 0 1 1 0 ' + radius * 2 + ' a ' + radius + ' ' + radius + ' 0 1 1 0 -' + radius * 2;
    },
    perimeter: function perimeter() {
      var radius = 50 - parseFloat(this.relativeStrokeWidth) / 2;
      return 2 * Math.PI * radius;
    },
    circlePathStyle: function circlePathStyle() {
      var perimeter = this.perimeter;
      return {
        strokeDasharray: perimeter + 'px,' + perimeter + 'px',
        strokeDashoffset: (1 - this.percentage / 100) * perimeter + 'px',
        transition: 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease'
      };
    },
    stroke: function stroke() {
      var ret;
      switch (this.status) {
        case 'success':
          ret = '#13ce66';
          break;
        case 'exception':
          ret = '#ff4949';
          break;
        default:
          ret = '#20a0ff';
      }
      return ret;
    },
    iconClass: function iconClass() {
      if (this.type === 'line') {
        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-cross';
      } else {
        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
      }
    },
    progressTextSize: function progressTextSize() {
      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
    }
  }
});

/***/ }),

/***/ "sEM+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-404",
  "use": "icon-404-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-404\"><defs><style type=\"text/css\"></style></defs><path d=\"M931.6 585.6l0 79c28.6-60.2 44.8-127.4 44.8-198.4C976.4 211 769.4 4 514.2 4S52 211 52 466.2c0 3.2 0.2 6.4 0.2 9.6l166-206 96.4 0L171.8 485.6l46.4 0 0-54.8 99.2-154.6 0 209.4 0 100 0 82.4-99.2 0 0-82.4L67.6 585.6c43 161 170.6 287.4 332.4 328.6-10.4 26.2-40.6 89.4-90.8 100.6-62.2 14 168.8 3.4 333.6-104.6 126.6-36.6 230.8-125.8 287.4-242.2l-97.6 0 0-82.4-166.2 0 0-87.2 0-12.8L666.4 476l166.2-206.2 94 0-140.4 215.8 46.4 0 0-59 99.2-154 0 213.2L931.8 585.6zM366.2 608c-4.8-11.2-7.2-23.2-7.2-36L359 357.6c0-12.8 2.4-24.8 7.2-36 4.8-11.2 11.4-21 19.6-29.2 8.2-8.2 18-14.8 29.2-19.6 11.2-4.8 23.2-7.2 36-7.2l81.6 0c12.8 0 24.8 2.4 36 7.2 11 4.8 20.6 11.2 28.8 19.2l-88.6 129.4 0-23c0-4.8-1.6-8.8-4.8-12-3.2-3.2-7.2-4.8-12-4.8-4.8 0-8.8 1.6-12 4.8-3.2 3.2-4.8 7.2-4.8 12l0 72L372.6 620C370.2 616.2 368 612.2 366.2 608zM624.4 572c0 12.8-2.4 24.8-7.2 36-4.8 11.2-11.4 21-19.6 29.2-8.2 8.2-18 14.8-29.2 19.6-11.2 4.8-23.2 7.2-36 7.2l-81.6 0c-12.8 0-24.8-2.4-36-7.2-11.2-4.8-21-11.4-29.2-19.6-3.6-3.6-7-7.8-10-12l99.2-144.6 0 50.6c0 4.8 1.6 8.8 4.8 12 3.2 3.2 7.2 4.8 12 4.8 4.8 0 8.8-1.6 12-4.8 3.2-3.2 4.8-7.2 4.8-12l0-99.6 92.6-135.2c6.6 7.4 12 15.8 16 25.2 4.8 11.2 7.2 23.2 7.2 36L624.2 572z\" p-id=\"10207\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "sHk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-wujiaoxing",
  "use": "icon-wujiaoxing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-wujiaoxing\"><defs><style type=\"text/css\"></style></defs><path d=\"M565.272827 34.627285l112.095872 237.542288c8.706637 18.321022 25.411424 31.051641 44.82285 33.996289l250.776598 38.081157c48.697387 7.411435 68.22505 70.046082 32.933559 105.979639l-181.494353 184.937155c-13.998147 14.230618-20.352386 34.815477-17.05903 54.93539l42.819161 261.127145c8.346858 50.695541-42.64204 89.451974-86.225039 65.51841l-224.307979-123.271141c-17.285968-9.525824-37.992596-9.525824-55.278564 0l-224.313514 123.271141c-43.582999 23.933565-94.571897-14.822869-86.219504-65.51841l42.813626-261.127145c3.321031-20.119914-3.088559-40.704772-17.086706-54.93539l-181.439002-184.937155c-35.285956-35.933557-15.819179-98.57374 32.933559-105.979639l250.748923-38.081157c19.350541-2.939112 36.083003-15.675267 44.75643-33.996289l112.123547-237.542288C480.497972-11.540583 543.509003-11.540583 565.272827 34.627285z\" p-id=\"9771\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "szRj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("cqz9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ec3b6ec_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("m52m");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("XSqF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ec3b6ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ec3b6ec_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/QnUpload-1.0.0/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ec3b6ec", Component.options)
  } else {
    hotAPI.reload("data-v-7ec3b6ec", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t1l9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  el: {
    colorpicker: {
      confirm: '确定',
      clear: '清空'
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      // week: '周次',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择'
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择'
    },
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页'
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!'
    },
    upload: {
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传'
    },
    table: {
      emptyText: '暂无数据',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计'
    },
    tree: {
      emptyText: '暂无数据'
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项'
    }
  }
});

/***/ }),

/***/ "t21O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-demand",
  "use": "icon-demand-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-demand\"><defs><style type=\"text/css\"></style></defs><path d=\"M358.72 896c11.712 22.848 25.536 44.416 41.728 64L128 960 64 960c-17.664 0-32-14.336-32-32S46.336 896 64 896l41.408 0 67.968-191.104C68.992 636.224 0 518.272 0 384c0-212.096 171.904-384 384-384s384 171.904 384 384c0 4.544-0.704 8.896-0.832 13.376-20.416-5.696-41.472-9.792-63.232-11.776C703.936 385.088 704 384.576 704 384c0-176.448-143.552-320-320-320S64 207.552 64 384c0 105.92 52.352 199.296 131.904 257.6 17.536 12.864 36.16 24 56.128 33.088 22.208 10.112 45.76 17.728 70.208 22.72C320.832 710.08 320 722.944 320 736c0 8.896 0.704 17.6 1.344 26.304-31.808-5.312-62.4-14.016-91.072-26.56L173.312 896 358.72 896zM384 337.472c55.936 0 101.76 41.856 109.056 95.808 18.816-11.136 38.72-20.544 59.584-28.032C533.44 329.6 465.536 273.472 384 273.472 287.616 273.472 209.472 351.616 209.472 448c0 50.816 22.016 96.128 56.64 128 20.928 19.328 46.72 33.152 75.136 40.448C348.8 595.648 358.144 575.808 369.28 557.056 315.328 549.76 273.472 503.936 273.472 448 273.472 387.072 323.072 337.472 384 337.472zM430.528 192c0-25.728-20.864-46.528-46.528-46.528S337.472 166.272 337.472 192 358.272 238.528 384 238.528 430.528 217.728 430.528 192zM960 736c0 159.04-128.96 288-288 288S384 895.04 384 736 512.96 448 672 448 960 576.96 960 736zM896 736C896 612.48 795.52 512 672 512S448 612.48 448 736 548.48 960 672 960 896 859.52 896 736zM576 576l0 307.2 256-153.6L576 576z\" p-id=\"1534\" fill=\"#bfbfbf\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "tAWD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-yanjing",
  "use": "icon-yanjing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yanjing\"><defs><style type=\"text/css\"></style></defs><path d=\"M941.677063 391.710356c9.337669-14.005992 6.224772-32.68133-6.224772-43.575447-14.005992-10.894118-32.68133-7.78122-43.575447 6.224771-1.556449 1.556449-174.300768 205.426673-379.727441 205.426673-199.200878 0-379.727441-205.426673-381.28389-206.982098-10.894118-12.450567-31.124881-14.005992-43.575448-3.112898-12.450567 10.894118-14.005992 31.124881-3.112897 43.575448 3.112897 4.668323 40.46255 46.687322 99.600439 93.375667l-79.369676 82.48155c-12.450567 12.450567-10.894118 32.68133 1.556449 43.575448 3.112897 6.224772 10.894118 9.337669 18.675338 9.337669 7.78122 0 15.562441-3.112897 21.787213-9.337669l85.594447-88.706321c40.46255 28.013007 88.706321 54.469566 141.619438 73.14388L340.959485 707.631586c-4.668323 17.118889 4.669346 34.237779 21.787213 38.906101h9.337669c14.005992 0 26.456558-9.337669 29.568432-23.343661l32.68133-110.494556c24.90011 4.668323 51.356668 7.78122 77.813227 7.78122s52.913117-3.112897 77.813227-7.78122l32.68133 108.938108c3.112897 14.005992 17.118889 23.343661 29.569456 23.343661 3.112897 0 6.224772 0 7.78122-1.556449 17.118889-4.669346 26.456558-21.787212 21.788236-38.906102l-32.68133-108.938108c52.913117-18.675338 101.156888-45.131897 141.619438-73.14388l84.037998 87.150896c6.224772 6.224772 14.005992 9.337669 21.787212 9.337669 7.78122 0 15.562441-3.112897 21.787212-9.337669 12.450567-12.450567 12.450567-31.124881 1.556449-43.575448l-79.369675-82.48155c63.808258-46.688345 101.158934-91.820242 101.158934-91.820242z\" p-id=\"7879\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "tLL1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_locale__ = __webpack_require__("CRCD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress__ = __webpack_require__("WcXo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_locale__["a" /* default */]],

  components: { ElProgress: __WEBPACK_IMPORTED_MODULE_1__progress__["a" /* default */], draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a },

  props: {
    files: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    handlePreview: Function,
    handleChange: Function,
    listType: String
  },
  data: function data() {
    return {
      drapConfig: {
        group: 'description',
        animation: 200,
        ghostClass: 'ghost',
        draggable: '.el-upload-list__item',
        sort: true
      }
    };
  },

  methods: {
    onChange: function onChange(e) {
      this.handleChange(e.moved.element, this.files);
      console.log('handleChange', e);
    },
    parsePercentage: function parsePercentage(val) {
      return parseInt(val, 10);
    },
    handleClick: function handleClick(file) {
      this.handlePreview && this.handlePreview(file);
    },
    isVideo: function isVideo(file) {
      if (file.info && file.info.type) {
        return file.info.type.includes('video');
      } else if (file.raw && file.raw.type) {
        return file.raw.type.includes('video');
      } else if (file.url) {
        return file.url.includes('.mp4');
      }
      return false;
    }
  }
});

/***/ }),

/***/ "teFm":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.qn-cropper[data-v-0d850c2c] .el-dialog--small {\n  width: 440px;\n}\n.qn-cropper[data-v-0d850c2c] .el-dialog__body {\n  text-align: right;\n}\n", ""]);

// exports


/***/ }),

/***/ "tgmO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/**
 * v-hover-editor 指令
 * 功能：鼠标悬停时在元素右上角显示编辑图标
 * 使用方式：<div v-hover-editor>内容</div>
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    // 保存原始定位和光标样式
    var originalPosition = window.getComputedStyle(el).position;
    var originalCursor = el.style.cursor;

    // 如果元素没有定位，设置为relative以便图标绝对定位
    if (originalPosition === 'static') {
      el.style.position = 'relative';
    }

    // 创建编辑图标的函数
    var createEditorIcon = function createEditorIcon() {
      // 检查是否已存在图标，避免重复创建
      if (el.querySelector('.hover-editor-icon')) {
        return;
      }

      // 创建图标容器
      var iconWrapper = document.createElement('div');
      iconWrapper.className = 'hover-editor-icon';
      iconWrapper.style.cssText = '\n        position: absolute;\n        top: 4px;\n        right: 4px;\n        z-index: 999;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 24px;\n        height: 24px;\n        border-radius: 4px;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        transition: all 0.3s ease;\n      ';

      // 创建SVG图标
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'svg-icon editor');
      svg.setAttribute('aria-hidden', 'true');
      svg.style.cssText = '\n        width: 16px;\n        height: 16px;\n        fill: currentColor;\n        color: #409EFF;\n      ';

      var use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
      use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#icon-editor');

      svg.appendChild(use);
      iconWrapper.appendChild(svg);

      // 点击图标时触发自定义事件或回调
      iconWrapper.addEventListener('click', function (e) {
        // 移除 e.stopPropagation()，允许事件冒泡到父元素
        // 如果指令绑定了值（函数），则执行
        if (binding.value && typeof binding.value === 'function') {
          binding.value(el);
        }
        // 触发自定义事件
        el.dispatchEvent(new CustomEvent('editor-click', { detail: { element: el } }));
      });

      el.appendChild(iconWrapper);
    };

    // 移除编辑图标的函数
    var removeEditorIcon = function removeEditorIcon() {
      var icon = el.querySelector('.hover-editor-icon');
      if (icon) {
        icon.remove();
      }
    };

    // 鼠标进入事件
    var handleMouseEnter = function handleMouseEnter() {
      el.style.cursor = 'pointer';
      createEditorIcon();
    };

    // 鼠标离开事件
    var handleMouseLeave = function handleMouseLeave() {
      el.style.cursor = originalCursor;
      removeEditorIcon();
    };

    // 绑定事件监听器
    el.addEventListener('mouseenter', handleMouseEnter);
    el.addEventListener('mouseleave', handleMouseLeave);

    // 在元素上保存事件处理函数，以便在unbind时移除
    el._hoverEditorHandlers = {
      mouseenter: handleMouseEnter,
      mouseleave: handleMouseLeave,
      originalPosition: originalPosition,
      originalCursor: originalCursor
    };
  },
  unbind: function unbind(el) {
    // 移除事件监听器
    if (el._hoverEditorHandlers) {
      el.removeEventListener('mouseenter', el._hoverEditorHandlers.mouseenter);
      el.removeEventListener('mouseleave', el._hoverEditorHandlers.mouseleave);

      // 恢复原始样式
      if (el._hoverEditorHandlers.originalPosition === 'static') {
        el.style.position = '';
      }
      el.style.cursor = el._hoverEditorHandlers.originalCursor;

      // 移除可能残留的图标
      var icon = el.querySelector('.hover-editor-icon');
      if (icon) {
        icon.remove();
      }

      // 清理保存的引用
      delete el._hoverEditorHandlers;
    }
  }
});

/***/ }),

/***/ "uMKz":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.app-levelbar.el-breadcrumb[data-v-4a0bc5c6] {\n  display: inline-block;\n  font-size: 14px;\n  line-height: 50px;\n  margin-left: 10px;\n}\n.app-levelbar.el-breadcrumb .no-redirect[data-v-4a0bc5c6] {\n    color: #97a8be;\n    cursor: text;\n}\n", ""]);

// exports


/***/ }),

/***/ "uZLf":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASAAAADYCAMAAAB8685yAAAAXVBMVEVHcEz6+vr6+vr6+vr6+vr6+vr5+fn////6+vr6+vr5+fn6+vr6+vr6+vr////6+vr6+vr5+fn6+vr6+vr6+vr6+vr6+vr6+vr6+vr////6+vr8/Pz7+/v9/f3+/v5xDZdaAAAAGXRSTlMAlI+V1/ksBv38K5COvQm71CqY+PrW2PTzgNQjbwAABHVJREFUeNrt3QlyIyEMBVCy2s6+zIaFdP9jTuKkpuKMoRENvaD/L5DKK6AxLTXOveX57vJ1jxzl9efds/vI5mwLj1PZvjwcfB5BEcv95g3oAg7xnDl3swNDPLsbdw6FVM7dJRBSuXRXQEjlysEgHQABCEAAAhCAAAQgACEAAtD0QMTi+45wKAYK7E1EuAyIvJ1QARB7SxE1kC2fuFAMKHgPoRSQmAOKrEMOA+hfNEBsEYgUQGIRiAFUsExHgLzHIpQNxNRxagCFnn+sAwhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQFogAhCAAAQgAAEIQACaN4FYRJgoAOh/nONqXCYAfQ2dqLXgAKDPxGqZJABony5WziDqHohL659tAIXBQi82DRQyCuHYMlBWoSDbBcospCSrQNnNNsEmUH6tu9gEUlQqB4tAmmYJsQikKnUP9oB03TZkD0jXbSP2gJTNJOaAtP1sZA2IAFRzCUr8IOsVSNvPJgACUPz/AhCAAAQgAOEpho2iZSD8Fis9Mev2uMPjuKPmKm3wwIzqLEEdH9rXmWEdA3GNh3zXLw6rDKCegajCCtR38YKMfoTtUf4yMME6BwrjNtH9A2WV4IW9YaDhWTZYCNx9GTCNqnE1UWkf3zHmdCOY6NU4/Vn5vGYNI90+35p9Bj9Ubw7ogER8yLr6xUQW/lmCmYFk8QNwXiBe/hSdFYizdyM2gVjX+2cOiFfxBZn5gEjZ+mcNiPQ/i0wBUWETshUgKjmaMQQUSnuQjQCFEeczFoBC6RsGI0Bh3Blo90CDB+lkHGj4RQObBsp5mSeGgfJedi5oIZoYKLvuK9gEUtTskEUgVW0u2wNS1i4vYyGaEEh/sW8wBVRy8TH1AcStfMoXIqK1AZVenF2yZzxcYl5rBZsIqPzeWvU/Guq+TJoGaNS9vqrZcvTNTVoL0Mh7j1k9eCruFKYAGn0vtJTx5BcBzQsUxt/qmzESSNrsyCcAqnLrMY3YpNOygSrdCk3KuVVrKWoOVO3WbNbOrTrzrDVQxVvFT44DkhabhemA2NdM0M6tCvOsLVBdn2/DgKT+s3BioNo+X/8UScV1bCYg8vXzMQoCN9ouTArUwuewEI3aeWrnWTugRj5v/2Kj/cLEQM182m/LJwEKfskRmhto2T6apagN0OJ98peiJkBr8MldiloABVkHUNY8awG0Fp+sA8cGQCvy8dNcXcMr9hl85FcHWpvP0FJUG4j9GtP4+0FCn+2yzOJXGgqR1ACyEwABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIABZAxKLPgKgdFgBRBaBSAEUsASlgSzOMVYBGZxjQQVkbwhFiohcs2bvHp7xKSBjQtHefbeHkE8V6bnidvWehk+iEtalv6pA3PtiLQO3uLg9sgcQgAAEIAABCEAAQgAEIAABaGFAVzBI5Y+7BEIqT+4cCKncuusdFOLZXTt3AYZ4Lpxzm0c4xHK/ce9CZ1tQnMr25cF95Ob21w94HOf30+31u81fWSRb8qQmCt8AAAAASUVORK5CYII="

/***/ }),

/***/ "vXUM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-yonghuming",
  "use": "icon-yonghuming-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yonghuming\"><defs><style type=\"text/css\"></style></defs><path d=\"M504.951 511.98c93.49 0 169.28-74.002 169.28-165.26 0-91.276-75.79-165.248-169.28-165.248-93.486 0-169.287 73.972-169.279 165.248-0.001 91.258 75.793 165.26 169.28 165.26z m77.6 55.098H441.466c-120.767 0-218.678 95.564-218.678 213.45V794.3c0 48.183 97.911 48.229 218.678 48.229H582.55c120.754 0 218.66-1.78 218.66-48.229v-13.77c0-117.887-97.898-213.45-218.66-213.45z\" p-id=\"7987\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "vuLS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppMain',
  computed: {
    key: function key() {
      return this.$route.name !== undefined ? this.$route.name : this.$route;
    }
  }
});

/***/ }),

/***/ "wK7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', _vm._g(_vm._b({
    staticClass: "preview",
    attrs: {
      "modal": false,
      "before-close": _vm.handleBeforeClose,
      "title": "预览"
    }
  }, 'el-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "bg-img"
  }, [(_vm.isVideo(_vm.selection)) ? _c('video', {
    ref: "video",
    staticClass: "video",
    attrs: {
      "src": _vm.selection.url,
      "alt": _vm.selection.name,
      "controls": ""
    }
  }) : _c('img', {
    staticClass: "mosaic-bg",
    attrs: {
      "src": _vm.selection.url,
      "alt": _vm.selection.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [(_vm.isEdit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleToEdit
    }
  }, [_vm._v("剪 切")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")])], 1), _vm._v(" "), (_vm.list.length) ? _c('ul', {
    staticClass: "thumbnail-list"
  }, _vm._l((_vm.list), function(item) {
    return _c('li', {
      key: item.url,
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.handleSwitch(item)
        }
      }
    }, [(_vm.isVideo(item)) ? _c('video', {
      staticClass: "mosaic-bg",
      attrs: {
        "src": item.url,
        "alt": item.name
      }
    }) : _c('img', {
      staticClass: "mosaic-bg",
      attrs: {
        "src": item.url,
        "alt": item.name
      }
    })])
  })) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d60a365", esExports)
  }
}

/***/ }),

/***/ "wSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_upload_vue__ = __webpack_require__("atwv");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_upload_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/QnUpload-1.0.0/upload/src/iframe-upload.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4de293b2", Component.options)
  } else {
    hotAPI.reload("data-v-4de293b2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__env_js__ = __webpack_require__("yZtZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svrapi_js__ = __webpack_require__("Mp/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_vendor_qnbar_msgWsClient__ = __webpack_require__("V8LJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_http_ws_base__ = __webpack_require__("xjuR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");





var _name$provide$data$be;

//
//
//
//
//
//
//
//








var PT = __WEBPACK_IMPORTED_MODULE_5__env_js__["a" /* default */].PT;

/* harmony default export */ __webpack_exports__["a"] = (_name$provide$data$be = {
  name: "mainPage",
  provide: function provide() {
    // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    };
  },

  data: function data() {
    return {
      agent_id: ""
    };
  },

  beforeMount: function beforeMount() {
    // 平台
    var self = this;
    //--------- 固定统一登录初始化流程 ---------

    var withLocalSessClean = PT.qnlogin.findGetParameter("local_sess_clean");
    if (withLocalSessClean) {
      PT.apiClient.blockQuery();
    }

    //登录模块的配置和初始化
    var LoginRunConf = {};

    //本地session ok时执行
    function OnLocalSessionOkDoFunc() {
      self.hasLogin = PT.qnlogin.isLocalSessOk;
    }
    //没有本地session时执行, 注意不是完全没有，可能带ticket或tgc...
    function OnLocalSessionNotOkDoFunc() {
      self.hasLogin = PT.qnlogin.isLocalSessOk;
    }

    //平台本地ticket校验并返回session的接口
    function OnHasTicketDoFunc(ticket) {
      var postParams = {
        service_ticket: ticket
      };
      PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_6__svrapi_js__["a" /* default */].loginValidateTicket, postParams, PT.qnlogin.handleTicketValidate);
      PT.apiClient.blockQuery();
    }

    function OnSessionFailDoFunc() {
      //本地和passport都失败，完全没有session
      // console.log("OnSessionFailDoFunc");
      PT.apiClient.blockQuery();
      self.jumpLogin();
    }

    //避免无失败卡页面
    function OnTicketValidateFailFunc() {
      alert("登录ticket验证失败！请尝试重新登录");
      PT.qnlogin.logout();
      this.hasLogin = PT.qnlogin.isLocalSessOk;
      window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl);
    }

    //----------- 外部执行带入登录工具的配置 ------------
    LoginRunConf.JumpBackUrl = PT.config.loginJumpBackUrl; //登录回跳地址
    LoginRunConf.OnLocalSessionOkDo = OnLocalSessionOkDoFunc;
    LoginRunConf.OnLocalSessionNotOkDo = OnLocalSessionNotOkDoFunc;
    LoginRunConf.OnHasTicketDo = OnHasTicketDoFunc;
    LoginRunConf.OnSessionFailDo = OnSessionFailDoFunc;
    LoginRunConf.OnTicketValidateFail = OnTicketValidateFailFunc;

    //---- 登录ok后的执行和鉴权的执行 ----

    //权限检查对象
    //全局 - 获取当前登录用户的全量权限code
    function checkAllUserPermission() {
      //开始执行鉴权请求
      PT.apiClient.blockQuery();
      PT.permissionChecker.queryAllPermissions(PT.apiClient, PT.config.platformUsagespace, PT.qnlogin.getLocalSess(), onAllPermissionQueryOK, onAllPermissionQueryFail);
    }

    //全局 - 登录OK后执行内容
    function onPageSessionOk() {
      self.user_title = "读取中...";
      self.hasLogin = PT.qnlogin.isLocalSessOk;
      //有登录，就执行权限获取
      checkAllUserPermission();
    }

    //执行passport登录模块的页面初始化运行过程
    LoginRunConf.OnAfterLocalSessionOkDo = onPageSessionOk;
    PT.qnlogin.runInPageReady(LoginRunConf);

    function onAllPermissionQueryOK() {
      //勿动~
      //PT.apiClient.resumeQuery();

      var data = PT.permissionChecker.hasPermission("local_user_base_module");
      eventBus.$emit("Jurisdiction", data); //判断权限

      PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_6__svrapi_js__["a" /* default */].loginUserInfo, "", function (rsp) {
        if (rsp.code == 0) {
          //debugger;
          // console.log("app请求");
          self.$store.commit("SET_USER_INFO", rsp.data);
          self.commonSetLocalDataNew("identity", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(rsp.data));
          // console.log(rsp);
          self.getUserInfo();
          self.$store.dispatch('setAuth');
        } else {
          alert("获取用户信息错误！");
        }
      }, null, "", true);
    }

    function onAllPermissionQueryFail() {
      alert("请求权限失败，请尝试重新登录...");
      PT.qnlogin.logout();
      this.hasLogin = PT.qnlogin.isLocalSessOk;
      window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl);
    }
  },

  mounted: function mounted() {
    //内容审核
    // const setTime = setTimeout(() => {
    //   this.$store.dispatch('getWhiteListType')
    //   this.$store.dispatch('getExamineRemind')
    //   //清除定时器
    //   clearTimeout(setTime);
    // },1000)
    var self = this;

    //【业务逻辑入口改到这里了！！！】
    // 获取待配送订单
    self.getWaitOrder = function () {
      PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_6__svrapi_js__["a" /* default */].getOrderList, { type: 3 }, function (rsp) {
        if (rsp.code == 0) {
          self.$store.commit("SET_WAIT_ORDER", rsp.data);
          handleWs();
        } else {
          alert('待配送订单获取错误！');
        }
      });
    };

    // 获得权限
    Notification.requestPermission();

    // 3秒拉取一次投影仪服务请求
    // var timer = setInterval(getRemindMsg, 3000);
    // function getRemindMsg() {
    //   PT.apiClient.query(SvrApi.waitDistribution, {}, function(rsp) {
    //     if (rsp.code == 0) {
    //       if (rsp.data.is_notic > 0) {
    //         self.$store.commit("GET_ISORDER_DATA", true);
    //         showDeskTopNotice("待配送数量", rsp.data.num);
    //       }
    //     } else {
    //       self.$alert(rsp.msg, "提示");
    //       clearInterval(timer);
    //     }
    //   });
    // }
    function showDeskTopNotice(title, msg) {
      var Notification = window.Notification || window.mozNotification || window.webkitNotification;
      if (Notification) {
        Notification.requestPermission(function (status) {
          // console.log('status: ' + status)
          //status默认值'default'等同于拒绝 'denied' 意味着用户不想要通知 'granted' 意味着用户同意启用通知
          if ("granted" != status) {
            return;
          } else {
            var tag = "qnbar" + Math.random();
            var notify = new Notification(title, {
              dir: "auto",
              lang: "zh-CN",
              tag: tag, //实例化的notification的id
              icon: "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80", //通知的缩略图,//icon 支持ico、png、jpg、jpeg格式
              body: msg //通知的具体内容
            });
            notify.onclick = function () {
              //如果通知消息被点击,通知窗口将被激活
              window.focus();
            }, notify.onerror = function () {
              // console.log("HTML5桌面消息出错！！！");
            };
            notify.onshow = function () {
              // setTimeout(function(){
              //     notify.close();
              // },2000)
            };
            notify.onclose = function () {
              // console.log("HTML5桌面消息关闭！！！");
            };
          }
        });
      } else {
        alert("您的浏览器不支持桌面消息");
      }
    }

    // ----------- 执行一个全局或当前页的websocket -----------
    function handleWs() {
      // ---- 1.身份绑定 -----
      // 测试内容: 商户页面通知业务
      // 门店序号绑定
      // sn = agent_id
      var storeSn = self.agent_id + "@MM.STORE"; // sn@group
      // console.log(storeSn)
      // 业务-组和序号 的绑定
      var bzAndIdBindMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
      bzAndIdBindMap.set(__WEBPACK_IMPORTED_MODULE_8__src_http_ws_base__["a" /* ws_base */].BZ_MCH_WEB_NTF, storeSn);
      bzAndIdBindMap.set(__WEBPACK_IMPORTED_MODULE_8__src_http_ws_base__["a" /* ws_base */].BZ_HOTEL_ROOM_MGR, storeSn);
      bzAndIdBindMap.set(__WEBPACK_IMPORTED_MODULE_8__src_http_ws_base__["a" /* ws_base */].AGENT_WEB_MSG, storeSn);
      // ---- 2.业务处理器绑定 ----
      // 测试内容: 商户页面通知业务
      // 对收到的消息进行处理
      var bzMchWebNtfDealer = function bzMchWebNtfDealer(protoMsg) {
        // todo 这里最好也配置化然后处理
        window.eventBus.$emit(protoMsg.getOp(), JSON.parse(protoMsg.getBzdata())); // 发送事件
        if (protoMsg.getOp() == "prjt_retail_ntf") {
          // 投影商品购买通知...
          if (protoMsg.getBzdata()) {
            // console.log(protoMsg.getBzdata());
            var data = JSON.parse(protoMsg.getBzdata());
            var sendData = {
              total: data.num
            };
            if (data.type == 1) {
              var Prompt = document.getElementById("Prompt");
              Prompt.play();
              showDeskTopNotice("待配送数量", data.num);
              self.$store.commit('SET_WAIT_ORDER', sendData);
              self.$store.commit("GET_ISORDER_DATA", true);
            } else if (data.type == 2) {
              self.$store.commit('SET_WAIT_ORDER', sendData);
              self.$store.commit("GET_ISORDER_DATA", true);
            } else {
              // console.log('error')
            }
          } else {
              // console.log("?????");
            }
        }
        // 如果当前路由无法处理，使用其他形式传达通知
      };
      var bzMchHotelRoomMgr = function bzMchHotelRoomMgr(protoMsg) {
        window.eventBus.$emit(protoMsg.getOp(), protoMsg.getBzdata()); // 发送事件
      };
      var bzMsgDealerMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
      bzMsgDealerMap.set(__WEBPACK_IMPORTED_MODULE_8__src_http_ws_base__["a" /* ws_base */].BZ_MCH_WEB_NTF, bzMchWebNtfDealer);
      bzMsgDealerMap.set(__WEBPACK_IMPORTED_MODULE_8__src_http_ws_base__["a" /* ws_base */].BZ_HOTEL_ROOM_MGR, bzMchHotelRoomMgr);
      bzMsgDealerMap.set(__WEBPACK_IMPORTED_MODULE_8__src_http_ws_base__["a" /* ws_base */].AGENT_WEB_MSG, bzMchHotelRoomMgr);

      // ---- 3.鉴权信息获取 ----
      var PT_NAME = PT.config.platformUsagespace;

      // ---- 4.初始化并启动客户端 ----
      __WEBPACK_IMPORTED_MODULE_7__src_vendor_qnbar_msgWsClient__["a" /* default */].MsgWsClient.init({
        proto: PT.config.wsProto,
        host: PT.config.wsHost, // 必填
        port: PT.config.wsPort, // 必填
        path: __WEBPACK_IMPORTED_MODULE_8__src_http_ws_base__["a" /* ws_base */].wsPath, // 必填
        authSys: PT_NAME, // 必填 项目配置中的平台字符串
        authKey: PT.qnlogin.getLocalSess(), // 必填 本地系统的session key/token
        toBindMap: bzAndIdBindMap, // 必填
        bzMsgDealerMap: bzMsgDealerMap // 必填
        //debug : true,
      });
      __WEBPACK_IMPORTED_MODULE_7__src_vendor_qnbar_msgWsClient__["a" /* default */].MsgWsClient.startRun();
      var obj = {
        proto: PT.config.wsProto,
        host: PT.config.wsHost, // 必填
        port: PT.config.wsPort, // 必填
        path: __WEBPACK_IMPORTED_MODULE_8__src_http_ws_base__["a" /* ws_base */].wsPath, // 必填
        authSys: PT_NAME, // 必填 项目配置中的平台字符串
        authKey: PT.qnlogin.getLocalSess(), // 必填 本地系统的session key/token
        toBindMap: bzAndIdBindMap, // 必填
        bzMsgDealerMap: bzMsgDealerMap // 必填
      };
      console.log(obj);
      // ------- 发送消息功能暂时禁用中 -------
      // test send a msg to self
      // wsc.MsgWsClient.sendMsg(BZ_MCH_WEB_NTF, "prjt_retail_ntf", "test send and receive self", storeSn);
      // test send a msg to projector
      // wsc.MsgWsClient.sendMsg(BZ_PRJT_TXT_MSG, "send_msg", "hello!!!", "2@p");
    }
  }

}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$provide$data$be, "data", function data() {
  return {
    hasLogin: false,
    user_title: "未登录",
    agent_id: "",
    isRouterAlive: true // 控制视图是否显示的变量
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$provide$data$be, "methods", {
  // -- 这坨是登录的 --
  handleCheckLoginInfoFail: function handleCheckLoginInfoFail() {
    //单一用户类型，直接进入登录
    PT.qnlogin.jumpToCheck(PT.config.loginJumpBackUrl, "merchant"); //official_staff 官方运营人员  /  agent 合作商  /  merchant 商户 /  merchant_staff 员工
    this.hasLogin = PT.qnlogin.isLocalSessOk;
  },


  // 跳转登录身份
  jumpToLoginChoose: function jumpToLoginChoose() {
    var self = this;
    self.$router.push({ path: "/login" });
  },
  handleOnLogout: function handleOnLogout(rsp) {
    window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl);
  },
  jumpLogin: function jumpLogin() {
    //console.log('jumpLogin');
    PT.qnlogin.firstCheck(PT.config.loginJumpBackUrl,
    // this.handleCheckLoginInfoFail
    this.jumpToLoginChoose);
  },
  runLogout: function runLogout() {
    var postParams = {
      local_sess: PT.qnlogin.getLocalSess()
    };
    PT.apiClient.query(__WEBPACK_IMPORTED_MODULE_6__svrapi_js__["a" /* default */].logout, postParams, this.handleOnLogout);
    PT.qnlogin.logout();

    this.hasLogin = PT.qnlogin.isLocalSessOk;
  },


  // -- 这坨是菜单的 --
  goPage: function goPage(routePath) {
    //todo 先鉴权
    this.$router.push(routePath);
  },
  reload: function reload() {
    this.isRouterAlive = false; // 先关闭，
    this.$nextTick(function () {
      this.isRouterAlive = true; // 再打开
    });
  },

  //判断酒店足浴
  getUserInfo: function getUserInfo() {
    var self = this;
    PT.apiClient.query("bz-mix/bz/get-base-info", "", function (rsp) {
      if (rsp.code == 0) {
        self.agent_id = rsp.data.agent_id;
        // 属于新起点门店
        if (['5', '6'].includes(rsp.data.group_id)) {
          // 登出
          return self.runLogout();
        }
        if (rsp.data.agentType != 1 && rsp.data.agentType != 2) {
          self.getWaitOrder();
        }
        // console.log("设置数据")
        // console.log("设置数据")
        // console.log(self.commonSetLocalDataNew)
        self.commonSetLocalDataNew("user_data", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(rsp.data));
        self.$store.commit("SET_ROUTE", rsp.data);
        var opendata = {
          store_id: rsp.data.agent_id,
          type: 1,
          operation: 3
        };
        // self.getIsopen(opendata);
        //旧
        self.$store.commit("GET_NAVBAR_DATA", rsp.data);
        //存储酒店足浴
        self.$store.commit("SET_HOTEL_OR_FOOTBATH", rsp.data);
        //globalData.agentType = rsp.data.agentType;//5代表酒店7代表足浴
        if (!!rsp.data.agentType && rsp.data.agentType == 5) {
          //eventBus.$emit('user_title', "酒店");
          self.$store.commit("SET_USER_TITLE", "酒店");
        } else if (!!rsp.data.agentType && rsp.data.agentType == 7) {
          //eventBus.$emit('user_title', "足浴");
          self.$store.commit("SET_USER_TITLE", "足浴");
        } else {}

        PT.apiClient.resumeQuery();
      } else {
        alert("获取用户信息错误！!");
      }
    }, null, "", true);
  }
  // getIsopen(data) {
  //   PT.apiClient.query(
  //     SvrApi.queryOpen,
  //     data,
  //     function(rsp) {
  //       if (rsp.code == 0) {
  //         // console.log(rsp.data.is_open)
  //         localStorage.setItem("isopen",JSON.stringify(rsp.data));
  //       } else {
  //         self.$alert(res.msg, "提示");
  //       }
  //     },
  //     null,
  //     "",
  //     true
  //   );
  // }

}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$provide$data$be, "computed", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])(['the_agent_id']))), _name$provide$data$be);

/***/ }),

/***/ "xNsp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("6HNQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cfbc316_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("EVlv");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cfbc316_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Icon-svg/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0cfbc316", Component.options)
  } else {
    hotAPI.reload("data-v-0cfbc316", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xPWx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var PackHeadLen = 16;

var TransPacket = function () {
    //static PackHeadLen = 16;

    function TransPacket(versionInt, cmdInt, reserveInt, bodyUint8Af) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TransPacket);

        this.H_Version = 0;
        this.H_Cmd = 0;
        this.H_Reserve = 0;
        this.H_BodyLen = 0;
        this.PayloadBody = null; // Uint8Array

        if (Number(versionInt) > 0) {
            this.H_Version = versionInt;
        }
        if (Number(cmdInt) > 0) {
            this.H_Cmd = cmdInt;
        }
        if (Number(reserveInt) > 0) {
            this.H_Reserve = reserveInt;
        }

        if (bodyUint8Af) {
            this.H_BodyLen = bodyUint8Af.byteLength;
            this.PayloadBody = bodyUint8Af;
        }
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TransPacket, [{
        key: "encodeToBytes",
        value: function encodeToBytes() {
            var buffer = new Uint8Array(PackHeadLen + this.H_BodyLen);
            var headBuffer = new ArrayBuffer(PackHeadLen);
            var dv = new DataView(headBuffer);
            dv.setUint32(0, this.H_Version);
            dv.setUint32(4, this.H_Cmd);
            dv.setUint32(8, this.H_BodyLen);
            dv.setUint32(12, this.H_Reserve);

            buffer.set(new Uint8Array(headBuffer), 0);
            if (this.H_BodyLen > 0) {
                buffer.set(this.PayloadBody, headBuffer.byteLength);
            }

            return buffer.buffer;
        }
    }], [{
        key: "decodeByBytes",
        value: function decodeByBytes(arrayBuffData) {
            if (arrayBuffData.byteLength <= PackHeadLen) {
                return null;
            }
            var dv = new DataView(arrayBuffData);
            var ver = dv.getUint32(0);
            var cmd = dv.getUint32(4);
            var bodyLen = dv.getUint32(8);
            var reserve = dv.getUint32(12);
            var bodyPayload = new Uint8Array(arrayBuffData.slice(PackHeadLen));
            return new TransPacket(ver, cmd, reserve, bodyPayload);
        }
    }]);

    return TransPacket;
}();

// 导出对象


var MsgSvrPacker = {
    pack: function pack(verInt, cmdInt, dataUint8ArrBuf) {
        var pack = new TransPacket(verInt, cmdInt, 0, dataUint8ArrBuf);
        return pack.encodeToBytes();
    },
    unpack: function unpack(arrayBuffData) {
        return TransPacket.decodeByBytes(arrayBuffData);
    }

    // node exports
    //module.exports.TransPacket = TransPacket;
    // module.exports.MsgSvrPacker = MsgSvrPacker;
};/* harmony default export */ __webpack_exports__["a"] = ({
    MsgSvrPacker: MsgSvrPacker

    // es6 exports

});

/***/ }),

/***/ "xfsc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper",
    class: {
      hideSidebar: !_vm.sidebar.opened
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper",
    on: {
      "mouseover": function($event) {
        _vm.toggleSidebar()
      }
    }
  }, [_c('sidebar', {
    staticClass: "sidebar-container"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('navbar'), _vm._v(" "), _c('app-main')], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5f289638", esExports)
  }
}

/***/ }),

/***/ "xjuR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ws_base; });
var ws_base = {
    // ----------- File 1 Ws配置 ----------- 
    // wsHost : "10.10.4.6", // 测试环境 10.10.4.6
    // wsPort : "16666",         // 暂时固定
    wsPath: "/msgws", // 固定


    // ----------- File 2 全局ws业务定义，和服务端同步定义 ----------- 
    BZ_PRJT_TXT_MSG: 1001, // 投影仪即时显示的文字消息业务
    BZ_FTSTORE_ROOM_MGR: 1002, // 方糖门店房间管理业务
    BZ_HOTEL_ZYU_ROOM_MGR: 1003, // 酒店足浴房间管理业务
    BZ_FBS_STORE_ROOM_MGR: 1004, // 加盟商门店房间管理的
    BZ_MCH_WEB_NTF: 1005, // 商户web端消息推送
    BZ_HOTEL_ROOM_MGR: 1008, // 开关房操作
    AGENT_WEB_MSG: 1012 // 投影仪即时显示的文字消息业务

};



/***/ }),

/***/ "yDPa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-progress",
    class: [
      'el-progress--' + _vm.type,
      _vm.status ? 'is-' + _vm.status : '',
      {
        'el-progress--without-text': !_vm.showText,
        'el-progress--text-inside': _vm.textInside,
      }
    ]
  }, [(_vm.type === 'line') ? _c('div', {
    staticClass: "el-progress-bar"
  }, [_c('div', {
    staticClass: "el-progress-bar__outer",
    style: ({
      height: _vm.strokeWidth + 'px'
    })
  }, [_c('div', {
    staticClass: "el-progress-bar__inner",
    style: (_vm.barStyle)
  }, [(_vm.showText && _vm.textInside) ? _c('div', {
    staticClass: "el-progress-bar__innerText"
  }, [_vm._v(_vm._s(_vm.percentage) + "%")]) : _vm._e()])])]) : _c('div', {
    staticClass: "el-progress-circle",
    style: ({
      height: _vm.width + 'px',
      width: _vm.width + 'px'
    })
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 100 100"
    }
  }, [_c('path', {
    staticClass: "el-progress-circle__track",
    attrs: {
      "d": _vm.trackPath,
      "stroke": "#e5e9f2",
      "stroke-width": _vm.relativeStrokeWidth,
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "el-progress-circle__path",
    style: (_vm.circlePathStyle),
    attrs: {
      "d": _vm.trackPath,
      "stroke-linecap": "round",
      "stroke": _vm.stroke,
      "stroke-width": _vm.relativeStrokeWidth,
      "fill": "none"
    }
  })])]), _vm._v(" "), (_vm.showText && !_vm.textInside) ? _c('div', {
    staticClass: "el-progress__text",
    style: ({
      fontSize: _vm.progressTextSize + 'px'
    })
  }, [(!_vm.status) ? [_vm._v(_vm._s(_vm.percentage) + "%")] : _c('i', {
    class: _vm.iconClass
  })], 2) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a89de698", esExports)
  }
}

/***/ }),

/***/ "yZtZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env_release_js__ = __webpack_require__("o6Ms");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env_test_js__ = __webpack_require__("PvI4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__env_local_js__ = __webpack_require__("+nHC");




var env = null;
if (true) {
    env = __WEBPACK_IMPORTED_MODULE_0__env_release_js__["a" /* default */];
} else if (process.env.NODE_ENV === 'testing') {
    env = test;
} else {
    env = local;
}
/* harmony default export */ __webpack_exports__["a"] = (env);

/***/ }),

/***/ "z035":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);

/* harmony default export */ __webpack_exports__["a"] = ({

    // -------------------addStoreForm----------------------
    // 检查是否为空
    checkEmpty: function checkEmpty(rule, value, callback) {
        setTimeout(function () {
            // console.log(value);
            if (value == "" || value == undefined) {
                callback(new Error('不能为空'));
            } else {
                callback();
            }
        }, 500);
    },
    // 检车账户名长度
    checklength: function checklength(rule, value, callback) {
        var login_name = $.trim(value);
        var istrue = /^.{1,6}$/;
        var error = "不能超过6个字符";
        // 如果为1开头则验证手机号码 
        if (value == "" || value == undefined) {
            callback(new Error('名称不能为空'));
        } else {
            if (istrue.exec(login_name)) {
                callback();
                return false;
            } else {
                callback(new Error(error));
                return false;
            }
        }
    },
    // 检验门店账号
    checklogin_name: function checklogin_name(rule, value, callback) {
        var login_name = $.trim(value);
        var istrue = /^[a-zA-Z][a-zA-Z0-9]{2,15}$/;
        var error = "请输入英文开头的3至16个字符";
        // 如果为1开头则验证手机号码 
        if (value == "" || value == undefined) {
            callback(new Error('账号不能为空'));
        } else {
            if (istrue.exec(login_name)) {
                callback();
                return false;
            } else {
                callback(new Error(error));
                return false;
            }
        }
    },
    //检验门店密码
    checklogin_pass: function checklogin_pass(rule, value, callback) {
        var login_name = $.trim(value);
        var istrue = /^[a-zA-Z0-9]{6,16}$/;
        var error = "请输入6至16位英文数字密码";
        // 如果为1开头则验证手机号码 
        if (value == "" || value == undefined) {
            callback(new Error('密码不能为空'));
        } else {
            if (istrue.exec(login_name)) {
                callback();
                return false;
            } else {
                callback(new Error(error));
                return false;
            }
        }
    },
    // 检查是否选择日期或者选择永久
    checkdate: function checkdate(rule, value, callback) {
        setTimeout(function () {
            // console.log(typeof value);
            if (value == "" || value == undefined) {
                callback(new Error('请选择日期或者永久'));
            } else {
                callback();
            }
        }, 500);
    },
    // 检查是否是正整数
    checkPlusNumber: function checkPlusNumber(rule, value, callback) {
        if (!value) {
            return callback(new Error('不能为空'));
        }
        setTimeout(function () {
            value = Number(value);
            if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
                callback(new Error('请输入正整数'));
            } else {
                if (value < 0) {
                    callback(new Error('大于0正整数'));
                } else {
                    callback();
                }
            }
        }, 500);
    },
    // 验证电话号码
    checkContactNumber: function checkContactNumber(rule, value, callback) {
        var mobile = $.trim(value);
        var isMobile = /^1[0-9]{10}$/;
        var isPhone = /^0\d{2,3}-?\d{7,8}$/;
        var error = "请正确填写电话号码，例如:13511111111或010-11111111";
        //如果为1开头则验证手机号码 
        if (value == "" || value == undefined) {
            callback(new Error('号码不能为空'));
        } else {
            if (mobile.substring(0, 1) == 1) {
                if (isMobile.exec(mobile) && mobile.length == 11) {
                    callback();
                    return false;
                } else {
                    callback(new Error(error));
                    return false;
                }
            } else if (mobile.substring(0, 1) == 0) {
                if (isPhone.test(mobile)) {
                    callback();
                    return false;
                } else {
                    callback(new Error(error));
                    return false;
                }
            } else {
                callback(new Error(error));
            }
        }
    },
    //验证不是必填的电话号码
    checkphoneNumber: function checkphoneNumber(rule, value, callback) {
        var mobile = $.trim(value);
        var isMobile = /^1[0-9]{10}$/;
        var isPhone = /^0\d{2,3}-?\d{7,8}$/;
        var error = "请正确填写电话号码，例如:13511111111或010-11111111";
        //如果为1开头则验证手机号码 
        if (value == "" || value == undefined) {
            callback();
        } else {
            if (mobile.substring(0, 1) == 1) {
                if (isMobile.exec(mobile) && mobile.length == 11) {
                    callback();
                    return false;
                } else {
                    callback(new Error(error));
                    return false;
                }
            } else if (mobile.substring(0, 1) == 0) {
                if (isPhone.test(mobile)) {
                    callback();
                    return false;
                } else {
                    callback(new Error(error));
                    return false;
                }
            } else {
                callback(new Error(error));
            }
        }
    },
    //检验数字
    check_number: function check_number(rule, value, callback) {
        var login_name = $.trim(value);
        var istrue = /^[0-9\-0-9]{1,20}$/;
        var error = "请输入正确的号码";
        // 如果为1开头则验证手机号码 
        if (value == "" || value == undefined) {
            callback();
            return false;
        } else {
            if (istrue.exec(login_name)) {
                callback();
                return false;
            } else {
                callback(new Error(error));
                return false;
            }
        }
    },
    // 检查是否是0-1440
    checkNumberOne: function checkNumberOne(rule, value, callback) {
        var myvalue = $.trim(value);
        // console.log(myvalue)
        var isnumber = /^[1-9]\d*$/;
        if (value == "" || value == undefined || null) {
            return callback(new Error('不能为空'));
        } else if (value == 0) {
            callback();
            return false;
        } else {
            if (isnumber.test(myvalue)) {
                if (myvalue <= 1440) {
                    callback();
                    return false;
                } else {
                    callback(new Error('请输入0-1440的整数'));
                    return false;
                }
            } else {
                callback(new Error('请输入0-1440的整数'));
                return false;
            }
        }
    },
    // 检查是否是1-1440
    checkNumberTwo: function checkNumberTwo(rule, value, callback) {
        var myvalue = $.trim(value);
        // console.log(myvalue)
        var isnumber = /^[1-9]\d*$/;
        if (value == "" || value == undefined || null) {
            return callback(new Error('不能为空'));
        } else {
            if (isnumber.test(myvalue)) {
                if (myvalue <= 1440) {
                    callback();
                    return false;
                } else {
                    callback(new Error('请输入1-1440的整数'));
                    return false;
                }
            } else {
                callback(new Error('请输入1-1440的整数'));
                return false;
            }
        }
    },
    // 检查房间名称长度
    checkroomlength: function checkroomlength(rule, value, callback) {
        var login_name = $.trim(value);
        var t = login_name.replace(/[\u4e00-\u9fa5]/g, ''); //替换中文
        var km = (login_name.length - t.length) * 2 + t.length; //判断长度
        // console.log(t)
        // console.log(km)
        var istrue = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
        var error = "不超过12个字节的英文数字或汉字";
        // 如果为1开头则验证手机号码 
        if (value == "" || value == undefined) {
            callback(new Error('名称不能为空'));
        } else {
            if (istrue.exec(login_name) && km <= 12) {
                callback();
                return false;
            } else {
                callback(new Error(error));
                return false;
            }
        }
    }
    // -------------------addStoreForm----------------------
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "zN+a":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "*{margin:0;padding:0;}\nhtml,body,#app,.wrapper{\n    width:100%;\n    height:100%;\n    overflow: hidden;\n}\nbody{\n    font-family:\"Helvetica Neue\",Helvetica, \"microsoft yahei\", arial, STHeiTi, sans-serif;\n}\na{text-decoration: none}\n.content{\n    background: none repeat scroll 0 0 #fff;\n    position: absolute;\n    left: 200px;\n    right: 0;\n    top: 70px;\n    bottom:0;\n    width: auto;\n    padding:40px;\n    box-sizing: border-box;\n    overflow-y: scroll;\n}\n.crumbs{\n    margin-bottom: 20px;\n}\n.pagination{\n    margin: 20px 0;\n    text-align: right;\n}\n.plugins-tips{\n    padding:20px 10px;\n    margin-bottom: 20px;\n}\n.el-button+.el-tooltip {\n    margin-left: 10px;\n}\n.el-table td,.el-table th{\n    padding:5px 18px;\n}\n.el-table tr:hover{\n    background: #f6faff;\n}\n.mgb20{\n    margin-bottom: 20px;\n}\n\n.move-enter-active,.move-leave-active{\n    transition: opacity .5s;\n}\n.move-enter,.move-leave{\n    opacity: 0;\n}\n/*BaseForm*/\n.form-box{\n    width:600px;\n}\n.form-box .line{\n    text-align: center;\n}\n.el-time-panel__content::after, .el-time-panel__content::before {\n    margin-top: -7px;\n}\n/*Readme*/\n.ms-doc .el-checkbox__input.is-disabled+.el-checkbox__label{\n    color: #333;\n    cursor: pointer;\n}\n/*Upload*/\n.pure-button{\n    width:150px;\n    height:40px;\n    line-height: 40px;\n    text-align: center;\n    color: #fff;\n    border-radius: 3px;\n}\n.g-core-image-corp-container .info-aside{\n    height:45px;\n}\n/* .el-upload--text {\n    background-color: #fff;\n    border: 1px dashed #d9d9d9;\n    border-radius: 6px;\n    box-sizing: border-box;\n    width: 360px;\n    height: 180px;\n    text-align: center;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n} */\n.el-upload--text .el-icon-upload {\n    font-size: 67px;\n    color: #97a8be;\n    margin: 40px 0 16px;\n    line-height: 50px;\n}\n.el-upload--text {\n    color: #97a8be;\n    font-size: 14px;\n    text-align: center;\n}\n.el-upload--text em {\n    font-style: normal;\n}\n/*VueEditor*/\n.ql-container{\n    min-height: 400px;\n}\n.ql-snow .ql-tooltip{\n    transform: translateX(117.5px) translateY(10px) !important;\n}\n.editor-btn{\n    margin-top: 20px;\n}\n.icon {\n    width: 1.15em;\n    height: 1.15em;\n    vertical-align: -0.2em;\n    fill: currentColor;\n    overflow: hidden;\n}\n.m-l-10{\n    margin-left: 10px !important;\n}\n\n\n\n\n.mouse-Up{\n    cursor:pointer;\n}\n.locationA{\n    position:absolute;\n    top:0px;\n    right:0px;\n}\n.locationR{\n    position:relative;\n}\n.m_l_10{\n    margin-left:10px;\n}\n.m_l_42{\n    margin-left:42px;\n}\n.btnColor{\n    background:#d7d7d7!important;\n    color:#000!important;\n}\n.d7{\n    background:#d7d7d7!important;\n}\n.b7{\n    background-color: #3366b7!important;\n}\n\n\n.lef{\n    float:left;\n}\n.rig{\n    float:right;\n}\n.m_r_15{\n    margin-right:15px;\n}\n", ""]);

// exports


/***/ }),

/***/ "zmfK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-capital",
  "use": "icon-capital-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-capital\"><defs><style type=\"text/css\"></style></defs><path d=\"M641.910448 502.447761H372.537313c-15.283582 0-28.656716-13.373134-28.656716-28.656716s13.373134-28.656716 28.656716-28.656717h269.373135c15.283582 0 28.656716 13.373134 28.656716 28.656717s-13.373134 28.656716-28.656716 28.656716zM641.910448 597.970149H372.537313c-15.283582 0-28.656716-13.373134-28.656716-28.656716s13.373134-28.656716 28.656716-28.656717h269.373135c15.283582 0 28.656716 13.373134 28.656716 28.656717s-13.373134 28.656716-28.656716 28.656716z\" fill=\"#BFCBD9\" p-id=\"2487\" /><path d=\"M508.179104 722.149254c-15.283582 0-28.656716-13.373134-28.656716-28.656717V475.701493c0-15.283582 13.373134-28.656716 28.656716-28.656717s28.656716 13.373134 28.656717 28.656717v217.791044c0 15.283582-13.373134 28.656716-28.656717 28.656717z\" fill=\"#BFCBD9\" p-id=\"2488\" /><path d=\"M510.089552 500.537313c-9.552239 0-17.19403-3.820896-22.925373-11.462686L382.089552 349.61194c-9.552239-13.373134-7.641791-30.567164 5.731344-40.119403s30.567164-7.641791 40.119403 5.731344l105.074626 139.462686c9.552239 13.373134 7.641791 30.567164-5.731343 40.119403-5.731343 3.820896-11.462687 5.731343-17.19403 5.731343z\" fill=\"#BFCBD9\" p-id=\"2489\" /><path d=\"M502.447761 500.537313c-5.731343 0-11.462687-1.910448-17.19403-5.731343-13.373134-9.552239-15.283582-26.746269-5.731343-40.119403l105.074627-139.462686c9.552239-13.373134 26.746269-15.283582 40.119403-5.731344 13.373134 9.552239 15.283582 26.746269 5.731343 40.119403l-105.074627 139.462687c-5.731343 7.641791-13.373134 11.462687-22.925373 11.462686z\" fill=\"#BFCBD9\" p-id=\"2490\" /><path d=\"M508.179104 970.507463c-252.179104 0-458.507463-206.328358-458.507462-458.507463s206.328358-458.507463 458.507462-458.507463c112.716418 0 219.701493 40.119403 303.761195 114.626866 19.104478 17.19403 36.298507 36.298507 53.492537 55.402985 13.373134 17.19403 11.462687 40.119403-5.731343 53.492537s-40.119403 11.462687-53.492538-5.731343c-13.373134-17.19403-28.656716-32.477612-43.940298-45.850746-70.686567-61.134328-160.477612-95.522388-254.089553-95.522388-210.149254 0-382.089552 171.940299-382.089552 382.089552s171.940299 382.089552 382.089552 382.089552 382.089552-171.940299 382.089553-382.089552c0-32.477612-3.820896-64.955224-11.462687-95.522388-5.731343-21.014925 7.641791-42.029851 26.746269-45.850746 21.014925-5.731343 42.029851 7.641791 45.850746 26.746268 9.552239 38.208955 15.283582 76.41791 15.283582 116.537314 0 252.179104-206.328358 456.597015-458.507463 456.597015z\" fill=\"#BFCBD9\" p-id=\"2491\" /><path d=\"M842.507463 273.19403c-13.373134 0-26.746269-9.552239-28.656717-24.835821l-19.104477-118.447761c-3.820896-15.283582 7.641791-30.567164 22.925373-32.477612 15.283582-1.910448 30.567164 7.641791 32.477612 22.925373l19.104477 118.447761c1.910448 15.283582-7.641791 30.567164-22.925373 32.477612 0 1.910448-1.910448 1.910448-3.820895 1.910448z\" fill=\"#BFCBD9\" p-id=\"2492\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "zuNs":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("teFm");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5f4a8aa1", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0d850c2c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0d850c2c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.461dfd2a029955a53937.js